(function () {
  'use strict';

  var U_CDN = 'https://cinai.app/api/v1/uploads/';
  var ARCH_DEFAULT_COVER = {
    keychain: U_CDN + 'ct-keychain-cover.webp?v=5',
    lamp: U_CDN + 'ct-lampshade-cover.webp?v=1',
    mandala: U_CDN + 'ct-layered-art-cover.webp?v=1',
    caketopper: U_CDN + 'ct-caketopper-cover.webp?v=1',
    qrcode: U_CDN + 'ct-qrcode-cover.webp?v=1',
    puzzle: U_CDN + 'pz-cover.webp?v=1',
    map: U_CDN + 'ct-layered-art-cover.webp?v=1',
    halftone: U_CDN + 'ct-ai3d.webp',
    plaque: U_CDN + 'ct-music-plaque-cover.webp?v=1',
    box: U_CDN + 'ct-card-giftbox-cover.webp?v=1'
  };

  var ARCH_FEATURE_COVERS = [
    U_CDN + 'ct-lampshade-cover.webp?v=1',
    U_CDN + 'ct-layered-art-cover.webp?v=1',
    U_CDN + 'ct-ai3d.webp',
    U_CDN + 'ct-card-giftbox-cover.webp?v=1',
    U_CDN + 'ct-keychain-cover.webp?v=5',
    U_CDN + 'ct-music-plaque-cover.webp?v=1'
  ];

  // Crisp bespoke SVG icons (0 emojis anywhere)
  var IC_FOLDER = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"/></svg>';
  var IC_CART = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>';
  var IC_GIFT = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#EA580C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';
  var IC_TRASH = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg>';
  var IC_EDIT = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg>';
  var IC_SAVE = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>';
  var IC_AI_NODE = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>';
  var IC_UPLOAD = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>';
  var IC_DOWNLOAD = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>';
  var IC_CHECK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><polyline points="20 6 9 17 4 12"/></svg>';

  // Curated Materials Catalog for "Choosing the Right Material for Your Project" block
  var ARCH_MATERIALS = {
    lamp: [
      { name: '3mm Basswood Plywood Sheet (6-Pack)', spec: '300 × 300 × 3.0 mm · Laser Grade A+', price: '$14.90', tag: 'Best Seller', img: U_CDN + 'ct-lampshade-cover.webp?v=1' },
      { name: 'Warm White E26/E27 LED Cord & Socket Kit', spec: '1.8m braided cord with inline switch', price: '$9.50', tag: 'Hardware Kit', img: U_CDN + 'ct-card-giftbox-cover.webp?v=1' },
      { name: 'Frosted Diffuser Cast Acrylic (3mm)', spec: 'Soft warm light diffusion · Zero glare', price: '$16.00', tag: 'Optical Grade', img: U_CDN + 'ct-layered-art-cover.webp?v=1' },
      { name: 'Walnut Veneer MDF Core (3.2mm)', spec: 'Rich natural grain · Press-fit ready', price: '$18.50', tag: 'Premium Wood', img: U_CDN + 'ct-music-plaque-cover.webp?v=1' }
    ],
    halftone: [
      { name: 'Solid Brass Challenge Coin Blank (45mm)', spec: '45 × 4.0 mm · Reeded edge + Acrylic capsule', price: '$8.90', tag: 'Mint Grade', img: U_CDN + 'ct-ai3d.webp' },
      { name: 'Optical K9 Crystal Cube + RGB LED Base', spec: '60 × 60 × 60 mm · Sub-surface 3D laser ready', price: '$19.90', tag: '3D Crystal', img: U_CDN + 'ct-keychain-cover.webp?v=5' },
      { name: 'Antique Silver & Bronze Relief Blanks (3-Pack)', spec: 'Deep fiber/diode relief engraving blanks', price: '$22.00', tag: 'Collector Pack', img: U_CDN + 'ct-music-plaque-cover.webp?v=1' },
      { name: 'High-Density Basswood Carving Block (10mm)', spec: 'For 3D depthmap bas-relief engraving', price: '$12.50', tag: '3D Relief', img: U_CDN + 'ct-layered-art-cover.webp?v=1' }
    ],
    keychain: [
      { name: '3mm Crystal Clear Cast Acrylic + Gold Clasps', spec: 'Includes 10 Acrylic blanks + star lobster clasps', price: '$12.90', tag: 'Starter Kit', img: U_CDN + 'ct-keychain-cover.webp?v=5' },
      { name: 'Holographic Rainbow Starlight Acrylic Sheet', spec: 'Prismatic shimmer · UV print & laser cut', price: '$15.90', tag: 'Trending', img: U_CDN + 'ct-caketopper-cover.webp?v=1' },
      { name: 'Two-Tone Laserable Acrylic Sheet (Gold/Black)', spec: 'Crisp single-pass contrast engraving', price: '$14.50', tag: '2-Layer Pro', img: U_CDN + 'ct-qrcode-cover.webp?v=1' },
      { name: 'Natural Cherry & Walnut Keychain Blanks (12pc)', spec: 'Pre-sanded 3mm hardwood + split rings', price: '$11.90', tag: 'Eco Wood', img: U_CDN + 'ct-card-giftbox-cover.webp?v=1' }
    ]
  };

  // ── 1. Per-User Identity & Per-App Project Storage Engine ──
  function sanitizeEmailKey(em) {
    return String(em || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '_');
  }

  function getCurrentUserId() {
    try {
      var savedEmail = localStorage.getItem('vog_account_email');
      if (savedEmail && savedEmail.trim().indexOf('@') !== -1) {
        return 'user_' + sanitizeEmailKey(savedEmail);
      }
      if (window.TG_CUSTOMER_EMAIL && String(window.TG_CUSTOMER_EMAIL).indexOf('@') !== -1) {
        return 'user_' + sanitizeEmailKey(window.TG_CUSTOMER_EMAIL);
      }
      if (window.TG_CUSTOMER_ID) return 'cust_' + String(window.TG_CUSTOMER_ID);
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId) {
        return 'cust_' + String(window.ShopifyAnalytics.meta.page.customerId);
      }
      var uid = localStorage.getItem('tg_studio_uid');
      if (!uid) {
        uid = 'u_' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
        localStorage.setItem('tg_studio_uid', uid);
      }
      return uid;
    } catch (e) {
      return 'u_default';
    }
  }

  function getCurrentUserProfile() {
    try {
      var uid = getCurrentUserId();
      var savedEmail = (localStorage.getItem('vog_account_email') || window.TG_CUSTOMER_EMAIL || '').trim();
      var savedName = (localStorage.getItem('vog_account_name') || window.TG_CUSTOMER_NAME || '').trim();
      var isLogged = Boolean(savedEmail && savedEmail.indexOf('@') !== -1) || Boolean(window.TG_CUSTOMER_ID);
      if (isLogged) {
        var fallbackName = savedEmail ? savedEmail.split('@')[0].replace(/[._-]+/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }) : 'ThoughtyGift Creator';
        var finalName = savedName || fallbackName;
        var initChar = (finalName.charAt(0) || savedEmail.charAt(0) || 'T').toUpperCase();
        return {
          uid: uid,
          isLoggedIn: true,
          name: finalName,
          email: savedEmail || ('Customer #' + window.TG_CUSTOMER_ID),
          initial: initChar,
          roleBadge: 'VIP Studio Member'
        };
      }
      return {
        uid: uid,
        isLoggedIn: false,
        name: 'Guest Creator',
        email: 'Not Signed In (Guest Session)',
        initial: 'G',
        roleBadge: 'Guest · Sign In for +200 Free Credits'
      };
    } catch (e) {
      return { uid: 'u_default', isLoggedIn: false, name: 'Guest Creator', email: 'Guest Session', initial: 'G', roleBadge: 'Guest' };
    }
  }

  function getCreditStorageKey() {
    return 'tg_credits_v2_' + getCurrentUserId();
  }

  function getStorageKey() {
    return 'tg_user_projects_v1_' + getCurrentUserId();
  }

  function formatTimestamp(ts) {
    var d = ts ? new Date(ts) : new Date();
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    return d.getFullYear() + '/' + pad(d.getMonth() + 1) + '/' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
  }

  function generateGid() {
    var s = '861';
    for (var i = 0; i < 12; i++) s += Math.floor(Math.random() * 10);
    return s;
  }

  function getBridge() {
    return window.CinaiStudioBridge || null;
  }

  function getToolMeta(slug) {
    var b = getBridge();
    var reg = (b && b.TOOL_REGISTRY) || {};
    var rec = reg[slug] || reg['table-lamp-generator'] || ['Creative Tool Generator', '', 'lamp', 'lighthouse', '#E8D5B8', '#9C6B3F', 'THOUGHTYGIFT', 'STUDIO', 8, 3, 1, '~g'];
    var VIDEO_APP_COVER_MAP = {
      'halftone': 'https://image-res.atomm.com/resource/xtool/xcs-cms//atomm/landingTemplate/3ca39219-1358-4680-9ce6-1e0913736c00.png?x-oss-process=image/resize,m_lfit,w_960,limit_0/interlace,1/format,webp/auto-orient,1',
      'stained-glass-generator': 'https://storage-public.atomm.com/xtool/atomm-cms/generator/cover/2613cbdb-aeac-4a30-b131-574c5cb8ebcb.gif',
      'distress-maker': 'https://storage-public.atomm.com/xtool/atomm-cms/generator/cover/d65e3ab4-9c1e-4b3b-ba00-473bb0046825.jpg?x-oss-process=image/resize,m_fill,w_640,h_480/format,webp',
      'commemorative-coin-generator': 'https://image-res.atomm.com/resource/xtool/community/atomm/landingTemplate/b2c53124-e4df-4770-975d-1dd2ef247cde.png?x-oss-process=image/resize,m_lfit,w_960,limit_0/interlace,1/format,webp/auto-orient,1',
      'pet-portrait-generator': 'https://image-res.atomm.com/resource/xtool/community/atomm/landingTemplate/fa51673b-d04c-4be3-88bb-c929adca5cb0.png?x-oss-process=image/resize,m_lfit,w_960,limit_0/interlace,1/format,webp/auto-orient,1',
      'card-generator': 'https://image-res.atomm.com/resource/xtool/community/atomm/landingTemplate/59774d3b-5882-4d63-9e1d-9cafc1d69f69.png?x-oss-process=image/resize,m_lfit,w_960,limit_0/interlace,1/format,webp/auto-orient,1',
      'colorful-ornament-generator': 'https://image-res.atomm.com/resource/xtool/community/atomm/landingTemplate/77d62473-ea5b-4517-b919-e474c631c5f9.jpg?x-oss-process=image/resize,m_lfit,w_960,limit_0/interlace,1/format,webp/auto-orient,1',
      'raster-card-generator': 'https://image-res.atomm.com/resource/xtool/xcs-cms//atomm/landingTemplate/169c91fd-5711-4eab-b569-460a5bca26a6.png?x-oss-process=image/resize,m_lfit,w_960,limit_0/interlace,1/format,webp/auto-orient,1',
      'opticut': 'https://storage-public.atomm.com/generator-resource/797734/app_14fuaZsmxpQKjVHG/cover/a597f304-66c3-45fd-a179-85772623b14d.png?x-oss-process=image/resize,m_fill,w_640,h_480,limit_0/interlace,1/format,webp/auto-orient,1',
      'rhinestone-text-generator': 'https://storage-public.atomm.com/generator-resource/ubIa7x5Uc/app_5wuF3tbS1rEIznnb/cover/ab8e188c-4d25-41e3-ad71-4cfd686d0018.jpg?x-oss-process=image/resize,m_fill,w_640,h_480,limit_0/interlace,1/format,webp/auto-orient,1',
      '3d-glasses-free-generator': 'https://image-res.atomm.com/resource/xtool/xcs-cms//atomm/landingTemplate/60f8dca4-e9be-4356-9a6f-67c82f6f60b6.png?x-oss-process=image/resize,m_lfit,w_960,limit_0/interlace,1/format,webp/auto-orient,1',
      'lenticular-card-generator': 'https://image-res.atomm.com/resource/xtool/xcs-cms//atomm/landingTemplate/169c91fd-5711-4eab-b569-460a5bca26a6.png?x-oss-process=image/resize,m_lfit,w_960,limit_0/interlace,1/format,webp/auto-orient,1',
      'background-remover': 'https://image-res.atomm.com/resource/xtool/xcs-cms//atomm/landingTemplate/6221a5a6-045e-41c0-b225-c6fa3f1c560e.jpg?x-oss-process=image/resize,m_lfit,w_960,limit_0/interlace,1/format,webp/auto-orient,1',
      'design-extraction': 'https://image-res.atomm.com/resource/xtool/xcs-cms//atomm/landingTemplate/0ed2a3e9-ccd0-4b7d-b5e4-058a797e4cd7.png?x-oss-process=image/resize,m_lfit,w_960,limit_0/interlace,1/format,webp/auto-orient,1',
      'parse-image': 'https://image-res.atomm.com/resource/xtool/xcs-cms//atomm/landingTemplate/04783dab-3e92-4493-99d9-3fc7ba587dcb.png?x-oss-process=image/resize,m_lfit,w_960,limit_0/interlace,1/format,webp/auto-orient,1'
    };
    window.TgGetAppCoverUrl = function (s) {
      return VIDEO_APP_COVER_MAP[s] || '';
    };
    var cardImg = VIDEO_APP_COVER_MAP[slug] || null;
    var cardVid = null;
    try {
      var cardEl = document.querySelector('[data-id="' + slug + '"]');
      if (cardEl) {
        var imgEl = cardEl.querySelector('img.at-card__media');
        if (imgEl && imgEl.src && imgEl.src.indexOf('http') === 0) cardImg = imgEl.src;
        var vidEl = cardEl.querySelector('video.at-card__media');
        if (vidEl) {
          cardVid = vidEl.src || vidEl.getAttribute('data-src') || '';
          var vPoster = vidEl.getAttribute('poster') || '';
          if (!cardImg && vPoster.indexOf('http') === 0) cardImg = vPoster;
        }
      }
    } catch (e) {}
    var arch = rec[2] || 'lamp';
    return {
      slug: slug,
      enTitle: rec[0] || slug,
      viTitle: rec[1] || rec[0] || slug,
      arch: arch,
      preset: rec[3],
      backColor: rec[4],
      midColor: rec[5],
      defaultText: rec[6],
      defaultSub: rec[7],
      paramA: rec[8],
      paramB: rec[9],
      nameEnabled: Boolean(rec[10]),
      shortUrl: rec[11] || '',
      cover: cardImg || ARCH_DEFAULT_COVER[arch] || ARCH_DEFAULT_COVER.lamp,
      video: cardVid || ''
    };
  }

  function loadAllUserProjects() {
    try {
      var raw = localStorage.getItem(getStorageKey());
      if (raw) {
        var parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') return parsed;
      }
    } catch (e) {}
    return {};
  }

  function saveAllUserProjects(map) {
    try {
      localStorage.setItem(getStorageKey(), JSON.stringify(map));
    } catch (e) {}
  }

  function getUserProjectsForApp(slug) {
    var all = loadAllUserProjects();
    var meta = getToolMeta(slug);
    if (!Array.isArray(all[slug]) || all[slug].length === 0) {
      var now = Date.now();
      var baseName = meta.enTitle.replace(/\s+Generator$/i, '') + ' Draft';
      all[slug] = [
        {
          gid: '861197532404869',
          toolSlug: slug,
          title: baseName,
          updatedAt: formatTimestamp(now - 3600 * 1000 * 2),
          ts: now - 3600 * 1000 * 2,
          thumb: meta.cover,
          snap: {
            shapeId: meta.preset,
            sizePt: 227,
            backColor: meta.backColor,
            midColor: meta.midColor,
            nameEnabled: meta.nameEnabled,
            nameText: meta.defaultText,
            subText: meta.defaultSub,
            paramA: meta.paramA,
            paramB: meta.paramB,
            engineMode: meta.shortUrl ? '3d' : 'cad'
          }
        },
        {
          gid: '861197532404512',
          toolSlug: slug,
          title: baseName + ' #2',
          updatedAt: formatTimestamp(now - 3600 * 1000 * 5),
          ts: now - 3600 * 1000 * 5,
          thumb: ARCH_DEFAULT_COVER[meta.arch] || meta.cover,
          snap: {
            shapeId: meta.preset,
            sizePt: 240,
            backColor: '#1E293B',
            midColor: '#F59E0B',
            nameEnabled: true,
            nameText: meta.defaultText + ' PRO',
            subText: meta.defaultSub,
            paramA: Math.max(2, (meta.paramA || 6) + 2),
            paramB: meta.paramB,
            engineMode: meta.shortUrl ? '3d' : 'cad'
          }
        }
      ];
      saveAllUserProjects(all);
    } else {
      var changed = false;
      for (var k = 0; k < all[slug].length; k++) {
        if (!all[slug][k].thumb || /ct-emboss-cover|ct-3dmap-cover/.test(all[slug][k].thumb)) {
          all[slug][k].thumb = meta.cover;
          changed = true;
        }
      }
      if (changed) saveAllUserProjects(all);
    }
    return all[slug];
  }

  function captureCurrentSvgThumb(fallbackCover) {
    return fallbackCover;
  }

  function setBackgroundCatalogVideosPaused(shouldPause) {
    try {
      var vids = document.querySelectorAll('video.at-card__media, #TglHeroMediaWrap video');
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i];
        if (shouldPause) {
          if (!v.paused) v.pause();
        } else if (v.classList.contains('at-card__media')) {
          v.play().catch(function () {});
        }
      }
    } catch (e) {}
  }

  var activeSession = {
    slug: 'table-lamp-generator',
    pdpUrl: '',
    gid: ''
  };

  function createNewProjectForApp(slug, customTitle) {
    var all = loadAllUserProjects();
    var list = getUserProjectsForApp(slug);
    var meta = getToolMeta(slug);
    var gid = generateGid();
    var now = Date.now();
    var baseName = customTitle || (meta.enTitle.replace(/\s+Generator$/i, '') + ' Draft');
    var newRec = {
      gid: gid,
      toolSlug: slug,
      title: baseName,
      updatedAt: formatTimestamp(now),
      ts: now,
      thumb: meta.cover,
      snap: {
        shapeId: meta.preset,
        sizePt: 227,
        backColor: meta.backColor,
        midColor: meta.midColor,
        nameEnabled: meta.nameEnabled,
        nameText: meta.defaultText,
        subText: meta.defaultSub,
        paramA: meta.paramA,
        paramB: meta.paramB,
        engineMode: meta.shortUrl ? '3d' : 'cad'
      }
    };
    list.unshift(newRec);
    all[slug] = list.slice(0, 30);
    saveAllUserProjects(all);
    return newRec;
  }

  function saveCurrentStudioToDraft(showToast, explicitThumb, explicitTitle) {
    var b = getBridge();
    if (!b || !b.state) return null;
    var slug = b.state.toolSlug || activeSession.slug || 'table-lamp-generator';
    var meta = getToolMeta(slug);
    var all = loadAllUserProjects();
    var list = getUserProjectsForApp(slug);
    var gid = activeSession.gid || (list[0] && list[0].gid) || generateGid();
    activeSession.gid = gid;
    var now = Date.now();
    var existingIdx = -1;
    for (var i = 0; i < list.length; i++) {
      if (list[i].gid === gid) { existingIdx = i; break; }
    }
    var thumb = explicitThumb || captureCurrentSvgThumb(meta.cover);
    var snap = {
      shapeId: b.state.shapeId,
      sizePt: b.state.sizePt,
      backColor: b.state.backColor,
      midColor: b.state.midColor,
      nameEnabled: b.state.nameEnabled,
      nameText: b.state.nameText,
      subText: b.state.subText,
      paramA: b.state.paramA,
      paramB: b.state.paramB,
      engineMode: b.state.engineMode,
      aiState: window.TgAiEngine ? window.TgAiEngine.getStateSnapshot() : null
    };
    var rec;
    if (existingIdx !== -1) {
      rec = list[existingIdx];
      if (explicitTitle) rec.title = explicitTitle;
      rec.updatedAt = formatTimestamp(now);
      rec.ts = now;
      rec.thumb = thumb || rec.thumb;
      rec.snap = snap;
      list.splice(existingIdx, 1);
      list.unshift(rec);
    } else {
      rec = {
        gid: gid,
        toolSlug: slug,
        title: explicitTitle || (meta.enTitle.replace(/\s+Generator$/i, '') + ' Draft'),
        updatedAt: formatTimestamp(now),
        ts: now,
        thumb: thumb,
        snap: snap
      };
      list.unshift(rec);
    }
    all[slug] = list.slice(0, 30);
    saveAllUserProjects(all);
    syncStudioProjectHeaderBar();
    if (showToast) {
      var saveBtn = document.getElementById('KcBtnSaveDraftTxt');
      if (saveBtn) {
        var orig = saveBtn.textContent;
        saveBtn.textContent = 'Saved';
        setTimeout(function () { saveBtn.textContent = orig; }, 1400);
      }
    }
    return rec;
  }

  function renameProjectDraft(slug, gid, newTitle) {
    var all = loadAllUserProjects();
    var list = getUserProjectsForApp(slug);
    for (var i = 0; i < list.length; i++) {
      if (list[i].gid === gid) {
        list[i].title = String(newTitle || '').trim() || list[i].title;
        list[i].updatedAt = formatTimestamp(Date.now());
        break;
      }
    }
    all[slug] = list;
    saveAllUserProjects(all);
    renderRecentlyCards(slug);
    renderHistoryDrawerList(slug);
    syncStudioProjectHeaderBar();
  }

  function deleteProjectDraft(slug, gid) {
    var all = loadAllUserProjects();
    var list = getUserProjectsForApp(slug).filter(function (item) { return item.gid !== gid; });
    all[slug] = list;
    saveAllUserProjects(all);
    if (activeSession.gid === gid) {
      activeSession.gid = list[0] ? list[0].gid : '';
    }
    renderRecentlyCards(slug);
    renderHistoryDrawerList(slug);
    syncStudioProjectHeaderBar();
  }

  function openProjectInStudio(slug, gid, explicitPdpUrl) {
    var list = getUserProjectsForApp(slug);
    var rec = null;
    if (gid) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].gid === gid) { rec = list[i]; break; }
      }
    }
    if (!rec) {
      rec = createNewProjectForApp(slug);
    }
    activeSession.slug = slug;
    activeSession.gid = rec.gid;
    if (explicitPdpUrl) activeSession.pdpUrl = explicitPdpUrl;

    closeLandingPage(true);
    closeHistoryDrawer();

    try {
      var nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('openStudio', '1');
      nextUrl.searchParams.set('tool', slug);
      nextUrl.searchParams.set('gid', rec.gid);
      nextUrl.searchParams.delete('landing');
      window.history.pushState({ tool: slug, gid: rec.gid }, '', nextUrl.toString());
    } catch (e) {}

    setBackgroundCatalogVideosPaused(true);

    if (typeof window.openCinaiStudio === 'function') {
      window.openCinaiStudio(slug, activeSession.pdpUrl);
    }

    var b = getBridge();
    if (b && b.state && rec && rec.snap) {
      var s = rec.snap;
      if (s.shapeId) b.state.shapeId = s.shapeId;
      if (s.sizePt) b.state.sizePt = s.sizePt;
      if (s.backColor) b.state.backColor = s.backColor;
      if (s.midColor) b.state.midColor = s.midColor;
      if (typeof s.nameEnabled === 'boolean') b.state.nameEnabled = s.nameEnabled;
      if (s.nameText) b.state.nameText = s.nameText;
      if (s.subText) b.state.subText = s.subText;
      if (s.paramA !== undefined) b.state.paramA = s.paramA;
      if (s.paramB !== undefined) b.state.paramB = s.paramB;
      if (typeof b.syncLiveEngineFrame === 'function') b.syncLiveEngineFrame();
      if (typeof b.syncAllUI === 'function') b.syncAllUI(true);
    }
    syncStudioProjectHeaderBar();
    ensureAiStudioWorkbench(slug);
  }

  // ── 2. Load Landings Dataset ──
  var landingsCache = null;
  var landingsPromise = null;

  function fetchLandingsData() {
    if (landingsCache) return Promise.resolve(landingsCache);
    if (landingsPromise) return landingsPromise;
    var url = window.TG_LANDINGS_URL || '/cdn/shop/t/1/assets/tg-creative-landings.json';
    landingsPromise = fetch(url)
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (data) {
        landingsCache = data || {};
        return landingsCache;
      })
      .catch(function () {
        landingsCache = {};
        return landingsCache;
      });
    return landingsPromise;
  }

  function getFallbackLanding(slug) {
    var meta = getToolMeta(slug);
    var t = meta.enTitle;
    return {
      type: 'official',
      desc: 'Customize your ' + t + ' in real time with interactive 3D preview and parametric 2D vector CAD controls. Dial in your dimensions, materials, and laser kerf offset, then export a production-ready SVG cut file or order custom-cut materials.',
      howTitle: 'How to Make a Custom Project with ' + t,
      howSub: 'Three simple steps from concept to finished laser-cut or UV-printed piece.',
      steps: [
        { t: 'Pick a template or upload art', d: 'Choose from built-in parametric forms or upload your own reference photo/SVG to generate interlocking cut & engrave layers automatically.' },
        { t: 'Customize dimensions & material', d: 'Set exact millimeter or inch sizing, pick wood or acrylic surface swatches, and adjust slot kerf compensation for a tight press-fit.' },
        { t: 'Preview in 3D & export cut file', d: 'Inspect your finished piece in interactive 3D Studio or 2D Vector CAD, then download the free SVG or order the matching Supplies Kit.' }
      ],
      features: [
        { t: 'Parametric Joinery & Precision Fit', d: 'Every slot, tab, and contour automatically recalculates when you change material thickness or overall size — no manual node editing required.' },
        { t: 'Interactive 3D & 2D Cut Layout', d: 'Switch seamlessly between realistic 3D Studio preview and color-coded 2D laser cut/engrave paths (#cc3333 cut, #0066ff score/engrave).' },
        { t: 'Per-User Cloud & Local Drafts', d: 'Every variation you create is saved in your personal Recently project list so you can revisit, rename, duplicate, or re-export anytime.' }
      ],
      useTitle: 'Where Custom ' + t + ' Projects Shine',
      useCases: [
        { t: 'Personalized Gifts & Keepsakes', d: 'Create one-of-a-kind commemorative gifts, desk decor, and custom nameplates with zero minimum order quantity.' },
        { t: 'Craft Fair & Small Batch Production', d: 'Change names, colors, or sizes in seconds to fulfill custom customer orders from a single nested master layout.' },
        { t: 'Home, Studio & Event Decor', d: 'Produce wedding signage, holiday ornaments, and architectural lamps ready to assemble right off the laser bed.' },
        { t: 'Ready-to-Cut Supplies Kits', d: 'Pair your design with pre-selected basswood, cast acrylic, and LED/clasp hardware delivered straight to your door.' }
      ],
      ctaTitle: 'Get Started with ThoughtyGift Creative Studio Today',
      faqs: [
        { q: 'Is the ' + t + ' free to use?', a: 'Yes! Designing, previewing in 3D, saving drafts to your personal project workspace, and exporting SVG cut files are completely free.' },
        { q: 'Where are my saved projects stored?', a: 'Your drafts are automatically saved per user and per app under "Recently" and in the "My Projects" drawer, so you can reopen or rename any draft anytime.' },
        { q: 'What materials work best?', a: '1/8 inch (3mm) basswood plywood, walnut veneer, cast acrylic sheets, and two-tone laserable plaques — all available in the Supplies Kit drawer.' },
        { q: 'Can I order the finished product or materials directly?', a: 'Yes. Click "Buy Materials" or "Supplies Kit & Order" inside the Studio to order matching material sheets or custom-made pieces.' }
      ]
    };
  }

  // ── 3. Build 1:1 App Landing Page Overlay + My Projects Right Drawer (.history-drawer) ──
  var ATOMM_HERO_DECOR_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="560" height="392" viewBox="0 0 560 392" fill="none" style="position:absolute;inset:0;width:100%;height:100%;pointer-events:none;">' +
      '<rect x="75.3496" y="13.2852" width="400" height="300" rx="12" transform="rotate(6.02116 75.3496 13.2852)" fill="url(#tg_paint0_linear)"/>' +
      '<rect opacity="0.9" x="62.2578" y="45.8164" width="400" height="300" rx="12" transform="rotate(-1.90616 62.2578 45.8164)" fill="url(#tg_paint1_linear)"/>' +
      '<path d="M36 93.457C44.9182 91.6134 51.9885 84.9967 54.525 76.2775L55.0545 74.457L55.5841 76.2775C58.1206 84.9967 65.1909 91.6134 74.1091 93.457C65.1909 95.3007 58.1206 101.917 55.5841 110.637L55.0545 112.457L54.525 110.637C51.9885 101.917 44.9182 95.3007 36 93.457Z" fill="url(#tg_paint2_linear)"/>' +
      '<path d="M510 123.457C515.633 122.293 520.098 118.114 521.7 112.607L522.034 111.457L522.369 112.607C523.971 118.114 528.436 122.293 534.069 123.457C528.436 124.621 523.971 128.8 522.369 134.307L522.034 135.457L521.7 134.307C520.098 128.8 515.633 124.621 510 123.457Z" fill="url(#tg_paint3_linear)"/>' +
      '<defs>' +
        '<linearGradient id="tg_paint0_linear" x1="487.589" y1="21.0282" x2="404.961" y2="275.873" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBCBC"/><stop offset="1" stop-color="white" stop-opacity="0"/></linearGradient>' +
        '<linearGradient id="tg_paint1_linear" x1="87.8788" y1="68.0067" x2="365.417" y2="207.298" gradientUnits="userSpaceOnUse"><stop stop-color="#FEE6FF"/><stop offset="1" stop-color="#E6EBFF"/></linearGradient>' +
        '<linearGradient id="tg_paint2_linear" x1="59.066" y1="86.957" x2="49.7059" y2="112.457" gradientUnits="userSpaceOnUse"><stop stop-color="#FFFDFD"/><stop offset="1" stop-color="#FFE0E0"/></linearGradient>' +
        '<linearGradient id="tg_paint3_linear" x1="524.568" y1="119.352" x2="518.656" y2="135.457" gradientUnits="userSpaceOnUse"><stop stop-color="#FFF4F4"/><stop offset="1" stop-color="#FFD4D9"/></linearGradient>' +
      '</defs>' +
    '</svg>';

  function ensureLandingAndDrawerDom() {
    if (document.getElementById('TgAppLandingOverlay')) return;

    var style = document.createElement('style');
    style.id = 'TgLandingAndProjectsStyles';
    style.textContent =
      '#TgAppLandingOverlay{position:fixed;inset:0;z-index:2147483640;background:#FFFFFF;overflow-y:auto;overflow-x:hidden;box-sizing:border-box;display:none;font-family:Inter,-apple-system,BlinkMacSystemFont,sans-serif;color:#171719;}' +
      '#TgAppLandingOverlay *,#TgAppLandingOverlay *::before,#TgAppLandingOverlay *::after{box-sizing:border-box;}' +
      '#TgAppLandingOverlay.is-open{display:block;}' +
      '.tgl-topbar{position:sticky;top:0;z-index:50;background:rgba(255,255,255,0.92);backdrop-filter:blur(8px);border-bottom:1px solid rgba(23,23,25,0.06);padding:8px 40px;display:flex;align-items:center;justify-content:space-between;}' +
      '.tgl-crumb{display:flex;align-items:center;gap:4px;font-size:12px;font-weight:400;color:rgba(23,23,25,0.56);min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}' +
      '.tgl-crumb a,.tgl-crumb button{border:none;background:transparent;color:rgba(23,23,25,0.56);cursor:pointer;padding:2px 4px;border-radius:4px;font-size:12px;font-weight:400;text-decoration:none;flex-shrink:0;}' +
      '.tgl-crumb a:hover,.tgl-crumb button:hover{color:#171719;}' +
      '.tgl-topbar-actions{display:flex;align-items:center;gap:10px;flex-shrink:0;}' +
      '.tgl-a3d-mob-tips{display:none;flex-direction:column;align-items:center;justify-content:center;text-align:center;gap:4px;}' +
      '.tgl-a3d-mob-sug-icon{display:none;}' +
      '.tgl-a3d-mob-mymodels{display:none;width:100%;padding-top:16px;}' +
      '.tgl-a3d-mob-mm-head{display:flex;align-items:center;justify-content:space-between;padding:0 4px 12px;cursor:pointer;user-select:none;}' +
      '.tgl-a3d-mob-mm-title{font-size:16px;font-weight:600;color:#171719;line-height:24px;}' +
      '.tgl-a3d-mob-mm-arrow{width:20px;height:20px;color:#171719;transition:transform .2s;}' +
      '.tgl-a3d-mob-mymodels.is-open .tgl-a3d-mob-mm-arrow{transform:rotate(180deg);}' +
      '.tgl-a3d-mob-mm-body{display:none;padding:8px 0 12px;}' +
      '.tgl-a3d-mob-mymodels.is-open .tgl-a3d-mob-mm-body{display:block;}' +
      '.tgl-sticky-bottom{position:sticky;bottom:0;left:0;right:0;height:64px;background:#ffffff;box-shadow:0px 0px 32px 0px rgba(0,0,0,0.07);display:flex;align-items:center;justify-content:space-between;gap:16px;padding:0 40px;z-index:40;}' +
      '.tgl-sticky-bottom__text{margin:0;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:16px;font-weight:500;color:#171719;}' +
      '.tgl-sticky-bottom__actions{display:flex;align-items:center;gap:8px;flex-shrink:0;}' +
      '.tgl-sticky-btn-shop{height:36px;padding:0 14px;border-radius:8px;border:none;background:#FA253D;color:#ffffff;font-size:14px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;white-space:nowrap;text-decoration:none;}' +
      '.tgl-sticky-btn-earn{height:36px;padding:0 14px;border-radius:8px;border:1px solid #E4E4E7;background:#ffffff;color:#3D3E42;font-size:14px;font-weight:500;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;gap:6px;white-space:nowrap;}' +
      /* Archetype 3: .generator-entry-block */
      '.tgl-hero-wrap{background:#ffffff;padding:20px 40px 32px;}' +
      '.tgl-hero{max-width:1440px;margin:0 auto;display:flex;align-items:center;gap:32px;}' +
      '.tgl-hero__asset{position:relative;width:560px;height:392px;flex-shrink:0;display:flex;align-items:center;justify-content:center;}' +
      '.tgl-hero__img-wrap{position:relative;z-index:2;width:400px;height:300px;border-radius:12px;background:#ffffff;box-shadow:0 12px 32px rgba(0,0,0,0.08);overflow:hidden;}' +
      '.tgl-hero__img-wrap img,.tgl-hero__img-wrap video{width:100%;height:100%;object-fit:cover;border-radius:12px;display:block;}' +
      '.tgl-hero__info{flex:1;min-width:0;}' +
      '.tgl-hero__title{font-size:40px;line-height:48px;font-weight:700;color:#171719;margin:0 0 12px;letter-spacing:-0.01em;}' +
      '.tgl-hero__desc{font-size:18px;line-height:22px;color:rgba(23,23,25,0.64);margin:0 0 24px;max-width:760px;}' +
      '.tgl-btn-create-hero{display:inline-flex;align-items:center;justify-content:center;gap:6px;height:44px;padding:0 20px;border-radius:10px;border:none;background:#FF0035;color:#ffffff;font-size:16px;font-weight:600;cursor:pointer;transition:transform .15s,background .15s;}' +
      '.tgl-btn-create-hero:hover{background:#E0002E;transform:translateY(-1px);}' +
      /* Archetype 2: .ai-tool-block */
      '#TglAiToolHeroBlock{display:none;position:relative;background:linear-gradient(180deg,#FFD5DB 0.19%,#FFFFFF 42.55%);padding:36px 24px 56px;}' +
      '#TglAiToolHeroBlock.is-active{display:block;}' +
      '.tgl-aitool-inner{max-width:980px;margin:0 auto;}' +
      '.tgl-aitool-title{font-size:48px;line-height:56px;font-weight:700;color:#171719;text-align:center;margin:0 0 12px;}' +
      '.tgl-aitool-desc{font-size:18px;line-height:22px;color:rgba(23,23,25,0.72);text-align:center;margin:0 auto 40px;max-width:860px;}' +
      '.tgl-aitool-box{display:flex;align-items:stretch;gap:32px;}' +
      '.tgl-aitool-left{width:50%;position:relative;aspect-ratio:4/3;display:flex;align-items:center;justify-content:center;}' +
      '.tgl-aitool-media{position:relative;z-index:2;width:85%;height:85%;border-radius:12px;overflow:hidden;background:#ffffff;box-shadow:0 12px 32px rgba(0,0,0,0.08);}' +
      '.tgl-aitool-media img,.tgl-aitool-media video{width:100%;height:100%;object-fit:cover;display:block;}' +
      '.tgl-aitool-right{width:50%;display:flex;flex-direction:column;}' +
      '.tgl-aitool-drop{flex:1;border:2px dashed rgba(83,91,136,0.16);border-radius:12px;background:#ffffff;padding:32px 24px;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;cursor:pointer;transition:border-color .15s,background .15s;}' +
      '.tgl-aitool-drop:hover{border-color:#171719;background:#FAFAFC;}' +
      '.tgl-aitool-upbtn{margin-top:20px;height:44px;padding:0 24px;border-radius:10px;border:none;background:#171719;color:#ffffff;font-size:15px;font-weight:600;display:inline-flex;align-items:center;gap:8px;cursor:pointer;}' +
      /* Archetype 1: .ai-3d-generator-block */
      '#TglAtomm3dHeroBlock{position:relative;display:none;flex-direction:column;align-items:center;padding:32px 24px 64px;background:linear-gradient(rgb(255,213,219) 0.19%,rgb(255,255,255) 42.55%);overflow:hidden;}' +
      '#TglAtomm3dHeroBlock.is-active{display:flex;}' +
      '.tgl-a3d-bg-img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;pointer-events:none;z-index:0;}' +
      '.tgl-a3d-title{position:relative;z-index:2;font-size:40px;line-height:48px;font-weight:700;color:#171719;margin:0 0 8px;text-align:center;max-width:980px;}' +
      '.tgl-a3d-sub{position:relative;z-index:2;font-size:18px;line-height:22px;color:#171719;margin:0 0 24px;text-align:center;max-width:980px;}' +
      '.tgl-a3d-tabs{position:relative;z-index:2;display:inline-flex;align-items:center;gap:20px;margin-bottom:12px;}' +
      '.tgl-a3d-tab{position:relative;border:none;background:transparent;color:rgba(23,23,25,0.64);font-size:16px;font-weight:500;height:56px;padding:8px 16px 8px 10px;border-radius:20px;cursor:pointer;display: inline-flex;align-items:center;gap:8px;transition:all .15s;}' +
      '.tgl-a3d-tab img{width:40px;height:40px;border-radius:999px;object-fit:cover;flex-shrink:0;}' +
      '.tgl-a3d-tab.is-active{background:linear-gradient(rgba(255,255,255,0.6),rgba(254,233,232,0));color:#171719;font-weight:700;}' +
      '.tgl-a3d-tab.is-active::after{content:"";position:absolute;bottom:4px;left:calc(50% + 14px);transform:translateX(-50%);width:16px;height:3px;border-radius:2px;background:#FF0035;}' +
      '.tgl-a3d-card-wrap{position:relative;z-index:2;width:100%;max-width:800px;}' +
      '.tgl-a3d-card{width:100%;height:480px;background:#ffffff;border-radius:12px;box-shadow:0 12px 40px rgba(23,23,25,0.06);display:flex;flex-direction:column;justify-content:space-between;}' +
      '.tgl-a3d-upload-wrap{width:100%;height:420px;padding:12px 16px 8px;box-sizing:border-box;}' +
      '.tgl-a3d-drop{width:100%;height:100%;border:1px dashed rgba(83,91,136,0.16);border-radius:10px;background:#F6F6FA;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:20px;position:relative;transition:all .15s;cursor:pointer;overflow:hidden;box-sizing:border-box;}' +
      '.tgl-a3d-drop:hover{border-color:rgba(83,91,136,0.36);background:#F0F1F7;}' +
      '.tgl-a3d-drop.has-img{border-style:solid;border-color:#E5E6EB;cursor:default;}' +
      '.tgl-a3d-upbtn{margin-top:20px;height:40px;padding:0 16px;border-radius:8px;border:1px solid rgba(83,91,136,0.16);background:#ffffff;color:#171719;font-size:14px;font-weight:500;display:inline-flex;align-items:center;gap:8px;cursor:pointer;transition:background .15s;}' +
      '.tgl-a3d-upbtn:hover{background:#F8F9FA;}' +
      '.tgl-a3d-SugPop{position:absolute;bottom:68px;left:50%;transform:translateX(-50%);width:460px;max-width:92vw;background:#ffffff;border-radius:14px;box-shadow:0 16px 40px rgba(0,0,0,0.16);border:1px solid #E5E6EB;padding:16px;z-index:30;display:none;text-align:left;cursor:default;}' +
      '.tgl-a3d-SugPop.is-open{display:block;}' +
      '.tgl-a3d-foot{height:60px;padding:8px 16px 20px;display:flex;align-items:center;justify-content:space-between;gap:12px;box-sizing:border-box;}' +
      '.tgl-a3d-switch{position:relative;display:inline-flex;width:36px;height:20px;border-radius:999px;background:#171719;cursor:pointer;transition:background .15s;padding:2px;box-sizing:border-box;border:none;align-items:center;}' +
      '.tgl-a3d-switch.is-off{background:#D1D5DB;}' +
      '.tgl-a3d-switch span{width:16px;height:16px;border-radius:999px;background:#ffffff;display:block;transition:transform .15s;transform:translateX(16px);}' +
      '.tgl-a3d-switch.is-off span{transform:translateX(0);}' +
      '.tgl-a3d-size-inp{width:40px;height:32px;border-radius:8px;border:1px solid rgba(83,91,136,0.16);background:#ffffff;text-align:center;font-size:12px;color:#171719;outline:none;}' +
      '.tgl-a3d-genbtn{margin-left:auto;height:40px;padding:0 16px;border-radius:8px;border:none;background:#171719;color:#ffffff;font-size:14px;font-weight:500;cursor:pointer;display:inline-flex;align-items:center;gap:6px;transition:opacity .15s,background .15s;opacity:0.4;}' +
      '.tgl-a3d-genbtn.is-ready{opacity:1;}' +
      '.tgl-a3d-genbtn:hover{opacity:0.9;}' +
      '.tgl-a3d-folder{position:absolute;left:calc(100% + 16px);top:0;width:80px;height:70px;cursor:pointer;user-select:none;z-index:5;}' +
      '.tgl-a3d-folder__left{position:absolute;left:12px;top:6px;width:38px;height:38px;border-radius:8px;background:#ffffff;border:2px solid #ffffff;box-shadow:0 2px 6px rgba(0,0,0,0.08);transform:rotate(-13deg);transition:transform .2s;}' +
      '.tgl-a3d-folder__right{position:absolute;right:12px;top:6px;width:38px;height:38px;border-radius:8px;background:#ffffff;border:2px solid #ffffff;box-shadow:0 2px 6px rgba(0,0,0,0.12);overflow:hidden;transform:rotate(12deg);transition:transform .2s;}' +
      '.tgl-a3d-folder__right img{width:100%;height:100%;object-fit:cover;display:block;}' +
      '.tgl-a3d-folder__bottom{position:absolute;bottom:0;left:0;width:80px;height:45px;border-radius:10px;background:linear-gradient(180deg,rgba(255,255,255,0.92) 0%,#FFFFFF 100%);box-shadow:0 4px 14px rgba(23,23,25,0.10);border:1px solid rgba(255,255,255,0.9);display:flex;align-items:flex-end;justify-content:center;padding-bottom:6px;box-sizing:border-box;}' +
      '.tgl-a3d-folder:hover .tgl-a3d-folder__left{transform:rotate(-18deg) translateY(-4px);}' +
      '.tgl-a3d-folder:hover .tgl-a3d-folder__right{transform:rotate(17deg) translateY(-4px);}' +
      /* Recently Section */
      '.tgl-recent-sec{max-width:1440px;margin:0 auto;padding:24px 40px 32px;}' +
      '.tgl-recent-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;}' +
      '.tgl-recent-title{font-size:24px;font-weight:700;color:#171719;}' +
      '.tgl-recent-more{border:none;background:transparent;font-size:14px;font-weight:500;color:rgba(23,23,25,0.72);cursor:pointer;padding:6px 10px;border-radius:8px;}' +
      '.tgl-recent-more:hover{background:#F4F4F6;color:#171719;}' +
      '.tgl-recent-grid{display:grid;grid-template-columns:repeat(6,1fr);gap:16px;}' +
      '.tgl-card-new{position:relative;border:1px dashed rgba(83,91,136,0.24);border-radius:10px;background:#F4F4F6;padding:8px;cursor:pointer;display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:210px;transition:all .15s;}' +
      '.tgl-card-new:hover{border-color:#171719;background:#EAECEF;}' +
      '.tgl-card-new__plus{width:32px;height:32px;border-radius:8px;background:#171719;color:#ffffff;display:flex;align-items:center;justify-content:center;font-size:20px;font-weight:500;margin-bottom:8px;}' +
      '.tgl-card-draft{position:relative;border-radius:10px;background:#F4F4F6;padding:8px;cursor:pointer;transition:all .15s;display:flex;flex-direction:column;}' +
      '.tgl-card-draft:hover{box-shadow:0 8px 24px rgba(0,0,0,0.08);}' +
      '.tgl-card-draft__cov{aspect-ratio:4/3;width:100%;border-radius:8px;background:#ffffff;overflow:hidden;display:flex;align-items:center;justify-content:center;}' +
      '.tgl-card-draft__cov img{width:100%;height:100%;object-fit:contain;display:block;}' +
      '.tgl-card-draft__name{font-size:14px;font-weight:600;color:#171719;margin:8px 0 2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}' +
      '.tgl-card-draft__time{font-size:12px;color:rgba(23,23,25,0.45);}' +
      '.tgl-card-draft__more{position:absolute;top:14px;right:14px;width:28px;height:28px;border-radius:999px;background:rgba(255,255,255,0.92);border:1px solid #E5E6EB;color:#171719;display:flex;align-items:center;justify-content:center;cursor:pointer;font-weight:800;font-size:14px;z-index:5;opacity:0;transition:opacity .15s;}' +
      '.tgl-card-draft:hover .tgl-card-draft__more{opacity:1;}' +
      '.tgl-card-menu{position:absolute;top:44px;right:14px;background:#ffffff;border:1px solid #E5E6EB;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,0.12);padding:4px;z-index:20;min-width:110px;display:none;}' +
      '.tgl-card-menu.is-open{display:block;}' +
      '.tgl-card-menu button{width:100%;border:none;background:transparent;padding:7px 10px;text-align:left;font-size:13px;font-weight:500;color:#171719;border-radius:6px;cursor:pointer;display:block;}' +
      '.tgl-card-menu button:hover{background:#F2F3F5;}' +
      '.tgl-card-menu button.is-danger{color:#EF4444;}' +
      '.tgl-card-menu button.is-danger:hover{background:#FEF2F2;}' +
      /* Showcase single-asset-block */
      '#TglShowcaseSec{background:#F6F6FA;padding:64px 24px;display:none;}' +
      '.tgl-showcase-inner{max-width:1120px;margin:0 auto;text-align:center;}' +
      '.tgl-showcase-title{font-size:36px;line-height:44px;font-weight:700;color:#171719;margin:0 0 36px;}' +
      '.tgl-showcase-img{width:100%;border-radius:16px;display:block;margin:0 auto;}' +
      /* How It Works Section (Atomm Black #000000 style) */
      '#TglStepsSec{background:#000000;padding:64px 24px;}' +
      '.tgl-steps-inner{max-width:980px;margin:0 auto;}' +
      '.tgl-steps-head{text-align:center;margin:0 auto 40px;max-width:760px;}' +
      '.tgl-steps-title{font-size:36px;line-height:44px;font-weight:700;color:#ffffff;margin:0 0 10px;}' +
      '.tgl-steps-sub{font-size:16px;line-height:24px;color:rgba(255,255,255,0.72);margin:0;}' +
      '.tgl-steps-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px;}' +
      '.tgl-step-card{background:#ffffff;border-radius:12px;padding:32px;display:flex;flex-direction:column;gap:12px;}' +
      '.tgl-step-num{font-size:36px;font-weight:700;color:#9CA3AF;line-height:40px;}' +
      '.tgl-step-title{font-size:20px;line-height:28px;font-weight:700;color:#171719;margin:0;}' +
      '.tgl-step-desc{font-size:16px;line-height:24px;color:#4B5563;margin:0;}' +
      /* Materials Section (Atomm horizontal 3-col product cards) */
      '#TglMaterialsSec{background:#ffffff;padding:64px 24px;}' +
      '.tgl-mat-inner{max-width:1280px;margin:0 auto;}' +
      '.tgl-sec__head{text-align:center;max-width:820px;margin:0 auto 40px;}' +
      '.tgl-sec__title{font-size:36px;line-height:44px;font-weight:700;color:#171719;margin:0 0 10px;}' +
      '.tgl-sec__sub{font-size:16px;color:#4B5563;margin:0;line-height:24px;}' +
      '.tgl-mat-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;}' +
      '.tgl-mat-card{background:#ffffff;border:1px solid #E5E7EB;border-radius:12px;padding:20px;display:flex;align-items:center;gap:16px;transition:box-shadow .15s,border-color .15s;}' +
      '.tgl-mat-card:hover{box-shadow:0 8px 24px rgba(0,0,0,0.06);border-color:#D1D5DB;}' +
      '.tgl-mat-img{width:132px;height:132px;border-radius:8px;background:#F3F4F6;overflow:hidden;flex-shrink:0;position:relative;}' +
      '.tgl-mat-img img{width:100%;height:100%;object-fit:cover;display:block;}' +
      '.tgl-mat-body{flex:1;min-width:0;display:flex;flex-direction:column;justify-content:space-between;min-height:132px;}' +
      '.tgl-mat-title{font-size:14px;line-height:20px;font-weight:600;color:#171719;margin:0 0 6px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}' +
      '.tgl-mat-spec{font-size:12px;color:#6B7280;background:#F3F4F6;border-radius:6px;padding:4px 8px;margin:0 0 10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}' +
      '.tgl-mat-foot{display:flex;align-items:center;justify-content:space-between;gap:8px;}' +
      /* Alternating Feature Rows (.text-asset-block) */
      '#TglFeaturesSec{background:#ffffff;padding:32px 24px 64px;}' +
      '.tgl-feat-list{max-width:980px;margin:0 auto;display:flex;flex-direction:column;gap:80px;}' +
      '.tgl-feat-row{display:flex;align-items:center;gap:40px;}' +
      '.tgl-feat-row:nth-child(odd){flex-direction:row-reverse;}' +
      '.tgl-feat-text{flex:1;min-width:0;}' +
      '.tgl-feat-title{font-size:32px;line-height:40px;font-weight:700;color:#171719;margin:0 0 16px;}' +
      '.tgl-feat-desc{font-size:16px;line-height:24px;color:#4B5563;margin:0 0 24px;}' +
      '.tgl-feat-btn{display:inline-flex;align-items:center;justify-content:center;padding:12px 28px;border-radius:8px;border:none;background:#171719;color:#ffffff;font-size:16px;font-weight:600;cursor:pointer;transition:opacity .15s;}' +
      '.tgl-feat-btn:hover{opacity:0.88;}' +
      '.tgl-feat-img{width:480px;aspect-ratio:4/3;border-radius:16px;overflow:hidden;flex-shrink:0;background:#F3F4F6;}' +
      '.tgl-feat-img img,.tgl-feat-img video{width:100%;height:100%;object-fit:cover;display:block;}' +
      /* Why Choose / Use Cases */
      '#TglUseCasesSec{background:#ffffff;padding:48px 24px 64px;}' +
      '.tgl-use-inner{max-width:980px;margin:0 auto;}' +
      '.tgl-use-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px;}' +
      '.tgl-use-grid.cols-4{grid-template-columns:repeat(4,1fr);}' +
      '.tgl-use-card{background:#ffffff;border-radius:12px;padding:32px;border:1px solid #E5E7EB;box-shadow:0 1px 3px rgba(0,0,0,0.04);}' +
      '.tgl-use-card h3{font-size:20px;line-height:28px;font-weight:700;color:#171719;margin:0 0 12px;}' +
      '.tgl-use-card p{font-size:16px;line-height:24px;color:#4B5563;margin:0;}' +
      /* Discover More Tools (Atomm 3-col horizontal mini cards on #F5F5F5) */
      '#TglRelatedSec{background:#F5F5F5;padding:64px 24px;}' +
      '.tgl-rel-inner{max-width:980px;margin:0 auto;}' +
      '.tgl-rel-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;}' +
      '.tgl-rel-card{background:#ffffff;border-radius:12px;padding:12px;cursor:pointer;transition:box-shadow .15s,transform .15s;display:flex;align-items:center;gap:12px;}' +
      '.tgl-rel-card:hover{transform:translateY(-2px);box-shadow:0 8px 20px rgba(0,0,0,0.06);}' +
      '.tgl-rel-card img{width:80px;height:80px;object-fit:cover;border-radius:8px;background:#F3F4F6;flex-shrink:0;}' +
      /* CTA Banner (.banner-block) */
      '#TglCtaCoverSec{position:relative;width:100%;height:360px;overflow:hidden;display:flex;align-items:center;justify-content:center;text-align:center;background:#FFF0F3;}' +
      '.tgl-cta-bg{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;pointer-events:none;z-index:0;}' +
      '.tgl-cta-content{position:relative;z-index:2;max-width:820px;padding:0 24px;}' +
      /* FAQs (.faq-block) */
      '#TglFaqSec{background:#ffffff;padding:64px 24px 96px;}' +
      '.tgl-faq-list{max-width:832px;margin:0 auto;display:flex;flex-direction:column;gap:24px;}' +
      '.tgl-faq-item{background:transparent;border:none;border-radius:0;}' +
      '.tgl-faq-q{width:100%;border:none;background:transparent;padding:8px 0;text-align:left;font-size:22px;line-height:30px;font-weight:700;color:#171719;cursor:pointer;display:flex;align-items:center;justify-content:space-between;gap:16px;}' +
      '.tgl-faq-icon{font-size:24px;font-weight:400;color:#171719;transition:transform .2s;line-height:1;flex-shrink:0;}' +
      '.tgl-faq-item.is-open .tgl-faq-icon{transform:rotate(45deg);}' +
      '.tgl-faq-a{padding:8px 0 4px;font-size:16px;line-height:24px;color:rgba(23,23,25,0.72);display:none;}' +
      '.tgl-faq-item.is-open .tgl-faq-a{display:block;}' +
      '.tgl-comm-box{max-width:980px;margin:0 auto;background:#F9FAFB;border-radius:16px;padding:32px 36px;border:1px solid #E5E7EB;display:grid;grid-template-columns:1.2fr 1fr;gap:36px;}' +
      '.tgl-comm-ul{list-style:none;padding:0;margin:0;display:flex;flex-direction:column;gap:10px;}' +
      '.tgl-comm-ul li{display:flex;align-items:flex-start;gap:10px;font-size:14px;line-height:1.6;color:#374151;}' +
      '.tgl-history-drawer{position:fixed;inset:0;z-index:2147483646;background:rgba(0,0,0,0.35);display:none;justify-content:flex-end;}' +
      '.tgl-history-drawer.is-open{display:flex;}' +
      '.tgl-history-drawer__panel{width:380px;max-width:92vw;height:100%;background:#ffffff;box-shadow:-8px 0 32px rgba(0,0,0,0.15);display:flex;flex-direction:column;}' +
      '.tgl-history-drawer__head{height:56px;padding:0 18px;border-bottom:1px solid #E5E6EB;display:flex;align-items:center;justify-content:space-between;}' +
      '.tgl-history-drawer__body{flex:1;overflow-y:auto;padding:16px;display:grid;grid-template-columns:repeat(2,1fr);gap:12px;align-content:start;}' +
      '.tgl-hitem{position:relative;border-radius:10px;border:1px solid #E5E6EB;background:#F8F9FA;overflow:hidden;cursor:pointer;aspect-ratio:4/3;}' +
      '.tgl-hitem img{width:100%;height:100%;object-fit:contain;display:block;background:#ffffff;}' +
      '.tgl-hitem__mask{position:absolute;inset:0;background:rgba(0,0,0,0.52);opacity:0;transition:opacity .15s;display:flex;flex-direction:column;justify-content:space-between;padding:8px;color:#ffffff;}' +
      '.tgl-hitem:hover .tgl-hitem__mask{opacity:1;}' +
      '#Tg3dModelStudioHost input[type="checkbox"],#TgAppLandingOverlay input[type="checkbox"]{display:inline-block !important;opacity:1 !important;position:static !important;width:15px !important;height:15px !important;appearance:auto !important;-webkit-appearance:checkbox !important;pointer-events:auto !important;margin:0 !important;}' +
      '#Tg3dModelStudioHost input[type="range"]{appearance:auto !important;-webkit-appearance:slider-horizontal !important;background:#E5E6EB !important;height:5px !important;border-radius:999px !important;padding:0 !important;}' +
      '#Tg3dModelStudioHost svg[fill="none"],#TgAppLandingOverlay svg[fill="none"]{fill:none !important;}' +
      '.tgl-mob-navbar{display:none;align-items:center;justify-content:space-between;height:56px;padding:0 16px;background:#ffffff;position:sticky;top:0;z-index:25;box-sizing:border-box;}' +
      '.tgl-mob-navbar__left{display:flex;align-items:center;gap:12px;}' +
      '.tgl-mob-navbar__right{display:flex;align-items:center;gap:14px;}' +
      '.tgl-mob-icon-btn{border:none;background:transparent;padding:0;width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;color:#171719;cursor:pointer;}' +
      '@media(max-width:1024px){.tgl-a3d-folder{position:static;margin:16px auto 0;}.tgl-recent-grid{grid-template-columns:repeat(3,1fr);}.tgl-mat-grid,.tgl-rel-grid{grid-template-columns:repeat(2,minmax(0,1fr));}}' +
      '@media(max-width:768px){' +
        'html,body{overflow-x:hidden !important;max-width:100vw !important;}' +
        '.halo-popup:not(.show) .halo-popup-close{right:0 !important;}' +
        '.tgl-mob-navbar{display:flex !important;}' +
        '.tgl-topbar{position:static !important;padding:10px 16px !important;height:44px !important;flex-wrap:nowrap !important;border-bottom:none !important;}' +
        '.tgl-topbar-actions{display:none !important;}' +
        '.tgl-crumb{font-size:14px !important;gap:8px !important;width:100% !important;}' +
        '.tgl-crumb a,.tgl-crumb button{font-size:14px !important;color:#171719 !important;padding:0 !important;}' +
        '#TglCrumbAppTitle{color:#85878B !important;font-weight:400 !important;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}' +
        '#TglAtomm3dHeroBlock{padding:32px 16px 24px !important;}' +
        '.tgl-a3d-title{font-size:24px !important;line-height:32px !important;margin:0 0 12px !important;}' +
        '.tgl-a3d-sub{font-size:14px !important;line-height:20px !important;color:#3D3E42 !important;margin:0 0 16px !important;}' +
        '.tgl-a3d-tabs{width:100% !important;height:50px !important;border-bottom:1px solid rgba(23,23,25,0.08) !important;justify-content:center !important;gap:32px !important;margin-bottom:16px !important;}' +
        '.tgl-a3d-tab{height:49px !important;padding:12px 0 !important;border-radius:0 !important;background:transparent !important;font-size:16px !important;font-weight:600 !important;color:#85878B !important;}' +
        '.tgl-a3d-tab img{display:none !important;}' +
        '.tgl-a3d-tab.is-active{background:transparent !important;color:#171719 !important;font-weight:600 !important;}' +
        '.tgl-a3d-tab.is-active::after{left:50% !important;bottom:0 !important;transform:translateX(-50%) !important;width:24px !important;height:3px !important;background:#FF3B30 !important;}' +
        '.tgl-a3d-card{height:auto !important;border-radius:12px !important;box-shadow:none !important;}' +
        '.tgl-a3d-upload-wrap{height:auto !important;padding:12px 12px 8px !important;}' +
        '.tgl-a3d-drop{height:280px !important;min-height:280px !important;padding:16px !important;border-radius:12px !important;background:#FCFCFD !important;border:1px dashed rgba(83,91,136,0.3) !important;}' +
        '#TglA3dGuideImg,#TglA3dGuideVid,#TglA3dGuideTitle,.tgl-a3d-fmt-desktop,.tgl-a3d-upbtn,.tgl-a3d-sug-txt,.tgl-a3d-sug-desktop-ic{display:none !important;}' +
        '.tgl-a3d-mob-tips{display:flex !important;}' +
        '#TglA3dSugToggle{position:absolute !important;top:9px !important;right:9px !important;width:28px !important;height:28px !important;padding:0 !important;margin:0 !important;color:#85878B !important;justify-content:center !important;align-items:center !important;}' +
        '.tgl-a3d-mob-sug-icon{display:block !important;}' +
        '#TglA3dPreviewImg{max-height:244px !important;max-width:100% !important;}' +
        '.tgl-a3d-foot{height:auto !important;flex-direction:column !important;align-items:stretch !important;padding:12px 16px 16px !important;gap:12px !important;}' +
        '#TglA3dParamsPhoto,#TglA3dParamsModel{flex-direction:column !important;align-items:stretch !important;gap:12px !important;width:100% !important;}' +
        '.tgl-a3d-param-row{display:flex !important;width:100% !important;min-height:36px !important;justify-content:space-between !important;align-items:center !important;}' +
        '.tgl-a3d-param-lbl{color:#85878B !important;font-size:14px !important;}' +
        '.tgl-a3d-size-inp{width:48px !important;height:32px !important;background:#F4F4F5 !important;border:none !important;border-radius:6px !important;font-size:12px !important;}' +
        '#TglA3dModelSelect{height:36px !important;min-width:128px !important;background:#F4F4F5 !important;border:none !important;border-radius:8px !important;font-size:14px !important;font-weight:500 !important;padding:0 10px !important;}' +
        '.tgl-a3d-genbtn{width:100% !important;height:44px !important;margin-left:0 !important;justify-content:center !important;border-radius:8px !important;font-size:14px !important;font-weight:500 !important;}' +
        '#TglA3dMyModelsFolder{display:none !important;}' +
        '.tgl-a3d-mob-mymodels{display:block !important;}' +
        /* Archetype 2 (.ai-tool-block) Mobile 1:1 Atomm */
        '#TglAiToolHeroBlock{padding:20px 16px 24px !important;}' +
        '.tgl-aitool-title{font-size:28px !important;line-height:36px !important;font-weight:700 !important;margin:0 0 8px !important;}' +
        '.tgl-aitool-desc{font-size:14px !important;line-height:20px !important;margin:0 auto 20px !important;padding:0 4px !important;}' +
        '.tgl-aitool-box{flex-direction:column !important;gap:20px !important;background:transparent !important;border:none !important;box-shadow:none !important;padding:0 !important;}' +
        '.tgl-aitool-left{width:100% !important;aspect-ratio:4/3 !important;min-height:0 !important;padding:6px !important;background:#ffffff !important;border-radius:12px !important;box-shadow:0 4px 16px rgba(0,0,0,0.04) !important;}' +
        '.tgl-aitool-left .tgl-hero__decor{display:none !important;}' +
        '.tgl-aitool-media{width:100% !important;height:100% !important;aspect-ratio:auto !important;border-radius:10px !important;}' +
        '.tgl-aitool-right{width:100% !important;padding:0 !important;display:flex !important;justify-content:center !important;}' +
        '.tgl-aitool-drop{width:auto !important;min-height:0 !important;border:none !important;background:transparent !important;padding:0 !important;}' +
        '.tgl-aitool-drop > div{display:none !important;}' +
        '.tgl-aitool-upbtn{margin-top:0 !important;height:36px !important;padding:0 16px !important;border-radius:8px !important;background:#27272A !important;font-size:14px !important;font-weight:500 !important;}' +
        '.tgl-aitool-upbtn__desk{display:none !important;}' +
        '.tgl-aitool-upbtn__mob{display:inline !important;}' +
        /* Archetype 3 (.generator-entry-block) Mobile 1:1 Atomm */
        '.tgl-hero-wrap{padding:12px 16px 16px !important;}' +
        '.tgl-hero{flex-direction:column !important;gap:20px !important;text-align:center !important;}' +
        '.tgl-hero__asset{width:100% !important;height:auto !important;aspect-ratio:4/3 !important;padding:6px !important;background:#ffffff !important;border-radius:12px !important;box-shadow:0 4px 16px rgba(0,0,0,0.04) !important;}' +
        '.tgl-hero__decor{display:none !important;}' +
        '.tgl-hero__img-wrap{width:100% !important;height:100% !important;border-radius:10px !important;box-shadow:none !important;}' +
        '.tgl-hero__info{width:100% !important;display:flex !important;flex-direction:column !important;align-items:center !important;text-align:center !important;}' +
        '.tgl-hero__cat-pill{margin:0 auto 10px !important;}' +
        '.tgl-hero__title{font-size:28px !important;line-height:36px !important;font-weight:700 !important;margin:0 0 8px !important;text-align:center !important;}' +
        '.tgl-hero__desc{font-size:14px !important;line-height:20px !important;margin:0 0 20px !important;text-align:center !important;}' +
        '#TglHeroCreateBtn{height:36px !important;padding:0 20px !important;border-radius:8px !important;font-size:14px !important;font-weight:500 !important;margin:0 auto !important;}' +
        '.tgl-recent-sec{display:none !important;}' +
        /* #CinaiStudioModal & #Tg3dModUploadModal Mobile Header & Layout */
        '#TgCatalogCreditBtn{display:none !important;}' +
        '#CinaiStudioModal .kc-header{height:48px !important;min-height:48px !important;padding:0 8px !important;gap:4px !important;flex-wrap:nowrap !important;overflow:hidden !important;justify-content:space-between !important;}' +
        '#CinaiStudioModal .kc-header__left{gap:4px !important;min-width:0 !important;flex:1 1 auto !important;overflow:hidden !important;display:flex !important;align-items:center !important;}' +
        '#CinaiStudioModal .kc-logo,#CinaiStudioModal .kc-brand,#CinaiStudioModal .kc-mtitle,#KcEngineSeg,#KcEarnCreditsBtn,#KcHeaderAuthBtn,#KcProjLandingBtn,#CinaiStudioModal .kc-header__center,#KcHeaderShareEarnBtn,#CinaiStudioModal .kc-status-pill{display:none !important;}' +
        '#KcProjectHeaderBar{margin-left:2px !important;padding-left:6px !important;gap:4px !important;min-width:0 !important;flex:1 1 auto !important;overflow:hidden !important;}' +
        '#KcProjTitleBtn{max-width:105px !important;padding:0 6px !important;height:28px !important;font-size:12px !important;}' +
        '#KcProjSaveBtn,#KcProjHistoryBtn{padding:0 6px !important;height:28px !important;font-size:0 !important;gap:2px !important;flex-shrink:0 !important;}' +
        '#KcProjHistoryCount{font-size:10px !important;}' +
        '#CinaiStudioModal .kc-header__right{gap:4px !important;flex-shrink:0 !important;display:flex !important;align-items:center !important;}' +
        '#KcHeaderEngineBar{margin-right:0 !important;gap:4px !important;}' +
        '#KcCreditsPill{height:28px !important;padding:0 7px !important;font-size:11px !important;}' +
        '#KcAvatarBtn{width:28px !important;height:28px !important;font-size:11px !important;}' +
        '#KcBtnHeaderOrder{height:28px !important;padding:0 8px !important;font-size:11px !important;border-radius:6px !important;white-space:nowrap !important;}' +
        '#KcBtnClose{width:28px !important;height:28px !important;flex-shrink:0 !important;}' +
        '#Kc3dEngineWrap,#KcSuppliesKitHost{top:48px !important;height:calc(100vh - 48px) !important;overflow:hidden !important;}' +
        '#Kc3dFooterOverride{width:100% !important;left:0 !important;right:0 !important;height:auto !important;padding:10px 12px !important;display:flex !important;flex-direction:row !important;gap:8px !important;background:#ffffff !important;border-top:1px solid #E5E7EB !important;box-sizing:border-box !important;}' +
        '#Kc3dFooterOverride button{flex:1 1 0 !important;height:40px !important;margin:0 !important;font-size:12px !important;padding:0 8px !important;white-space:nowrap !important;}' +
        '#Kc3dQuickCadBtn{bottom:68px !important;left:12px !important;right:auto !important;width:44px !important;height:44px !important;font-size:9px !important;}' +
        '#Tg3dModUploadModal .tg3d-card{max-width:calc(100vw - 24px) !important;max-height:calc(100vh - 24px) !important;border-radius:16px !important;}' +
        '#TglShowcaseSec{padding:32px 16px !important;}' +
        '.tgl-showcase-title{font-size:24px !important;line-height:32px !important;font-weight:600 !important;margin:0 0 24px !important;}' +
        '#TglStepsSec{padding:24px 16px !important;}' +
        '.tgl-steps-head{text-align:left !important;margin:0 0 12px !important;}' +
        '.tgl-steps-title{font-size:16px !important;line-height:22px !important;font-weight:600 !important;margin:0 !important;}' +
        '.tgl-steps-sub{display:none !important;}' +
        '.tgl-steps-grid{display:flex !important;flex-direction:row !important;overflow-x:auto !important;gap:16px !important;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding-bottom:4px;}' +
        '.tgl-step-card{flex:0 0 287px !important;width:287px !important;padding:16px !important;gap:8px !important;scroll-snap-align:start;}' +
        '.tgl-step-num{font-size:32px !important;line-height:36px !important;}' +
        '.tgl-step-title{font-size:20px !important;line-height:26px !important;font-weight:600 !important;}' +
        '.tgl-step-desc{font-size:14px !important;line-height:20px !important;}' +
        '#TglMaterialsSec{padding:24px 16px !important;}' +
        '#TglMaterialsSec .tgl-sec__head{text-align:left !important;margin:0 0 12px !important;}' +
        '#TglMaterialsTitle{font-size:16px !important;line-height:22px !important;font-weight:600 !important;margin:0 !important;}' +
        '.tgl-mat-grid{grid-template-columns:minmax(0,1fr) !important;gap:12px !important;width:100% !important;}' +
        '.tgl-mat-card{width:100% !important;max-width:100% !important;padding:12px !important;gap:12px !important;overflow:hidden !important;}' +
        '.tgl-mat-img{width:116px !important;height:116px !important;}' +
        '.tgl-mat-body{min-height:116px !important;min-width:0 !important;overflow:hidden !important;}' +
        '#TglFeaturesSec{padding:24px 16px 32px !important;}' +
        '.tgl-feat-list{gap:48px !important;}' +
        '.tgl-feat-row,.tgl-feat-row:nth-child(odd){flex-direction:column !important;gap:24px !important;text-align:center !important;}' +
        '.tgl-feat-title{font-size:24px !important;line-height:32px !important;font-weight:600 !important;margin:0 0 12px !important;text-align:center !important;}' +
        '.tgl-feat-desc{font-size:14px !important;line-height:20px !important;margin:0 0 20px !important;text-align:center !important;}' +
        '.tgl-feat-img{width:100% !important;border-radius:12px !important;}' +
        '#TglUseCasesSec{padding:24px 16px !important;}' +
        '#TglUseCasesSec .tgl-sec__head{text-align:left !important;margin:0 0 12px !important;}' +
        '#TglUseTitle{font-size:16px !important;line-height:22px !important;font-weight:600 !important;margin:0 !important;}' +
        '.tgl-use-grid,.tgl-use-grid.cols-4{display:flex !important;flex-direction:row !important;overflow-x:auto !important;gap:16px !important;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding-bottom:4px;}' +
        '.tgl-use-card{flex:0 0 287px !important;width:287px !important;padding:16px !important;scroll-snap-align:start;}' +
        '.tgl-use-card h3{font-size:20px !important;line-height:26px !important;font-weight:600 !important;margin:0 0 8px !important;}' +
        '.tgl-use-card p{font-size:14px !important;line-height:20px !important;}' +
        '#TglRelatedSec{padding:24px 16px 32px !important;}' +
        '#TglRelatedSec .tgl-sec__head{text-align:left !important;margin:0 0 16px !important;}' +
        '#TglRelatedSec .tgl-sec__title{font-size:16px !important;line-height:22px !important;font-weight:600 !important;margin:0 !important;}' +
        '.tgl-rel-grid{grid-template-columns:minmax(0,1fr) !important;gap:12px !important;}' +
        '#TglCtaCoverSec{height:200px !important;padding:32px 16px !important;}' +
        '#TglCtaBannerTitle{font-size:24px !important;line-height:32px !important;margin:0 0 16px !important;}' +
        '#TglFaqSec{padding:32px 16px 48px !important;}' +
        '#TglFaqSec .tgl-sec__head{margin-bottom:20px !important;}' +
        '#TglFaqTitle{font-size:24px !important;line-height:32px !important;}' +
        '.tgl-faq-q{font-size:16px !important;line-height:24px !important;}' +
        '.tgl-faq-a{font-size:14px !important;line-height:20px !important;}' +
        '.tgl-comm-box{grid-template-columns:minmax(0,1fr) !important;padding:20px 16px !important;}' +
        '.tgl-recent-grid{grid-template-columns:repeat(2,minmax(0,1fr)) !important;}' +
        '.tgl-sticky-bottom{padding:0 16px !important;gap:12px !important;}' +
        '#vog-quick-chat-widget,#vog-chat-minimized{display:none !important;}' +
      '}' +
      '#TgAppLandingOverlay h1,#TgAppLandingOverlay h2,#TgAppLandingOverlay h3,#TgAppLandingOverlay h4{font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif !important;letter-spacing:normal !important;text-transform:none !important;}';
    document.head.appendChild(style);

    var siteLogoEl = document.querySelector('.vog-topbar__logo img');
    var siteLogoSrc = (siteLogoEl && siteLogoEl.src) ? siteLogoEl.src : 'https://www.thoughtygift.com/cdn/shop/t/42/assets/thoughtygift-logo-cropped.png?v=6531222963713690691792176459';

    var overlay = document.createElement('div');
    overlay.id = 'TgAppLandingOverlay';
    overlay.setAttribute('data-no-gtx', 'true');
    overlay.innerHTML =
      '<div class="tgl-mob-navbar">' +
        '<div class="tgl-mob-navbar__left">' +
          '<button type="button" class="tgl-mob-icon-btn" id="TglMobMenuBtn" aria-label="Menu">' +
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M2.5 5h15M2.5 10h15M2.5 15h15" stroke="#171719" stroke-width="1.8" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<a href="/" style="display:inline-flex;align-items:center;text-decoration:none;">' +
            '<img src="' + siteLogoSrc + '" alt="ThoughtyGift" style="height:22px;width:auto;max-width:130px;object-fit:contain;display:block;"/>' +
          '</a>' +
        '</div>' +
        '<div class="tgl-mob-navbar__right">' +
          '<button type="button" class="tgl-mob-icon-btn" id="TglMobSearchBtn" aria-label="Search Tools">' +
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="9.2" cy="9.2" r="5.8" stroke="#171719" stroke-width="1.7"/><path d="M13.5 13.5L17 17" stroke="#171719" stroke-width="1.7" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<button type="button" class="tgl-mob-icon-btn" id="TglMobCreateBtn" aria-label="Create New">' +
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M4 10h12" stroke="#171719" stroke-width="1.8" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<button type="button" class="tgl-mob-icon-btn" id="TglMobLangBtn" aria-label="Language">' +
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="7.2" stroke="#171719" stroke-width="1.6"/><ellipse cx="10" cy="10" rx="3.2" ry="7.2" stroke="#171719" stroke-width="1.5"/><path d="M3.2 10h13.6" stroke="#171719" stroke-width="1.5"/></svg>' +
          '</button>' +
          '<button type="button" class="tgl-mob-icon-btn" id="TglMobProjectsBtn" aria-label="My Projects">' +
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15 7.2a5 5 0 1 0-10 0c0 5.2-2.2 6.6-2.2 6.6h14.4S15 12.4 15 7.2Z" stroke="#171719" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.6 16.5a1.6 1.6 0 0 0 2.8 0" stroke="#171719" stroke-width="1.6" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<button type="button" class="tgl-mob-icon-btn" id="TglMobCreditBtn" aria-label="Studio Credits" style="width:24px;height:24px;">' +
            '<img src="https://storage-us.atomm.com/resource/xart/static/agent/imgs/credits.svg" alt="Credits" style="width:22px;height:22px;display:block;"/>' +
          '</button>' +
        '</div>' +
      '</div>' +
      '<div class="tgl-topbar">' +
        '<div class="tgl-crumb">' +
          '<a href="/">Home</a><span>›</span>' +
          '<button type="button" id="TglBackToCatalogBtn">Creative Tools</button><span>›</span>' +
          '<span id="TglCrumbAppTitle" style="color:#171719;font-weight:500;">AI 3D Model Generator</span>' +
        '</div>' +
        '<div class="tgl-topbar-actions">' +
          '<button type="button" id="TglTopCreditBtn" title="My Studio Credits & Top-Up" style="border:1px solid #E5E7EB;background:#ffffff;color:#171719;height:32px;padding:0 10px;border-radius:999px;font-size:12px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:5px;">' +
            '<img src="https://storage-us.atomm.com/resource/xart/static/agent/imgs/credits.svg" alt="" style="width:15px;height:15px;display:inline-block;flex-shrink:0;"/>' +
            '<span id="TglTopCreditVal">200</span>' +
          '</button>' +
          '<button type="button" id="TglTopMyProjectsBtn" style="border:1px solid #E5E7EB;background:#ffffff;color:#171719;height:32px;padding:0 10px;border-radius:8px;font-size:12px;font-weight:500;cursor:pointer;display:inline-flex;align-items:center;gap:6px;">' +
            IC_FOLDER + '<span>My Projects</span><span id="TglTopProjCount" style="background:#F3F4F6;color:#171719;padding:1px 6px;border-radius:999px;font-weight:600;font-size:11px;">2</span>' +
          '</button>' +
        '</div>' +
      '</div>' +
      /* ARCHETYPE 1: .ai-3d-generator-block (1:1 Atomm AI 3D Model Generator) */
      '<div id="TglAtomm3dHeroBlock">' +
        '<img class="tgl-a3d-bg-img" src="https://storage-us.atomm.com/resource/xtool/xcs-cms//atomm/landingTemplate/16f41064-c2fa-4c48-b585-0c3d0c57f67e.png" alt=""/>' +
        '<h1 class="tgl-a3d-title" id="TglA3dHeroTitle">AI 3D Model Generator</h1>' +
        '<div class="tgl-a3d-sub" id="TglA3dHeroSub">Convert images into high‑quality 3D models in minutes. Ideal for crystal and glass inner engraving, our image to 3D model generator delivers production‑ready files optimized for glass and crystal design.</div>' +
        '<div class="tgl-a3d-tabs">' +
          '<button type="button" class="tgl-a3d-tab is-active" data-a3d-mode="photo">' +
            '<img src="https://storage-us.atomm.com/resource/xart/static/agent/imgs/ai-3d-photo-tab.png" alt="3D Photo"/>' +
            '<span>3D Photo</span>' +
          '</button>' +
          '<button type="button" class="tgl-a3d-tab" data-a3d-mode="model">' +
            '<img src="https://storage-us.atomm.com/resource/xart/static/agent/imgs/ai-3d-modeling-tab.png" alt="3D Modeling"/>' +
            '<span>3D Modeling</span>' +
          '</button>' +
        '</div>' +
        '<div class="tgl-a3d-card-wrap">' +
          '<div class="tgl-a3d-card">' +
            '<div class="tgl-a3d-upload-wrap">' +
              '<div class="tgl-a3d-drop" id="TglA3dDropZone">' +
                '<input type="file" id="TglA3dFileInput" accept="image/jpeg,image/png,image/webp" style="display:none;"/>' +
                '<div class="tgl-a3d-SugPop" id="TglA3dSugPopover">' +
                  '<div style="font-size:14px;font-weight:700;color:#171719;margin-bottom:4px;">Image Upload Suggestions</div>' +
                  '<div style="font-size:12px;color:#4E5969;margin-bottom:12px;" id="TglA3dSugDesc">Clear, front-facing photos of people or pets work best.</div>' +
                  '<div style="display:grid;grid-template-columns:repeat(2,1fr);gap:10px;margin-bottom:10px;" id="TglA3dSugGoodGrid"></div>' +
                  '<div style="display:grid;grid-template-columns:repeat(2,1fr);gap:10px;" id="TglA3dSugBadGrid"></div>' +
                '</div>' +
                '<div id="TglA3dEmptyState" style="display:flex;flex-direction:column;align-items:center;text-align:center;">' +
                  '<img id="TglA3dGuideImg" src="https://storage-us.atomm.com/resource/xart/static/agent/imgs/ai-3d-photo-guide.png" alt="3D Guide" style="width:160px;height:120px;object-fit:contain;margin-bottom:8px;"/>' +
                  '<video id="TglA3dGuideVid" src="https://storage-us.atomm.com/resource/xart/static/agent/imgs/3d_modeling/guide.mp4" autoplay loop muted playsinline style="display:none;width:200px;height:140px;object-fit:contain;margin-bottom:8px;"></video>' +
                  '<div id="TglA3dGuideTitle" style="font-size:16px;font-weight:700;color:#171719;line-height:20px;">Convert your photo into a 3D-like relief with depth effects</div>' +
                  '<div class="tgl-a3d-fmt-desktop" style="font-size:12px;color:rgba(23,23,25,0.4);line-height:16px;margin-top:4px;">Supported formats: JPG/JPEG/PNG/WEBP, Maximum size: 10M.</div>' +
                  '<div class="tgl-a3d-mob-tips">' +
                    '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" style="color:#85878B;margin-bottom:4px;"><path d="M12 15V4M12 4L7.5 8.5M12 4L16.5 8.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 15v2.5A2.5 2.5 0 0 0 6.5 20h11a2.5 2.5 0 0 0 2.5-2.5V15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                    '<p style="margin:0;font-size:14px;font-weight:600;color:#3D3E42;line-height:20px;">Click to upload image</p>' +
                    '<p style="margin:0;font-size:12px;font-weight:400;color:#85878B;line-height:18px;">JPG,JPEG,PNG,WEBP Size ≤ 10MB</p>' +
                  '</div>' +
                  '<button type="button" id="TglA3dSugToggle" style="border:none;background:transparent;color:#FF7C23;font-size:12px;line-height:16px;display:inline-flex;align-items:center;gap:4px;cursor:pointer;margin-top:4px;padding:2px 4px;">' +
                    '<span class="tgl-a3d-sug-txt">Image upload suggestions</span>' +
                    '<svg class="tgl-a3d-sug-desktop-ic" width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="#FF7C23" stroke-width="1.3"/><path d="M8 7.2V11" stroke="#FF7C23" stroke-width="1.3" stroke-linecap="round"/><circle cx="8" cy="5.2" r="0.8" fill="#FF7C23"/></svg>' +
                    '<svg class="tgl-a3d-mob-sug-icon" width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="#85878B" stroke-width="1.6"/><path d="M9.6 9.4a2.4 2.4 0 1 1 3.6 2.08c-.72.42-1.2.95-1.2 1.72v.3" stroke="#85878B" stroke-width="1.6" stroke-linecap="round"/><circle cx="12" cy="16.8" r="1" fill="#85878B"/></svg>' +
                  '</button>' +
                  '<button type="button" class="tgl-a3d-upbtn">' +
                    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 10.5V3.5M8 3.5L5 6.5M8 3.5L11 6.5M3 12.5H13" stroke="#171719" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                    '<span>Upload image</span>' +
                  '</button>' +
                '</div>' +
                '<div id="TglA3dPreviewState" style="display:none;width:100%;height:100%;position:relative;align-items:center;justify-content:center;">' +
                  '<img id="TglA3dPreviewImg" src="" alt="Uploaded preview" style="max-height:340px;max-width:100%;border-radius:10px;object-fit:contain;box-shadow:0 6px 20px rgba(0,0,0,0.10);"/>' +
                  '<button type="button" id="TglA3dClearImgBtn" title="Remove image" style="position:absolute;top:0;right:0;width:30px;height:30px;border-radius:8px;border:1px solid #E5E6EB;background:#ffffff;color:#171719;cursor:pointer;font-weight:700;">×</button>' +
                '</div>' +
              '</div>' +
            '</div>' +
            '<div class="tgl-a3d-foot">' +
              '<div id="TglA3dParamsPhoto" style="display:flex;align-items:center;gap:16px;flex-wrap:wrap;">' +
                '<div class="tgl-a3d-param-row" style="display:inline-flex;align-items:center;gap:8px;font-size:14px;color:#171719;">' +
                  '<span class="tgl-a3d-param-lbl">Remove Background</span>' +
                  '<button type="button" class="tgl-a3d-switch" id="TglA3dRmBgSwitch" aria-checked="true"><span></span></button>' +
                '</div>' +
                '<div class="tgl-a3d-param-row" style="display:inline-flex;align-items:center;gap:6px;font-size:14px;color:#171719;">' +
                  '<span class="tgl-a3d-param-lbl" style="display:inline-flex;align-items:center;gap:4px;">Processing Size(mm)<span title="Physical inner engraving crystal block dimensions (mm)" style="color:#85878B;display:inline-flex;align-items:center;"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.3"/><path d="M8 7.2V11" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><circle cx="8" cy="5.2" r="0.8" fill="currentColor"/></svg></span></span>' +
                  '<span style="display:inline-flex;align-items:center;gap:6px;">' +
                    '<input type="text" class="tgl-a3d-size-inp" id="TglA3dSizeW" value="70"/>' +
                    '<span style="font-size:12px;color:#85878B;">x</span>' +
                    '<input type="text" class="tgl-a3d-size-inp" id="TglA3dSizeH" value="70"/>' +
                  '</span>' +
                '</div>' +
              '</div>' +
              '<div id="TglA3dParamsModel" style="display:none;align-items:center;gap:16px;flex-wrap:wrap;">' +
                '<div class="tgl-a3d-param-row" style="display:inline-flex;align-items:center;gap:8px;font-size:14px;color:#171719;">' +
                  '<span class="tgl-a3d-param-lbl">Model</span>' +
                  '<select id="TglA3dModelSelect" style="height:32px;border-radius:8px;border:1px solid rgba(83,91,136,0.16);padding:0 10px;font-size:12px;color:#171719;background:#ffffff;">' +
                    '<option value="meshy">Meshy 7.1</option>' +
                    '<option value="tripo">Tripo 3.0</option>' +
                    '<option value="hitem">Hitem 1.5</option>' +
                  '</select>' +
                '</div>' +
                '<div class="tgl-a3d-param-row" style="display:inline-flex;align-items:center;gap:8px;font-size:14px;color:#171719;">' +
                  '<span class="tgl-a3d-param-lbl" style="display:inline-flex;align-items:center;gap:4px;">Texture<span style="color:#85878B;display:inline-flex;align-items:center;"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.3"/><path d="M8 7.2V11" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><circle cx="8" cy="5.2" r="0.8" fill="currentColor"/></svg></span></span>' +
                  '<button type="button" class="tgl-a3d-switch" id="TglA3dTexSwitch" aria-checked="true"><span></span></button>' +
                '</div>' +
                '<div class="tgl-a3d-param-row" style="display:inline-flex;align-items:center;gap:8px;font-size:14px;color:#171719;">' +
                  '<span class="tgl-a3d-param-lbl" style="display:inline-flex;align-items:center;gap:4px;">Image Optimization<span style="color:#85878B;display:inline-flex;align-items:center;"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.3"/><path d="M8 7.2V11" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><circle cx="8" cy="5.2" r="0.8" fill="currentColor"/></svg></span></span>' +
                  '<button type="button" class="tgl-a3d-switch" id="TglA3dOptSwitch" aria-checked="true"><span></span></button>' +
                '</div>' +
              '</div>' +
              '<button type="button" class="tgl-a3d-genbtn" id="TglA3dGenBtn">' +
                '<span>Generate</span>' +
                '<img src="https://storage-us.atomm.com/resource/xart/static/agent/imgs/credits.svg" alt="" style="width:16px;height:16px;display:inline-block;flex-shrink:0;"/>' +
                '<span id="TglA3dCreditCost">6</span>' +
              '</button>' +
            '</div>' +
          '</div>' +
          '<div class="tgl-a3d-folder" id="TglA3dMyModelsFolder" title="Open My Models">' +
            '<div class="tgl-a3d-folder__left"></div>' +
            '<div class="tgl-a3d-folder__right"><img id="TglA3dFolderThumb" src="https://storage-us.atomm.com/resource/xart/static/agent/imgs/ai-history-entry.png" alt="My Models"/></div>' +
            '<div class="tgl-a3d-folder__bottom"><span style="font-size:11px;font-weight:500;color:#171719;line-height:14px;">My Models</span></div>' +
          '</div>' +
          '<div class="tgl-a3d-mob-mymodels" id="TglA3dMyModelsMobile">' +
            '<div class="tgl-a3d-mob-mm-head" id="TglA3dMobMmHead">' +
              '<span class="tgl-a3d-mob-mm-title">My Models</span>' +
              '<svg class="tgl-a3d-mob-mm-arrow" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</div>' +
            '<div class="tgl-a3d-mob-mm-body" id="TglA3dMobMmBody">' +
              '<div style="text-align:center;padding:16px 0;font-size:12px;color:#85878B;">No Data</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      /* ARCHETYPE 2: .ai-tool-block (1:1 Atomm AI Image Tools) */
      '<div id="TglAiToolHeroBlock">' +
        '<div class="tgl-aitool-inner">' +
          '<h1 class="tgl-aitool-title" id="TglAiToolTitle">Remove Background from Image Instantly</h1>' +
          '<p class="tgl-aitool-desc" id="TglAiToolDesc"></p>' +
          '<div class="tgl-aitool-box">' +
            '<div class="tgl-aitool-left">' +
              ATOMM_HERO_DECOR_SVG +
              '<div class="tgl-aitool-media" id="TglAiToolMediaWrap"></div>' +
            '</div>' +
            '<div class="tgl-aitool-right">' +
              '<div class="tgl-aitool-drop" id="TglAiToolDropZone">' +
                '<input type="file" id="TglAiToolFileInput" accept="image/jpeg,image/png,image/webp" style="display:none;"/>' +
                '<div style="font-size:20px;font-weight:700;color:#171719;margin-bottom:8px;">Click or drag an image to upload</div>' +
                '<div style="font-size:12px;line-height:18px;color:rgba(23,23,25,0.45);max-width:300px;">Supported formats: JPG, JPEG, PNG, WEBP. Image size ≤10 MB, dimensions &lt;4096×4096 px.</div>' +
                '<button type="button" class="tgl-aitool-upbtn">' +
                  '<svg width="18" height="18" viewBox="0 0 16 16" fill="none"><path d="M8 10.5V3.5M8 3.5L5 6.5M8 3.5L11 6.5M3 12.5H13" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                  '<span class="tgl-aitool-upbtn__desk">Upload Image</span>' +
                  '<span class="tgl-aitool-upbtn__mob" style="display:none;">Upload</span>' +
                '</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      /* ARCHETYPE 3: .generator-entry-block (1:1 Atomm Parametric & Halftone Generators) */
      '<div class="tgl-hero-wrap" id="TglStandardHeroWrap">' +
        '<div class="tgl-hero">' +
          '<div class="tgl-hero__asset">' +
            ATOMM_HERO_DECOR_SVG +
            '<div class="tgl-hero__img-wrap" id="TglHeroMediaWrap"><img id="TglHeroImg" src="" alt="Generator preview"/></div>' +
          '</div>' +
          '<div class="tgl-hero__info">' +
            '<h1 class="tgl-hero__title" id="TglHeroTitle">Table Lamp Generator</h1>' +
            '<p class="tgl-hero__desc" id="TglHeroDesc"></p>' +
            '<div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;">' +
              '<button type="button" class="tgl-btn-create-hero" id="TglHeroCreateBtn">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M9.99935 3.16667C10.4596 3.16667 10.8327 3.53976 10.8327 4V9.16667H16.0007C16.4609 9.16667 16.834 9.53976 16.834 10C16.834 10.4602 16.4609 10.8333 16.0007 10.8333H10.8327V16C10.8327 16.4602 10.4596 16.8333 9.99935 16.8333C9.53911 16.8333 9.16602 16.4602 9.16602 16V10.8333H4.00065C3.54041 10.8333 3.16732 10.4602 3.16732 10C3.16732 9.53976 3.54041 9.16667 4.00065 9.16667H9.16602V4C9.16602 3.53976 9.53911 3.16667 9.99935 3.16667Z" fill="white"/></svg>' +
                '<span id="TglHeroCreateTxt">Create New</span>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<section class="tgl-recent-sec">' +
        '<div class="tgl-recent-head">' +
          '<div class="tgl-recent-title" id="TglRecentHeading">Recently</div>' +
          '<button type="button" class="tgl-recent-more" id="TglRecentMoreBtn">More ›</button>' +
        '</div>' +
        '<div class="tgl-recent-grid" id="TglRecentGrid"></div>' +
      '</section>' +
      /* Showcase Block (.single-asset-block, e.g. Laser-Ready Creations Made with 3D Model Generator) */
      '<section id="TglShowcaseSec">' +
        '<div class="tgl-showcase-inner">' +
          '<h2 class="tgl-showcase-title" id="TglShowcaseTitle">Laser-Ready Creations Made with 3D Model Generator</h2>' +
          '<img class="tgl-showcase-img" id="TglShowcaseImg" src="" alt="Showcase" loading="lazy"/>' +
        '</div>' +
      '</section>' +
      '<section id="TglCommunityOverviewSec" style="display:none;padding:32px 24px;">' +
        '<div class="tgl-comm-box" id="TglCommunityOverviewBox"></div>' +
      '</section>' +
      /* How to Section (Black #000000 3-card block) */
      '<section id="TglStepsSec">' +
        '<div class="tgl-steps-inner">' +
          '<div class="tgl-steps-head">' +
            '<h2 class="tgl-steps-title" id="TglHowTitle">How to Convert 2D Image to 3D Online</h2>' +
            '<p class="tgl-steps-sub" id="TglHowSub"></p>' +
          '</div>' +
          '<div class="tgl-steps-grid" id="TglStepsGrid"></div>' +
        '</div>' +
      '</section>' +
      /* Materials Section */
      '<section id="TglMaterialsSec">' +
        '<div class="tgl-mat-inner">' +
          '<div class="tgl-sec__head">' +
            '<h2 class="tgl-sec__title" id="TglMaterialsTitle">Choosing the Right Material for Your Project</h2>' +
          '</div>' +
          '<div class="tgl-mat-grid" id="TglMaterialsGrid"></div>' +
        '</div>' +
      '</section>' +
      /* Alternating Feature Rows (.text-asset-block) */
      '<section id="TglFeaturesSec">' +
        '<div class="tgl-feat-list" id="TglFeaturesList"></div>' +
      '</section>' +
      /* Why Choose / Use Cases */
      '<section id="TglUseCasesSec">' +
        '<div class="tgl-use-inner">' +
          '<div class="tgl-sec__head">' +
            '<h2 class="tgl-sec__title" id="TglUseTitle">Why Choose ThoughtyGift?</h2>' +
          '</div>' +
          '<div class="tgl-use-grid" id="TglUseGrid"></div>' +
        '</div>' +
      '</section>' +
      /* Discover More Tools */
      '<section id="TglRelatedSec">' +
        '<div class="tgl-rel-inner">' +
          '<div class="tgl-sec__head" style="margin-bottom:32px;">' +
            '<h2 class="tgl-sec__title">Discover More Tools</h2>' +
          '</div>' +
          '<div class="tgl-rel-grid" id="TglRelatedGrid"></div>' +
        '</div>' +
      '</section>' +
      /* Start Designing Banner (.banner-block) */
      '<section id="TglCtaCoverSec">' +
        '<img class="tgl-cta-bg" id="TglCtaBannerImg" src="https://storage-us.atomm.com/resource/xtool/xcs-cms//atomm/landingTemplate/cc486547-7c05-4580-a790-f67496dcd6d1.jpg" alt=""/>' +
        '<div class="tgl-cta-content">' +
          '<h2 style="font-size:36px;line-height:44px;font-weight:700;margin:0 0 24px;color:#171719;" id="TglCtaBannerTitle">Start Designing with ThoughtyGift AI</h2>' +
          '<button type="button" class="tgl-btn-create-hero" id="TglCtaBannerBtn" style="padding:0 32px;">Try Now</button>' +
        '</div>' +
      '</section>' +
      /* Frequently Asked Questions (.faq-block) */
      '<section id="TglFaqSec">' +
        '<div class="tgl-sec__head" style="margin-bottom:36px;">' +
          '<h2 class="tgl-sec__title" id="TglFaqTitle">Frequently Asked Questions</h2>' +
        '</div>' +
        '<div class="tgl-faq-list" id="TglFaqList"></div>' +
      '</section>' +
      '<div class="tgl-sticky-bottom">' +
        '<h2 class="tgl-sticky-bottom__text">Limited time offers available now.</h2>' +
        '<div class="tgl-sticky-bottom__actions">' +
          '<a href="/collections/all" class="tgl-sticky-btn-shop">Shop Now</a>' +
          '<button type="button" id="TglStickyInviteBtn" class="tgl-sticky-btn-earn">' +
            '<svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M18.5713 7.95922V11.3613C18.5713 11.4592 18.5392 11.5429 18.4706 11.6041C18.402 11.6653 18.3185 11.7 18.2156 11.7H17.1442V16.1225C17.1442 16.4062 17.0413 16.647 16.8313 16.8449C16.6235 17.0429 16.3685 17.1429 16.0728 17.1429H3.92704C3.62918 17.1429 3.37632 17.0449 3.16847 16.8449C2.96061 16.647 2.85561 16.4041 2.85561 16.1225V11.7021H1.78418C1.68132 11.7021 1.59347 11.6715 1.52918 11.6062C1.46061 11.5409 1.42847 11.4613 1.42847 11.3633V7.95922C1.42847 7.86126 1.46061 7.77759 1.52918 7.71636C1.59775 7.65106 1.68132 7.62044 1.78418 7.62044H6.69561C6.00347 7.62044 5.41418 7.38779 4.92561 6.92452C4.43704 6.45922 4.1949 5.89799 4.1949 5.23881C4.1949 4.57963 4.43918 4.0184 4.92561 3.5531C5.41418 3.08779 6.00347 2.85718 6.69561 2.85718C7.49061 2.85718 8.11632 3.13065 8.57061 3.67555L9.9999 5.43065L11.4292 3.67555C11.8813 3.13065 12.5092 2.85718 13.3042 2.85718C13.9963 2.85718 14.5856 3.08983 15.0742 3.5531C15.5628 4.0184 15.8049 4.57963 15.8049 5.23881C15.8049 5.89799 15.5606 6.45922 15.0742 6.92452C14.5856 7.38983 13.9963 7.62044 13.3042 7.62044H18.2156C18.3185 7.62044 18.4063 7.65106 18.4706 7.71636C18.537 7.77963 18.5713 7.86126 18.5713 7.95922ZM11.7849 15.2306V7.6184H8.21275V15.2266C8.21275 15.4041 8.28132 15.5388 8.41418 15.6347C8.54704 15.7306 8.71847 15.7776 8.92847 15.7776H11.0713C11.2792 15.7776 11.4506 15.7306 11.5856 15.6347C11.7163 15.5449 11.7849 15.4082 11.7849 15.2306Z" fill="#FF6500"/></svg>' +
            '<span>Earn Credits</span>' +
          '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    var drawer = document.createElement('div');
    drawer.id = 'TgHistoryDrawer';
    drawer.className = 'tgl-history-drawer';
    drawer.setAttribute('data-no-gtx', 'true');
    drawer.innerHTML =
      '<div class="tgl-history-drawer__panel">' +
        '<div class="tgl-history-drawer__head">' +
          '<div style="display:flex;align-items:center;gap:8px;">' +
            '<span style="font-size:16px;font-weight:700;color:#171719;" id="TgHistDrawerTitle">My Projects</span>' +
            '<span style="font-size:14px;font-weight:600;color:#86909C;" id="TgHistDrawerCount">0</span>' +
          '</div>' +
          '<div style="display:flex;align-items:center;gap:8px;">' +
            '<button type="button" id="TgHistDrawerNewBtn" style="border:none;border-radius:6px;background:#FF0035;color:#ffffff;padding:5px 10px;font-size:12px;font-weight:700;cursor:pointer;">+ New Draft</button>' +
            '<button type="button" id="TgHistDrawerCloseBtn" style="border:none;background:#F2F3F5;color:#4E5969;width:28px;height:28px;border-radius:999px;cursor:pointer;font-size:16px;line-height:1;">×</button>' +
          '</div>' +
        '</div>' +
        '<div class="tgl-history-drawer__body" id="TgHistDrawerGrid"></div>' +
      '</div>';
    document.body.appendChild(drawer);

    document.getElementById('TglBackToCatalogBtn').addEventListener('click', function () {
      closeLandingPage(false);
    });
    var handleStartNew = function () {
      var rec = createNewProjectForApp(activeSession.slug);
      openProjectInStudio(activeSession.slug, rec.gid, activeSession.pdpUrl);
    };
    document.getElementById('TglHeroCreateBtn').addEventListener('click', handleStartNew);
    document.getElementById('TglCtaBannerBtn').addEventListener('click', handleStartNew);
    document.getElementById('TglRecentMoreBtn').addEventListener('click', function () {
      openHistoryDrawer(activeSession.slug);
    });
    document.getElementById('TglTopMyProjectsBtn').addEventListener('click', function () {
      openHistoryDrawer(activeSession.slug);
    });
    document.getElementById('TglTopCreditBtn').addEventListener('click', function () {
      openGlobalCreditsModal('credits');
    });
    document.getElementById('TglStickyInviteBtn').addEventListener('click', function () {
      openGlobalCreditsModal('share');
    });
    var mobMenuBtn = document.getElementById('TglMobMenuBtn');
    if (mobMenuBtn) mobMenuBtn.addEventListener('click', function () { closeLandingPage(false); });
    var mobSearchBtn = document.getElementById('TglMobSearchBtn');
    if (mobSearchBtn) mobSearchBtn.addEventListener('click', function () { closeLandingPage(false); });
    var mobCreateBtn = document.getElementById('TglMobCreateBtn');
    if (mobCreateBtn) mobCreateBtn.addEventListener('click', handleStartNew);
    var mobProjBtn = document.getElementById('TglMobProjectsBtn');
    if (mobProjBtn) mobProjBtn.addEventListener('click', function () { openHistoryDrawer(activeSession.slug); });
    var mobCredBtn = document.getElementById('TglMobCreditBtn');
    if (mobCredBtn) mobCredBtn.addEventListener('click', function () { openGlobalCreditsModal('credits'); });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closeHistoryDrawer();
    });
    document.getElementById('TgHistDrawerCloseBtn').addEventListener('click', closeHistoryDrawer);
    document.getElementById('TgHistDrawerNewBtn').addEventListener('click', handleStartNew);

    // Wire Archetype 2 (.ai-tool-block) Upload dropzone
    var aiToolDrop = document.getElementById('TglAiToolDropZone');
    var aiToolFile = document.getElementById('TglAiToolFileInput');
    var handleAiToolFile = function (file) {
      if (!file) return;
      var reader = new FileReader();
      reader.onload = function (ev) {
        var dataUrl = String(ev.target.result || '');
        var rec = createNewProjectForApp(activeSession.slug);
        if (dataUrl) rec.thumb = dataUrl;
        window.__tgPendingAiToolUpload = { slug: activeSession.slug, imageUrl: dataUrl };
        openProjectInStudio(activeSession.slug, rec.gid, activeSession.pdpUrl);
      };
      reader.readAsDataURL(file);
    };
    if (aiToolDrop && aiToolFile) {
      aiToolDrop.addEventListener('click', function () {
        aiToolFile.click();
      });
      aiToolDrop.addEventListener('dragover', function (e) { e.preventDefault(); });
      aiToolDrop.addEventListener('drop', function (e) {
        e.preventDefault();
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) {
          handleAiToolFile(e.dataTransfer.files[0]);
        }
      });
      aiToolFile.addEventListener('change', function () {
        if (aiToolFile.files && aiToolFile.files[0]) handleAiToolFile(aiToolFile.files[0]);
      });
    }

    // Wire Archetype 1 (.ai-3d-generator-block) interactive controls
    var a3dHeroMode = 'photo';
    var a3dHeroDataUrl = '';
    var renderA3dSugTips = function (mode) {
      var descEl = document.getElementById('TglA3dSugDesc');
      var goodEl = document.getElementById('TglA3dSugGoodGrid');
      var badEl = document.getElementById('TglA3dSugBadGrid');
      if (!goodEl || !badEl) return;
      var base = 'https://cdn.shopify.com/s/files/1/0707/8078/0796/files/1_1_72cc0b02-4027-4496-8e73-a392694f3a87.jpg?v=1729238196';
      if (mode === 'model') {
        if (descEl) descEl.textContent = 'Single full-body subjects with clear silhouettes and even lighting work best for 3D Modeling.';
        goodEl.innerHTML =
          '<div style="border-radius:8px;overflow:hidden;border:1px solid #10B981;background:#ECFDF5;padding:4px;text-align:center;"><img src="' + base + 'model-correct1.webp" style="width:100%;height:74px;object-fit:cover;border-radius:6px;"/><div style="font-size:11px;font-weight:700;color:#059669;margin-top:3px;">✓ Clear Subject</div></div>' +
          '<div style="border-radius:8px;overflow:hidden;border:1px solid #10B981;background:#ECFDF5;padding:4px;text-align:center;"><img src="' + base + 'model-correct2.webp" style="width:100%;height:74px;object-fit:cover;border-radius:6px;"/><div style="font-size:11px;font-weight:700;color:#059669;margin-top:3px;">✓ Full Silhouette</div></div>';
        badEl.innerHTML =
          '<div style="border-radius:8px;overflow:hidden;border:1px solid #EF4444;background:#FEF2F2;padding:4px;text-align:center;"><img src="' + base + 'model-incorrect1.webp" style="width:100%;height:74px;object-fit:cover;border-radius:6px;"/><div style="font-size:11px;font-weight:700;color:#DC2626;margin-top:3px;">✕ Complex Scene</div></div>' +
          '<div style="border-radius:8px;overflow:hidden;border:1px solid #EF4444;background:#FEF2F2;padding:4px;text-align:center;"><img src="' + base + 'model-incorrect2.webp" style="width:100%;height:74px;object-fit:cover;border-radius:6px;"/><div style="font-size:11px;font-weight:700;color:#DC2626;margin-top:3px;">✕ Cropped Limbs</div></div>';
      } else {
        if (descEl) descEl.textContent = 'Front-facing portraits or pets with good lighting produce the best K9 crystal engraving results.';
        goodEl.innerHTML =
          '<div style="border-radius:8px;overflow:hidden;border:1px solid #10B981;background:#ECFDF5;padding:4px;text-align:center;"><img src="' + base + 'photo-correct1.webp" style="width:100%;height:74px;object-fit:cover;border-radius:6px;"/><div style="font-size:11px;font-weight:700;color:#059669;margin-top:3px;">✓ Clear Portrait</div></div>' +
          '<div style="border-radius:8px;overflow:hidden;border:1px solid #10B981;background:#ECFDF5;padding:4px;text-align:center;"><img src="' + base + 'photo-correct2.webp" style="width:100%;height:74px;object-fit:cover;border-radius:6px;"/><div style="font-size:11px;font-weight:700;color:#059669;margin-top:3px;">✓ Sharp Pet Photo</div></div>';
        badEl.innerHTML =
          '<div style="border-radius:8px;overflow:hidden;border:1px solid #EF4444;background:#FEF2F2;padding:4px;text-align:center;"><img src="' + base + 'photo-incorrect1.webp" style="width:100%;height:74px;object-fit:cover;border-radius:6px;"/><div style="font-size:11px;font-weight:700;color:#DC2626;margin-top:3px;">✕ Blurry / Dark</div></div>' +
          '<div style="border-radius:8px;overflow:hidden;border:1px solid #EF4444;background:#FEF2F2;padding:4px;text-align:center;"><img src="' + base + 'photo-incorrect2.webp" style="width:100%;height:74px;object-fit:cover;border-radius:6px;"/><div style="font-size:11px;font-weight:700;color:#DC2626;margin-top:3px;">✕ Occluded Face</div></div>';
      }
    };
    renderA3dSugTips('photo');

    // Toggle switches inside .tgl-a3d-foot
    var a3dSwitches = overlay.querySelectorAll('.tgl-a3d-switch');
    for (var sw = 0; sw < a3dSwitches.length; sw++) {
      a3dSwitches[sw].addEventListener('click', function () {
        this.classList.toggle('is-off');
        this.setAttribute('aria-checked', this.classList.contains('is-off') ? 'false' : 'true');
      });
    }

    var a3dTabs = overlay.querySelectorAll('[data-a3d-mode]');
    for (var ti = 0; ti < a3dTabs.length; ti++) {
      a3dTabs[ti].addEventListener('click', function () {
        a3dHeroMode = this.getAttribute('data-a3d-mode') || 'photo';
        for (var tj = 0; tj < a3dTabs.length; tj++) {
          a3dTabs[tj].classList.toggle('is-active', a3dTabs[tj] === this);
        }
        var costEl = document.getElementById('TglA3dCreditCost');
        if (costEl) costEl.textContent = a3dHeroMode === 'model' ? '70' : '6';
        var pPhoto = document.getElementById('TglA3dParamsPhoto');
        var pModel = document.getElementById('TglA3dParamsModel');
        if (pPhoto) pPhoto.style.display = a3dHeroMode === 'photo' ? 'flex' : 'none';
        if (pModel) pModel.style.display = a3dHeroMode === 'model' ? 'flex' : 'none';
        var gImg = document.getElementById('TglA3dGuideImg');
        var gVid = document.getElementById('TglA3dGuideVid');
        var gTitle = document.getElementById('TglA3dGuideTitle');
        if (gImg) gImg.style.display = a3dHeroMode === 'photo' ? 'block' : 'none';
        if (gVid) gVid.style.display = a3dHeroMode === 'model' ? 'block' : 'none';
        if (gTitle) {
          gTitle.textContent = a3dHeroMode === 'model'
            ? 'Generate a fully 360° 3D model with complete geometry from a single image.'
            : 'Convert your photo into a 3D-like relief with depth effects';
        }
        renderA3dSugTips(a3dHeroMode);
      });
    }

    var sugBtn = document.getElementById('TglA3dSugToggle');
    var sugPop = document.getElementById('TglA3dSugPopover');
    if (sugBtn && sugPop) {
      sugBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        sugPop.classList.toggle('is-open');
      });
    }

    var dropZone = document.getElementById('TglA3dDropZone');
    var fileInp = document.getElementById('TglA3dFileInput');
    var emptySt = document.getElementById('TglA3dEmptyState');
    var prevSt = document.getElementById('TglA3dPreviewState');
    var prevImg = document.getElementById('TglA3dPreviewImg');
    var clearBtn = document.getElementById('TglA3dClearImgBtn');
    var a3dGenBtn = document.getElementById('TglA3dGenBtn');

    var loadHeroFile = function (file) {
      if (!file) return;
      var reader = new FileReader();
      reader.onload = function (ev) {
        a3dHeroDataUrl = String(ev.target.result || '');
        if (prevImg) prevImg.src = a3dHeroDataUrl;
        if (emptySt) emptySt.style.display = 'none';
        if (prevSt) prevSt.style.display = 'flex';
        if (dropZone) dropZone.classList.add('has-img');
        if (a3dGenBtn) a3dGenBtn.classList.add('is-ready');
      };
      reader.readAsDataURL(file);
    };

    if (dropZone && fileInp) {
      dropZone.addEventListener('click', function (e) {
        if (e.target.closest('#TglA3dSugToggle') || e.target.closest('#TglA3dSugPopover') || e.target.closest('#TglA3dClearImgBtn')) return;
        fileInp.click();
      });
      dropZone.addEventListener('dragover', function (e) {
        e.preventDefault();
      });
      dropZone.addEventListener('drop', function (e) {
        e.preventDefault();
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) {
          loadHeroFile(e.dataTransfer.files[0]);
        }
      });
      fileInp.addEventListener('change', function () {
        if (fileInp.files && fileInp.files[0]) loadHeroFile(fileInp.files[0]);
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        a3dHeroDataUrl = '';
        if (fileInp) fileInp.value = '';
        if (prevImg) prevImg.src = '';
        if (emptySt) emptySt.style.display = 'flex';
        if (prevSt) prevSt.style.display = 'none';
        if (dropZone) dropZone.classList.remove('has-img');
        if (a3dGenBtn) a3dGenBtn.classList.remove('is-ready');
      });
    }

    if (a3dGenBtn) {
      a3dGenBtn.addEventListener('click', function () {
        var rmBgSw = document.getElementById('TglA3dRmBgSwitch');
        window.__tgPending3dLaunch = {
          mode: a3dHeroMode,
          generateBust: rmBgSw ? !rmBgSw.classList.contains('is-off') : true,
          imageUrl: a3dHeroDataUrl || ''
        };
        var targetSlug = activeSession.slug || 'ai-3d-model-generator';
        var rec = createNewProjectForApp(targetSlug);
        if (a3dHeroDataUrl) rec.thumb = a3dHeroDataUrl;
        openProjectInStudio(targetSlug, rec.gid, activeSession.pdpUrl);
      });
    }

    var a3dFolder = document.getElementById('TglA3dMyModelsFolder');
    if (a3dFolder) {
      a3dFolder.addEventListener('click', function () {
        openHistoryDrawer(activeSession.slug || 'ai-3d-model-generator');
      });
    }
    var a3dMobMmHead = document.getElementById('TglA3dMobMmHead');
    var a3dMobMmWrap = document.getElementById('TglA3dMyModelsMobile');
    if (a3dMobMmHead && a3dMobMmWrap) {
      a3dMobMmHead.addEventListener('click', function () {
        a3dMobMmWrap.classList.toggle('is-open');
      });
    }

    document.addEventListener('click', function () {
      var openMenus = document.querySelectorAll('.tgl-card-menu.is-open');
      for (var i = 0; i < openMenus.length; i++) openMenus[i].classList.remove('is-open');
      if (sugPop) sugPop.classList.remove('is-open');
    });
  }

  function renderRecentlyCards(slug) {
    var grid = document.getElementById('TglRecentGrid');
    if (!grid) return;
    var list = getUserProjectsForApp(slug);
    var countBadge = document.getElementById('TglTopProjCount');
    if (countBadge) countBadge.textContent = String(list.length);

    var mobMmBody = document.getElementById('TglA3dMobMmBody');
    if (mobMmBody) {
      if (!list || list.length === 0) {
        mobMmBody.innerHTML = '<div style="text-align:center;padding:16px 0;font-size:12px;color:#85878B;">No Data</div>';
      } else {
        mobMmBody.innerHTML =
          '<div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;">' +
          list.slice(0, 6).map(function (item) {
            return (
              '<div data-mob-mm-gid="' + item.gid + '" style="background:#ffffff;border:1px solid rgba(23,23,25,0.08);border-radius:8px;padding:6px;cursor:pointer;display:flex;flex-direction:column;gap:4px;">' +
                '<div style="aspect-ratio:1/1;border-radius:6px;background:#F6F6FA;overflow:hidden;display:flex;align-items:center;justify-content:center;">' +
                  '<img src="' + item.thumb + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block;"/>' +
                '</div>' +
                '<div style="font-size:11px;font-weight:500;color:#171719;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + item.title + '</div>' +
              '</div>'
            );
          }).join('') +
          '</div>';
        var mobItems = mobMmBody.querySelectorAll('[data-mob-mm-gid]');
        for (var mi = 0; mi < mobItems.length; mi++) {
          mobItems[mi].addEventListener('click', function () {
            var mgid = this.getAttribute('data-mob-mm-gid');
            openProjectInStudio(slug, mgid, activeSession.pdpUrl);
          });
        }
      }
    }

    var html =
      '<div class="tgl-card-new" id="TglCardCreateNew">' +
        '<div class="tgl-card-new__plus">+</div>' +
        '<span style="font-size:14px;font-weight:600;color:#171719;">Create New</span>' +
      '</div>';

    list.slice(0, 5).forEach(function (item) {
      html +=
        '<div class="tgl-card-draft" data-gid="' + item.gid + '">' +
          '<button type="button" class="tgl-card-draft__more" data-more-gid="' + item.gid + '" title="Project options">⋯</button>' +
          '<div class="tgl-card-menu" id="TglMenu_' + item.gid + '">' +
            '<button type="button" data-rename-gid="' + item.gid + '">Rename</button>' +
            '<button type="button" class="is-danger" data-delete-gid="' + item.gid + '">Delete</button>' +
          '</div>' +
          '<div class="tgl-card-draft__cov"><img src="' + item.thumb + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy"/></div>' +
          '<div class="tgl-card-draft__name" title="' + item.title.replace(/"/g, '&quot;') + '">' + item.title + '</div>' +
          '<div class="tgl-card-draft__time">' + item.updatedAt + '</div>' +
        '</div>';
    });

    grid.innerHTML = html;

    var createCard = document.getElementById('TglCardCreateNew');
    if (createCard) {
      createCard.addEventListener('click', function () {
        var rec = createNewProjectForApp(slug);
        openProjectInStudio(slug, rec.gid, activeSession.pdpUrl);
      });
    }

    var draftCards = grid.querySelectorAll('.tgl-card-draft');
    for (var i = 0; i < draftCards.length; i++) {
      draftCards[i].addEventListener('click', function (e) {
        if (e.target.closest('.tgl-card-draft__more') || e.target.closest('.tgl-card-menu')) return;
        var gid = this.getAttribute('data-gid');
        openProjectInStudio(slug, gid, activeSession.pdpUrl);
      });
    }

    var moreBtns = grid.querySelectorAll('[data-more-gid]');
    for (var m = 0; m < moreBtns.length; m++) {
      moreBtns[m].addEventListener('click', function (e) {
        e.stopPropagation();
        var gid = this.getAttribute('data-more-gid');
        var menu = document.getElementById('TglMenu_' + gid);
        var openMenus = document.querySelectorAll('.tgl-card-menu.is-open');
        for (var k = 0; k < openMenus.length; k++) {
          if (openMenus[k] !== menu) openMenus[k].classList.remove('is-open');
        }
        if (menu) menu.classList.toggle('is-open');
      });
    }

    var renBtns = grid.querySelectorAll('[data-rename-gid]');
    for (var r = 0; r < renBtns.length; r++) {
      renBtns[r].addEventListener('click', function (e) {
        e.stopPropagation();
        var gid = this.getAttribute('data-rename-gid');
        var cur = list.find(function (x) { return x.gid === gid; });
        var nextName = window.prompt('Rename project draft:', cur ? cur.title : 'Custom Draft');
        if (nextName !== null && nextName.trim()) {
          renameProjectDraft(slug, gid, nextName.trim());
        }
      });
    }

    var delBtns = grid.querySelectorAll('[data-delete-gid]');
    for (var d = 0; d < delBtns.length; d++) {
      delBtns[d].addEventListener('click', function (e) {
        e.stopPropagation();
        var gid = this.getAttribute('data-delete-gid');
        deleteProjectDraft(slug, gid);
      });
    }
  }

  function renderHistoryDrawerList(slug) {
    var grid = document.getElementById('TgHistDrawerGrid');
    var countEl = document.getElementById('TgHistDrawerCount');
    if (!grid) return;
    var list = getUserProjectsForApp(slug);
    if (countEl) countEl.textContent = String(list.length);

    grid.innerHTML = list.map(function (item) {
      return (
        '<div class="tgl-hitem" data-hitem-gid="' + item.gid + '">' +
          '<img src="' + item.thumb + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy"/>' +
          '<div class="tgl-hitem__mask">' +
            '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:4px;">' +
              '<span style="font-size:11px;font-weight:700;background:rgba(0,0,0,0.55);padding:2px 6px;border-radius:4px;max-width:110px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + item.title + '</span>' +
              '<button type="button" data-hdel-gid="' + item.gid + '" style="width:24px;height:24px;border-radius:6px;border:none;background:#ffffff;color:#EF4444;cursor:pointer;font-size:13px;font-weight:700;display:flex;align-items:center;justify-content:center;" title="Delete project">' + IC_TRASH + '</button>' +
            '</div>' +
            '<div style="font-size:11px;font-weight:600;">' + item.updatedAt + '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    var items = grid.querySelectorAll('[data-hitem-gid]');
    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('click', function (e) {
        if (e.target.closest('[data-hdel-gid]')) return;
        var gid = this.getAttribute('data-hitem-gid');
        openProjectInStudio(slug, gid, activeSession.pdpUrl);
      });
    }

    var delBtns = grid.querySelectorAll('[data-hdel-gid]');
    for (var d = 0; d < delBtns.length; d++) {
      delBtns[d].addEventListener('click', function (e) {
        e.stopPropagation();
        var gid = this.getAttribute('data-hdel-gid');
        deleteProjectDraft(slug, gid);
      });
    }
  }

  function openHistoryDrawer(slug) {
    ensureLandingAndDrawerDom();
    var targetSlug = slug || activeSession.slug || 'table-lamp-generator';
    renderHistoryDrawerList(targetSlug);
    var dr = document.getElementById('TgHistoryDrawer');
    if (dr) dr.classList.add('is-open');
  }

  function closeHistoryDrawer() {
    var dr = document.getElementById('TgHistoryDrawer');
    if (dr) dr.classList.remove('is-open');
  }

  function showAtommFloatingLoadingPill(containerEl, labelText, durationMs) {
    if (!containerEl) return;
    if (!document.getElementById('KcAtommLoaderKeyframes')) {
      var kf = document.createElement('style');
      kf.id = 'KcAtommLoaderKeyframes';
      kf.textContent = '@keyframes kcAtommSpin{to{transform:rotate(360deg)}}@keyframes kcAtommSlideDown{from{opacity:0;transform:translate(-50%,-10px)}to{opacity:1;transform:translate(-50%,0)}}';
      document.head.appendChild(kf);
    }
    var pill = document.getElementById('TgAtommGlobalLoadingPill');
    if (!pill) {
      pill = document.createElement('div');
      pill.id = 'TgAtommGlobalLoadingPill';
      pill.style.cssText = 'position:fixed;top:72px;left:50%;transform:translateX(-50%);z-index:2147483646;display:none;align-items:center;border-radius:8px;padding:10px 16px 10px 36px;border:1px solid #3867FF;background:#F0F4FF;box-shadow:0 6px 20px rgba(56,103,255,0.16),0 2px 6px rgba(7,11,16,0.08);color:#070B10;font-size:12px;font-weight:500;line-height:16px;pointer-events:none;transition:opacity 0.22s ease;font-family:Inter,system-ui,-apple-system,sans-serif;';
      pill.innerHTML =
        '<svg style="position:absolute;left:12px;width:16px;height:16px;animation:kcAtommSpin 0.9s linear infinite;color:#070B10;" viewBox="0 0 24 24" fill="none"><path d="M12 2.75a9.25 9.25 0 1 0 9.25 9.25" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
        '<span id="TgAtommGlobalLoadingTxt">Loading...</span>';
      document.body.appendChild(pill);
    }
    var txtEl = document.getElementById('TgAtommGlobalLoadingTxt');
    if (txtEl) txtEl.textContent = labelText || 'Loading...';
    pill.style.display = 'inline-flex';
    pill.style.opacity = '1';
    if (pill._hideTimer) clearTimeout(pill._hideTimer);
    pill._hideTimer = setTimeout(function () {
      pill.style.opacity = '0';
      setTimeout(function () {
        if (pill.style.opacity === '0') pill.style.display = 'none';
      }, 230);
    }, durationMs || 520);
  }

  function openLandingPage(slug, explicitPdpUrl) {
    ensureLandingAndDrawerDom();
    var stModal = document.getElementById('CinaiStudioModal');
    if (stModal && stModal.classList.contains('is-open') && typeof window.closeCinaiStudio === 'function') {
      window.closeCinaiStudio();
    }
    var b = getBridge();
    var resolvedSlug = (b && typeof b.resolveActiveToolKey === 'function')
      ? b.resolveActiveToolKey(slug)
      : (slug || 'table-lamp-generator');

    activeSession.slug = resolvedSlug;
    activeSession.gid = '';
    if (explicitPdpUrl) activeSession.pdpUrl = explicitPdpUrl;

    var meta = getToolMeta(resolvedSlug);
    var fbInit = getFallbackLanding(resolvedSlug);
    var overlay = document.getElementById('TgAppLandingOverlay');
    showAtommFloatingLoadingPill(overlay || document.body, 'Loading ' + meta.enTitle + '...', 480);

    document.getElementById('TglCrumbAppTitle').textContent = meta.enTitle;
    document.getElementById('TglHeroTitle').textContent = meta.enTitle;
    document.getElementById('TglHeroDesc').textContent = fbInit.desc;

    // Synchronously switch Hero Archetype before async fetchLandingsData so previous app's hero never flashes
    var initArchetype = 'generator-entry-block';
    if (resolvedSlug === 'ai-3d-model-generator' || resolvedSlug === 'ai-3d-model' || resolvedSlug === '3d-relief-generator') {
      initArchetype = 'ai-3d-generator-block';
    } else if (/^(background-remover|magic-eraser|laser-prep|image-upscaler|ai-expand|ai-replace|ai-image-variations|design-extraction|parse-image|font-generator|crochet-pattern-generator|style-match|image-to-)/.test(resolvedSlug)) {
      initArchetype = 'ai-tool-block';
    }
    var a3dHeroInit = document.getElementById('TglAtomm3dHeroBlock');
    var aiToolHeroInit = document.getElementById('TglAiToolHeroBlock');
    var stdHeroInit = document.getElementById('TglStandardHeroWrap');
    var recSecInit = overlay ? overlay.querySelector('.tgl-recent-sec') : null;
    if (a3dHeroInit) a3dHeroInit.classList.toggle('is-active', initArchetype === 'ai-3d-generator-block');
    if (aiToolHeroInit) aiToolHeroInit.classList.toggle('is-active', initArchetype === 'ai-tool-block');
    if (stdHeroInit) stdHeroInit.style.display = (initArchetype === 'generator-entry-block') ? '' : 'none';
    if (recSecInit) recSecInit.style.display = (initArchetype === 'generator-entry-block') ? '' : 'none';

    var mediaWrap = document.getElementById('TglHeroMediaWrap');
    if (mediaWrap) {
      mediaWrap.innerHTML = '<img id="TglHeroImg" src="' + meta.cover + '" alt="' + meta.enTitle.replace(/"/g, '&quot;') + '"/>';
    }

    renderRecentlyCards(resolvedSlug);

    fetchLandingsData().then(function (allLandings) {
      var data = (allLandings && (allLandings[resolvedSlug] || allLandings[slug])) || getFallbackLanding(resolvedSlug);
      var fb = getFallbackLanding(resolvedSlug);
      var titleText = data.title || meta.enTitle;
      var desc = data.desc || fb.desc;
      document.getElementById('TglCrumbAppTitle').textContent = titleText;
      document.getElementById('TglHeroTitle').textContent = titleText;
      document.getElementById('TglHeroDesc').textContent = desc;

      // Determine Hero Archetype (1: ai-3d-generator-block, 2: ai-tool-block, 3: generator-entry-block)
      var archetype = data.archetype || 'generator-entry-block';
      if (resolvedSlug === 'ai-3d-model-generator' || resolvedSlug === 'ai-3d-model' || resolvedSlug === '3d-relief-generator') {
        archetype = 'ai-3d-generator-block';
      } else if (/^(background-remover|magic-eraser|laser-prep|image-upscaler|ai-expand|ai-replace|ai-image-variations|design-extraction|parse-image|font-generator|crochet-pattern-generator|style-match|image-to-)/.test(resolvedSlug)) {
        archetype = 'ai-tool-block';
      }

      var a3dHero = document.getElementById('TglAtomm3dHeroBlock');
      var aiToolHero = document.getElementById('TglAiToolHeroBlock');
      var stdHero = document.getElementById('TglStandardHeroWrap');
      var recSec = overlay ? overlay.querySelector('.tgl-recent-sec') : null;

      if (a3dHero) a3dHero.classList.toggle('is-active', archetype === 'ai-3d-generator-block');
      if (aiToolHero) aiToolHero.classList.toggle('is-active', archetype === 'ai-tool-block');
      if (stdHero) stdHero.style.display = (archetype === 'generator-entry-block') ? '' : 'none';
      if (recSec) recSec.style.display = (archetype === 'generator-entry-block') ? '' : 'none';

      var heroVid = data.heroVideo || meta.video || '';
      var heroImg = (archetype === 'ai-3d-generator-block' ? meta.cover : (data.heroImg || meta.cover));

      if (archetype === 'ai-3d-generator-block') {
        var a3dTitleEl = document.getElementById('TglA3dHeroTitle');
        var a3dSubEl = document.getElementById('TglA3dHeroSub');
        if (a3dTitleEl) a3dTitleEl.textContent = titleText;
        if (a3dSubEl) a3dSubEl.textContent = desc;
        var list3d = getUserProjectsForApp(resolvedSlug);
        var fThumb = document.getElementById('TglA3dFolderThumb');
        if (fThumb) {
          fThumb.src = (list3d[0] && list3d[0].thumb && list3d[0].thumb.indexOf('data:') === 0)
            ? list3d[0].thumb
            : 'https://storage-us.atomm.com/resource/xart/static/agent/imgs/ai-history-entry.png';
        }
      } else if (archetype === 'ai-tool-block') {
        var aiTitleEl = document.getElementById('TglAiToolTitle');
        var aiDescEl = document.getElementById('TglAiToolDesc');
        var aiMediaWrap = document.getElementById('TglAiToolMediaWrap');
        if (aiTitleEl) aiTitleEl.textContent = titleText;
        if (aiDescEl) aiDescEl.textContent = desc;
        if (aiMediaWrap) {
          aiMediaWrap.innerHTML = heroVid
            ? '<video src="' + heroVid + '" poster="' + heroImg + '" autoplay loop muted playsinline></video>'
            : '<img src="' + heroImg + '" alt="' + titleText.replace(/"/g, '&quot;') + '"/>';
        }
      } else if (mediaWrap) {
        if (heroVid) {
          mediaWrap.innerHTML = '<video src="' + heroVid + '" poster="' + heroImg + '" autoplay loop muted playsinline></video>';
        } else {
          mediaWrap.innerHTML = '<img id="TglHeroImg" src="' + heroImg + '" alt="' + titleText.replace(/"/g, '&quot;') + '"/>';
        }
      }

      // Showcase Block (.single-asset-block, e.g. Laser-Ready Creations Made with 3D Model Generator)
      var showcaseSec = document.getElementById('TglShowcaseSec');
      var showcaseTitle = document.getElementById('TglShowcaseTitle');
      var showcaseImg = document.getElementById('TglShowcaseImg');
      if (showcaseSec && showcaseTitle && showcaseImg) {
        if (data.showcaseImg) {
          showcaseSec.style.display = 'block';
          showcaseTitle.textContent = data.showcaseTitle || ('Laser-Ready Creations Made with ' + titleText);
          showcaseImg.src = data.showcaseImg;
        } else {
          showcaseSec.style.display = 'none';
        }
      }

      var steps = (data.steps && data.steps.length > 0) ? data.steps : fb.steps;
      var features = (data.features && data.features.length > 0) ? data.features : fb.features;
      var useCases = (data.useCases && data.useCases.length > 0) ? data.useCases : fb.useCases;
      var faqs = (data.faqs && data.faqs.length > 0) ? data.faqs : fb.faqs;

      // Community Overview Section (Full Description + Bullet Features)
      var commSec = document.getElementById('TglCommunityOverviewSec');
      var commBox = document.getElementById('TglCommunityOverviewBox');
      if (commSec && commBox) {
        if ((data.bulletFeatures && data.bulletFeatures.length > 0) || (data.fullParagraphs && data.fullParagraphs.length > 1)) {
          commSec.style.display = 'block';
          var parasHtml = (data.fullParagraphs || [desc]).slice(0, 4).map(function (p) {
            return '<p style="font-size:14px;line-height:1.7;color:#4B5563;margin:0 0 12px;">' + p + '</p>';
          }).join('');
          var bulletsHtml = (data.bulletFeatures || []).slice(0, 8).map(function (btxt) {
            return '<li>' + IC_CHECK + '<span>' + btxt + '</span></li>';
          }).join('');
          commBox.innerHTML =
            '<div>' +
              '<h3 style="font-size:20px;font-weight:800;color:#171719;margin:0 0 14px;">About ' + titleText + '</h3>' +
              parasHtml +
            '</div>' +
            '<div>' +
              '<h3 style="font-size:18px;font-weight:800;color:#171719;margin:0 0 14px;">Key Parametric & Production Features</h3>' +
              '<ul class="tgl-comm-ul">' + bulletsHtml + '</ul>' +
            '</div>';
        } else {
          commSec.style.display = 'none';
        }
      }

      // Steps Section (Black #000000 3-Card Section)
      document.getElementById('TglHowTitle').textContent = data.howTitle || fb.howTitle;
      var howSubEl = document.getElementById('TglHowSub');
      if (howSubEl) {
        howSubEl.textContent = (archetype === 'ai-3d-generator-block') ? '' : (data.howSub || fb.howSub);
        howSubEl.style.display = howSubEl.textContent ? 'block' : 'none';
      }
      var stepsGrid = document.getElementById('TglStepsGrid');
      stepsGrid.innerHTML = steps.slice(0, 3).map(function (st, idx) {
        return (
          '<div class="tgl-step-card">' +
            '<div class="tgl-step-num">0' + (idx + 1) + '</div>' +
            '<h3 class="tgl-step-title">' + st.t + '</h3>' +
            '<p class="tgl-step-desc">' + st.d + '</p>' +
          '</div>'
        );
      }).join('');

      // Materials Section ("Choosing the Right Material for Your Project" — 3-col horizontal cards)
      var matTitle = document.getElementById('TglMaterialsTitle');
      if (matTitle) matTitle.textContent = 'Choosing the Right Material for Your Project';
      var matGrid = document.getElementById('TglMaterialsGrid');
      if (matGrid) {
        var mats = (ARCH_MATERIALS[meta.arch] || ARCH_MATERIALS.lamp).slice(0, 3);
        matGrid.innerHTML = mats.map(function (m) {
          return (
            '<div class="tgl-mat-card">' +
              '<div class="tgl-mat-img">' +
                '<img src="' + m.img + '" alt="' + m.name.replace(/"/g, '&quot;') + '" loading="lazy"/>' +
              '</div>' +
              '<div class="tgl-mat-body">' +
                '<div>' +
                  '<h4 class="tgl-mat-title">' + m.name + '</h4>' +
                  '<div class="tgl-mat-spec">' + m.spec + '</div>' +
                '</div>' +
                '<div class="tgl-mat-foot">' +
                  '<span style="font-size:16px;font-weight:700;color:#171719;">' + m.price + '</span>' +
                  '<button type="button" class="tgl-feat-btn" data-mat-buy="1" style="padding:6px 14px;font-size:12px;border-radius:6px;">Select</button>' +
                '</div>' +
              '</div>' +
            '</div>'
          );
        }).join('');
        var matBtns = matGrid.querySelectorAll('[data-mat-buy]');
        for (var mb = 0; mb < matBtns.length; mb++) {
          matBtns[mb].addEventListener('click', function () {
            var rec = getUserProjectsForApp(resolvedSlug)[0] || createNewProjectForApp(resolvedSlug);
            openProjectInStudio(resolvedSlug, rec.gid, activeSession.pdpUrl);
            setTimeout(function () {
              if (typeof window.openSuppliesKitDrawer === 'function') window.openSuppliesKitDrawer();
            }, 150);
          });
        }
      }

      // Alternating Feature Rows (.text-asset-block, up to 6 rows)
      var featList = document.getElementById('TglFeaturesList');
      featList.innerHTML = features.slice(0, 6).map(function (ft, idx) {
        var covImg = ft.img || (idx === 0 ? heroImg : ARCH_FEATURE_COVERS[(idx + resolvedSlug.length) % ARCH_FEATURE_COVERS.length]);
        var mediaHtml = ft.vid
          ? '<video src="' + ft.vid + '" poster="' + covImg + '" autoplay loop muted playsinline></video>'
          : '<img src="' + covImg + '" alt="' + ft.t.replace(/"/g, '&quot;') + '" loading="lazy"/>';
        return (
          '<div class="tgl-feat-row">' +
            '<div class="tgl-feat-text">' +
              '<h2 class="tgl-feat-title">' + ft.t + '</h2>' +
              '<p class="tgl-feat-desc">' + ft.d + '</p>' +
              '<button type="button" class="tgl-feat-btn" data-try-studio="1">Try Now</button>' +
            '</div>' +
            '<div class="tgl-feat-img">' + mediaHtml + '</div>' +
          '</div>'
        );
      }).join('');

      var tryBtns = featList.querySelectorAll('[data-try-studio]');
      for (var t = 0; t < tryBtns.length; t++) {
        tryBtns[t].addEventListener('click', function () {
          var rec = createNewProjectForApp(resolvedSlug);
          openProjectInStudio(resolvedSlug, rec.gid, activeSession.pdpUrl);
        });
      }

      // Why Choose / Use Cases Section
      document.getElementById('TglUseTitle').textContent = data.useTitle || fb.useTitle;
      var useGrid = document.getElementById('TglUseGrid');
      var shownUseCases = useCases.slice(0, 4);
      useGrid.classList.toggle('cols-4', shownUseCases.length === 4);
      useGrid.innerHTML = shownUseCases.map(function (u) {
        return (
          '<div class="tgl-use-card">' +
            '<h3>' + u.t + '</h3>' +
            '<p>' + u.d + '</p>' +
          '</div>'
        );
      }).join('');

      // CTA Banner (.banner-block)
      var ctaBannerTitle = document.getElementById('TglCtaBannerTitle');
      if (ctaBannerTitle) {
        ctaBannerTitle.textContent = (data.ctaTitle && data.ctaTitle.indexOf('Laser-Ready Creations') === -1)
          ? data.ctaTitle
          : 'Start Designing with ThoughtyGift AI';
      }
      var ctaBannerImg = document.getElementById('TglCtaBannerImg');
      if (ctaBannerImg) {
        ctaBannerImg.src = (data.ctaImg && data.ctaImg.indexOf('6bbd3b2b') === -1)
          ? data.ctaImg
          : 'https://storage-us.atomm.com/resource/xtool/xcs-cms//atomm/landingTemplate/cc486547-7c05-4580-a790-f67496dcd6d1.jpg';
      }

      // Discover More Tools (Atomm 3-col 9 horizontal mini-cards)
      var relGrid = document.getElementById('TglRelatedGrid');
      if (relGrid) {
        var allCards = Array.from(document.querySelectorAll('[data-id]')).filter(function (el) {
          var cid = el.getAttribute('data-id');
          return cid && cid !== resolvedSlug;
        });
        var startIdx = (resolvedSlug.length * 5) % Math.max(1, allCards.length - 9);
        var picked = allCards.slice(startIdx, startIdx + 9);
        if (picked.length < 9) picked = allCards.slice(0, 9);
        relGrid.innerHTML = picked.map(function (el) {
          var cid = el.getAttribute('data-id');
          var rMeta = getToolMeta(cid);
          var rLand = (allLandings && allLandings[cid]) || {};
          var rDesc = rLand.desc || ('Create custom ' + rMeta.enTitle + ' designs online in seconds.');
          return (
            '<div class="tgl-rel-card" data-rel-slug="' + cid + '">' +
              '<img src="' + rMeta.cover + '" alt="' + rMeta.enTitle.replace(/"/g, '&quot;') + '" loading="lazy"/>' +
              '<div style="flex:1;min-width:0;">' +
                '<div style="font-size:15px;font-weight:700;color:#171719;margin-bottom:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + rMeta.enTitle + '</div>' +
                '<div style="font-size:12px;line-height:16px;color:#4B5563;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;">' + rDesc + '</div>' +
              '</div>' +
            '</div>'
          );
        }).join('');
        var relCards = relGrid.querySelectorAll('[data-rel-slug]');
        for (var rc = 0; rc < relCards.length; rc++) {
          relCards[rc].addEventListener('click', function () {
            openLandingPage(this.getAttribute('data-rel-slug'));
          });
        }
      }

      // Frequently Asked Questions (Atomm borderless + / × style)
      document.getElementById('TglFaqTitle').textContent = 'Frequently Asked Questions';
      var faqList = document.getElementById('TglFaqList');
      faqList.innerHTML = faqs.slice(0, 8).map(function (f, idx) {
        return (
          '<div class="tgl-faq-item' + (idx === 0 ? ' is-open' : '') + '">' +
            '<button type="button" class="tgl-faq-q"><span>' + f.q + '</span><span class="tgl-faq-icon">+</span></button>' +
            '<div class="tgl-faq-a">' + f.a + '</div>' +
          '</div>'
        );
      }).join('');

      var faqQs = faqList.querySelectorAll('.tgl-faq-q');
      for (var q = 0; q < faqQs.length; q++) {
        faqQs[q].addEventListener('click', function () {
          this.parentElement.classList.toggle('is-open');
        });
      }
    });

    overlay.classList.add('is-open');
    overlay.scrollTop = 0;
    document.body.style.overflow = 'hidden';

    try {
      var nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('landing', resolvedSlug);
      nextUrl.searchParams.set('tool', resolvedSlug);
      nextUrl.searchParams.delete('openStudio');
      nextUrl.searchParams.delete('studio');
      nextUrl.searchParams.delete('gid');
      window.history.pushState({ landing: resolvedSlug }, '', nextUrl.toString());
    } catch (e) {}
  }

  function closeLandingPage(keepOverflowHidden) {
    var overlay = document.getElementById('TgAppLandingOverlay');
    if (overlay) overlay.classList.remove('is-open');
    if (!keepOverflowHidden) {
      document.body.style.overflow = '';
      try {
        var nextUrl = new URL(window.location.href);
        nextUrl.searchParams.delete('landing');
        nextUrl.searchParams.delete('openStudio');
        nextUrl.searchParams.delete('studio');
        nextUrl.searchParams.delete('tool');
        nextUrl.searchParams.delete('gid');
        window.history.pushState({}, '', nextUrl.toString());
      } catch (e) {}
    }
  }

  // ── 4. Inject Per-User Project Bar Inside #CinaiStudioModal Header ──
  function syncStudioProjectHeaderBar() {
    var modal = document.getElementById('CinaiStudioModal');
    if (!modal) return;
    var headerLeft = modal.querySelector('.kc-header__left');
    if (!headerLeft) return;

    var b = getBridge();
    var slug = (b && b.state && b.state.toolSlug) || activeSession.slug || 'table-lamp-generator';
    activeSession.slug = slug;
    var list = getUserProjectsForApp(slug);
    if (!activeSession.gid && list[0]) activeSession.gid = list[0].gid;
    var activeRec = list.find(function (x) { return x.gid === activeSession.gid; }) || list[0];

    var projBar = document.getElementById('KcProjectHeaderBar');
    if (!projBar) {
      projBar = document.createElement('div');
      projBar.id = 'KcProjectHeaderBar';
      projBar.style.cssText = 'display:inline-flex;align-items:center;gap:6px;margin-left:10px;padding-left:10px;border-left:1px solid #E5E7EB;';
      projBar.innerHTML =
        '<button type="button" id="KcActiveDraftBtn" title="Click to rename current project draft" style="border:1px solid #E5E7EB;background:#F9FAFB;color:#111827;height:30px;padding:0 10px;border-radius:6px;font-size:12px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:5px;max-width:190px;">' +
          '<span id="KcActiveDraftName" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">Draft</span>' +
          IC_EDIT +
        '</button>' +
        '<button type="button" id="KcBtnSaveDraft" title="Save project to your personal workspace" style="border:1px solid #D1FAE5;background:#ECFDF5;color:#059669;height:30px;padding:0 10px;border-radius:6px;font-size:12px;font-weight:700;cursor:pointer;display:inline-flex;align-items:center;gap:4px;">' +
          IC_SAVE + '<span id="KcBtnSaveDraftTxt">Save Draft</span>' +
        '</button>' +
        '<button type="button" id="KcBtnMyProjects" title="Open My Projects drawer for this app" style="border:1px solid #E5E7EB;background:#ffffff;color:#374151;height:30px;padding:0 10px;border-radius:6px;font-size:12px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:5px;">' +
          IC_FOLDER + '<span>My Projects</span><span id="KcBtnMyProjectsCnt" style="background:#FFF7ED;color:#EA580C;padding:1px 5px;border-radius:999px;font-size:11px;font-weight:700;">2</span>' +
        '</button>' +
        '<button type="button" id="KcBtnViewLanding" title="View App Landing Page & Recently Projects" style="border:1px solid #E5E7EB;background:#ffffff;color:#374151;height:30px;padding:0 9px;border-radius:6px;font-size:12px;font-weight:600;cursor:pointer;">App Overview</button>';
      headerLeft.appendChild(projBar);

      document.getElementById('KcActiveDraftBtn').addEventListener('click', function () {
        var curSlug = (getBridge() && getBridge().state && getBridge().state.toolSlug) || activeSession.slug;
        var curList = getUserProjectsForApp(curSlug);
        var curRec = curList.find(function (x) { return x.gid === activeSession.gid; }) || curList[0];
        var nextTitle = window.prompt('Rename project draft:', curRec ? curRec.title : 'Custom Draft');
        if (nextTitle !== null && nextTitle.trim() && curRec) {
          renameProjectDraft(curSlug, curRec.gid, nextTitle.trim());
        }
      });

      document.getElementById('KcBtnSaveDraft').addEventListener('click', function () {
        saveCurrentStudioToDraft(true);
      });

      document.getElementById('KcBtnMyProjects').addEventListener('click', function () {
        var curSlug = (getBridge() && getBridge().state && getBridge().state.toolSlug) || activeSession.slug;
        openHistoryDrawer(curSlug);
      });

      document.getElementById('KcBtnViewLanding').addEventListener('click', function () {
        saveCurrentStudioToDraft(false);
        var curSlug = (getBridge() && getBridge().state && getBridge().state.toolSlug) || activeSession.slug;
        if (typeof window.closeCinaiStudio === 'function') window.closeCinaiStudio();
        openLandingPage(curSlug, activeSession.pdpUrl);
      });
    }

    var nameEl = document.getElementById('KcActiveDraftName');
    if (nameEl && activeRec) nameEl.textContent = activeRec.title;
    var cntEl = document.getElementById('KcBtnMyProjectsCnt');
    if (cntEl) cntEl.textContent = String(list.length);
  }

  // ── 5. E2E AI Generation API & Interactive 3D Relief / Coin / Crystal / Vector Engine ──
  var aiState = {
    prompt: 'Founder Gold Crest Lion & Laurel Crown',
    rimText: 'THOUGHTYGIFT STUDIO · LIMITED EDITION · 2026',
    finish: 'gold_coin', // gold_coin | silver_coin | bronze_coin | banknote | crystal_3d | wood_relief
    depth: 78,
    diameterMm: 50,
    rotX: 16,
    rotY: -18,
    autoSpin: false,
    refImg: null,
    lastGeneratedAt: 0,
    generationCount: 0
  };

  var FINISH_PALETTES = {
    gold_coin: { name: 'Antique Gold 3D Coin', bg1: '#FEF3C7', bg2: '#D97706', bg3: '#78350F', rim: '#F59E0B', spec: '#FFFBEB', shadow: '#451A03' },
    silver_coin: { name: 'Polished Silver Coin', bg1: '#F8FAFC', bg2: '#94A3B8', bg3: '#334155', rim: '#CBD5E1', spec: '#FFFFFF', shadow: '#0F172A' },
    bronze_coin: { name: 'Aged Bronze Medal', bg1: '#FFEDD5', bg2: '#C2410C', bg3: '#431407', rim: '#EA580C', spec: '#FED7AA', shadow: '#270902' },
    banknote: { name: 'Guilloche Collector Banknote', bg1: '#ECFDF5', bg2: '#047857', bg3: '#064E3B', rim: '#10B981', spec: '#D1FAE5', shadow: '#022C22' },
    crystal_3d: { name: '3D Sub-Surface K9 Crystal', bg1: '#E0F2FE', bg2: '#38BDF8', bg3: '#0C4A6E', rim: '#7DD3FC', spec: '#FFFFFF', shadow: '#082F49' },
    wood_relief: { name: '3D Bas-Relief Walnut Carving', bg1: '#FDE68A', bg2: '#92400E', bg3: '#451A03', rim: '#B45309', spec: '#FEF3C7', shadow: '#290F02' },
    laser_halftone: { name: 'Laser Line-Art & Stencil Plate', bg1: '#FFFFFF', bg2: '#334155', bg3: '#0F172A', rim: '#64748B', spec: '#F8FAFC', shadow: '#020617' }
  };

  function getCreditBalance() {
    var prof = getCurrentUserProfile();
    if (!prof.isLoggedIn) {
      return 0;
    }
    try {
      var userKey = getCreditStorageKey();
      var raw = localStorage.getItem(userKey);
      if (raw !== null) {
        var saved = parseInt(raw, 10);
        if (!isNaN(saved) && saved >= 0) return saved;
      }
      // Logged-in user receives 200 Free Starter Credits
      localStorage.setItem(userKey, '200');
      localStorage.setItem('tg_studio_credits_v2', '200');
      return 200;
    } catch (e) {
      return 200;
    }
  }

  function setCreditBalance(nextVal) {
    var safeVal = Math.max(0, parseInt(nextVal, 10) || 0);
    var formatted = safeVal.toLocaleString('en-US');
    try {
      var userKey = getCreditStorageKey();
      localStorage.setItem(userKey, String(safeVal));
      localStorage.setItem('tg_studio_credits_v2', String(safeVal));
      localStorage.setItem('cinai_user_credits_v1', JSON.stringify({ balance: safeVal, updatedAt: Date.now() }));
    } catch (e) {}
    if (typeof window.TgSetCreditBalance === 'function') {
      window.TgSetCreditBalance(safeVal);
    }
    ['KcCreditBalance', 'KcProfCredVal', 'KcCredModalBal', 'KcCreditsCountTxt', 'TglTopCreditVal', 'TgCatalogCreditVal', 'KcProfMenuCredBadge', 'TgHeaderCreditVal', 'TgHeaderMenuCreditVal'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.textContent = formatted;
    });
    if (typeof window.TgSyncSiteHeaderAuth === 'function') {
      try { window.TgSyncSiteHeaderAuth(); } catch (e) {}
    }
    var zeroAlert = document.getElementById('KcZeroCredAlert');
    if (zeroAlert) {
      zeroAlert.style.display = safeVal < 8 ? 'flex' : 'none';
    }
    try {
      var ifr = document.getElementById('Kc3dEngineFrame');
      if (ifr && ifr.contentWindow) {
        ifr.contentWindow.postMessage({ type: 'TG_CREDITS_SYNC', credits: safeVal }, '*');
      }
    } catch (e) {}
    return safeVal;
  }

  window.addEventListener('message', function (ev) {
    var d = ev && ev.data;
    if (!d || typeof d !== 'object') return;
    if (d.type === 'TG_REQUEST_CREDITS') {
      var bal = getCreditBalance();
      var prof = getCurrentUserProfile();
      if (!prof.isLoggedIn) bal = 200;
      try {
        if (ev.source && typeof ev.source.postMessage === 'function') {
          ev.source.postMessage({ type: 'TG_CREDITS_SYNC', credits: bal }, '*');
        }
      } catch (e) {}
    } else if (d.type === 'TG_DEDUCT_CREDITS') {
      var cost = Number(d.amount) || 12;
      var cur = getCreditBalance();
      var prof2 = getCurrentUserProfile();
      if (prof2.isLoggedIn) {
        setCreditBalance(Math.max(0, cur - cost));
      }
    } else if (d.type === 'TG_INSUFFICIENT_CREDITS') {
      showZeroCreditPopup();
    }
  });

  function openGlobalCreditsModal(tabMode) {
    if (typeof window.TgOpenCreditsModal === 'function') {
      window.TgOpenCreditsModal(tabMode || 'credits');
    }
    ensureCreditPaymentModalEnhancements();
    var host = document.getElementById('KcAccountModalHost');
    if (host) {
      if (host.parentElement !== document.body) {
        document.body.appendChild(host);
      }
      host.style.zIndex = '2147483647';
      var shareBox = document.getElementById('KcShareEarnBox');
      var credBox = document.getElementById('KcMyCreditsBox');
      if (tabMode === 'share') {
        if (shareBox) shareBox.style.display = 'block';
        if (credBox) credBox.style.display = 'none';
      } else {
        if (shareBox) shareBox.style.display = 'none';
        if (credBox) credBox.style.display = 'block';
      }
      host.style.display = 'flex';
    }
  }

  function showZeroCreditPopup() {
    openGlobalCreditsModal('credits');
    var zeroAlert = document.getElementById('KcZeroCredAlert');
    if (zeroAlert) zeroAlert.style.display = 'flex';
  }

  function deductAiCredits(amount) {
    var prof = getCurrentUserProfile();
    if (!prof.isLoggedIn) {
      openStudioAuthModal('signup');
      showStudioAuthToast('Please Sign Up or Log In to claim your 200 Free AI Credits!', true);
      return null;
    }
    var cost = amount || 8;
    var curBal = getCreditBalance();
    if (curBal < cost) {
      showZeroCreditPopup();
      return null;
    }
    var nextBal = Math.max(0, curBal - cost);
    setCreditBalance(nextBal);
    if (nextBal === 0 || nextBal < cost) {
      setTimeout(function () {
        showZeroCreditPopup();
      }, 220);
    }
    return nextBal;
  }

  // ============================================================================
  // LIVE PRODUCTION AI GATEWAY CLIENT (shopify.cinai.app -> cinai.app)
  // ============================================================================
  var TG_AI_GATEWAY_URL = 'https://shopify.cinai.app/proxy/tg-ai';

  function loadCorsImage(url) {
    return new Promise(function (resolve) {
      if (!url) return resolve(null);
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { resolve(null); };
      img.src = url;
    });
  }

  function callStorefrontAiGateway(payload, onProgress) {
    return new Promise(function (resolve) {
      fetch(TG_AI_GATEWAY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload || {})
      })
        .then(function (r) { return r.json(); })
        .then(function (startData) {
          if (!startData || !startData.ok || !startData.callId) {
            return resolve({ ok: false, error: (startData && startData.error) || 'start_failed' });
          }
          var activeCallId = startData.callId;
          var activeChain = startData.chain || '';
          var attempts = 0;
          var maxAttempts = 90;

          function pollNext() {
            attempts++;
            if (typeof onProgress === 'function') {
              try { onProgress(attempts, { callId: activeCallId, chain: activeChain }); } catch (e) {}
            }
            var pollUrl = TG_AI_GATEWAY_URL + '?callId=' + encodeURIComponent(activeCallId) +
              (activeChain ? '&chain=' + encodeURIComponent(activeChain) : '');
            fetch(pollUrl)
              .then(function (pr) { return pr.json(); })
              .then(function (pData) {
                if (!pData || !pData.ok) {
                  return resolve({ ok: false, error: (pData && pData.error) || 'poll_failed' });
                }
                if (pData.status === 'chained' && pData.nextCallId) {
                  activeCallId = pData.nextCallId;
                  activeChain = '';
                  attempts = 0;
                  setTimeout(pollNext, 1200);
                  return;
                }
                if (pData.status === 'succeeded') {
                  var primaryUrl = pData.cutoutUrl || pData.imageUrl || '';
                  Promise.all([
                    loadCorsImage(primaryUrl),
                    loadCorsImage(pData.depthUrl || '')
                  ]).then(function (imgs) {
                    resolve({
                      ok: true,
                      callId: activeCallId,
                      imageUrl: pData.imageUrl || primaryUrl,
                      cutoutUrl: pData.cutoutUrl || '',
                      depthUrl: pData.depthUrl || '',
                      plyUrl: pData.plyUrl || '',
                      imgElement: imgs[0],
                      depthImgElement: imgs[1]
                    });
                  });
                  return;
                }
                if (pData.status === 'failed' || pData.status === 'cancelled' || attempts >= maxAttempts) {
                  return resolve({ ok: false, error: pData.error || 'timeout_or_failed' });
                }
                setTimeout(pollNext, 1350);
              })
              .catch(function (err) {
                if (attempts >= maxAttempts) {
                  resolve({ ok: false, error: String(err) });
                } else {
                  setTimeout(pollNext, 1500);
                }
              });
          }

          setTimeout(pollNext, 1200);
        })
        .catch(function (err) {
          resolve({ ok: false, error: String(err) });
        });
    });
  }
  window.TgCallStorefrontAi = callStorefrontAiGateway;

  // Trace any real AI-generated 2-tone graphic into clean 2D Vector CAD SVG paths (fullD + contourD)
  function traceAiImageToKeychainVector(img) {
    var gw = 72;
    var gh = 72;
    var cnv = document.createElement('canvas');
    cnv.width = gw;
    cnv.height = gh;
    var ctx = cnv.getContext('2d');
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, gw, gh);
    ctx.drawImage(img, 4, 6, gw - 8, gh - 10);
    var d = ctx.getImageData(0, 0, gw, gh).data;

    // Sample corner luminance to detect background polarity
    var cornerLum = (
      (0.299 * d[0] + 0.587 * d[1] + 0.114 * d[2]) +
      (0.299 * d[(gw - 1) * 4] + 0.587 * d[(gw - 1) * 4 + 1] + 0.114 * d[(gw - 1) * 4 + 2])
    ) / 510;
    var bgIsLight = cornerLum >= 0.5;

    var fgMask = new Uint8Array(gw * gh);
    for (var y = 0; y < gh; y++) {
      for (var x = 0; x < gw; x++) {
        var idx = y * gw + x;
        var p = idx * 4;
        var a = d[p + 3];
        var lum = (0.299 * d[p] + 0.587 * d[p + 1] + 0.114 * d[p + 2]) / 255;
        if (a < 40) {
          fgMask[idx] = 0;
        } else {
          fgMask[idx] = bgIsLight ? (lum < 0.62 ? 1 : 0) : (lum > 0.38 ? 1 : 0);
        }
      }
    }

    // Build horizontal scanline merged rectangles for crisp inner vector engraving path (mapped to 16..84 in 100x100 space)
    var scale = 68 / gw;
    var offX = 16;
    var offY = 18;
    var fullParts = [];
    for (var r = 1; r < gh - 1; r++) {
      var runStart = -1;
      for (var c = 1; c <= gw - 1; c++) {
        var on = c < gw - 1 ? fgMask[r * gw + c] : 0;
        if (on && runStart === -1) {
          runStart = c;
        } else if (!on && runStart !== -1) {
          if (c - runStart >= 1) {
            var x0 = (offX + runStart * scale).toFixed(1);
            var x1 = (offX + c * scale).toFixed(1);
            var y0 = (offY + r * scale).toFixed(1);
            var y1 = (offY + (r + 1.05) * scale).toFixed(1);
            fullParts.push('M' + x0 + ' ' + y0 + 'H' + x1 + 'V' + y1 + 'H' + x0 + 'Z');
          }
          runStart = -1;
        }
      }
    }

    // Radial convex/silhouette envelope around center + top keychain hole for smooth laser outer cutline (contourD)
    var cx = gw / 2;
    var cy = gh / 2;
    var rays = 36;
    var contourPts = [];
    for (var k = 0; k < rays; k++) {
      var ang = (k / rays) * Math.PI * 2 - Math.PI / 2;
      var cosA = Math.cos(ang);
      var sinA = Math.sin(ang);
      var maxR = 14;
      for (var rad = 6; rad < gw * 0.48; rad += 1) {
        var sx = Math.round(cx + cosA * rad);
        var sy = Math.round(cy + sinA * rad);
        if (sx >= 1 && sx < gw - 1 && sy >= 1 && sy < gh - 1) {
          if (fgMask[sy * gw + sx]) maxR = rad + 4.5;
        }
      }
      var px = 50 + cosA * Math.min(42, maxR * scale);
      var py = 52 + sinA * Math.min(40, maxR * scale);
      contourPts.push([px.toFixed(1), py.toFixed(1)]);
    }
    var contourD = 'M' + contourPts[0][0] + ' ' + contourPts[0][1];
    for (var ptIdx = 1; ptIdx < contourPts.length; ptIdx++) {
      contourD += 'L' + contourPts[ptIdx][0] + ' ' + contourPts[ptIdx][1];
    }
    contourD += 'Z';
    // Add top keychain ring tab & hole
    var ringOuter = 'M44 14 A6 6 0 1 1 56 14 A6 6 0 1 1 44 14 Z';
    var ringHole = 'M47.2 14 A2.8 2.8 0 1 0 52.8 14 A2.8 2.8 0 1 0 47.2 14 Z';
    var fullD = ringOuter + ' ' + ringHole + ' ' + (fullParts.length ? fullParts.join(' ') : contourD);

    // Also compute 24x24 luma array for studio preview
    var lCnv = document.createElement('canvas');
    lCnv.width = 24;
    lCnv.height = 24;
    var lCtx = lCnv.getContext('2d');
    lCtx.fillStyle = '#FFFFFF';
    lCtx.fillRect(0, 0, 24, 24);
    lCtx.drawImage(img, 0, 0, 24, 24);
    var lData = lCtx.getImageData(0, 0, 24, 24).data;
    var luma = [];
    for (var lp = 0; lp < lData.length; lp += 4) {
      luma.push((0.299 * lData[lp] + 0.587 * lData[lp + 1] + 0.114 * lData[lp + 2]) / 255);
    }

    return {
      fullD: fullD,
      contourD: contourD,
      luma: luma
    };
  }

  function showClassicStudioGenOverlay(promptText) {
    var modal = document.getElementById('CinaiStudioModal');
    if (!modal) return;
    var ovr = document.getElementById('TgClassicAiGenOverlay');
    if (!ovr) {
      ovr = document.createElement('div');
      ovr.id = 'TgClassicAiGenOverlay';
      ovr.style.cssText = 'position:fixed;inset:0;z-index:99998;background:rgba(17,24,39,0.32);backdrop-filter:blur(2px);display:none;align-items:center;justify-content:center;pointer-events:auto;font-family:Inter,sans-serif;';
      ovr.innerHTML =
        '<div style="background:#ffffff;border-radius:16px;padding:22px 28px;box-shadow:0 20px 48px rgba(0,0,0,0.22);display:flex;flex-direction:column;align-items:center;gap:12px;min-width:270px;max-width:320px;text-align:center;">' +
          '<div class="tg-atomm-conic-loader" style="width:32px;height:32px;"></div>' +
          '<div id="TgClassicAiGenTitle" style="font-size:14px;font-weight:600;color:#171719;line-height:1.4;">Generating AI design...</div>' +
          '<div style="width:100%;height:4px;border-radius:99px;background:#E5E7EB;overflow:hidden;">' +
            '<div id="TgClassicAiGenFill" style="width:12%;height:100%;background:#171719;border-radius:99px;transition:width .2s linear;"></div>' +
          '</div>' +
          '<div style="font-size:12px;color:#848B96;line-height:1.4;">Usually takes 5–10 seconds, please wait...</div>' +
        '</div>';
      modal.appendChild(ovr);
    }
    var titleEl = document.getElementById('TgClassicAiGenTitle');
    var fillEl = document.getElementById('TgClassicAiGenFill');
    if (titleEl) titleEl.textContent = 'Generating "' + String(promptText || '').slice(0, 24) + '"...';
    if (fillEl) fillEl.style.width = '12%';
    ovr.style.display = 'flex';
    if (ovr._timer) clearInterval(ovr._timer);
    var t0 = performance.now();
    ovr._timer = setInterval(function () {
      var elapsed = (performance.now() - t0) / 1000;
      var pct = Math.min(95, Math.round(95 * (1 - Math.exp(-elapsed / 4.5))));
      if (fillEl) fillEl.style.width = Math.max(12, pct) + '%';
    }, 180);
  }

  function hideClassicStudioGenOverlay() {
    var ovr = document.getElementById('TgClassicAiGenOverlay');
    if (!ovr) return;
    if (ovr._timer) {
      clearInterval(ovr._timer);
      ovr._timer = null;
    }
    var fillEl = document.getElementById('TgClassicAiGenFill');
    if (fillEl) fillEl.style.width = '100%';
    setTimeout(function () {
      ovr.style.display = 'none';
    }, 160);
  }

  window.TgTraceAiKeychainShape = function (prompt, cb) {
    var cleanPrompt = String(prompt || '').trim();
    if (!cleanPrompt) {
      if (typeof cb === 'function') cb({ ok: false, reason: 'empty_prompt' });
      return;
    }
    var nextBal = deductAiCredits(6);
    if (nextBal === null) {
      if (typeof cb === 'function') cb({ ok: false, reason: 'insufficient_credits' });
      return;
    }
    showClassicStudioGenOverlay(cleanPrompt);
    showStudioAuthToast('Generating AI vector shape for "' + cleanPrompt + '"...');
    callStorefrontAiGateway({ mode: 'keychain-shape', prompt: cleanPrompt }).then(function (res) {
      hideClassicStudioGenOverlay();
      if (res && res.ok && res.imgElement) {
        var traced = traceAiImageToKeychainVector(res.imgElement);
        showStudioAuthToast('AI Vector Shape "' + cleanPrompt + '" generated! -6 Credits (' + nextBal + ' remaining)');
        if (typeof cb === 'function') {
          cb({
            ok: true,
            prompt: cleanPrompt,
            imageUrl: res.imageUrl,
            fullD: traced.fullD,
            contourD: traced.contourD,
            luma: traced.luma,
            creditsRemaining: nextBal
          });
        }
      } else {
        if (typeof cb === 'function') cb({ ok: false, reason: (res && res.error) || 'ai_failed', creditsRemaining: nextBal });
      }
    });
  };

  function drawProceduralMotif(ctx, cx, cy, r, promptStr, pal) {
    var p = String(promptStr || '').toLowerCase();
    ctx.save();
    // Ornamental laurel wreath around inner rim
    var leaves = 28;
    for (var i = 0; i < leaves; i++) {
      var ang = (i / leaves) * Math.PI * 2;
      var lx = cx + Math.cos(ang) * (r * 0.72);
      var ly = cy + Math.sin(ang) * (r * 0.72);
      ctx.save();
      ctx.translate(lx, ly);
      ctx.rotate(ang + Math.PI / 2);
      ctx.fillStyle = pal.spec;
      ctx.globalAlpha = 0.55;
      ctx.beginPath();
      ctx.ellipse(0, 0, 3.2, 8.5, 0.25, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    }

    // Center high-relief sculpted emblem based on prompt keywords
    ctx.shadowColor = pal.shadow;
    ctx.shadowBlur = Math.max(6, (aiState.depth / 100) * 18);
    ctx.shadowOffsetX = (aiState.rotY / 25) * 6;
    ctx.shadowOffsetY = (aiState.rotX / 25) * 6;

    var grad = ctx.createRadialGradient(cx - r * 0.15, cy - r * 0.15, 4, cx, cy, r * 0.55);
    grad.addColorStop(0, pal.spec);
    grad.addColorStop(0.55, pal.bg1);
    grad.addColorStop(1, pal.bg2);
    ctx.fillStyle = grad;
    ctx.strokeStyle = pal.bg3;
    ctx.lineWidth = 2.2;

    if (/celestial|star|moon|galaxy|astro/.test(p)) {
      // 8-point sculpted celestial compass star + crescent
      ctx.beginPath();
      for (var s = 0; s < 16; s++) {
        var sa = (s / 16) * Math.PI * 2 - Math.PI / 2;
        var sr = (s % 2 === 0) ? r * 0.48 : r * 0.19;
        var sx = cx + Math.cos(sa) * sr;
        var sy = cy + Math.sin(sa) * sr;
        if (s === 0) ctx.moveTo(sx, sy); else ctx.lineTo(sx, sy);
      }
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
    } else if (/dragon|phoenix|myth|tia|cat|mascot|pet|dog/.test(p)) {
      // Sculpted heraldic crest shield + crown + mascot silhouette
      ctx.beginPath();
      ctx.moveTo(cx, cy - r * 0.46);
      ctx.lineTo(cx + r * 0.38, cy - r * 0.28);
      ctx.bezierCurveTo(cx + r * 0.38, cy + r * 0.18, cx + r * 0.18, cy + r * 0.38, cx, cy + r * 0.48);
      ctx.bezierCurveTo(cx - r * 0.18, cy + r * 0.38, cx - r * 0.38, cy + r * 0.18, cx - r * 0.38, cy - r * 0.28);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      // Crown atop shield
      ctx.beginPath();
      ctx.moveTo(cx - r * 0.22, cy - r * 0.12);
      ctx.lineTo(cx - r * 0.26, cy - r * 0.30);
      ctx.lineTo(cx - r * 0.10, cy - r * 0.20);
      ctx.lineTo(cx, cy - r * 0.36);
      ctx.lineTo(cx + r * 0.10, cy - r * 0.20);
      ctx.lineTo(cx + r * 0.26, cy - r * 0.30);
      ctx.lineTo(cx + r * 0.22, cy - r * 0.12);
      ctx.closePath();
      ctx.fillStyle = pal.spec;
      ctx.fill();
      ctx.stroke();
    } else {
      // Royal Founder Crest: Crowned Shield + Radiant Sunburst + Laurel
      for (var ray = 0; ray < 24; ray++) {
        var ra = (ray / 24) * Math.PI * 2;
        ctx.beginPath();
        ctx.moveTo(cx, cy);
        ctx.lineTo(cx + Math.cos(ra) * r * 0.52, cy + Math.sin(ra) * r * 0.52);
        ctx.strokeStyle = pal.spec;
        ctx.globalAlpha = 0.35;
        ctx.lineWidth = 1.5;
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
      ctx.beginPath();
      ctx.arc(cx, cy, r * 0.36, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();
      // Sculpted crown inside medallion
      ctx.beginPath();
      ctx.moveTo(cx - r * 0.20, cy + r * 0.08);
      ctx.lineTo(cx - r * 0.24, cy - r * 0.14);
      ctx.lineTo(cx - r * 0.10, cy - r * 0.02);
      ctx.lineTo(cx, cy - r * 0.22);
      ctx.lineTo(cx + r * 0.10, cy - r * 0.02);
      ctx.lineTo(cx + r * 0.24, cy - r * 0.14);
      ctx.lineTo(cx + r * 0.20, cy + r * 0.08);
      ctx.closePath();
      ctx.fillStyle = pal.spec;
      ctx.fill();
      ctx.stroke();
    }

    // Embossed center title from prompt
    var shortLabel = String(promptStr || 'FOUNDER EDITION')
      .replace(/[^a-zA-Z0-9\s]/g, '')
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .join(' ')
      .toUpperCase() || 'FOUNDER GOLD';
    ctx.font = '800 13px Inter, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = pal.spec;
    ctx.fillText(shortLabel, cx, cy + r * 0.23);
    ctx.restore();
  }

  function render3dAiCanvas() {
    var canvas = document.getElementById('Tg3dAiRenderCanvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var w = canvas.width;
    var h = canvas.height;
    ctx.clearRect(0, 0, w, h);

    var pal = FINISH_PALETTES[aiState.finish] || FINISH_PALETTES.gold_coin;

    // Dark studio environment backdrop with subtle radial spotlight
    var bgGrad = ctx.createRadialGradient(w / 2, h / 2, 20, w / 2, h / 2, w * 0.65);
    bgGrad.addColorStop(0, '#1E293B');
    bgGrad.addColorStop(1, '#0B0F17');
    ctx.fillStyle = bgGrad;
    ctx.fillRect(0, 0, w, h);

    var cx = w / 2;
    var cy = h / 2 - 6;
    var scaleX = Math.cos((aiState.rotY * Math.PI) / 180);
    var scaleY = Math.cos((aiState.rotX * Math.PI) / 180);
    var tiltShiftX = Math.sin((aiState.rotY * Math.PI) / 180) * 18;
    var tiltShiftY = Math.sin((aiState.rotX * Math.PI) / 180) * 14;

    ctx.save();
    ctx.translate(cx, cy);
    ctx.scale(Math.max(0.55, Math.abs(scaleX)), Math.max(0.65, Math.abs(scaleY)));
    ctx.translate(-cx, -cy);

    if (aiState.finish === 'banknote') {
      // Render 3D Guilloche Collector Banknote
      var bw = 340;
      var bh = 176;
      var bx = cx - bw / 2;
      var by = cy - bh / 2;
      ctx.shadowColor = 'rgba(0,0,0,0.65)';
      ctx.shadowBlur = 28;
      ctx.shadowOffsetX = -tiltShiftX;
      ctx.shadowOffsetY = 14 - tiltShiftY;

      var noteGrad = ctx.createLinearGradient(bx, by, bx + bw, by + bh);
      noteGrad.addColorStop(0, pal.bg1);
      noteGrad.addColorStop(0.5, pal.spec);
      noteGrad.addColorStop(1, pal.bg2);
      ctx.fillStyle = noteGrad;
      ctx.strokeStyle = pal.rim;
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.roundRect(bx, by, bw, bh, 10);
      ctx.fill();
      ctx.stroke();

      ctx.shadowBlur = 0;
      ctx.strokeStyle = pal.bg3;
      ctx.lineWidth = 1.2;
      ctx.strokeRect(bx + 10, by + 10, bw - 20, bh - 20);

      // Guilloche wave pattern
      ctx.save();
      ctx.strokeStyle = pal.bg2;
      ctx.globalAlpha = 0.28;
      for (var wv = 0; wv < 18; wv++) {
        ctx.beginPath();
        for (var x = bx + 14; x < bx + bw - 14; x += 6) {
          var y = by + bh / 2 + Math.sin((x + wv * 12) * 0.045) * (24 + wv * 2.2);
          if (x === bx + 14) ctx.moveTo(x, y); else ctx.lineTo(x, y);
        }
        ctx.stroke();
      }
      ctx.restore();

      if (aiState.refImg) {
        ctx.save();
        ctx.beginPath();
        ctx.arc(cx, cy, 52, 0, Math.PI * 2);
        ctx.clip();
        ctx.drawImage(aiState.refImg, cx - 52, cy - 52, 104, 104);
        ctx.restore();
      } else {
        drawProceduralMotif(ctx, cx, cy, 64, aiState.prompt, pal);
      }

      ctx.fillStyle = pal.bg3;
      ctx.font = '800 14px Inter, sans-serif';
      ctx.fillText('1000', bx + 24, by + 32);
      ctx.fillText('1000', bx + bw - 60, by + bh - 22);
      ctx.font = '700 10px Inter, sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText(aiState.rimText.slice(0, 44), cx, by + bh - 16);
    } else if (aiState.finish === 'crystal_3d') {
      // Render 3D Sub-Surface Laser Engraved K9 Crystal Cube + Glowing LED Pedestal
      var cw = 210;
      var ch = 220;
      var kx = cx - cw / 2;
      var ky = cy - ch / 2 - 10;

      // Glowing LED Pedestal Base
      var baseGrad = ctx.createLinearGradient(kx + 20, ky + ch, kx + cw - 20, ky + ch + 34);
      baseGrad.addColorStop(0, '#0F172A');
      baseGrad.addColorStop(0.5, '#334155');
      baseGrad.addColorStop(1, '#0F172A');
      ctx.fillStyle = baseGrad;
      ctx.beginPath();
      ctx.roundRect(kx + 16, ky + ch - 4, cw - 32, 34, 6);
      ctx.fill();

      // Upward LED beam
      var beamGrad = ctx.createRadialGradient(cx, ky + ch, 8, cx, cy, 140);
      beamGrad.addColorStop(0, 'rgba(125,211,252,0.75)');
      beamGrad.addColorStop(0.5, 'rgba(56,189,248,0.22)');
      beamGrad.addColorStop(1, 'rgba(56,189,248,0)');
      ctx.fillStyle = beamGrad;
      ctx.fillRect(kx, ky, cw, ch);

      // Crystal Cube glass walls & beveled edges
      ctx.strokeStyle = 'rgba(224,242,254,0.85)';
      ctx.lineWidth = 2.5;
      ctx.strokeRect(kx, ky, cw, ch);
      ctx.strokeStyle = 'rgba(125,211,252,0.35)';
      ctx.lineWidth = 1;
      ctx.strokeRect(kx + 8, ky + 8, cw - 16, ch - 16);

      // Point-cloud internal 3D laser engraving
      ctx.save();
      ctx.globalAlpha = 0.92;
      if (aiState.refImg) {
        ctx.beginPath();
        ctx.arc(cx, cy - 10, 68, 0, Math.PI * 2);
        ctx.clip();
        ctx.drawImage(aiState.refImg, cx - 68, cy - 78, 136, 136);
      } else {
        drawProceduralMotif(ctx, cx, cy - 10, 82, aiState.prompt, pal);
      }
      ctx.restore();

      ctx.fillStyle = '#E0F2FE';
      ctx.font = '700 10px Inter, sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText(aiState.rimText.slice(0, 36), cx, ky + ch - 14);
    } else {
      // Render 3D Metallic Commemorative Coin / Medallion / Bas-Relief with Extruded Reeded Edge
      var r = 128;
      var thickness = Math.max(8, Math.round((aiState.depth / 100) * 18));

      // Extruded 3D cylinder rim & reeded edge notches
      for (var d = thickness; d >= 1; d--) {
        var ex = cx - (tiltShiftX * d) / thickness;
        var ey = cy + (d * 0.85) - (tiltShiftY * d) / thickness;
        ctx.beginPath();
        ctx.arc(ex, ey, r, 0, Math.PI * 2);
        ctx.fillStyle = d % 2 === 0 ? pal.bg3 : pal.rim;
        ctx.fill();
      }

      // Main Coin Face with dynamic directional metallic specular reflection
      var lightX = cx + tiltShiftX * 2.2 - 35;
      var lightY = cy + tiltShiftY * 2.2 - 35;
      var faceGrad = ctx.createRadialGradient(lightX, lightY, 12, cx, cy, r * 1.15);
      faceGrad.addColorStop(0, pal.spec);
      faceGrad.addColorStop(0.38, pal.bg1);
      faceGrad.addColorStop(0.78, pal.bg2);
      faceGrad.addColorStop(1, pal.bg3);

      ctx.beginPath();
      ctx.arc(cx, cy, r, 0, Math.PI * 2);
      ctx.fillStyle = faceGrad;
      ctx.fill();
      ctx.lineWidth = 4;
      ctx.strokeStyle = pal.rim;
      ctx.stroke();

      // Reeded inner ring
      ctx.save();
      var notches = 90;
      for (var n = 0; n < notches; n++) {
        var na = (n / notches) * Math.PI * 2;
        ctx.beginPath();
        ctx.moveTo(cx + Math.cos(na) * (r - 4), cy + Math.sin(na) * (r - 4));
        ctx.lineTo(cx + Math.cos(na) * (r - 10), cy + Math.sin(na) * (r - 10));
        ctx.strokeStyle = n % 2 === 0 ? pal.spec : pal.bg3;
        ctx.lineWidth = 1.6;
        ctx.stroke();
      }
      ctx.restore();

      // Inner recessed field
      var innerGrad = ctx.createRadialGradient(cx + 15, cy + 15, 8, cx, cy, r * 0.78);
      innerGrad.addColorStop(0, pal.bg2);
      innerGrad.addColorStop(1, pal.bg3);
      ctx.beginPath();
      ctx.arc(cx, cy, r * 0.78, 0, Math.PI * 2);
      ctx.fillStyle = innerGrad;
      ctx.fill();
      ctx.lineWidth = 2;
      ctx.strokeStyle = pal.spec;
      ctx.stroke();

      // If user uploaded a reference photo, render it as a 3D metallic embossed relief!
      if (aiState.refImg) {
        ctx.save();
        ctx.beginPath();
        ctx.arc(cx, cy, r * 0.62, 0, Math.PI * 2);
        ctx.clip();
        ctx.drawImage(aiState.refImg, cx - r * 0.62, cy - r * 0.62, r * 1.24, r * 1.24);
        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = pal.bg1;
        ctx.fillRect(cx - r, cy - r, r * 2, r * 2);
        ctx.restore();
      } else {
        drawProceduralMotif(ctx, cx, cy, r, aiState.prompt, pal);
      }

      // Circular Rim Inscription Text
      var rimStr = String(aiState.rimText || 'THOUGHTYGIFT STUDIO · 2026').toUpperCase();
      ctx.save();
      ctx.font = '700 10.5px Inter, sans-serif';
      ctx.fillStyle = pal.spec;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var textRadius = r * 0.855;
      var totalAngle = Math.min(Math.PI * 1.65, rimStr.length * 0.095);
      var startAngle = -Math.PI / 2 - totalAngle / 2;
      for (var chIdx = 0; chIdx < rimStr.length; chIdx++) {
        var charAngle = startAngle + (chIdx / Math.max(1, rimStr.length - 1)) * totalAngle;
        ctx.save();
        ctx.translate(cx + Math.cos(charAngle) * textRadius, cy + Math.sin(charAngle) * textRadius);
        ctx.rotate(charAngle + Math.PI / 2);
        ctx.fillText(rimStr[chIdx], 0, 0);
        ctx.restore();
      }
      ctx.restore();
    }

    ctx.restore();

    // Spec Footer Overlay inside Canvas
    ctx.fillStyle = 'rgba(255,255,255,0.75)';
    ctx.font = '600 11px Inter, sans-serif';
    ctx.textAlign = 'left';
    ctx.fillText(pal.name + ' · Ø' + aiState.diameterMm + 'mm · Relief ' + aiState.depth + '%', 14, h - 12);
    ctx.textAlign = 'right';
    ctx.fillStyle = '#38BDF8';
    ctx.fillText('Drag to rotate 3D · Ready for Laser & Print', w - 14, h - 12);
  }

  function exportAiDepthmapPng() {
    var srcCanvas = document.getElementById('Tg3dAiRenderCanvas');
    if (!srcCanvas) return;
    var tmp = document.createElement('canvas');
    tmp.width = srcCanvas.width;
    tmp.height = srcCanvas.height;
    var tctx = tmp.getContext('2d');
    tctx.drawImage(srcCanvas, 0, 0);
    var imgData = tctx.getImageData(0, 0, tmp.width, tmp.height);
    var d = imgData.data;
    for (var i = 0; i < d.length; i += 4) {
      var lum = Math.round(0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]);
      d[i] = lum;
      d[i + 1] = lum;
      d[i + 2] = lum;
    }
    tctx.putImageData(imgData, 0, 0);
    var a = document.createElement('a');
    a.href = tmp.toDataURL('image/png');
    a.download = (activeSession.slug || 'thoughtygift-ai') + '-3d-depthmap.png';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  function exportAiVectorSvg() {
    var dMm = aiState.diameterMm || 50;
    var promptClean = String(aiState.prompt || 'CUSTOM DESIGN').replace(/[<>&"]/g, '').slice(0, 32).toUpperCase();
    var rimClean = String(aiState.rimText || 'THOUGHTYGIFT STUDIO').replace(/[<>&"]/g, '').slice(0, 48).toUpperCase();
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="' + dMm + 'mm" height="' + dMm + 'mm" viewBox="0 0 200 200">' +
        '<!-- RED (#cc3333) = OUTER LASER CUT PATH | BLUE (#0066ff) = SCORE & ENGRAVE LAYER -->' +
        '<circle cx="100" cy="100" r="94" fill="none" stroke="#cc3333" stroke-width="1.5"/>' +
        '<circle cx="100" cy="100" r="82" fill="none" stroke="#0066ff" stroke-width="1.2" stroke-dasharray="3,2"/>' +
        '<circle cx="100" cy="100" r="68" fill="none" stroke="#0066ff" stroke-width="1.2"/>' +
        '<polygon points="100,42 114,76 150,76 121,97 132,132 100,111 68,132 79,97 50,76 86,76" fill="none" stroke="#0066ff" stroke-width="1.5"/>' +
        '<text x="100" y="24" text-anchor="middle" font-family="Arial,sans-serif" font-size="8" font-weight="bold" fill="#0066ff">' + rimClean + '</text>' +
        '<text x="100" y="152" text-anchor="middle" font-family="Arial,sans-serif" font-size="9" font-weight="bold" fill="#0066ff">' + promptClean + '</text>' +
      '</svg>';
    var blob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = (activeSession.slug || 'thoughtygift-ai') + '-cut-engrave.svg';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
  }

  // ============================================================================
  // NATIVE THOUGHTYGIFT HALFTONE & AI GENERATOR STUDIO (100% 1:1 WITH ATOMM)
  // ============================================================================
  var hfState = {
    activeTab: 'ai', // 'ai' | 'mockup'
    rightTab: 'basic', // 'basic' | 'advanced'
    viewTab: 'original', // 'original' | 'preview' | 'export' | 'mask'
    prompt: '',
    aspect: '1:1',
    bgToggle: true,
    style: 'bold_street',
    unit: 'mm',
    knockout: true,
    knockoutColor: '#000000',
    knockoutTolerance: 25,
    bgColor: '#000000',
    dotShape: 'merge_dot', // merge_dot | round | ellipse | diamond | square | line | none
    frequency: 30, // LPI (5 - 60)
    dotAngle: 45, // deg (-180 to 180)
    printWidthMm: 87,
    productWidthMm: 560,
    exportDpi: 300,
    blurPx: 0,
    gammaVal: 1,
    minDotMm: 0.2,
    shadowCleanupMm: 0.2,
    whiteUnderbase: true,
    zoomPct: 100,
    showGuideCard: true,
    guideStep: 1,
    sourceMode: 'sample', // 'ai' | 'sample' | 'upload' | 'empty'
    sampleId: 'skull',
    sampleImg: null,
    uploadedImg: null,
    uploadedThumbUrl: '',
    aiGeneratedImg: null,
    aiGeneratedUrl: '',
    refImgDataUrl: '',
    showMoreStyles: false,
    mockupId: '', // '' | 'tshirt' | 'canvas_bag' | 'hoodie'
    mockupImg: null,
    isGenerating: false,
    history: []
  };

  var HF_STYLES = [
    { id: 'bold_street', name: 'Bold Street', bg1: '#111827', bg2: '#EF4444', acc: '#F59E0B', tag: 'STREET', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/bold-street-uDmNhQAx.jpg' },
    { id: 'vintage', name: 'Vintage', bg1: '#451A03', bg2: '#D97706', acc: '#FDE68A', tag: 'RETRO', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/vintage-DNF6NG6y.jpg' },
    { id: 'dark_gothic', name: 'Dark Gothic', bg1: '#09090B', bg2: '#7F1D1D', acc: '#E4E4E7', tag: 'GOTHIC', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/dark-gothic-CDuFt65R.jpg' },
    { id: 'y2k', name: 'Y2k', bg1: '#1E1B4B', bg2: '#EC4899', acc: '#38BDF8', tag: 'Y2K', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/y2k-D7Sf8htf.jpg' },
    { id: 'graffiti', name: 'Graffiti Type', bg1: '#0F172A', bg2: '#8B5CF6', acc: '#10B981', tag: 'GRAFFITI', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/graffiti-type-C-TtEe4b.jpg' },
    { id: 'gradient', name: 'Gradient Type', bg1: '#31102F', bg2: '#F97316', acc: '#FACC15', tag: 'GRADIENT', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/gradient-type-R9CsgDxb.jpg' },
    { id: 'airbrush', name: 'Airbrush', bg1: '#1E3A8A', bg2: '#3B82F6', acc: '#93C5FD', tag: 'AIRBRUSH', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/airbrush-BpEZT00E.jpg', more: true },
    { id: 'sticker_bomb', name: 'Sticker Bomb', bg1: '#7C2D12', bg2: '#EA580C', acc: '#FDBA74', tag: 'STICKER', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/sticker-bomb-CvhyaCiD.jpg', more: true },
    { id: 'skate_punk', name: 'Skate Punk', bg1: '#18181B', bg2: '#DC2626', acc: '#FACC15', tag: 'PUNK', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/skate-punk-CSg061Yk.jpg', more: true },
    { id: 'japanese_street', name: 'Japanese Street', bg1: '#0F172A', bg2: '#E11D48', acc: '#FDE047', tag: 'JP STREET', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/japanese-street-BkPuvYJa.jpg', more: true },
    { id: 'psychedelic', name: 'Psychedelic', bg1: '#4C1D95', bg2: '#EC4899', acc: '#34D399', tag: 'PSYCH', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/psychedelic-type-Joru922e.jpg', more: true },
    { id: 'chrome_type', name: 'Chrome Type', bg1: '#09090B', bg2: '#475569', acc: '#E2E8F0', tag: 'CHROME', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/chrome-type-BG03H26N.jpg', more: true }
  ];

  var HF_DOT_SHAPES = [
    { id: 'merge_dot', name: 'Merge Dots', thumb: 'data:image/png;base64,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', icon: '<circle cx="9" cy="12" r="4.5" fill="currentColor"/><circle cx="15" cy="12" r="4.5" fill="currentColor"/>' },
    { id: 'round', name: 'Round', thumb: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAI4ElEQVR4AeybAXbjNgxE/ff+d24zUiBRFECBlLhx3exbhCQwMwABK3b7vH/++f7zer3+Mft23VpMK1pHxCMtz9+j7/GvfFf6V3yL//navAAtm8HxvAUe3MDcHJDThxyuvjqM8WqdP+ALge+vBbwzjHM9vU/2LU/AJ1/w3e+m94B3r/Gj6wufgK83meGL3+EOJ/3LxKfuuAxAYrXNvo/yzcyR1c/iZtW6DGCGuC4m87Qjv4ctfVleFldq9+xNH1g+QcJ5NcyV7rQBWGIVUpvFRlZptXheHM4NAjYZj7MFgw3sfA8C7bhxpg/AEmVW4PSK8nhqWGQ1Hqhd2xlY8slhetpHZhgggnT7hwcAbMV3Z3UIgON93coBvubrdfwDO86abAg7a5UPdqzOGTOuh+0eAHBoChzPXpIrH9CEQDvukaGfU+qoabLSN7oHXtIyMx2duwYA8aUgjllCb4UcD3I4L0fGB9f6cI3J5FLjZcJ2DUCE/4LBM4168q7g1/SRA3iycbO1fgcwu8MX+h85APv9enH3vxqOauoaQCSim7RiikeW5WVxUZ4rf0Y/g7nKU8e7BiByXYTOMsXeyd6tJmD5+A7HtXsAarIuZ6bzXWtptWJ38xpfOWwPxwbBfhamxOp814YGcDdpxNflaouwsDcG9n2JN63SV+7LOKwaZbzeA4tLvGXzwI/pAwC+H719vVM3rDqRBnAKqWGenYAJB6z60mvBr+LGnToAWIu1ZLaC77f43RX69GEMryZHlr3DMgDg0VepkgNaQoN23CNCngN5rJfrrg9y+ZcB3E1W8yGXvOb9xBnGaoUxXn3HKV9LqZP8nuMOTHkC4nS/kboD4ddS9OZSg3/Pz3dgeQLqZtfn3rQZfgbTm7fEZ/WzuFJb+1GeuKUtA5BDgmY63zVp3dWo+TM06xwjZ2D7FGn8bK3bAIz45OoVIZ9sNE+GG2FgbVSdO8LXODsbHs56sPoAgzfXqQNQZhVbmnx3TXqRRh0DTq9OOPtqXksfVn6EKf1X++kDuCrA4rBeCs6rYcpVDfOsxADl0d3DjpGeC/p2XsW/YV3L0ACA7VUFdCX0wNDWgHZ8RLPkwK6vJkcmDuxYnbMmTQ/bPQA4FwBnn5fsv+6De/fUEGrrGgDEBUAcazUecjzI4Vq5WjGYqx/l7hpAJPJufviZZrb6AH5NHzmAViPeLfY7gL80Ef3u91I9NoAogZd0tu+darm6a9cAootF/qvkime5WZw0Ryyjn8Fc5QYOH+G7BiBxFVGb/HdMei3+Vdzj9nBqLBybBHgp0j7pA0vja1L3AGqBp84qUlbreT7DwHopWFfzv743Le43ZPnauO3B11Ec1lhGU/jSgPJ42L/NAKwqXbA085cr4L6a4Ow3rZJve8VsD9i2ucL6Xf8mqCM4dQDA0ig4rh31naDAyVc74IxRs2szHpzxFvNWWIcgPS8uv8yL1b5tAMDWrBo0cgZCGsSxkPQVgDHeF3XaXzW6NiWDXK3LAOAIhuNZgk8bzM0BOX3I4Z6+v+lN+VYE/Oyl7HIzV3jmjssTMLPQX+12B34H0O7P9OiUr6XoTWl65T+c4Kk7Lk9ALVafZ9x1do6sfhY3owfSXAagjQox0/muSSvSaMUijvyjPHFnGbB9fId1r1zZWrcBiHTPzmwV4dkZmfdI7wrtYWBtDuyr6Xh4i3mr8LDqeHFYY8J58dI3dQBlouwe1uJhXT2eLiarY/LJSj/EOsAGrXlboNoIBzuvCh+OcI17mwEAy6N8uMHXAfj66f9VM0qrURBzDQs7xrQsVq4Wgx1fxlt7caN49wCApVGwr5F41g80odCOe2TIc+CIVcNq83JkfRD/v6OuAcCxUCsAfL/FWyvkuJDDtXK1YnCtD9eYVg7F6sF2DUACkcH94iLtXj+8Ty1XtT82gKtE//c4+C+K3wH88CvjIweg37M/3NdT+qimrgFEIsrWiikeWZaXxUV5rvyz9aP8XQOQiFeo5xP208y7Z88dgdNH+O4BKKEKKU2+OyatFv8q7nF7OCUWzk2C1ac8JVbnrAEudGgArtJNpy4WmScNnF5NwAEqvYPDOZQYOPJrOLTjNT5znj4A4NCoTFFXGCCEwDGmBpsZyc5azQdHnvnrFeL/qq2xmfPUAcD5UsAykExxHgbw3Acf+Bg1XHYAfx3Ax3+F3L+w4qUlK0E6m5X+aL8NAFgaA0TYLj88o1Mmhec1S/3RvTVcq2lArtZlAHAEw/FsotkVrvlwjcnm83CQ04ccrs4BY7xaZ8rXUuokv+e4A8sTEId/I7M7MOVbEbOL/iT9KU9A+Wb07s0arXWUV/djGYDEaquBvWfptThXcY+7cbxg5evBVtRHjtn8ywAeyeiIREVEfkdiyNWrP4oHto/ucNxnC586ABWhy9Um/6iZVsRXvI7BsTmwnmtc5mz6QBMO7biRpw/AEmVW4PSKinhqhGclHla90lfuYY+bVhmv98LIB2h5xIYGAGyNeqIKWPU8LYhjHn7EB2w0NTkygWDH6nzXugcAxwKAZRh3C3maDzwteUsvGmrXACC+FMSxVuWQ40EO18rVisG1PlxjWjm8WNcAPIF39MHzjbp7T/Br+sgB3G3W3+T/DuBvdtvJ9ZED0Buec9cfdUU1dQzgdfhn/fVtogQ1rj5neVlcrZ89Z/QzmEw+YPvk2DUAiasImfYy7WXaj9oV/yru5R3hlDqwN6n0j+xVC6x6wCYBvLoH8Pr+I1HZ9/H2EmlFfksI+4XMZ+sV18MB26tTcVjPgI7N3wILwPkBK9cJjQ/AE7vrU8Nq8zSBpUnAEgYO58X5/UN639vTophMAVg1tI8MVoxxIlyPf/gJyCaBtWjY1yzXwwGee/PBOa6GeWYkOHMsFq3Si2LyX8WFkU0bALC8KpWkNqB2pc6Q40EOl0rqgGDVV5MjgxXj0A+uZQDA0izY1wNqwgGYoLpLQk4fcrhd+dndMgBPEsYLg3GuV8s7+uCZO4ZfS3nHS39iTeET8ImXfcc7hQPQm8towXe4ozln8Wbr/gsAAP//i1Z/cgAAAAZJREFUAwBKyZooYq60kgAAAABJRU5ErkJggg==', icon: '<circle cx="12" cy="12" r="6" fill="currentColor"/>' },
    { id: 'ellipse', name: 'Ellipse', thumb: 'data:image/png;base64,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', icon: '<ellipse cx="12" cy="12" rx="7" ry="4.2" transform="rotate(-25 12 12)" fill="currentColor"/>' },
    { id: 'diamond', name: 'Diamond', thumb: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAEzElEQVR4AeyYi5LbIAxFc/r//9wGEy8CYxuQCGlWnWUQD13BPZ1dxn/+vv49Ho+/sr2mhzupdRb3ip/p1OZ7tGv5d3N3+nf5+/qfZ/AAQudtgQMbgAV1veTLAQfwMmJV5wBWOf+q6wBeRqzqNgDPv+iPsq060G+ruwGYcekAdIbuJ2kC2wsSjn3rOacBCAcIEK5a2PPuBuNmybMCcjgcTwUwfKpnIpD973pOHX5NXsGFPB/iOOh8UlsOAKIxkPdTTaqIX8GUa5VU1VQXAMhNgnysOsmXJ0uIMu4C8OUeLbmeA1hieyrqAJIXSyIHsMT2VNQBJC+WRA5gie2paBcA+Xwq4yTpUc0ByJ/sEMddAGrC+1wAssc9fcjbW0+e9V6IhsB1b13XDIDFwXYQtV7qw7VJwOGzhcz/pPgtACAYdmy9RkDU6M0L+2tQ97mwvqpNAwDRLGDV3abW3eGd9a3FNwBA9uURaM33fUoHNgBKDU9XOOAAFOZZpDoACxcVGg5AYZ5FqgOwcFGhsQGoPaUUmp7a4cAGoGN/89Ya1H2uWeSDNwKHpzukudajTwNwdYBREHterS/rQTIDruMy13J8p7UEgDwUXJsDcV3m1OISSm3P1VyZH8ZX+63WhgFANAZSb3WoT9EJEMpmfbYuAPC9ZlsbW+qVIPdxF4BS1Md6BxyA3kOVggNQ2adPdgB6D1UKDkBlnz7ZAeg97FaA9JrsArA/nc767pP8ogRIpstrdwGQiVbxGcxyvqvewGZIBsF5PCB9mbIcwOXpikU4NwbytRLg1bgo89bhNACQGwLH8VtvalysBnSkRBUAMKL163MklFYzNgBA9m27Ndn36R3YAOhlXGHUAQcw6pxRngMwMnJUxgGMOmeUtwGQf71DbKTtMg0ObADKfQ6hdKRtDOk12ZbxeFQBtCbn+/JRgHjX8oz/awRkT3dg6ALTAAyd5ibpDqhcBw4GQX3upuzU5eUAoG4K5PNTXXiKS3hX8XOr6U8XAMhNgXxserIvE5NQ5dW6AMhEj8cdkDAcwLiPJpkOwMTGcREHMO6dSaYDMLFxXMQBjHtnktkFQP71Nqn+BSKtV4D8yQ5x3AVAFpMw9liuf0MM0SRIvfW9hgFYHWSHd9ff1YNkEnC3/bAOHD5dHDZNmFgCAOJle+8DMQ+Ofal1B1Sul7nvHE8DAEeTIM6984KzakmAtbi17gYAojGQ+lYB36dzYAOgk/BsjQMOQOOeQa4DMDBRI+EANO4Z5DoAAxM1EhsAzTNKU3w494sSNwAz7iOhztBfrQnpyQ7HuPV80wDIA0gYMpZ7WuI9t2VvuQeOJkGcK/e+c/wWAK0XgmgIHHupsYO46iHXkPmfFJsBAIbuBfx8BBsSMEq6ginXjMr9yHQBgGQW5PGPogdVByREGXcBqCr7pMoBB6CyT5/sAPQeqhQcgMo+fbID0HuoUugAoKrjyScOdAGQz6dafFLDp58OQP5shzjuAvDUMf+pgQxz5oVuBCEaAtf9jUz38nIAZycOEGQL++DaHEjrMlfGQeeT2lQAkAyBY7zCCAljj0fOEXJH8sqcaQCAstbXjQOEs9Z62Q0A8PNBDGLcKuD7dA5sAHQSnq1xwAFo3DPIdQAGJmokHMCNe7OX/wEAAP//ZxJKtwAAAAZJREFUAwB0yJsNIYe0MQAAAABJRU5ErkJggg==', icon: '<polygon points="12,4 20,12 12,20 4,12" fill="currentColor"/>' },
    { id: 'square', name: 'Square', thumb: 'data:image/png;base64,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', icon: '<rect x="6" y="6" width="12" height="12" rx="1.5" fill="currentColor"/>' },
    { id: 'line', name: 'Line', thumb: 'data:image/png;base64,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', icon: '<line x1="4" y1="7" x2="20" y2="7" stroke="currentColor" stroke-width="2.5"/><line x1="4" y1="12" x2="20" y2="12" stroke="currentColor" stroke-width="2.5"/><line x1="4" y1="17" x2="20" y2="17" stroke="currentColor" stroke-width="2.5"/>' },
    { id: 'none', name: 'None', thumb: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAABz0lEQVR4AeyTMY7DMAwEjfz/z0nYsmGxoCZ25nAsBIHaeAb7ej/o77qu993m9f3B/oMEFADCr2gFFAVwFADCr2gFFAVwFADCr2gFFAVwFADCr2gFFAVw/lMACLxHK6ATOXxWwGHgPU4BncjhswIOA+9xCuhEDp8VcBh4j1NAJ3L4rIDDwHucAjqRw2cFHAbe4w4K6NGei4ACigI4CgDhV7QCigI4CgDhV7QCigI4CgDhV7QCigI4CgDhV7QCigI4CliGPz2vgInQ8r0ClgFPzytgIrR8r4BlwNPzCpgILd8rYBnw9LwCJkLL9wpYBjw9r4CJ0PK9ApYBT88/U8D01T90rwBYhgIUABOA422AAmACcLwNUABMAI63AQqACcDxNuA5AuAvuWm8DYDFKUABMAE43gYoACYAx9sABcAE4HgboACYABxvA0IB6boCUoLhvgJCgOm6AlKC4b4CQoDpugJSguG+AkKA6boCUoLhvgJCgOm6AlKC4b4CQoDp+j0FpF/9Q/sKgGUoQAEwATjeBigAJgDH2wAFwATgeBugAJgAHG8D7iMA/qUPjbcBsFgFKAAmAMfbAAXABOB4G6AAmAAcbwMUABOA423AIGD7+gMAAP//GTk5SQAAAAZJREFUAwA1K/jIDFXrywAAAABJRU5ErkJggg==', icon: '<circle cx="12" cy="12" r="7" fill="none" stroke="currentColor" stroke-width="2"/><line x1="7" y1="17" x2="17" y2="7" stroke="currentColor" stroke-width="2"/>' }
  ];

  var HF_SAMPLES = [
    { id: 'skull', name: 'Skull on black', prompt: 'cyberpunk skull & roses', style: 'dark_gothic', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/skull-thumb-CCg4vLyj.jpg', fullUrl: 'https://www.atomm.com/creativetools/generator/halftone/assets/skull-DimXClN1.jpg' },
    { id: 'tiger', name: 'Tiger on yellow', prompt: 'roaring samurai tiger', style: 'vintage', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/tiger-thumb-yC2kJnGO.jpg', fullUrl: 'https://www.atomm.com/creativetools/generator/halftone/assets/tiger-CoUwxx0Q.jpg' },
    { id: 'wave', name: 'Wave on cyan', prompt: 'great ocean wave kanagawa', style: 'bold_street', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/wave-thumb-Ub1xubgm.jpg', fullUrl: 'https://www.atomm.com/creativetools/generator/halftone/assets/wave-C9OXsfZv.jpg' },
    { id: 'astronaut', name: 'Astronaut on pink', prompt: 'cosmic neon astronaut', style: 'y2k', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/astro-thumb-LGOMdhiT.jpg', fullUrl: 'https://www.atomm.com/creativetools/generator/halftone/assets/astro-KUl-9MUn.jpg' }
  ];

  var HF_MOCKUPS = [
    { id: 'tshirt', name: 'T-shirt', cta: 'Buy this T-shirt', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/t-shirt-preview-DEA9QhoR.png', stageUrl: 'https://www.atomm.com/creativetools/generator/halftone/assets/t-shirt-new-CO2QodK2.png' },
    { id: 'canvas_bag', name: 'Canvas Bag', cta: 'Buy', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/canvas-bag-new-CENIbnVS.png', stageUrl: 'https://www.atomm.com/creativetools/generator/halftone/assets/canvas-bag-new-CENIbnVS.png' },
    { id: 'hoodie', name: 'Cotton Hoodie', cta: 'Buy', thumb: 'https://www.atomm.com/creativetools/generator/halftone/assets/cotton-hoodie-preview-CuxZhj19.png', stageUrl: 'https://www.atomm.com/creativetools/generator/halftone/assets/cotton-hoodie-2-uFw7OR.png' }
  ];

  var hfSampleImgCache = {};

  function loadHfSamplePresetImg(smp, cb) {
    if (!smp || !smp.fullUrl) {
      if (typeof cb === 'function') cb(null);
      return;
    }
    if (hfSampleImgCache[smp.id]) {
      if (typeof cb === 'function') cb(hfSampleImgCache[smp.id]);
      return;
    }
    var wsrvUrl = 'https://wsrv.nl/?url=' + encodeURIComponent(smp.fullUrl);
    loadCorsImage(wsrvUrl).then(function (img) {
      if (img) hfSampleImgCache[smp.id] = img;
      if (typeof cb === 'function') cb(img);
    });
  }

  var hfSourceCanvas = null;

  function drawHfSourceArtwork() {
    if (!hfSourceCanvas) {
      hfSourceCanvas = document.createElement('canvas');
      hfSourceCanvas.width = 520;
      hfSourceCanvas.height = 520;
    }
    var ctx = hfSourceCanvas.getContext('2d');
    var w = hfSourceCanvas.width;
    var h = hfSourceCanvas.height;
    ctx.clearRect(0, 0, w, h);

    // White high-contrast base so luminance calculation is crisp
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, w, h);

    if (hfState.sourceMode === 'upload' && hfState.uploadedImg) {
      var img = hfState.uploadedImg;
      var scale = Math.min(w / img.width, h / img.height);
      var dw = img.width * scale;
      var dh = img.height * scale;
      ctx.drawImage(img, (w - dw) / 2, (h - dh) / 2, dw, dh);
      return hfSourceCanvas;
    }

    if (hfState.sourceMode === 'ai' && hfState.aiGeneratedImg) {
      var aImg = hfState.aiGeneratedImg;
      var aScale = Math.min(w / aImg.width, h / aImg.height);
      var adw = aImg.width * aScale;
      var adh = aImg.height * aScale;
      ctx.drawImage(aImg, (w - adw) / 2, (h - adh) / 2, adw, adh);
      return hfSourceCanvas;
    }

    if (hfState.sourceMode === 'sample' && hfState.sampleImg) {
      var sImg = hfState.sampleImg;
      var sScale = Math.min(w / sImg.width, h / sImg.height);
      var sdw = sImg.width * sScale;
      var sdh = sImg.height * sScale;
      ctx.drawImage(sImg, (w - sdw) / 2, (h - sdh) / 2, sdw, sdh);
      return hfSourceCanvas;
    }

    var stObj = HF_STYLES.find(function (s) { return s.id === hfState.style; }) || HF_STYLES[0];
    var p = String(hfState.prompt || 'dragon').toLowerCase();
    var cx = w / 2;
    var cy = h / 2 - 14;

    ctx.save();
    // Outer street-art emblem ring / sunburst
    var bgGrad = ctx.createRadialGradient(cx, cy, 20, cx, cy, 225);
    bgGrad.addColorStop(0, '#111827');
    bgGrad.addColorStop(0.68, stObj.bg1);
    bgGrad.addColorStop(0.88, stObj.bg2);
    bgGrad.addColorStop(1, '#FFFFFF');

    ctx.beginPath();
    ctx.arc(cx, cy, 210, 0, Math.PI * 2);
    ctx.fillStyle = bgGrad;
    ctx.fill();

    // Dynamic radiant spikes / street-art halftone aura
    for (var i = 0; i < 36; i++) {
      var ang = (i / 36) * Math.PI * 2;
      ctx.beginPath();
      ctx.moveTo(cx + Math.cos(ang) * 115, cy + Math.sin(ang) * 115);
      ctx.lineTo(cx + Math.cos(ang + 0.045) * 198, cy + Math.sin(ang + 0.045) * 198);
      ctx.lineTo(cx + Math.cos(ang - 0.045) * 198, cy + Math.sin(ang - 0.045) * 198);
      ctx.closePath();
      ctx.fillStyle = i % 2 === 0 ? '#FFFFFF' : stObj.acc;
      ctx.globalAlpha = i % 2 === 0 ? 0.24 : 0.42;
      ctx.fill();
    }
    ctx.globalAlpha = 1;

    if (/skull|bone|goth|skeleton/.test(p) || (hfState.sourceMode === 'sample' && hfState.sampleId === 'skull')) {
      // Detailed High-Contrast Streetwear Skull Illustration
      ctx.fillStyle = '#FFFFFF';
      ctx.strokeStyle = '#09090B';
      ctx.lineWidth = 8;
      // Cranium
      ctx.beginPath();
      ctx.arc(cx, cy - 22, 108, Math.PI * 0.88, Math.PI * 0.12, false);
      ctx.lineTo(cx + 68, cy + 72);
      ctx.lineTo(cx - 68, cy + 72);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      // Eye sockets
      ctx.fillStyle = '#09090B';
      ctx.beginPath();
      ctx.ellipse(cx - 42, cy - 16, 28, 32, -0.15, 0, Math.PI * 2);
      ctx.ellipse(cx + 42, cy - 16, 28, 32, 0.15, 0, Math.PI * 2);
      ctx.fill();
      // Glowing pupil highlights
      ctx.fillStyle = stObj.bg2;
      ctx.beginPath();
      ctx.arc(cx - 42, cy - 16, 10, 0, Math.PI * 2);
      ctx.arc(cx + 42, cy - 16, 10, 0, Math.PI * 2);
      ctx.fill();
      // Nasal cavity
      ctx.fillStyle = '#09090B';
      ctx.beginPath();
      ctx.moveTo(cx, cy + 6);
      ctx.lineTo(cx - 16, cy + 36);
      ctx.lineTo(cx + 16, cy + 36);
      ctx.closePath();
      ctx.fill();
      // Jaw teeth
      for (var t = -3; t <= 3; t++) {
        ctx.fillStyle = '#FFFFFF';
        ctx.strokeStyle = '#09090B';
        ctx.lineWidth = 4;
        ctx.fillRect(cx + t * 18 - 7, cy + 48, 14, 30);
        ctx.strokeRect(cx + t * 18 - 7, cy + 48, 14, 30);
      }
    } else if (/tiger|cat|lion|wolf|panther|beast/.test(p) || (hfState.sourceMode === 'sample' && hfState.sampleId === 'tiger')) {
      // Roaring Neo-Traditional Street Tiger Illustration
      ctx.fillStyle = stObj.acc;
      ctx.strokeStyle = '#09090B';
      ctx.lineWidth = 8;
      // Ears
      ctx.beginPath();
      ctx.arc(cx - 82, cy - 88, 34, 0, Math.PI * 2);
      ctx.arc(cx + 82, cy - 88, 34, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();
      // Head
      ctx.fillStyle = '#FFFFFF';
      ctx.beginPath();
      ctx.arc(cx, cy - 6, 118, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();
      // Tiger stripes
      ctx.fillStyle = '#09090B';
      for (var s = -2; s <= 2; s++) {
        if (s === 0) continue;
        var side = s < 0 ? -1 : 1;
        var sy = cy - 45 + Math.abs(s) * 28;
        ctx.beginPath();
        ctx.moveTo(cx + side * 112, sy - 10);
        ctx.lineTo(cx + side * 52, sy + 4);
        ctx.lineTo(cx + side * 110, sy + 14);
        ctx.closePath();
        ctx.fill();
      }
      // Fierce eyes
      ctx.fillStyle = stObj.bg2;
      ctx.beginPath();
      ctx.moveTo(cx - 68, cy - 34);
      ctx.lineTo(cx - 20, cy - 18);
      ctx.lineTo(cx - 52, cy - 8);
      ctx.closePath();
      ctx.moveTo(cx + 68, cy - 34);
      ctx.lineTo(cx + 20, cy - 18);
      ctx.lineTo(cx + 52, cy - 8);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      // Open roaring mouth & fangs
      ctx.fillStyle = '#09090B';
      ctx.beginPath();
      ctx.ellipse(cx, cy + 48, 46, 38, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = '#FFFFFF';
      ctx.beginPath();
      ctx.moveTo(cx - 30, cy + 20); ctx.lineTo(cx - 20, cy + 52); ctx.lineTo(cx - 10, cy + 24);
      ctx.moveTo(cx + 30, cy + 20); ctx.lineTo(cx + 20, cy + 52); ctx.lineTo(cx + 10, cy + 24);
      ctx.fill();
    } else if (/wave|ocean|sea|water|surf/.test(p) || (hfState.sourceMode === 'sample' && hfState.sampleId === 'wave')) {
      // Great Wave Kanagawa High-Contrast Illustration
      ctx.fillStyle = '#FFFFFF';
      ctx.beginPath();
      ctx.arc(cx + 45, cy - 45, 58, 0, Math.PI * 2);
      ctx.fill();
      // Concentric wave crests
      for (var wv = 0; wv < 5; wv++) {
        ctx.beginPath();
        ctx.arc(cx - 35 + wv * 18, cy + 35 - wv * 10, 120 - wv * 16, Math.PI * 0.65, Math.PI * 1.95, false);
        ctx.lineWidth = 18 - wv * 2;
        ctx.strokeStyle = wv % 2 === 0 ? '#FFFFFF' : stObj.acc;
        ctx.stroke();
      }
    } else if (/astro|space|cosmic|galaxy|moon|star/.test(p) || (hfState.sourceMode === 'sample' && hfState.sampleId === 'astronaut')) {
      // Cosmic Astronaut Helmet & Visor Reflection
      ctx.fillStyle = '#FFFFFF';
      ctx.strokeStyle = '#09090B';
      ctx.lineWidth = 8;
      ctx.beginPath();
      ctx.arc(cx, cy - 8, 118, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();
      // Visor
      var visGrad = ctx.createLinearGradient(cx - 80, cy - 60, cx + 80, cy + 40);
      visGrad.addColorStop(0, '#09090B');
      visGrad.addColorStop(0.5, stObj.bg2);
      visGrad.addColorStop(1, '#09090B');
      ctx.fillStyle = visGrad;
      ctx.beginPath();
      ctx.ellipse(cx, cy - 8, 86, 64, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();
      // Visor starlight reflection
      ctx.fillStyle = '#FFFFFF';
      ctx.beginPath();
      ctx.ellipse(cx - 36, cy - 32, 24, 10, -0.4, 0, Math.PI * 2);
      ctx.fill();
    } else {
      // Fierce Streetwear Dragon / Custom Prompt Illustration (Default for "dragon" & custom prompts)
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';

      // Coiled Dragon Serpentine Body
      ctx.strokeStyle = '#FFFFFF';
      ctx.lineWidth = 46;
      ctx.beginPath();
      ctx.moveTo(cx - 115, cy + 95);
      ctx.bezierCurveTo(cx - 165, cy - 20, cx - 45, cy - 140, cx + 35, cy - 75);
      ctx.bezierCurveTo(cx + 125, cy - 10, cx + 135, cy + 110, cx + 15, cy + 95);
      ctx.stroke();

      ctx.strokeStyle = '#09090B';
      ctx.lineWidth = 10;
      ctx.stroke();

      // Dragon Dorsal Scales / Spines
      for (var sp = 0; sp < 14; sp++) {
        var sa = -Math.PI * 0.85 + (sp / 13) * Math.PI * 1.45;
        var sx = cx + Math.cos(sa) * 126;
        var sy = cy + Math.sin(sa) * 116;
        var ex = cx + Math.cos(sa) * 168;
        var ey = cy + Math.sin(sa) * 158;
        ctx.beginPath();
        ctx.moveTo(sx - 10, sy - 10);
        ctx.lineTo(ex, ey);
        ctx.lineTo(sx + 10, sy + 10);
        ctx.closePath();
        ctx.fillStyle = stObj.acc;
        ctx.fill();
        ctx.lineWidth = 4;
        ctx.strokeStyle = '#09090B';
        ctx.stroke();
      }

      // Fierce Dragon Head Centerpiece
      ctx.fillStyle = '#FFFFFF';
      ctx.strokeStyle = '#09090B';
      ctx.lineWidth = 8;
      // Antler Horns
      ctx.beginPath();
      ctx.moveTo(cx - 38, cy - 58);
      ctx.lineTo(cx - 95, cy - 145);
      ctx.lineTo(cx - 55, cy - 125);
      ctx.lineTo(cx - 72, cy - 168);
      ctx.lineTo(cx - 18, cy - 78);
      ctx.closePath();
      ctx.moveTo(cx + 38, cy - 58);
      ctx.lineTo(cx + 95, cy - 145);
      ctx.lineTo(cx + 55, cy - 125);
      ctx.lineTo(cx + 72, cy - 168);
      ctx.lineTo(cx + 18, cy - 78);
      ctx.closePath();
      ctx.fillStyle = stObj.acc;
      ctx.fill();
      ctx.stroke();

      // Dragon Skull & Snout
      ctx.fillStyle = '#FFFFFF';
      ctx.beginPath();
      ctx.moveTo(cx, cy - 92);
      ctx.lineTo(cx + 76, cy - 36);
      ctx.lineTo(cx + 58, cy + 44);
      ctx.lineTo(cx, cy + 78);
      ctx.lineTo(cx - 58, cy + 44);
      ctx.lineTo(cx - 76, cy - 36);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();

      // Glowing Dragon Eyes
      ctx.fillStyle = '#09090B';
      ctx.beginPath();
      ctx.moveTo(cx - 58, cy - 28);
      ctx.lineTo(cx - 14, cy - 10);
      ctx.lineTo(cx - 44, cy + 4);
      ctx.closePath();
      ctx.moveTo(cx + 58, cy - 28);
      ctx.lineTo(cx + 14, cy - 10);
      ctx.lineTo(cx + 44, cy + 4);
      ctx.closePath();
      ctx.fill();

      // Roaring Dragon Maw & Fangs
      ctx.fillStyle = '#09090B';
      ctx.beginPath();
      ctx.moveTo(cx - 38, cy + 22);
      ctx.lineTo(cx + 38, cy + 22);
      ctx.lineTo(cx + 24, cy + 64);
      ctx.lineTo(cx - 24, cy + 64);
      ctx.closePath();
      ctx.fill();

      ctx.fillStyle = '#FFFFFF';
      ctx.beginPath();
      ctx.moveTo(cx - 30, cy + 22); ctx.lineTo(cx - 20, cy + 48); ctx.lineTo(cx - 10, cy + 22);
      ctx.moveTo(cx + 30, cy + 22); ctx.lineTo(cx + 20, cy + 48); ctx.lineTo(cx + 10, cy + 22);
      ctx.fill();
    }

    // Bold Streetwear Typography Banner at Bottom of Graphic
    var bannerText = String(hfState.prompt || 'DRAGON').trim().toUpperCase().slice(0, 16);
    ctx.fillStyle = '#09090B';
    ctx.strokeStyle = '#FFFFFF';
    ctx.lineWidth = 6;
    ctx.beginPath();
    ctx.roundRect(cx - 165, h - 88, 330, 56, 12);
    ctx.fill();
    ctx.stroke();

    ctx.font = '900 30px Inter, Impact, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = '#FFFFFF';
    ctx.fillText(bannerText, cx, h - 59);
    ctx.restore();

    return hfSourceCanvas;
  }

  function hexToRgbObj(hex) {
    var s = String(hex || '#000000').replace('#', '').trim();
    if (s.length === 3) s = s[0] + s[0] + s[1] + s[1] + s[2] + s[2];
    var num = parseInt(s, 16);
    if (isNaN(num)) return { r: 0, g: 0, b: 0 };
    return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
  }

  function renderHalftoneCanvas() {
    var outCanvas = document.getElementById('TgHfMainCanvas');
    if (!outCanvas) return;

    var emptyOvr = document.getElementById('TgHfEmptyStageOverlay');
    var canvasStageWrap = document.getElementById('TgHfActiveStageWrap');
    if (hfState.sourceMode === 'empty') {
      if (emptyOvr) emptyOvr.style.display = 'flex';
      if (canvasStageWrap) canvasStageWrap.style.display = 'none';
      return;
    } else {
      if (emptyOvr) emptyOvr.style.display = 'none';
      if (canvasStageWrap) canvasStageWrap.style.display = 'flex';
    }

    var src = drawHfSourceArtwork();
    var sctx = src.getContext('2d');
    var sw = src.width;
    var sh = src.height;
    var imgData = sctx.getImageData(0, 0, sw, sh).data;

    var ctx = outCanvas.getContext('2d');
    var w = outCanvas.width;
    var h = outCanvas.height;
    ctx.clearRect(0, 0, w, h);

    // Fill Background Color
    var bgHex = hfState.bgColor || '#000000';
    ctx.fillStyle = bgHex;
    ctx.fillRect(0, 0, w, h);

    // Sync right-sidebar Image card thumbnail
    var sideThumb = document.getElementById('TgHfSideImgThumb');
    if (sideThumb) {
      if (hfState.sourceMode === 'upload' && hfState.uploadedThumbUrl) {
        sideThumb.src = hfState.uploadedThumbUrl;
      } else if (hfState.sourceMode === 'ai' && hfState.aiGeneratedUrl) {
        sideThumb.src = hfState.aiGeneratedUrl;
      } else {
        var curSmp = HF_SAMPLES.find(function (x) { return x.id === hfState.sampleId; }) || HF_SAMPLES[0];
        if (curSmp && sideThumb.src !== curSmp.thumb) sideThumb.src = curSmp.thumb;
      }
    }

    // 1. Original View Tab (or Dot Shape === 'none'): draw full-resolution source image directly (1:1 with Atomm's Original tab)
    if (hfState.viewTab === 'original' || hfState.dotShape === 'none') {
      ctx.drawImage(src, 0, 0, w, h);
      return;
    }

    var koRgb = hexToRgbObj(hfState.knockoutColor || '#000000');
    var bgRgb = hexToRgbObj(bgHex);
    var bgLum = (0.299 * bgRgb.r + 0.587 * bgRgb.g + 0.114 * bgRgb.b) / 255;
    var tol = Math.max(5, Math.min(100, Number(hfState.knockoutTolerance) || 25)) * 2.55;

    // 2. Mask View Tab: render knockout mask preview
    if (hfState.viewTab === 'mask') {
      var maskImg = ctx.createImageData(w, h);
      var md = maskImg.data;
      for (var my = 0; my < h; my++) {
        var syM = Math.min(sh - 1, Math.floor((my / h) * sh));
        for (var mx = 0; mx < w; mx++) {
          var sxM = Math.min(sw - 1, Math.floor((mx / w) * sw));
          var sIdx = (syM * sw + sxM) * 4;
          var dr = imgData[sIdx] - koRgb.r;
          var dg = imgData[sIdx + 1] - koRgb.g;
          var db = imgData[sIdx + 2] - koRgb.b;
          var dist = Math.sqrt(dr * dr + dg * dg + db * db);
          var keep = (!hfState.knockout || dist > tol) ? 255 : 0;
          var dIdx = (my * w + mx) * 4;
          md[dIdx] = keep;
          md[dIdx + 1] = keep;
          md[dIdx + 2] = keep;
          md[dIdx + 3] = 255;
        }
      }
      ctx.putImageData(maskImg, 0, 0);
      return;
    }

    // 2.5 Specialized Native Tool Output Mapping (Preview & Export tabs match Atomm 1:1 per tool)
    var toolSlug = String(hfState.activeToolSlug || activeSession.slug || 'halftone').toLowerCase();
    if (toolSlug.indexOf('halftone') === -1 && hfState.dotShape === 'merge_dot') {
      // A. Cutout / Background Removal / Extraction Tools -> Checkerboard + Alpha Knockout
      if (/^(background-remover|magic-eraser|design-extraction|parse-image)$/.test(toolSlug)) {
        ctx.clearRect(0, 0, w, h);
        if (hfState.viewTab === 'preview') {
          var chk = 14;
          for (var cyGrid = 0; cyGrid < h; cyGrid += chk) {
            for (var cxGrid = 0; cxGrid < w; cxGrid += chk) {
              ctx.fillStyle = ((cxGrid / chk + cyGrid / chk) % 2 === 0) ? '#FFFFFF' : '#E5E7EB';
              ctx.fillRect(cxGrid, cyGrid, chk, chk);
            }
          }
        }
        var cutFrame = ctx.getImageData(0, 0, w, h);
        var cd = cutFrame.data;
        // Sample corner pixel as auto background reference if default black knockout is still set on light image
        var cR = imgData[0], cG = imgData[1], cB = imgData[2];
        var useCorner = (hfState.knockoutColor === '#000000' && (cR + cG + cB) > 540);
        var refR = useCorner ? cR : koRgb.r;
        var refG = useCorner ? cG : koRgb.g;
        var refB = useCorner ? cB : koRgb.b;
        var cutTol = Math.max(28, tol * 0.75);
        for (var pyC = 0; pyC < h; pyC++) {
          var syC = Math.min(sh - 1, Math.floor((pyC / h) * sh));
          for (var pxC = 0; pxC < w; pxC++) {
            var sxC = Math.min(sw - 1, Math.floor((pxC / w) * sw));
            var sIdxC = (syC * sw + sxC) * 4;
            var rC = imgData[sIdxC], gC = imgData[sIdxC + 1], bC = imgData[sIdxC + 2], aC = imgData[sIdxC + 3];
            var distBg = Math.sqrt((rC - refR) * (rC - refR) + (gC - refG) * (gC - refG) + (bC - refB) * (bC - refB));
            var fgAlpha = (!hfState.knockout) ? (aC / 255) : Math.min(1, Math.max(0, (distBg - cutTol * 0.55) / (cutTol * 0.65))) * (aC / 255);
            var dIdxC = (pyC * w + pxC) * 4;
            if (hfState.viewTab === 'preview') {
              cd[dIdxC] = Math.round(rC * fgAlpha + cd[dIdxC] * (1 - fgAlpha));
              cd[dIdxC + 1] = Math.round(gC * fgAlpha + cd[dIdxC + 1] * (1 - fgAlpha));
              cd[dIdxC + 2] = Math.round(bC * fgAlpha + cd[dIdxC + 2] * (1 - fgAlpha));
              cd[dIdxC + 3] = 255;
            } else {
              cd[dIdxC] = rC;
              cd[dIdxC + 1] = gC;
              cd[dIdxC + 2] = bC;
              cd[dIdxC + 3] = Math.round(fgAlpha * 255);
            }
          }
        }
        ctx.putImageData(cutFrame, 0, 0);
        return;
      }

      // B. Full-Color HD Enhancement, Style Transfer, Crochet & Font Tools
      if (/^(image-upscaler|style-match|ai-expand|ai-replace|ai-image-variations|crochet-pattern-generator|font-generator)$/.test(toolSlug)) {
        ctx.clearRect(0, 0, w, h);
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, w, h);
        ctx.save();
        ctx.filter = toolSlug === 'image-upscaler' ? 'contrast(1.08) saturate(1.12)' : 'contrast(1.04) saturate(1.06)';
        ctx.drawImage(src, 0, 0, w, h);
        ctx.restore();
        return;
      }

      // C. Continuous Archimedean Single-Line Spiral Portrait (spiral-portrait / spiral-cut-portrait)
      if (/^(spiral-portrait|spiral-cut-portrait)$/.test(toolSlug)) {
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, w, h);
        var cxSp = w / 2;
        var cySp = h / 2;
        var maxR = w * 0.46;
        var turns = Math.max(24, Math.min(72, Math.round((Number(hfState.frequency) || 30) * 1.4)));
        var maxTheta = turns * Math.PI * 2;
        var bSp = maxR / maxTheta;
        ctx.strokeStyle = '#111827';
        ctx.lineCap = 'round';
        var theta = 0.5;
        var prevX = cxSp + (bSp * theta) * Math.cos(theta);
        var prevY = cySp + (bSp * theta) * Math.sin(theta);
        while (theta < maxTheta) {
          var rNow = bSp * theta;
          var dTheta = Math.max(0.015, 2.2 / Math.max(8, rNow));
          theta += dTheta;
          var xNow = cxSp + rNow * Math.cos(theta);
          var yNow = cySp + rNow * Math.sin(theta);
          var sxSp = Math.min(sw - 1, Math.max(0, Math.floor((xNow / w) * sw)));
          var sySp = Math.min(sh - 1, Math.max(0, Math.floor((yNow / h) * sh)));
          var idxSp = (sySp * sw + sxSp) * 4;
          var lumSp = (0.299 * imgData[idxSp] + 0.587 * imgData[idxSp + 1] + 0.114 * imgData[idxSp + 2]) / 255;
          var darkness = Math.pow(1 - lumSp, 1.15);
          ctx.beginPath();
          ctx.moveTo(prevX, prevY);
          ctx.lineTo(xNow, yNow);
          ctx.lineWidth = 0.55 + darkness * (w / turns) * 0.72;
          ctx.stroke();
          prevX = xNow;
          prevY = yNow;
        }
        return;
      }

      // D. 2-Tone Vector Silhouette & Handwriting Engraving
      if (/^(image-to-silhouette-converter|handwriting-engraving)$/.test(toolSlug)) {
        var silImg = ctx.createImageData(w, h);
        var sd = silImg.data;
        var thresh = Math.max(40, Math.min(220, 255 - tol * 0.65));
        for (var ySil = 0; ySil < h; ySil++) {
          var sySil = Math.min(sh - 1, Math.floor((ySil / h) * sh));
          for (var xSil = 0; xSil < w; xSil++) {
            var sxSil = Math.min(sw - 1, Math.floor((xSil / w) * sw));
            var sIdxSil = (sySil * sw + sxSil) * 4;
            var lumSil = 0.299 * imgData[sIdxSil] + 0.587 * imgData[sIdxSil + 1] + 0.114 * imgData[sIdxSil + 2];
            var isInk = imgData[sIdxSil + 3] > 64 && lumSil < thresh;
            var dIdxSil = (ySil * w + xSil) * 4;
            var vSil = isInk ? 17 : 255;
            sd[dIdxSil] = vSil;
            sd[dIdxSil + 1] = vSil;
            sd[dIdxSil + 2] = vSil;
            sd[dIdxSil + 3] = 255;
          }
        }
        ctx.putImageData(silImg, 0, 0);
        return;
      }

      // E. Line-Art, Zentangle, Sketch & Ballpoint Pen Converters
      if (/^image-to-(zentangle|kids-drawing|abstract-line|ballpoint-pen-drawing|fine-line)-converter$/.test(toolSlug)) {
        var lineImg = ctx.createImageData(w, h);
        var ld = lineImg.data;
        var isPen = toolSlug.indexOf('ballpoint-pen') !== -1 && hfState.viewTab === 'preview';
        var inkR = isPen ? 24 : 17;
        var inkG = isPen ? 52 : 24;
        var inkB = isPen ? 138 : 39;
        for (var yLn = 0; yLn < h; yLn++) {
          var syLn = Math.min(sh - 1, Math.floor((yLn / h) * sh));
          var syNext = Math.min(sh - 1, syLn + 1);
          for (var xLn = 0; xLn < w; xLn++) {
            var sxLn = Math.min(sw - 1, Math.floor((xLn / w) * sw));
            var sxNext = Math.min(sw - 1, sxLn + 1);
            var i0 = (syLn * sw + sxLn) * 4;
            var iX = (syLn * sw + sxNext) * 4;
            var iY = (syNext * sw + sxLn) * 4;
            var l0 = 0.299 * imgData[i0] + 0.587 * imgData[i0 + 1] + 0.114 * imgData[i0 + 2];
            var lX = 0.299 * imgData[iX] + 0.587 * imgData[iX + 1] + 0.114 * imgData[iX + 2];
            var lY = 0.299 * imgData[iY] + 0.587 * imgData[iY + 1] + 0.114 * imgData[iY + 2];
            var grad = Math.min(255, Math.hypot(l0 - lX, l0 - lY) * 2.8);
            var dark = Math.max(0, 210 - l0);
            var strokeStrength = Math.min(1, Math.max(grad / 150, dark / 190));
            var dIdxLn = (yLn * w + xLn) * 4;
            ld[dIdxLn] = Math.round(255 - (255 - inkR) * strokeStrength);
            ld[dIdxLn + 1] = Math.round(255 - (255 - inkG) * strokeStrength);
            ld[dIdxLn + 2] = Math.round(255 - (255 - inkB) * strokeStrength);
            ld[dIdxLn + 3] = 255;
          }
        }
        ctx.putImageData(lineImg, 0, 0);
        return;
      }

      // F. Laser Prep Engraving Dither & Wood/Slate Preview
      if (toolSlug === 'laser-prep') {
        var lpImg = ctx.createImageData(w, h);
        var lpd = lpImg.data;
        var bayer4 = [
          [0, 8, 2, 10],
          [12, 4, 14, 6],
          [3, 11, 1, 9],
          [15, 7, 13, 5]
        ];
        var isWoodPreview = hfState.viewTab === 'preview';
        for (var yLp = 0; yLp < h; yLp++) {
          var syLp = Math.min(sh - 1, Math.floor((yLp / h) * sh));
          for (var xLp = 0; xLp < w; xLp++) {
            var sxLp = Math.min(sw - 1, Math.floor((xLp / w) * sw));
            var idxLp = (syLp * sw + sxLp) * 4;
            var lumLp = 0.299 * imgData[idxLp] + 0.587 * imgData[idxLp + 1] + 0.114 * imgData[idxLp + 2];
            var bVal = (bayer4[yLp & 3][xLp & 3] + 0.5) * 16;
            var burned = lumLp < bVal;
            var dIdxLp = (yLp * w + xLp) * 4;
            if (isWoodPreview) {
              lpd[dIdxLp] = burned ? 58 : 238;
              lpd[dIdxLp + 1] = burned ? 32 : 206;
              lpd[dIdxLp + 2] = burned ? 16 : 162;
            } else {
              var cVal = burned ? 17 : 255;
              lpd[dIdxLp] = cVal;
              lpd[dIdxLp + 1] = cVal;
              lpd[dIdxLp + 2] = cVal;
            }
            lpd[dIdxLp + 3] = 255;
          }
        }
        ctx.putImageData(lpImg, 0, 0);
        return;
      }
    }

    // 3. Preview / Export View Tabs: render high-definition Halftone dot pattern
    var lpi = Math.max(5, Math.min(60, Number(hfState.frequency) || 30));
    var cellSize = Math.max(5, Math.min(22, Math.round(180 / lpi)));
    var angleRad = ((Number(hfState.dotAngle) || 45) * Math.PI) / 180;
    var cosA = Math.cos(angleRad);
    var sinA = Math.sin(angleRad);

    var diag = Math.ceil(Math.sqrt(w * w + h * h));
    var halfDiag = diag / 2;
    var cx = w / 2;
    var cy = h / 2;

    if (hfState.dotShape === 'line') {
      for (var v = -halfDiag; v <= halfDiag; v += cellSize) {
        for (var u = -halfDiag; u <= halfDiag; u += 4) {
          var px = Math.round(cx + u * cosA - v * sinA);
          var py = Math.round(cy + u * sinA + v * cosA);
          if (px < 0 || px >= w || py < 0 || py >= h) continue;
          var sx = Math.min(sw - 1, Math.max(0, Math.floor((px / w) * sw)));
          var sy = Math.min(sh - 1, Math.max(0, Math.floor((py / h) * sh)));
          var idx = (sy * sw + sx) * 4;
          var rL = imgData[idx], gL = imgData[idx + 1], bL = imgData[idx + 2];
          var lum = (0.299 * rL + 0.587 * gL + 0.114 * bL) / 255;
          var distKo = Math.sqrt((rL - koRgb.r) * (rL - koRgb.r) + (gL - koRgb.g) * (gL - koRgb.g) + (bL - koRgb.b) * (bL - koRgb.b));
          var strength = hfState.knockout ? Math.min(1, Math.max(0, (distKo - tol * 0.4) / 220)) : (bgLum < 0.5 ? lum : 1 - lum);
          if (strength > 0.1) {
            ctx.fillStyle = hfState.viewTab === 'preview' ? ('rgb(' + rL + ',' + gL + ',' + bL + ')') : (bgLum < 0.5 ? '#FFFFFF' : '#111827');
            var lw = cellSize * 0.82 * strength;
            ctx.fillRect(px - lw / 2, py - lw / 2, 4, lw);
          }
        }
      }
    } else {
      for (var gy = -halfDiag; gy <= halfDiag; gy += cellSize) {
        for (var gx = -halfDiag; gx <= halfDiag; gx += cellSize) {
          var rx = cx + gx * cosA - gy * sinA;
          var ry = cy + gx * sinA + gy * cosA;
          if (rx < -cellSize || rx > w + cellSize || ry < -cellSize || ry > h + cellSize) continue;

          var srcX = Math.min(sw - 1, Math.max(0, Math.floor((rx / w) * sw)));
          var srcY = Math.min(sh - 1, Math.max(0, Math.floor((ry / h) * sh)));
          var pIdx = (srcY * sw + srcX) * 4;
          var r = imgData[pIdx];
          var g = imgData[pIdx + 1];
          var b = imgData[pIdx + 2];
          var a = imgData[pIdx + 3] / 255;
          if (a < 0.1) continue;

          var luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
          var distC = Math.sqrt((r - koRgb.r) * (r - koRgb.r) + (g - koRgb.g) * (g - koRgb.g) + (b - koRgb.b) * (b - koRgb.b));
          var intensity = hfState.knockout
            ? Math.min(1, Math.max(0, (distC - tol * 0.35) / 210))
            : (bgLum < 0.5 ? luminance : (1.0 - luminance));
          if (intensity <= 0.08) continue;

          // In Preview mode, tint dots with original artwork color; in Export mode, render high-contrast white/black screen dots
          ctx.fillStyle = hfState.viewTab === 'preview'
            ? ('rgb(' + r + ',' + g + ',' + b + ')')
            : (bgLum < 0.5 ? '#FFFFFF' : '#111827');

          var maxRadius = (hfState.dotShape === 'merge_dot' ? 0.68 : 0.52) * cellSize * intensity;

          if (hfState.dotShape === 'round' || hfState.dotShape === 'merge_dot') {
            ctx.beginPath();
            ctx.arc(rx, ry, maxRadius, 0, Math.PI * 2);
            ctx.fill();
          } else if (hfState.dotShape === 'ellipse') {
            ctx.save();
            ctx.translate(rx, ry);
            ctx.rotate(angleRad);
            ctx.beginPath();
            ctx.ellipse(0, 0, maxRadius * 1.25, maxRadius * 0.72, 0, 0, Math.PI * 2);
            ctx.fill();
            ctx.restore();
          } else if (hfState.dotShape === 'diamond') {
            ctx.save();
            ctx.translate(rx, ry);
            ctx.rotate(Math.PI / 4);
            var ds = maxRadius * 1.45;
            ctx.fillRect(-ds / 2, -ds / 2, ds, ds);
            ctx.restore();
          } else if (hfState.dotShape === 'square') {
            var ss = maxRadius * 1.6;
            ctx.fillRect(rx - ss / 2, ry - ss / 2, ss, ss);
          }
        }
      }
    }
  }

  function exportHalftoneSvgFile() {
    var outCanvas = document.getElementById('TgHfMainCanvas');
    if (!outCanvas) {
      exportAiVectorSvg();
      return;
    }
    var pngData = outCanvas.toDataURL('image/png');
    var wMm = hfState.printWidthMm || 87;
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="' + wMm + 'mm" height="' + wMm + 'mm" viewBox="0 0 520 520">' +
        '<!-- THOUGHTYGIFT HALFTONE LASER & PRINT EXPORT (' + esc(hfState.prompt || hfState.sampleId) + ' · ' + hfState.frequency + ' LPI) -->' +
        '<rect x="4" y="4" width="512" height="512" rx="12" fill="none" stroke="#cc3333" stroke-width="1.5"/>' +
        '<image href="' + pngData + '" x="10" y="10" width="500" height="500" preserveAspectRatio="xMidYMid meet"/>' +
      '</svg>';
    var blob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = 'thoughtygift-halftone-' + String(hfState.prompt || hfState.sampleId || 'design').replace(/[^a-z0-9]+/gi, '-').toLowerCase() + '.svg';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
  }

  function runNativeHalftoneAiGenerate() {
    if (hfState.isGenerating) return;
    var inp = document.getElementById('TgHfPromptInput');
    var promptVal = (inp && inp.value.trim()) ? inp.value.trim() : (hfState.prompt || 'cyberpunk skull & roses');
    hfState.prompt = promptVal;

    // Deduct 6 ThoughtyGift Studio Credits
    var nextBal = deductAiCredits(6);
    if (nextBal === null) {
      return { ok: false, reason: 'insufficient_credits', credits: getCreditBalance() };
    }

    hfState.isGenerating = true;
    hfState.genPct = 6;
    hfState.sourceMode = 'ai';
    hfState.aiGeneratedImg = null;
    hfState.aiGeneratedUrl = '';

    var stObj = HF_STYLES.find(function (s) { return s.id === hfState.style; }) || HF_STYLES[0];
    var activeSlug = String(hfState.activeToolSlug || activeSession.slug || 'halftone').toLowerCase();
    var reqMode = (activeSlug && activeSlug.indexOf('halftone') === -1) ? activeSlug : 'halftone';

    var genBtn = document.getElementById('TgHfGenerateBtn');
    if (genBtn) {
      genBtn.disabled = true;
      genBtn.style.cursor = 'progress';
      genBtn.style.background = '#171719';
      genBtn.innerHTML =
        '<span class="tg-atomm-btn-spinner" aria-hidden="true"></span>' +
        '<span>Generating...</span>' +
        '<img src="https://storage.atomm.com/xtool/aimake-static/static/icon/credits.svg" alt="" style="width:16px;height:16px;display:inline-block;"/>' +
        '<span>6</span>';
    }

    var stageGenOvr = document.getElementById('TgHfGeneratingOverlay');
    var stageGenTitle = document.getElementById('TgHfGenLoaderTitle');
    var stageGenFill = document.getElementById('TgHfGenLoaderFill');
    var stageGenPct = document.getElementById('TgHfGenLoaderPct');
    var topProcPill = document.getElementById('TgHfProcessingTopPill');
    var topProcTxt = document.getElementById('TgHfProcessingTopTxt');
    if (stageGenOvr) {
      stageGenOvr.style.display = 'flex';
      if (stageGenTitle) stageGenTitle.textContent = 'Generating "' + promptVal.slice(0, 22) + '" (' + stObj.name + ')...';
      if (stageGenFill) stageGenFill.style.width = '8%';
      if (stageGenPct) stageGenPct.textContent = '8%';
    }
    if (topProcPill) {
      topProcPill.style.display = 'inline-flex';
      if (topProcTxt) topProcTxt.textContent = 'Processing';
    }

    renderHalftoneCanvas();
    renderHfHistoryList();

    if (hfState._genTimer) clearInterval(hfState._genTimer);
    var genStartTime = performance.now();
    hfState._genTimer = setInterval(function () {
      if (!hfState.isGenerating) {
        clearInterval(hfState._genTimer);
        hfState._genTimer = null;
        return;
      }
      var elapsed = (performance.now() - genStartTime) / 1000;
      var expPct = Math.min(95, Math.round(95 * (1 - Math.exp(-elapsed / 4.2))));
      hfState.genPct = Math.max(hfState.genPct || 8, expPct);
      if (stageGenFill) stageGenFill.style.width = hfState.genPct + '%';
      if (stageGenPct) stageGenPct.textContent = hfState.genPct + '%';
      var pendPcts = document.querySelectorAll('.tg-hf-pending-pct');
      for (var p = 0; p < pendPcts.length; p++) pendPcts[p].textContent = hfState.genPct + '%';
    }, 180);

    callStorefrontAiGateway(
      {
        mode: reqMode,
        prompt: promptVal,
        style: hfState.style,
        aspect: hfState.aspect || '1:1',
        edit_url: hfState.refImgDataUrl || undefined
      },
      function (step) {
        if (hfState.isGenerating) {
          var stepPct = Math.min(95, Math.round((step / 10) * 100));
          hfState.genPct = Math.max(hfState.genPct || 8, stepPct);
          if (stageGenFill) stageGenFill.style.width = hfState.genPct + '%';
          if (stageGenPct) stageGenPct.textContent = hfState.genPct + '%';
        }
      }
    ).then(function (res) {
      hfState.isGenerating = false;
      if (hfState._genTimer) {
        clearInterval(hfState._genTimer);
        hfState._genTimer = null;
      }
      if (stageGenFill) stageGenFill.style.width = '100%';
      if (stageGenPct) stageGenPct.textContent = '100%';
      setTimeout(function () {
        if (stageGenOvr && !hfState.isGenerating) stageGenOvr.style.display = 'none';
        if (topProcPill && !hfState.isGenerating) topProcPill.style.display = 'none';
      }, 180);

      if (res && res.ok && res.imgElement) {
        hfState.aiGeneratedImg = res.imgElement;
        hfState.aiGeneratedUrl = res.imageUrl || '';
        hfState.sourceMode = 'ai';
        if (activeSlug.indexOf('halftone') === -1) {
          hfState.viewTab = 'preview';
          syncHfUiControls();
        }
      }
      hfState.history.unshift({
        id: 'h_' + Date.now(),
        prompt: promptVal,
        style: hfState.style,
        label: promptVal.slice(0, 18) + ' · ' + stObj.name,
        time: 'Just now',
        sampleId: '',
        aiImg: hfState.aiGeneratedImg,
        thumbUrl: hfState.aiGeneratedUrl
      });
      renderHalftoneCanvas();
      renderHfHistoryList();

      if (genBtn) {
        genBtn.disabled = false;
        genBtn.style.cursor = 'pointer';
        genBtn.style.background = '#171719';
        genBtn.innerHTML =
          '<span>Generate</span>' +
          '<img src="https://storage.atomm.com/xtool/aimake-static/static/icon/credits.svg" alt="" style="width:16px;height:16px;display:inline-block;"/>' +
          '<span>6</span>';
      }

      var outCanvas = document.getElementById('TgHfMainCanvas');
      var thumbData = outCanvas ? outCanvas.toDataURL('image/png') : null;
      saveCurrentStudioToDraft(false, thumbData, 'Halftone AI: ' + promptVal.slice(0, 20));
      showStudioAuthToast('AI Generated "' + promptVal + '" (' + stObj.name + ')! -6 Credits (' + nextBal + ' remaining)');
    });

    return { ok: true, prompt: promptVal, style: hfState.style, creditsRemaining: nextBal };
  }

  function renderHfHistoryList() {
    var html = '';
    if (hfState.isGenerating) {
      var curSt = HF_STYLES.find(function (s) { return s.id === hfState.style; }) || HF_STYLES[0];
      html +=
        '<div class="tghf-hist-pending" style="width:100%;border:1px solid #D1D5DB;border-radius:10px;background:#F6F6FA;padding:10px 12px;display:flex;align-items:center;gap:12px;">' +
          '<div style="width:42px;height:42px;border-radius:8px;background:#EBECEF;display:flex;align-items:center;justify-content:center;flex-shrink:0;">' +
            '<div class="tg-atomm-conic-loader" style="width:22px;height:22px;padding:3px;"></div>' +
          '</div>' +
          '<div style="min-width:0;flex:1;">' +
            '<div style="display:flex;align-items:center;justify-content:space-between;gap:6px;">' +
              '<span style="font-size:12px;font-weight:700;color:#171719;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">Generating "' + esc((hfState.prompt || '').slice(0, 16)) + '"</span>' +
              '<span class="tg-hf-pending-pct" style="font-size:11.5px;font-weight:700;color:#4E5969;flex-shrink:0;">' + (hfState.genPct || 8) + '%</span>' +
            '</div>' +
            '<div style="font-size:11px;color:#848B96;margin-top:2px;">' + esc(curSt.name) + ' · AI Processing...</div>' +
          '</div>' +
        '</div>';
    }
    if (!hfState.history.length && !hfState.isGenerating) {
      html = '<div style="font-size:12px;color:#9CA3AF;padding:4px 0;">No generated images yet</div>';
    } else if (hfState.history.length) {
      html += hfState.history.map(function (it, idx) {
        var stObj = HF_STYLES.find(function (s) { return s.id === it.style; }) || HF_STYLES[0];
        var imgUrl = it.thumbUrl || (stObj && stObj.thumb) || '';
        var thumbBox = imgUrl
          ? '<img src="' + esc(imgUrl) + '" alt="" style="width:42px;height:42px;border-radius:8px;object-fit:cover;flex-shrink:0;border:1px solid #E5E7EB;"/>'
          : '<div style="width:42px;height:42px;border-radius:8px;background:linear-gradient(135deg,' + stObj.bg1 + ',' + stObj.bg2 + ');color:#ffffff;font-weight:800;font-size:10px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">' + esc(stObj.tag) + '</div>';
        return (
          '<button type="button" class="tghf-hist-item" data-hf-hist="' + idx + '" style="width:100%;border:1px solid #E5E7EB;border-radius:10px;background:#ffffff;padding:8px 10px;display:flex;align-items:center;gap:10px;cursor:pointer;text-align:left;transition:all .15s;">' +
            thumbBox +
            '<div style="min-width:0;flex:1;">' +
              '<div style="font-size:12px;font-weight:700;color:#111827;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + esc(it.prompt) + '</div>' +
              '<div style="font-size:11px;color:#6B7280;margin-top:2px;">' + esc(stObj.name) + ' · ' + esc(it.time) + '</div>' +
            '</div>' +
          '</button>'
        );
      }).join('');
    }

    var targets = [
      document.getElementById('TgHfHistoryList'),
      document.getElementById('TgHfInlineHistoryList')
    ];
    for (var t = 0; t < targets.length; t++) {
      var listEl = targets[t];
      if (!listEl) continue;
      listEl.innerHTML = html;
      var btns = listEl.querySelectorAll('[data-hf-hist]');
      for (var i = 0; i < btns.length; i++) {
        btns[i].addEventListener('click', function () {
          var idx = parseInt(this.getAttribute('data-hf-hist'), 10);
          var item = hfState.history[idx];
          if (!item) return;
          hfState.prompt = item.prompt;
          hfState.style = item.style;
          hfState.sourceMode = item.sampleId ? 'sample' : 'ai';
          hfState.sampleId = item.sampleId || '';
          hfState.aiGeneratedImg = item.aiImg || null;
          hfState.aiGeneratedUrl = item.thumbUrl || '';
          var inp = document.getElementById('TgHfPromptInput');
          if (inp) inp.value = item.prompt;
          syncHfUiControls();
          if (item.sampleId) {
            var smp = HF_SAMPLES.find(function (s) { return s.id === item.sampleId; });
            if (smp) {
              loadHfSamplePresetImg(smp, function (loadedImg) {
                hfState.sampleImg = loadedImg;
                renderHalftoneCanvas();
              });
              return;
            }
          }
          renderHalftoneCanvas();
        });
      }
    }
  }

  function syncHfUiControls() {
    // Sync style cards
    var styleBtns = document.querySelectorAll('[data-hf-style]');
    for (var i = 0; i < styleBtns.length; i++) {
      var sid = styleBtns[i].getAttribute('data-hf-style');
      var isMore = styleBtns[i].getAttribute('data-hf-more') === '1';
      var active = sid === hfState.style;
      styleBtns[i].style.display = (isMore && !hfState.showMoreStyles) ? 'none' : 'flex';
      var frame = styleBtns[i].querySelector('.tghf-style-frame');
      if (frame) {
        frame.style.borderColor = active ? '#171719' : '#E5E7EB';
        frame.style.boxShadow = active ? '0 0 0 1.5px #171719' : 'none';
      }
      var lbl = styleBtns[i].querySelector('.tghf-style-lbl');
      if (lbl) {
        lbl.style.color = active ? '#111827' : '#4B5563';
        lbl.style.fontWeight = active ? '700' : '500';
      }
    }
    var moreBtn = document.getElementById('TgHfMoreStylesBtn');
    if (moreBtn) {
      moreBtn.innerHTML = hfState.showMoreStyles
        ? '<span>Less</span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m18 15-6-6-6 6"/></svg>'
        : '<span>More (6)</span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg>';
    }
    // Sync dot shape buttons (4-col Atomm layout)
    var shapeBtns = document.querySelectorAll('[data-hf-shape]');
    for (var j = 0; j < shapeBtns.length; j++) {
      var shId = shapeBtns[j].getAttribute('data-hf-shape');
      var isAct = shId === hfState.dotShape;
      var shFrame = shapeBtns[j].querySelector('.tghf-shape-frame');
      if (shFrame) {
        shFrame.style.borderColor = isAct ? '#171719' : '#E5E7EB';
        shFrame.style.boxShadow = isAct ? '0 0 0 1.5px #171719' : 'none';
        shFrame.style.background = isAct ? '#F3F4F6' : '#FFFFFF';
      }
      var shLbl = shapeBtns[j].querySelector('.tghf-shape-lbl');
      if (shLbl) {
        shLbl.style.fontWeight = isAct ? '700' : '500';
        shLbl.style.color = isAct ? '#111827' : '#4B5563';
      }
    }
    // Sync top center view tabs (Original | Preview | Export | Mask)
    var vTabs = document.querySelectorAll('[data-hf-viewtab]');
    for (var vt = 0; vt < vTabs.length; vt++) {
      var vId = vTabs[vt].getAttribute('data-hf-viewtab');
      var vAct = vId === hfState.viewTab;
      vTabs[vt].style.background = vAct ? '#FFFFFF' : 'transparent';
      vTabs[vt].style.color = vAct ? '#111827' : '#6B7280';
      vTabs[vt].style.fontWeight = vAct ? '600' : '500';
      vTabs[vt].style.boxShadow = vAct ? '0 1px 2px rgba(0,0,0,0.08)' : 'none';
    }
    // Sync Basic | Advanced right sidebar tabs
    var rTabBasic = document.getElementById('TgHfRightTabBasic');
    var rTabAdv = document.getElementById('TgHfRightTabAdv');
    if (rTabBasic && rTabAdv) {
      var isBasic = hfState.rightTab !== 'advanced';
      rTabBasic.style.background = isBasic ? '#FFFFFF' : 'transparent';
      rTabBasic.style.color = isBasic ? '#111827' : '#6B7280';
      rTabBasic.style.boxShadow = isBasic ? '0 1px 2px rgba(0,0,0,0.08)' : 'none';
      rTabAdv.style.background = !isBasic ? '#FFFFFF' : 'transparent';
      rTabAdv.style.color = !isBasic ? '#111827' : '#6B7280';
      rTabAdv.style.boxShadow = !isBasic ? '0 1px 2px rgba(0,0,0,0.08)' : 'none';
    }
    var advBlocks = document.querySelectorAll('.tghf-adv-only');
    for (var ab = 0; ab < advBlocks.length; ab++) {
      advBlocks[ab].style.display = hfState.rightTab === 'advanced' ? 'flex' : 'none';
    }
    // Sync Export DPI buttons (300 | 450 | 600)
    var dpiBtns = document.querySelectorAll('[data-hf-dpi]');
    for (var dp = 0; dp < dpiBtns.length; dp++) {
      var dpiVal = parseInt(dpiBtns[dp].getAttribute('data-hf-dpi'), 10);
      var dpiAct = dpiVal === hfState.exportDpi;
      dpiBtns[dp].style.background = dpiAct ? '#FFFFFF' : 'transparent';
      dpiBtns[dp].style.color = dpiAct ? '#111827' : '#6B7280';
      dpiBtns[dp].style.fontWeight = dpiAct ? '600' : '500';
      dpiBtns[dp].style.boxShadow = dpiAct ? '0 1px 2px rgba(0,0,0,0.08)' : 'none';
    }
    // Sync sample preset cards
    var smpBtns = document.querySelectorAll('[data-hf-sample]');
    for (var k = 0; k < smpBtns.length; k++) {
      var smpAct = hfState.sourceMode === 'sample' && smpBtns[k].getAttribute('data-hf-sample') === hfState.sampleId;
      smpBtns[k].style.borderColor = smpAct ? '#171719' : '#E5E7EB';
      smpBtns[k].style.boxShadow = smpAct ? '0 0 0 1.5px #171719' : '0 1px 2px rgba(0,0,0,0.05)';
    }
    var koSwitch = document.getElementById('TgHfKnockoutSwitch');
    if (koSwitch) {
      koSwitch.style.background = hfState.knockout ? '#111827' : '#D1D5DB';
      var thumb = koSwitch.querySelector('span');
      if (thumb) thumb.style.left = hfState.knockout ? '18px' : '2px';
    }
    var koHexTxt = document.getElementById('TgHfKnockoutHexTxt');
    var koSwatch = document.getElementById('TgHfKnockoutSwatch');
    if (koHexTxt) koHexTxt.textContent = String(hfState.knockoutColor || '#000000').toUpperCase();
    if (koSwatch) koSwatch.style.background = hfState.knockoutColor || '#000000';

    var bgHexTxt = document.getElementById('TgHfBgHexTxt');
    var bgSwatch = document.getElementById('TgHfBgSwatch');
    if (bgHexTxt) bgHexTxt.textContent = String(hfState.bgColor || '#000000').toUpperCase();
    if (bgSwatch) bgSwatch.style.background = hfState.bgColor || '#000000';

    var freqRange = document.getElementById('TgHfFreqRange');
    var freqInp = document.getElementById('TgHfFreqInput');
    if (freqRange) freqRange.value = String(hfState.frequency);
    if (freqInp) freqInp.value = String(hfState.frequency);

    var angRange = document.getElementById('TgHfAngleRange');
    var angInp = document.getElementById('TgHfAngleInput');
    if (angRange) angRange.value = String(hfState.dotAngle);
    if (angInp) angInp.value = String(hfState.dotAngle);

    var wInp = document.getElementById('TgHfWidthInp');
    if (wInp) wInp.value = String(hfState.printWidthMm);
  }

  function ensureNativeHalftoneStudioDom(slug) {
    var wrap = document.getElementById('Kc3dEngineWrap');
    if (!wrap) return;

    var curSlug = String(slug || activeSession.slug || '').toLowerCase();
    var isHalftoneOrImageAi = /^(halftone|custom-laser-engraved-halftone-photo-slate-wood-plaque|laser-prep|image-to-|background-remover|image-upscaler|magic-eraser|design-extraction|parse-image|style-match|ai-expand|ai-replace|ai-image-variations|font-generator|crochet-pattern-generator|handwriting-engraving|spiral-portrait|spiral-cut-portrait)/i.test(curSlug);
    if (isHalftoneOrImageAi && hfState.activeToolSlug !== curSlug) {
      hfState.activeToolSlug = curSlug;
      hfState.viewTab = curSlug.indexOf('halftone') !== -1 ? 'original' : 'preview';
    }

    if (!document.getElementById('TgStudioResponsiveStyles')) {
      var rStyle = document.createElement('style');
      rStyle.id = 'TgStudioResponsiveStyles';
      rStyle.textContent =
        '@keyframes tgAtommSpin{to{transform:rotate(1turn);}}' +
        '@keyframes tg3dCubeColorChange{0%{background:#6e757f;}33.33%{background:#b2b8c0;}66.67%{background:#d8dadf;}100%{background:#6e757f;}}' +
        '@keyframes tg3dCubeFloat{0%,100%{transform:rotateX(-25deg) rotateY(35deg) translateY(0);}50%{transform:rotateX(-22deg) rotateY(215deg) translateY(-2px);}}' +
        '.tg-atomm-conic-loader{width:30px;height:30px;padding:4px;aspect-ratio:1/1;border-radius:50%;background:#070B10;--_m:conic-gradient(#0000 10%,#000),linear-gradient(#000 0 0) content-box;-webkit-mask:var(--_m);mask:var(--_m);-webkit-mask-composite:source-out;mask-composite:subtract;animation:tgAtommSpin 1s infinite linear;box-sizing:border-box;flex-shrink:0;}' +
        '.tg-atomm-btn-spinner{width:14px;height:14px;border-radius:50%;border:2px solid currentColor;border-right-color:transparent;display:inline-block;animation:tgAtommSpin 0.8s linear infinite;flex-shrink:0;box-sizing:border-box;}' +
        '.tg-3d-preview-loading__cube{--cube-size:32px;width:32px;height:32px;margin-bottom:24px;display:flex;align-items:center;justify-content:center;}' +
        '.tg-3d-cube-wrapper{--cube-size:32px;width:var(--cube-size);height:var(--cube-size);perspective:600px;display:flex;align-items:center;justify-content:center;}' +
        '.tg-3d-cube{width:100%;height:100%;position:relative;transform-style:preserve-3d;transform:rotateX(-25deg) rotateY(35deg);animation:tg3dCubeFloat 4.8s ease-in-out infinite;}' +
        '.tg-3d-face{position:absolute;width:var(--cube-size);height:var(--cube-size);border-radius:1.5px;opacity:0.78;animation:tg3dCubeColorChange 1.5s infinite;}' +
        '.tg-3d-front{transform:translateZ(calc(var(--cube-size)/2));animation-delay:0s;}' +
        '.tg-3d-back{transform:rotateY(180deg) translateZ(calc(var(--cube-size)/2));animation-delay:0s;}' +
        '.tg-3d-right{transform:rotateY(90deg) translateZ(calc(var(--cube-size)/2));animation-delay:0.5s;}' +
        '.tg-3d-left{transform:rotateY(-90deg) translateZ(calc(var(--cube-size)/2));animation-delay:0.5s;}' +
        '.tg-3d-top{transform:rotateX(90deg) translateZ(calc(var(--cube-size)/2));animation-delay:1s;}' +
        '.tg-3d-bottom{transform:rotateX(-90deg) translateZ(calc(var(--cube-size)/2));animation-delay:1s;}' +
        '#TgHfMobileNav,#Tg3dMobileNav{display:none;}' +
        '@media(max-width:1280px){' +
          '#TgHfOnboardingCard{left:auto !important;right:12px !important;top:auto !important;bottom:56px !important;transform:none !important;width:220px !important;}' +
          '#TgHfOnboardingCard > div:first-child{display:none !important;}' +
        '}' +
        '@media(max-width:1024px){' +
          '#TgHalftoneStudioHost > div:nth-child(2){width:240px !important;}' +
          '#TgHalftoneStudioHost > div:nth-child(4){width:260px !important;}' +
          '#Tg3dLeftHistoryAside{width:140px !important;flex:0 0 140px !important;}' +
          '#Tg3dModRightInspector{width:260px !important;flex:0 0 260px !important;}' +
          '#TgHfMainCanvas{width:min(360px,50vh) !important;height:min(360px,50vh) !important;}' +
        '}' +
        '@media(max-width:768px){' +
          '.kc-header{height:auto !important;min-height:48px !important;flex-wrap:wrap !important;padding:6px 10px !important;gap:6px !important;}' +
          '#KcStudioProjectBar{order:3;width:100%;justify-content:space-between;padding-top:4px;border-top:1px solid #F3F4F6;}' +
          '#TgHalftoneStudioHost,#Tg3dModelStudioHost{flex-direction:column !important;padding-bottom:48px !important;}' +
          '#TgHfMobileNav,#Tg3dMobileNav{display:flex !important;position:fixed;left:0;right:0;bottom:0;height:48px;background:#FFFFFF;border-top:1px solid #E5E7EB;z-index:99;align-items:center;justify-content:space-around;padding:0 8px;box-shadow:0 -2px 10px rgba(0,0,0,0.06);}' +
          '#TgHfMobileNav button,#Tg3dMobileNav button{flex:1;height:36px;border:none;border-radius:8px;background:transparent;color:#6B7280;font-size:12px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:5px;}' +
          '#TgHfMobileNav button.is-active,#Tg3dMobileNav button.is-active{background:#171719;color:#FFFFFF;font-weight:700;}' +
          '#TgHalftoneStudioHost > div:nth-child(1){display:none !important;}' +
          '#TgHalftoneStudioHost[data-mob-pane="canvas"] > div:nth-child(2),#TgHalftoneStudioHost[data-mob-pane="canvas"] > div:nth-child(4){display:none !important;}' +
          '#TgHalftoneStudioHost[data-mob-pane="ai"] > div:nth-child(2){width:100% !important;flex:1 !important;display:flex !important;border-right:none !important;}' +
          '#TgHalftoneStudioHost[data-mob-pane="ai"] > div:nth-child(3),#TgHalftoneStudioHost[data-mob-pane="ai"] > div:nth-child(4){display:none !important;}' +
          '#TgHalftoneStudioHost[data-mob-pane="params"] > div:nth-child(4){width:100% !important;flex:1 !important;display:flex !important;border-left:none !important;}' +
          '#TgHalftoneStudioHost[data-mob-pane="params"] > div:nth-child(2),#TgHalftoneStudioHost[data-mob-pane="params"] > div:nth-child(3){display:none !important;}' +
          '#TgHalftoneStudioHost > div:nth-child(3){padding:8px 10px !important;}' +
          '#TgHfMainCanvas{width:min(82vw,42vh) !important;height:min(82vw,42vh) !important;}' +
          '#TgHfOnboardingCard{display:none !important;}' +
          '#Tg3dModelStudioHost[data-mob-pane="canvas"] #Tg3dLeftHistoryAside,#Tg3dModelStudioHost[data-mob-pane="canvas"] #Tg3dModRightInspector{display:none !important;}' +
          '#Tg3dModelStudioHost[data-mob-pane="models"] #Tg3dLeftHistoryAside{width:100% !important;flex:1 !important;display:flex !important;border-right:none !important;}' +
          '#Tg3dModelStudioHost[data-mob-pane="models"] main,#Tg3dModelStudioHost[data-mob-pane="models"] #Tg3dModRightInspector{display:none !important;}' +
          '#Tg3dModelStudioHost[data-mob-pane="params"] #Tg3dModRightInspector{width:100% !important;flex:1 !important;display:flex !important;border-left:none !important;}' +
          '#Tg3dModelStudioHost[data-mob-pane="params"] #Tg3dLeftHistoryAside,#Tg3dModelStudioHost[data-mob-pane="params"] main{display:none !important;}' +
          '#Tg3dModUploadModal > div{padding:12px 14px !important;max-height:84vh !important;overflow-y:auto !important;}' +
          '#Tg3dModUploadModal .tg-3d-params-photo,#Tg3dModUploadModal .tg-3d-params-modeling{flex-direction:column !important;align-items:stretch !important;width:100% !important;gap:10px !important;}' +
          '#Tg3dModRunBtn{width:100% !important;height:42px !important;justify-content:center !important;}' +
          '#Tg3dPreviewDisclaimer{bottom:54px !important;font-size:11px !important;}' +
          '.tgl-hero-wrap{padding:20px 16px 28px !important;}' +
          '.tgl-hero__img-wrap{width:100% !important;max-width:340px !important;height:240px !important;}' +
          '.tgl-hero__title,.tgl-a3d-title{font-size:24px !important;line-height:32px !important;}' +
          '.tgl-recent-sec,.tgl-sec{padding:24px 16px !important;}' +
        '}';
      document.head.appendChild(rStyle);
    }

    var host = document.getElementById('TgHalftoneStudioHost');
    if (!host) {
      host = document.createElement('div');
      host.id = 'TgHalftoneStudioHost';
      host.style.cssText = 'position:absolute;inset:0;z-index:60;background:#F3F4F6;display:none;font-family:Inter,sans-serif;color:#111827;overflow:hidden;';

      var styleCardsHtml = HF_STYLES.map(function (st) {
        var active = st.id === hfState.style;
        var isMore = st.more ? '1' : '0';
        var disp = (st.more && !hfState.showMoreStyles) ? 'none' : 'flex';
        return (
          '<button type="button" data-hf-style="' + st.id + '" data-hf-more="' + isMore + '" title="' + esc(st.name) + '" style="border:none;background:transparent;padding:0;cursor:pointer;display:' + disp + ';flex-direction:column;align-items:center;gap:5px;transition:all .15s;">' +
            '<span class="tghf-style-frame" style="width:100%;aspect-ratio:1/1;border-radius:10px;border:1.5px solid ' + (active ? '#171719' : '#E5E7EB') + ';' + (active ? 'box-shadow:0 0 0 1.5px #171719;' : '') + 'background:#ffffff;overflow:hidden;display:block;position:relative;">' +
              '<img src="' + esc(st.thumb) + '" alt="' + esc(st.name) + '" loading="lazy" draggable="false" style="width:100%;height:100%;object-fit:cover;display:block;"/>' +
            '</span>' +
            '<span class="tghf-style-lbl" style="font-size:11.5px;font-weight:' + (active ? '700' : '500') + ';color:' + (active ? '#111827' : '#4B5563') + ';text-align:center;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%;">' + esc(st.name) + '</span>' +
          '</button>'
        );
      }).join('');

      var dotShapesHtml = HF_DOT_SHAPES.map(function (sh) {
        var active = sh.id === hfState.dotShape;
        return (
          '<button type="button" data-hf-shape="' + sh.id + '" title="' + esc(sh.name) + '" style="border:none;background:transparent;padding:0;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:4px;">' +
            '<span class="tghf-shape-frame" style="width:100%;aspect-ratio:1/1;border-radius:10px;border:1.5px solid ' + (active ? '#171719' : '#E5E7EB') + ';' + (active ? 'box-shadow:0 0 0 1.5px #171719;' : '') + 'background:' + (active ? '#F3F4F6' : '#FFFFFF') + ';padding:5px;box-sizing:border-box;display:flex;align-items:center;justify-content:center;overflow:hidden;">' +
              '<img src="' + sh.thumb + '" alt="' + esc(sh.name) + '" draggable="false" style="width:100%;height:100%;object-fit:contain;display:block;"/>' +
            '</span>' +
            '<span class="tghf-shape-lbl" style="font-size:10.5px;font-weight:' + (active ? '700' : '500') + ';color:' + (active ? '#111827' : '#4B5563') + ';white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%;">' + esc(sh.name) + '</span>' +
          '</button>'
        );
      }).join('');

      var samplesHtml = HF_SAMPLES.map(function (smp) {
        return (
          '<button type="button" data-hf-sample="' + smp.id + '" title="' + esc(smp.name) + '" style="width:52px;height:52px;border:1.5px solid #E5E7EB;border-radius:10px;background:#ffffff;padding:2px;cursor:pointer;overflow:hidden;box-shadow:0 1px 2px rgba(0,0,0,0.05);transition:transform .15s;">' +
            '<img src="' + esc(smp.thumb) + '" alt="' + esc(smp.name) + '" draggable="false" style="width:100%;height:100%;object-fit:cover;border-radius:7px;display:block;"/>' +
          '</button>'
        );
      }).join('');

      var mockupsHtml = HF_MOCKUPS.map(function (mk) {
        return (
          '<div data-hf-mockup="' + mk.id + '" style="border:1.5px solid #E5E7EB;border-radius:12px;background:#ffffff;padding:10px;display:flex;flex-direction:column;gap:8px;cursor:pointer;transition:all .15s;">' +
            '<div style="width:100%;aspect-ratio:1/1;border-radius:8px;background:#F9FAFB;overflow:hidden;display:flex;align-items:center;justify-content:center;">' +
              '<img src="' + esc(mk.thumb) + '" alt="' + esc(mk.name) + '" style="width:100%;height:100%;object-fit:contain;display:block;"/>' +
            '</div>' +
            '<div style="display:flex;align-items:center;justify-content:space-between;gap:6px;">' +
              '<span style="font-size:12.5px;font-weight:700;color:#111827;">' + esc(mk.name) + '</span>' +
              '<span style="font-size:11px;font-weight:700;color:#FF7C23;background:#FFF7ED;padding:3px 8px;border-radius:6px;">' + esc(mk.cta) + '</span>' +
            '</div>' +
          '</div>'
        );
      }).join('');

      host.innerHTML =
        // 1. Far-left 54px Icon Rail (AI + Mockup — 1:1 with Atomm Halftone g-tool-rail)
        '<div style="width:54px;background:#ffffff;border-right:1px solid #E5E7EB;display:flex;flex-direction:column;align-items:center;padding:12px 4px;gap:10px;flex-shrink:0;z-index:5;">' +
          '<button type="button" id="TgHfRailAiBtn" style="width:44px;padding:8px 2px;border:none;border-radius:10px;background:#F3F4F6;color:#111827;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:4px;font-size:10px;font-weight:700;">' +
            '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3Z"/></svg>' +
            '<span>AI</span>' +
          '</button>' +
          '<button type="button" id="TgHfRailMockupBtn" style="width:44px;padding:8px 2px;border:none;border-radius:10px;background:transparent;color:#6B7280;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:4px;font-size:10px;font-weight:600;">' +
            '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/></svg>' +
            '<span>Mockup</span>' +
          '</button>' +
        '</div>' +

        // 2. Left AI Generate / Mockup Panel (300px — 3-col Style grid + More(6) + Generate + History)
        '<div style="width:300px;background:#ffffff;border-right:1px solid #E5E7EB;display:flex;flex-direction:column;flex-shrink:0;z-index:4;">' +
          '<div id="TgHfTabAiBody" style="display:flex;flex-direction:column;flex:1;min-height:0;padding:14px 16px;gap:14px;overflow-y:auto;">' +
            '<div style="display:flex;align-items:center;justify-content:space-between;">' +
              '<span style="font-size:14px;font-weight:700;color:#111827;">AI Generate</span>' +
            '</div>' +
            '<div style="background:#F3F4F6;border:1px solid #E5E7EB;border-radius:12px;padding:10px;display:flex;flex-direction:column;gap:8px;">' +
              '<div style="display:flex;align-items:center;gap:6px;">' +
                '<label title="Reference Images 0/4" style="width:36px;height:36px;border-radius:8px;border:1px dashed #D1D5DB;background:#ffffff;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;color:#6B7280;">' +
                  '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/></svg>' +
                  '<input type="file" id="TgHfRefFileInp" accept="image/*" style="display:none;"/>' +
                '</label>' +
              '</div>' +
              '<textarea id="TgHfPromptInput" rows="3" maxlength="150" placeholder="Describe the image you want to generate..." style="width:100%;border:none;background:transparent;resize:none;font-size:13px;color:#111827;outline:none;line-height:1.45;">' + esc(hfState.prompt) + '</textarea>' +
              '<div style="display:flex;align-items:center;justify-content:space-between;gap:6px;">' +
                '<div style="display:flex;align-items:center;gap:6px;">' +
                  '<button type="button" id="TgHfAspectBtn" style="height:26px;padding:0 8px;border-radius:6px;border:none;background:transparent;font-size:12px;font-weight:600;color:#374151;cursor:pointer;display:inline-flex;align-items:center;gap:5px;"><span style="width:11px;height:11px;border:1.5px solid currentColor;border-radius:2px;display:inline-block;"></span><span>1:1</span></button>' +
                  '<button type="button" id="TgHfBgToggleBtn" style="height:26px;padding:0 8px;border-radius:6px;border:none;background:transparent;font-size:12px;font-weight:600;color:#374151;cursor:pointer;display:inline-flex;align-items:center;gap:5px;"><span style="width:13px;height:13px;border-radius:3px;background:#000000;border:1px solid #D1D5DB;"></span><span>BG</span></button>' +
                '</div>' +
                '<span id="TgHfPromptCount" style="font-size:11px;color:#9CA3AF;">0/150</span>' +
              '</div>' +
            '</div>' +
            '<div>' +
              '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;">' +
                '<span style="font-size:12.5px;font-weight:600;color:#111827;">Style</span>' +
                '<button type="button" id="TgHfClearStyleBtn" style="border:none;background:transparent;font-size:12px;color:#9CA3AF;cursor:pointer;padding:0;">Clear</button>' +
              '</div>' +
              '<div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px 8px;">' + styleCardsHtml + '</div>' +
              '<button type="button" id="TgHfMoreStylesBtn" style="width:100%;margin-top:10px;border:none;background:transparent;color:#6B7280;font-size:12px;font-weight:500;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:4px;padding:4px 0;">' +
                '<span>More (6)</span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg>' +
              '</button>' +
            '</div>' +
            '<div>' +
              '<button type="button" id="TgHfGenerateBtn" style="width:100%;height:42px;border:none;border-radius:10px;background:#8C8C8C;color:#ffffff;font-size:14px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;transition:background .15s;">' +
                '<span>Generate</span>' +
                '<img src="https://storage.atomm.com/xtool/aimake-static/static/icon/credits.svg" alt="" style="width:16px;height:16px;display:inline-block;"/>' +
                '<span>6</span>' +
              '</button>' +
            '</div>' +
            '<div style="border-top:1px solid #F3F4F6;padding-top:12px;display:flex;flex-direction:column;gap:8px;">' +
              '<div style="font-size:13px;font-weight:600;color:#111827;">History</div>' +
              '<div id="TgHfInlineHistoryList" style="display:flex;flex-direction:column;gap:8px;"></div>' +
            '</div>' +
          '</div>' +
          '<div id="TgHfTabMockupBody" style="display:none;flex-direction:column;flex:1;min-height:0;padding:14px 16px;gap:12px;overflow-y:auto;">' +
            '<div style="font-size:14px;font-weight:700;color:#111827;">Mockup Preview</div>' +
            '<div style="display:flex;flex-direction:column;gap:10px;">' + mockupsHtml + '</div>' +
          '</div>' +
        '</div>' +

        // 3. Center Interactive Halftone Canvas Stage (1:1 with Atomm ?gid=... Workspace)
        '<div style="flex:1;min-width:0;position:relative;display:flex;flex-direction:column;align-items:center;justify-content:space-between;padding:14px 20px;overflow:hidden;background:#F3F4F6;">' +
          // 3A. Empty Upload State (shown only when user clicks Delete on Image card)
          '<div id="TgHfEmptyStageOverlay" style="display:none;position:absolute;inset:0;z-index:20;background:#F3F4F6;flex-direction:column;align-items:center;justify-content:center;gap:16px;">' +
            '<div style="width:260px;height:160px;background:#ffffff;border:1.5px dashed #D1D5DB;border-radius:16px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;box-shadow:0 4px 16px rgba(0,0,0,0.04);">' +
              '<div style="width:44px;height:44px;border-radius:10px;background:#F3F4F6;display:flex;align-items:center;justify-content:center;color:#6B7280;">' +
                '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect width="18" height="18" x="3" y="3" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/></svg>' +
              '</div>' +
              '<label style="height:36px;padding:0 18px;border-radius:8px;background:#171719;color:#ffffff;font-size:13px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:6px;">' +
                '<span>Choose An Image</span>' +
                '<input type="file" id="TgHfEmptyUploadInp" accept="image/*" style="display:none;"/>' +
              '</label>' +
            '</div>' +
            '<div style="font-size:12px;color:#6B7280;">Or try with these examples:</div>' +
            '<div style="display:flex;align-items:center;gap:10px;">' + samplesHtml + '</div>' +
          '</div>' +

          // 3B. Active Project Stage (Top Tabs: Original | Preview | Export | Mask + Tips + Blue Pill + Canvas + Onboarding Card + Bottom Zoom Bar)
          '<div id="TgHfActiveStageWrap" style="width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:space-between;position:relative;">' +
            // Top Bar: Centered 4-tab segmented control + Right Tips button
            '<div style="width:100%;display:flex;align-items:center;justify-content:center;position:relative;min-height:36px;z-index:10;">' +
              '<div style="display:inline-flex;align-items:center;background:#E5E7EB;padding:3px;border-radius:10px;gap:2px;">' +
                '<button type="button" data-hf-viewtab="original" style="height:30px;padding:0 16px;border:none;border-radius:8px;background:#FFFFFF;color:#111827;font-size:12.5px;font-weight:600;cursor:pointer;box-shadow:0 1px 2px rgba(0,0,0,0.08);">Original</button>' +
                '<button type="button" data-hf-viewtab="preview" style="height:30px;padding:0 16px;border:none;border-radius:8px;background:transparent;color:#6B7280;font-size:12.5px;font-weight:500;cursor:pointer;">Preview</button>' +
                '<button type="button" data-hf-viewtab="export" style="height:30px;padding:0 16px;border:none;border-radius:8px;background:transparent;color:#6B7280;font-size:12.5px;font-weight:500;cursor:pointer;">Export</button>' +
                '<button type="button" data-hf-viewtab="mask" style="height:30px;padding:0 16px;border:none;border-radius:8px;background:transparent;color:#6B7280;font-size:12.5px;font-weight:500;cursor:pointer;">Mask</button>' +
              '</div>' +
              '<button type="button" id="TgHfTipsTopBtn" style="position:absolute;right:0;top:2px;height:32px;padding:0 12px;border-radius:8px;border:1px solid #E5E7EB;background:#FFFFFF;color:#111827;font-size:12.5px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:5px;box-shadow:0 1px 2px rgba(0,0,0,0.04);">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>' +
                '<span>Tips</span>' +
              '</button>' +
            '</div>' +

            // Blue Instruction Pill below Top Tabs + Atomm Processing Top Pill
            '<div style="display:flex;align-items:center;gap:8px;margin-top:8px;z-index:11;">' +
              '<div id="TgHfKnockoutHintPill" style="background:rgba(59,130,246,0.12);color:#2563EB;padding:6px 14px;border-radius:8px;font-size:12.5px;font-weight:500;">Pick a color to define the knockout area.</div>' +
              '<div id="TgHfProcessingTopPill" style="display:none;align-items:center;gap:8px;background:#FFFFFF;color:#171719;padding:6px 14px;border-radius:999px;font-size:12px;font-weight:600;box-shadow:0 4px 14px rgba(0,0,0,0.08);">' +
                '<span class="tg-atomm-btn-spinner" style="border-color:#171719;border-right-color:transparent;"></span>' +
                '<span id="TgHfProcessingTopTxt">Processing</span>' +
              '</div>' +
            '</div>' +

            // Center Canvas + Blue Onboarding Popover Card + Atomm GenerateLoader Overlay
            '<div style="flex:1;display:flex;align-items:center;justify-content:center;position:relative;width:100%;min-height:0;padding:10px 0;">' +
              '<div style="position:relative;display:inline-flex;align-items:center;justify-content:center;">' +
                '<canvas id="TgHfMainCanvas" width="600" height="600" title="Click any pixel to pick Knockout Color" style="width:min(460px,58vh);height:min(460px,58vh);display:block;background:#000000;box-shadow:0 12px 32px rgba(0,0,0,0.12);cursor:crosshair;transition:transform .15s;"></canvas>' +

                // Atomm GenerateLoader Overlay Card on Canvas Stage during AI Generation
                '<div id="TgHfGeneratingOverlay" style="display:none;position:absolute;inset:0;z-index:25;background:rgba(17,24,39,0.38);backdrop-filter:blur(2px);align-items:center;justify-content:center;">' +
                  '<div style="background:#FFFFFF;border-radius:16px;padding:20px 26px;box-shadow:0 16px 40px rgba(0,0,0,0.22);display:flex;flex-direction:column;align-items:center;gap:10px;width:270px;text-align:center;">' +
                    '<div class="tg-atomm-conic-loader" style="width:30px;height:30px;"></div>' +
                    '<div id="TgHfGenLoaderTitle" style="font-size:13.5px;font-weight:600;color:#171719;line-height:1.4;">Generating AI design...</div>' +
                    '<div style="width:100%;display:flex;align-items:center;gap:8px;">' +
                      '<div style="flex:1;height:4px;border-radius:99px;background:#E5E7EB;overflow:hidden;">' +
                        '<div id="TgHfGenLoaderFill" style="width:12%;height:100%;background:#171719;border-radius:99px;transition:width .2s linear;"></div>' +
                      '</div>' +
                      '<span id="TgHfGenLoaderPct" style="font-size:11.5px;font-weight:700;color:#4E5969;min-width:30px;text-align:right;">12%</span>' +
                    '</div>' +
                    '<div style="font-size:11.5px;color:#848B96;line-height:1.4;">Usually takes 5–10 seconds, please wait...</div>' +
                  '</div>' +
                '</div>' +

                // Atomm Blue Onboarding Popover Card (1 / 3)
                '<div id="TgHfOnboardingCard" style="position:absolute;left:calc(100% + 14px);top:50%;transform:translateY(-50%);width:240px;background:#3B82F6;color:#FFFFFF;border-radius:12px;padding:14px 16px;box-shadow:0 12px 28px rgba(37,99,235,0.30);z-index:15;display:flex;flex-direction:column;gap:8px;">' +
                  '<div style="position:absolute;left:-6px;top:50%;transform:translateY(-50%) rotate(45deg);width:12px;height:12px;background:#3B82F6;"></div>' +
                  '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">' +
                    '<span id="TgHfGuideTitle" style="font-size:13px;font-weight:700;line-height:1.3;">Choose what gets knocked out</span>' +
                    '<button type="button" id="TgHfGuideSkipBtn" style="border:none;background:transparent;color:rgba(255,255,255,0.85);font-size:11.5px;cursor:pointer;padding:0;flex-shrink:0;">Skip</button>' +
                  '</div>' +
                  '<div id="TgHfGuideDesc" style="font-size:12px;color:rgba(255,255,255,0.92);line-height:1.45;">Choose which color becomes the cutout area. Pick a dominant color, then tune the range.</div>' +
                  '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:4px;">' +
                    '<span id="TgHfGuideStepTxt" style="font-size:11.5px;color:rgba(255,255,255,0.85);font-weight:500;">1 / 3</span>' +
                    '<button type="button" id="TgHfGuideNextBtn" style="width:26px;height:26px;border-radius:6px;border:none;background:#FFFFFF;color:#2563EB;cursor:pointer;display:flex;align-items:center;justify-content:center;font-weight:700;">' +
                      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="m9 18 6-6-6-6"/></svg>' +
                    '</button>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +

            // Bottom Floating Bar: Left Undo/Redo/Zoom + Center Sample Quick-Switch + Right Blue Action Button
            '<div style="width:100%;display:flex;align-items:center;justify-content:space-between;z-index:10;">' +
              '<div style="display:inline-flex;align-items:center;background:#FFFFFF;border:1px solid #E5E7EB;border-radius:10px;padding:3px;gap:2px;box-shadow:0 2px 6px rgba(0,0,0,0.04);">' +
                '<button type="button" id="TgHfUndoBtn" title="Undo" style="width:28px;height:28px;border:none;background:transparent;color:#9CA3AF;cursor:pointer;display:flex;align-items:center;justify-content:center;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 7v6h6"/><path d="M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13"/></svg></button>' +
                '<button type="button" id="TgHfRedoBtn" title="Redo" style="width:28px;height:28px;border:none;background:transparent;color:#9CA3AF;cursor:pointer;display:flex;align-items:center;justify-content:center;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 7v6h-6"/><path d="M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7"/></svg></button>' +
                '<div style="width:1px;height:16px;background:#E5E7EB;margin:0 2px;"></div>' +
                '<button type="button" id="TgHfZoomOutBtn" title="Zoom Out" style="width:28px;height:28px;border:none;background:transparent;color:#374151;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:15px;">−</button>' +
                '<span id="TgHfZoomLbl" style="font-size:12px;font-weight:600;color:#374151;min-width:42px;text-align:center;">100%</span>' +
                '<button type="button" id="TgHfZoomInBtn" title="Zoom In" style="width:28px;height:28px;border:none;background:transparent;color:#374151;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:15px;">+</button>' +
                '<div style="width:1px;height:16px;background:#E5E7EB;margin:0 2px;"></div>' +
                '<button type="button" id="TgHfZoomFitBtn" title="Fit to screen" style="width:28px;height:28px;border:none;background:transparent;color:#374151;cursor:pointer;display:flex;align-items:center;justify-content:center;"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M21 8V5a2 2 0 0 0-2-2h-3"/><path d="M3 16v3a2 2 0 0 0 2 2h3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/></svg></button>' +
              '</div>' +

              '<button type="button" id="TgHfQuickPreviewFab" title="Toggle Halftone Preview" style="width:36px;height:36px;border-radius:999px;border:none;background:#0EA5E9;color:#FFFFFF;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 14px rgba(14,165,233,0.35);">' +
                '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>' +

        // 4. Right Halftone Parameters Sidebar (320px — 1:1 with Atomm Basic | Advanced + Reset + Image, Color, Halftone Pattern, Size Settings + Footer)
        '<div style="width:320px;background:#F9FAFB;border-left:1px solid #E5E7EB;display:flex;flex-direction:column;flex-shrink:0;z-index:5;">' +
          // 4A. Top Bar: Basic | Advanced + Reset
          '<div style="padding:10px 14px;background:#FFFFFF;border-bottom:1px solid #E5E7EB;display:flex;align-items:center;justify-content:space-between;gap:8px;">' +
            '<div style="display:inline-flex;background:#F3F4F6;padding:3px;border-radius:8px;gap:2px;">' +
              '<button type="button" id="TgHfRightTabBasic" style="height:26px;padding:0 12px;border:none;border-radius:6px;background:#FFFFFF;color:#111827;font-size:12px;font-weight:600;cursor:pointer;box-shadow:0 1px 2px rgba(0,0,0,0.08);">Basic</button>' +
              '<button type="button" id="TgHfRightTabAdv" style="height:26px;padding:0 12px;border:none;border-radius:6px;background:transparent;color:#6B7280;font-size:12px;font-weight:500;cursor:pointer;">Advanced</button>' +
            '</div>' +
            '<button type="button" id="TgHfResetParamsBtn" style="height:26px;padding:0 8px;border:none;background:transparent;color:#6B7280;font-size:12px;font-weight:500;cursor:pointer;display:inline-flex;align-items:center;gap:4px;">' +
              '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>' +
              '<span>Reset</span>' +
            '</button>' +
          '</div>' +

          // 4B. Scrollable Cards Area
          '<div style="flex:1;overflow-y:auto;padding:12px;display:flex;flex-direction:column;gap:10px;">' +
            // Card 1: Image (56x56 thumb + Replace Image + Delete)
            '<div style="background:#FFFFFF;border:1px solid #E5E7EB;border-radius:12px;padding:12px;">' +
              '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px;">' +
                '<span style="font-size:13px;font-weight:700;color:#111827;">Image</span>' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2"><path d="m18 15-6-6-6 6"/></svg>' +
              '</div>' +
              '<div style="display:flex;align-items:center;gap:10px;">' +
                '<img id="TgHfSideImgThumb" src="https://www.atomm.com/creativetools/generator/halftone/assets/skull-thumb-CCg4vLyj.jpg" alt="Active Image" style="width:60px;height:60px;border-radius:8px;object-fit:cover;border:1px solid #E5E7EB;background:#000000;flex-shrink:0;"/>' +
                '<div style="flex:1;display:flex;flex-direction:column;gap:6px;">' +
                  '<label style="height:28px;border-radius:7px;background:#171719;color:#FFFFFF;font-size:12px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;">' +
                    '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect width="18" height="18" x="3" y="3" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/></svg>' +
                    '<span>Replace Image</span>' +
                    '<input type="file" id="TgHfMainUploadInp" accept="image/*" style="display:none;"/>' +
                  '</label>' +
                  '<button type="button" id="TgHfDeleteImgBtn" style="height:28px;border-radius:7px;border:1px solid #E5E7EB;background:#FFFFFF;color:#374151;font-size:12px;font-weight:500;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;">' +
                    '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg>' +
                    '<span>Delete</span>' +
                  '</button>' +
                '</div>' +
              '</div>' +
            '</div>' +

            // Card 2: Color (Knockout Color + Switch + Hex Box + Eyedropper + BG Color)
            '<div style="background:#FFFFFF;border:1px solid #E5E7EB;border-radius:12px;padding:12px;display:flex;flex-direction:column;gap:10px;">' +
              '<div style="display:flex;align-items:center;justify-content:space-between;">' +
                '<span style="font-size:13px;font-weight:700;color:#111827;">Color</span>' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2"><path d="m18 15-6-6-6 6"/></svg>' +
              '</div>' +
              '<div style="display:flex;align-items:center;justify-content:space-between;">' +
                '<span style="font-size:12px;font-weight:500;color:#374151;">Knockout Color</span>' +
                '<button type="button" id="TgHfKnockoutSwitch" style="position:relative;width:36px;height:20px;border-radius:999px;border:none;background:#111827;cursor:pointer;padding:0;"><span style="position:absolute;top:2px;left:18px;width:16px;height:16px;border-radius:999px;background:#ffffff;transition:left .15s;"></span></button>' +
              '</div>' +
              '<div style="display:flex;align-items:center;gap:6px;">' +
                '<label style="flex:1;height:32px;background:#F3F4F6;border:1px solid #E5E7EB;border-radius:8px;padding:0 10px;display:flex;align-items:center;gap:8px;cursor:pointer;position:relative;">' +
                  '<span id="TgHfKnockoutSwatch" style="width:16px;height:16px;border-radius:4px;background:#000000;border:1px solid rgba(0,0,0,0.15);flex-shrink:0;"></span>' +
                  '<span id="TgHfKnockoutHexTxt" style="font-size:12px;font-weight:600;color:#111827;">#000000</span>' +
                  '<input type="color" id="TgHfKnockoutColorInp" value="#000000" style="position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%;"/>' +
                '</label>' +
                '<button type="button" id="TgHfKoEyedropBtn" title="Pick color from canvas" style="width:32px;height:32px;border-radius:8px;border:1px solid #E5E7EB;background:#F3F4F6;color:#374151;cursor:pointer;display:flex;align-items:center;justify-content:center;">' +
                  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m2 22 1-1h3l9-9"/><path d="M3 21v-3l9-9"/><path d="m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z"/></svg>' +
                '</button>' +
              '</div>' +
              '<div class="tghf-adv-only" style="display:none;flex-direction:column;gap:4px;">' +
                '<div style="display:flex;justify-content:space-between;align-items:center;font-size:12px;color:#374151;"><span>Knockout Tolerance</span><div style="display:inline-flex;align-items:center;background:#F3F4F6;border-radius:6px;padding:2px 8px;font-size:11.5px;font-weight:600;"><span id="TgHfKoTolVal">25</span><span style="color:#9CA3AF;margin-left:4px;">%</span></div></div>' +
                '<input type="range" id="TgHfKoTolRange" min="1" max="100" value="25" style="width:100%;accent-color:#111827;cursor:pointer;"/>' +
              '</div>' +
              '<div style="font-size:12px;font-weight:500;color:#374151;margin-top:2px;">BG Color</div>' +
              '<div style="display:flex;align-items:center;gap:6px;">' +
                '<label style="flex:1;height:32px;background:#F3F4F6;border:1px solid #E5E7EB;border-radius:8px;padding:0 10px;display:flex;align-items:center;gap:8px;cursor:pointer;position:relative;">' +
                  '<span id="TgHfBgSwatch" style="width:16px;height:16px;border-radius:4px;background:#000000;border:1px solid rgba(0,0,0,0.15);flex-shrink:0;"></span>' +
                  '<span id="TgHfBgHexTxt" style="font-size:12px;font-weight:600;color:#111827;">#000000</span>' +
                  '<input type="color" id="TgHfBgColorInp" value="#000000" style="position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%;"/>' +
                '</label>' +
                '<button type="button" id="TgHfBgEyedropBtn" title="Pick BG color" style="width:32px;height:32px;border-radius:8px;border:1px solid #E5E7EB;background:#F3F4F6;color:#374151;cursor:pointer;display:flex;align-items:center;justify-content:center;">' +
                  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m2 22 1-1h3l9-9"/><path d="M3 21v-3l9-9"/><path d="m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>' +

            // Card 3: Halftone Pattern (4-col Dot Shape Grid + Frequency 30 LPI + Dot Angle 45°)
            '<div style="background:#FFFFFF;border:1px solid #E5E7EB;border-radius:12px;padding:12px;display:flex;flex-direction:column;gap:10px;">' +
              '<div style="display:flex;align-items:center;justify-content:space-between;">' +
                '<span style="font-size:13px;font-weight:700;color:#111827;">Halftone Pattern</span>' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2"><path d="m18 15-6-6-6 6"/></svg>' +
              '</div>' +
              '<div style="font-size:12px;font-weight:500;color:#374151;">Dot Shape</div>' +
              '<div style="display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px 6px;">' + dotShapesHtml + '</div>' +
              '<div style="margin-top:4px;">' +
                '<div style="display:flex;justify-content:space-between;align-items:center;font-size:12px;color:#374151;margin-bottom:4px;">' +
                  '<span>Frequency (LPI)</span>' +
                  '<div style="display:inline-flex;align-items:center;background:#F3F4F6;border:1px solid #E5E7EB;border-radius:6px;padding:0 6px;height:26px;">' +
                    '<input type="number" id="TgHfFreqInput" min="5" max="60" value="30" style="width:36px;border:none;background:transparent;text-align:center;font-size:12px;font-weight:600;color:#111827;outline:none;"/>' +
                    '<span style="font-size:11px;color:#9CA3AF;">LPI</span>' +
                  '</div>' +
                '</div>' +
                '<input type="range" id="TgHfFreqRange" min="5" max="60" value="30" style="width:100%;accent-color:#111827;cursor:pointer;"/>' +
              '</div>' +
              '<div>' +
                '<div style="display:flex;justify-content:space-between;align-items:center;font-size:12px;color:#374151;margin-bottom:4px;">' +
                  '<span>Dot Angle</span>' +
                  '<div style="display:inline-flex;align-items:center;background:#F3F4F6;border:1px solid #E5E7EB;border-radius:6px;padding:0 6px;height:26px;">' +
                    '<input type="number" id="TgHfAngleInput" min="-180" max="180" value="45" style="width:36px;border:none;background:transparent;text-align:center;font-size:12px;font-weight:600;color:#111827;outline:none;"/>' +
                    '<span style="font-size:11px;color:#9CA3AF;">°</span>' +
                  '</div>' +
                '</div>' +
                '<input type="range" id="TgHfAngleRange" min="-180" max="180" value="45" style="width:100%;accent-color:#111827;cursor:pointer;"/>' +
              '</div>' +
            '</div>' +

            // Card 4: Size Settings (Print Width 87 mm + Export DPI 300 | 450 | 600)
            '<div style="background:#FFFFFF;border:1px solid #E5E7EB;border-radius:12px;padding:12px;display:flex;flex-direction:column;gap:10px;">' +
              '<div style="display:flex;align-items:center;justify-content:space-between;">' +
                '<span style="font-size:13px;font-weight:700;color:#111827;">Size Settings</span>' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2"><path d="m18 15-6-6-6 6"/></svg>' +
              '</div>' +
              '<div>' +
                '<div style="display:flex;align-items:center;justify-content:space-between;">' +
                  '<span style="font-size:12px;font-weight:500;color:#374151;">Print Width</span>' +
                  '<div style="display:inline-flex;align-items:center;background:#F3F4F6;border:1px solid #E5E7EB;border-radius:6px;padding:0 8px;height:28px;">' +
                    '<input type="number" id="TgHfWidthInp" min="20" max="1200" value="87" style="width:46px;border:none;background:transparent;text-align:center;font-size:12px;font-weight:600;color:#111827;outline:none;"/>' +
                    '<span style="font-size:11px;color:#9CA3AF;">mm</span>' +
                  '</div>' +
                '</div>' +
                '<div style="font-size:11px;color:#9CA3AF;margin-top:4px;">Height auto adapts to the image ratio.</div>' +
              '</div>' +
              '<div class="tghf-adv-only" style="display:none;align-items:center;justify-content:space-between;">' +
                '<span style="font-size:12px;font-weight:500;color:#374151;">Product Width</span>' +
                '<div style="display:inline-flex;align-items:center;background:#F3F4F6;border:1px solid #E5E7EB;border-radius:6px;padding:0 8px;height:28px;">' +
                  '<input type="number" value="560" style="width:46px;border:none;background:transparent;text-align:center;font-size:12px;font-weight:600;color:#111827;outline:none;"/>' +
                  '<span style="font-size:11px;color:#9CA3AF;">mm</span>' +
                '</div>' +
              '</div>' +
              '<div>' +
                '<div style="font-size:12px;font-weight:500;color:#374151;margin-bottom:6px;">Export DPI</div>' +
                '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:4px;background:#F3F4F6;padding:3px;border-radius:8px;">' +
                  '<button type="button" data-hf-dpi="300" style="height:26px;border:none;border-radius:6px;background:#FFFFFF;color:#111827;font-size:12px;font-weight:600;cursor:pointer;box-shadow:0 1px 2px rgba(0,0,0,0.08);">300</button>' +
                  '<button type="button" data-hf-dpi="450" style="height:26px;border:none;border-radius:6px;background:transparent;color:#6B7280;font-size:12px;font-weight:500;cursor:pointer;">450</button>' +
                  '<button type="button" data-hf-dpi="600" style="height:26px;border:none;border-radius:6px;background:transparent;color:#6B7280;font-size:12px;font-weight:500;cursor:pointer;">600</button>' +
                '</div>' +
              '</div>' +
            '</div>' +

            // Card 5 (Advanced Only): Pre-Processing
            '<div class="tghf-adv-only" style="display:none;background:#FFFFFF;border:1px solid #E5E7EB;border-radius:12px;padding:12px;flex-direction:column;gap:10px;">' +
              '<div style="display:flex;align-items:center;justify-content:space-between;">' +
                '<span style="font-size:13px;font-weight:700;color:#111827;">Pre-Processing</span>' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2"><path d="m18 15-6-6-6 6"/></svg>' +
              '</div>' +
              '<div style="display:flex;justify-content:space-between;font-size:12px;color:#374151;"><span>Blur</span><span style="background:#F3F4F6;padding:2px 8px;border-radius:6px;font-weight:600;">0 px</span></div>' +
              '<div style="display:flex;justify-content:space-between;font-size:12px;color:#374151;"><span>Gamma</span><span style="background:#F3F4F6;padding:2px 8px;border-radius:6px;font-weight:600;">1</span></div>' +
              '<div style="display:flex;justify-content:space-between;font-size:12px;color:#374151;"><span>Min Dot Size</span><span style="background:#F3F4F6;padding:2px 8px;border-radius:6px;font-weight:600;">0.2 mm</span></div>' +
              '<div style="display:flex;justify-content:space-between;font-size:12px;color:#374151;"><span>Shadow Cleanup</span><span style="background:#F3F4F6;padding:2px 8px;border-radius:6px;font-weight:600;">0.2 mm</span></div>' +
            '</div>' +
          '</div>' +

          // 4C. Bottom Fixed Footer inside Right Sidebar (Buy Materials + Export 6)
          '<div style="padding:12px 14px;background:#FFFFFF;border-top:1px solid #E5E7EB;display:flex;flex-direction:column;gap:8px;">' +
            '<button type="button" id="TgHfBuyMaterialsBtn" style="width:100%;height:38px;border:none;border-radius:8px;background:#FF7C23;color:#FFFFFF;font-size:13.5px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;">' +
              '<svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M2.177 2.666H1.333V1.333h.844a2 2 0 0 1 1.98 1.717l.135.95H14a.667.667 0 0 1 .632.877l-1.03 3.088a2 2 0 0 1-1.897 1.368H5.054l.109.761a.667.667 0 0 0 .66.572H14v1.333H5.823a2 2 0 0 1-1.98-1.717L2.837 3.239a.667.667 0 0 0-.66-.573Z" fill="white"/></svg>' +
              '<span>Buy Materials</span>' +
            '</button>' +
            '<button type="button" id="TgHfExportBottomBtn" style="width:100%;height:38px;border:none;border-radius:8px;background:#171719;color:#FFFFFF;font-size:13.5px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;">' +
              '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" x2="12" y1="3" y2="15"/></svg>' +
              '<span>Export</span>' +
              '<img src="https://storage.atomm.com/xtool/aimake-static/static/icon/credits.svg" alt="" style="width:15px;height:15px;display:inline-block;"/>' +
              '<span>6</span>' +
            '</button>' +
          '</div>' +
        '</div>' +
        '<div id="TgHfMobileNav">' +
          '<button type="button" data-hf-mob="ai"><span>AI Generate</span></button>' +
          '<button type="button" data-hf-mob="canvas" class="is-active"><span>Canvas</span></button>' +
          '<button type="button" data-hf-mob="params"><span>Settings & Export</span></button>' +
        '</div>';

      host.setAttribute('data-mob-pane', 'canvas');
      wrap.appendChild(host);

      var hfMobBtns = host.querySelectorAll('[data-hf-mob]');
      for (var mbi = 0; mbi < hfMobBtns.length; mbi++) {
        hfMobBtns[mbi].addEventListener('click', function () {
          var pane = this.getAttribute('data-hf-mob') || 'canvas';
          host.setAttribute('data-mob-pane', pane);
          for (var k = 0; k < hfMobBtns.length; k++) {
            hfMobBtns[k].classList.toggle('is-active', hfMobBtns[k].getAttribute('data-hf-mob') === pane);
          }
          if (pane === 'canvas') renderHalftoneCanvas();
        });
      }

      // Wire events inside #TgHalftoneStudioHost
      function switchLeftRailTab(tab) {
        document.getElementById('TgHfTabAiBody').style.display = tab === 'ai' ? 'flex' : 'none';
        document.getElementById('TgHfTabMockupBody').style.display = tab === 'mockup' ? 'flex' : 'none';
        document.getElementById('TgHfRailAiBtn').style.background = tab === 'ai' ? '#F3F4F6' : 'transparent';
        document.getElementById('TgHfRailMockupBtn').style.background = tab === 'mockup' ? '#F3F4F6' : 'transparent';
        if (tab === 'ai') renderHfHistoryList();
      }
      document.getElementById('TgHfRailAiBtn').addEventListener('click', function () { switchLeftRailTab('ai'); });
      document.getElementById('TgHfRailMockupBtn').addEventListener('click', function () { switchLeftRailTab('mockup'); });

      var promptArea = document.getElementById('TgHfPromptInput');
      var promptCnt = document.getElementById('TgHfPromptCount');
      var genBtnEl = document.getElementById('TgHfGenerateBtn');
      if (promptArea) {
        promptArea.addEventListener('input', function () {
          var len = this.value.length;
          if (promptCnt) promptCnt.textContent = len + '/150';
          if (genBtnEl) genBtnEl.style.background = this.value.trim().length > 0 ? '#171719' : '#8C8C8C';
        });
      }

      var moreBtnEl = document.getElementById('TgHfMoreStylesBtn');
      if (moreBtnEl) {
        moreBtnEl.addEventListener('click', function () {
          hfState.showMoreStyles = !hfState.showMoreStyles;
          syncHfUiControls();
        });
      }

      var clrStyleBtn = document.getElementById('TgHfClearStyleBtn');
      if (clrStyleBtn) {
        clrStyleBtn.addEventListener('click', function () {
          hfState.style = 'bold_street';
          syncHfUiControls();
        });
      }

      var styleBtns = host.querySelectorAll('[data-hf-style]');
      for (var s = 0; s < styleBtns.length; s++) {
        styleBtns[s].addEventListener('click', function () {
          hfState.style = this.getAttribute('data-hf-style');
          syncHfUiControls();
          renderHalftoneCanvas();
        });
      }

      var shapeBtns = host.querySelectorAll('[data-hf-shape]');
      for (var d = 0; d < shapeBtns.length; d++) {
        shapeBtns[d].addEventListener('click', function () {
          hfState.dotShape = this.getAttribute('data-hf-shape');
          if (hfState.viewTab === 'original' && hfState.dotShape !== 'none') {
            hfState.viewTab = 'preview';
          }
          syncHfUiControls();
          renderHalftoneCanvas();
        });
      }

      // Top View Tabs (Original | Preview | Export | Mask)
      var viewTabBtns = host.querySelectorAll('[data-hf-viewtab]');
      for (var vtIdx = 0; vtIdx < viewTabBtns.length; vtIdx++) {
        viewTabBtns[vtIdx].addEventListener('click', function () {
          hfState.viewTab = this.getAttribute('data-hf-viewtab') || 'original';
          syncHfUiControls();
          renderHalftoneCanvas();
        });
      }

      // Right Sidebar Basic | Advanced + Reset
      document.getElementById('TgHfRightTabBasic').addEventListener('click', function () {
        hfState.rightTab = 'basic';
        syncHfUiControls();
      });
      document.getElementById('TgHfRightTabAdv').addEventListener('click', function () {
        hfState.rightTab = 'advanced';
        syncHfUiControls();
      });
      document.getElementById('TgHfResetParamsBtn').addEventListener('click', function () {
        hfState.knockout = true;
        hfState.knockoutColor = '#000000';
        hfState.bgColor = '#000000';
        hfState.dotShape = 'merge_dot';
        hfState.frequency = 30;
        hfState.dotAngle = 45;
        hfState.printWidthMm = 87;
        hfState.exportDpi = 300;
        syncHfUiControls();
        renderHalftoneCanvas();
      });

      // Delete Image -> show Empty "Choose An Image" state with 4 sample presets
      document.getElementById('TgHfDeleteImgBtn').addEventListener('click', function () {
        hfState.sourceMode = 'empty';
        renderHalftoneCanvas();
      });

      // Onboarding Popover Card (Skip & Next 1/3 -> 2/3 -> 3/3)
      var guideSteps = [
        { title: 'Choose what gets knocked out', desc: 'Choose which color becomes the cutout area. Pick a dominant color, then tune the range.' },
        { title: 'Customize Halftone Pattern', desc: 'Select your preferred Dot Shape, Frequency (LPI), and Dot Angle for screen printing or DTF.' },
        { title: 'Preview & Export High-DPI', desc: 'Switch between Original, Preview, Export, and Mask views, then export at 300–600 DPI.' }
      ];
      var guideCard = document.getElementById('TgHfOnboardingCard');
      document.getElementById('TgHfGuideSkipBtn').addEventListener('click', function () {
        if (guideCard) guideCard.style.display = 'none';
      });
      document.getElementById('TgHfGuideNextBtn').addEventListener('click', function () {
        if (hfState.guideStep < 3) {
          hfState.guideStep += 1;
          var stp = guideSteps[hfState.guideStep - 1];
          document.getElementById('TgHfGuideTitle').textContent = stp.title;
          document.getElementById('TgHfGuideDesc').textContent = stp.desc;
          document.getElementById('TgHfGuideStepTxt').textContent = hfState.guideStep + ' / 3';
        } else {
          if (guideCard) guideCard.style.display = 'none';
        }
      });
      document.getElementById('TgHfTipsTopBtn').addEventListener('click', function () {
        if (guideCard) {
          hfState.guideStep = 1;
          document.getElementById('TgHfGuideTitle').textContent = guideSteps[0].title;
          document.getElementById('TgHfGuideDesc').textContent = guideSteps[0].desc;
          document.getElementById('TgHfGuideStepTxt').textContent = '1 / 3';
          guideCard.style.display = 'flex';
        }
      });

      // Canvas Eyedropper Click (Pick Knockout Color directly from canvas)
      var mainCvs = document.getElementById('TgHfMainCanvas');
      if (mainCvs) {
        mainCvs.addEventListener('click', function (ev) {
          var rect = mainCvs.getBoundingClientRect();
          var cx = Math.floor(((ev.clientX - rect.left) / rect.width) * mainCvs.width);
          var cy = Math.floor(((ev.clientY - rect.top) / rect.height) * mainCvs.height);
          try {
            var p = mainCvs.getContext('2d').getImageData(cx, cy, 1, 1).data;
            var hex = '#' + [p[0], p[1], p[2]].map(function (x) { return ('0' + x.toString(16)).slice(-2); }).join('').toUpperCase();
            hfState.knockoutColor = hex;
            syncHfUiControls();
            renderHalftoneCanvas();
          } catch (e) {}
        });
      }

      // Zoom Controls
      function applyCanvasZoom() {
        var lbl = document.getElementById('TgHfZoomLbl');
        if (lbl) lbl.textContent = hfState.zoomPct + '%';
        if (mainCvs) mainCvs.style.transform = 'scale(' + (hfState.zoomPct / 100) + ')';
      }
      document.getElementById('TgHfZoomOutBtn').addEventListener('click', function () {
        hfState.zoomPct = Math.max(50, hfState.zoomPct - 10);
        applyCanvasZoom();
      });
      document.getElementById('TgHfZoomInBtn').addEventListener('click', function () {
        hfState.zoomPct = Math.min(160, hfState.zoomPct + 10);
        applyCanvasZoom();
      });
      document.getElementById('TgHfZoomFitBtn').addEventListener('click', function () {
        hfState.zoomPct = 100;
        applyCanvasZoom();
      });
      document.getElementById('TgHfQuickPreviewFab').addEventListener('click', function () {
        hfState.viewTab = hfState.viewTab === 'original' ? 'preview' : 'original';
        syncHfUiControls();
        renderHalftoneCanvas();
      });

      // Export DPI buttons
      var dpiBtns = host.querySelectorAll('[data-hf-dpi]');
      for (var dpIdx = 0; dpIdx < dpiBtns.length; dpIdx++) {
        dpiBtns[dpIdx].addEventListener('click', function () {
          hfState.exportDpi = parseInt(this.getAttribute('data-hf-dpi'), 10) || 300;
          syncHfUiControls();
        });
      }

      // Sample Preset Buttons
      var sampleBtns = host.querySelectorAll('[data-hf-sample]');
      for (var smpIdx = 0; smpIdx < sampleBtns.length; smpIdx++) {
        sampleBtns[smpIdx].addEventListener('click', function () {
          var sid = this.getAttribute('data-hf-sample');
          var found = HF_SAMPLES.find(function (x) { return x.id === sid; });
          if (found) {
            hfState.sourceMode = 'sample';
            hfState.sampleId = found.id;
            hfState.style = found.style;
            syncHfUiControls();
            loadHfSamplePresetImg(found, function (loadedImg) {
              hfState.sampleImg = loadedImg;
              renderHalftoneCanvas();
            });
          }
        });
      }

      var mockupCards = host.querySelectorAll('[data-hf-mockup]');
      for (var mkIdx = 0; mkIdx < mockupCards.length; mkIdx++) {
        mockupCards[mkIdx].addEventListener('click', function () {
          if (typeof window.openSuppliesKitDrawer === 'function') window.openSuppliesKitDrawer();
        });
      }

      document.getElementById('TgHfGenerateBtn').addEventListener('click', function () {
        runNativeHalftoneAiGenerate();
      });

      function handleImageUpload(file) {
        if (!file) return;
        var reader = new FileReader();
        reader.onload = function (ev) {
          var img = new Image();
          img.onload = function () {
            hfState.uploadedImg = img;
            hfState.uploadedThumbUrl = ev.target.result;
            hfState.sourceMode = 'upload';
            hfState.prompt = file.name.replace(/\.[^.]+$/, '');
            renderHalftoneCanvas();
          };
          img.src = ev.target.result;
        };
        reader.readAsDataURL(file);
      }

      document.getElementById('TgHfMainUploadInp').addEventListener('change', function () {
        if (this.files && this.files[0]) handleImageUpload(this.files[0]);
      });
      document.getElementById('TgHfEmptyUploadInp').addEventListener('change', function () {
        if (this.files && this.files[0]) handleImageUpload(this.files[0]);
      });
      document.getElementById('TgHfRefFileInp').addEventListener('change', function () {
        if (this.files && this.files[0]) handleImageUpload(this.files[0]);
      });

      document.getElementById('TgHfKnockoutSwitch').addEventListener('click', function () {
        hfState.knockout = !hfState.knockout;
        syncHfUiControls();
        renderHalftoneCanvas();
      });
      document.getElementById('TgHfKnockoutColorInp').addEventListener('input', function () {
        hfState.knockoutColor = this.value;
        syncHfUiControls();
        renderHalftoneCanvas();
      });
      document.getElementById('TgHfBgColorInp').addEventListener('input', function () {
        hfState.bgColor = this.value;
        syncHfUiControls();
        renderHalftoneCanvas();
      });
      var koTolRange = document.getElementById('TgHfKoTolRange');
      if (koTolRange) {
        koTolRange.addEventListener('input', function () {
          hfState.knockoutTolerance = parseInt(this.value, 10) || 25;
          var tolLbl = document.getElementById('TgHfKoTolVal');
          if (tolLbl) tolLbl.textContent = String(hfState.knockoutTolerance);
          renderHalftoneCanvas();
        });
      }
      document.getElementById('TgHfFreqRange').addEventListener('input', function () {
        hfState.frequency = parseInt(this.value, 10) || 30;
        if (hfState.viewTab === 'original') hfState.viewTab = 'preview';
        syncHfUiControls();
        renderHalftoneCanvas();
      });
      document.getElementById('TgHfFreqInput').addEventListener('input', function () {
        hfState.frequency = Math.max(5, Math.min(60, parseInt(this.value, 10) || 30));
        if (hfState.viewTab === 'original') hfState.viewTab = 'preview';
        syncHfUiControls();
        renderHalftoneCanvas();
      });
      document.getElementById('TgHfAngleRange').addEventListener('input', function () {
        hfState.dotAngle = parseInt(this.value, 10) || 0;
        if (hfState.viewTab === 'original') hfState.viewTab = 'preview';
        syncHfUiControls();
        renderHalftoneCanvas();
      });
      document.getElementById('TgHfAngleInput').addEventListener('input', function () {
        hfState.dotAngle = Math.max(-180, Math.min(180, parseInt(this.value, 10) || 0));
        if (hfState.viewTab === 'original') hfState.viewTab = 'preview';
        syncHfUiControls();
        renderHalftoneCanvas();
      });
      document.getElementById('TgHfWidthInp').addEventListener('input', function () {
        hfState.printWidthMm = Math.max(20, Math.min(1200, parseInt(this.value, 10) || 87));
        renderHalftoneCanvas();
      });

      // Right Sidebar Bottom Footer: Buy Materials & Export
      document.getElementById('TgHfBuyMaterialsBtn').addEventListener('click', function () {
        if (typeof window.openSuppliesKitDrawer === 'function') window.openSuppliesKitDrawer();
      });
      document.getElementById('TgHfExportBottomBtn').addEventListener('click', function () {
        exportHalftoneSvgFile();
        saveCurrentStudioToDraft(false);
      });

      renderHfHistoryList();

      // Preload default Skull & Roses high-res image (1:1 with Atomm ?gid=... default state)
      var defSmp = HF_SAMPLES[0];
      if (defSmp) {
        loadHfSamplePresetImg(defSmp, function (loadedImg) {
          if (loadedImg) {
            hfState.sampleImg = loadedImg;
            renderHalftoneCanvas();
          }
        });
      }
    }

    var ifr = document.getElementById('Kc3dEngineFrame');
    var footerOvr = document.getElementById('Kc3dFooterOverride');
    var quickCadBtn = document.getElementById('Kc3dQuickCadBtn');
    var b = getBridge();
    if (isHalftoneOrImageAi) {
      if (!b || !b.state || b.state.engineMode !== 'cad') {
        wrap.style.display = 'block';
        if (b && b.state) b.state.engineMode = '3d';
      }
      host.style.display = 'flex';
      if (footerOvr) footerOvr.style.display = 'none';
      if (quickCadBtn) quickCadBtn.style.display = 'none';
      if (ifr) {
        ifr.style.opacity = '0';
        ifr.setAttribute('data-loaded-url', 'native-halftone');
        if (ifr.src && ifr.src !== 'about:blank') ifr.src = 'about:blank';
      }
      var hfLoader = document.getElementById('Kc3dAppLoadingOverlay');
      if (hfLoader) {
        hfLoader.style.display = 'flex';
        hfLoader.style.opacity = '1';
        setTimeout(function () {
          hfLoader.style.opacity = '0';
          setTimeout(function () {
            if (hfLoader.style.opacity === '0') hfLoader.style.display = 'none';
          }, 240);
        }, 320);
      }
      var hintEl = document.getElementById('TgHfKnockoutHintPill');
      if (hintEl) {
        if (curSlug.indexOf('halftone') !== -1) {
          hintEl.textContent = 'Pick a color to define the knockout area.';
        } else {
          var metaInfo = getToolMeta(curSlug);
          hintEl.textContent = metaInfo.enTitle + ' Studio — Upload an image or generate with AI, then customize & export.';
        }
      }
      syncHfUiControls();
      renderHalftoneCanvas();
    } else {
      host.style.display = 'none';
    }
  }

  // ============================================================================
  // ATOMM 1:1 AI 3D MODEL & 3D PHOTO GENERATOR (LANDING HERO + 3D CRYSTAL STUDIO)
  // ============================================================================
  var ATOMM_3D_ASSETS = {
    heroBgImg: 'https://storage-us.atomm.com/resource/xtool/xcs-cms//atomm/landingTemplate/16f41064-c2fa-4c48-b585-0c3d0c57f67e.png',
    tabPhoto: 'https://storage-us.atomm.com/resource/xart/static/agent/imgs/ai-3d-photo-tab.png',
    tabModeling: 'https://storage-us.atomm.com/resource/xart/static/agent/imgs/ai-3d-modeling-tab.png',
    photoGuide: 'https://storage-us.atomm.com/resource/xart/static/agent/imgs/ai-3d-photo-guide.png',
    modelingVideo: 'https://storage-us.atomm.com/resource/xart/static/agent/imgs/3d_modeling/guide.mp4',
    historyCard: 'https://storage-us.atomm.com/resource/xart/static/agent/imgs/ai-history-entry.png',
    historyPocket: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsCAYAAAAv1f1mAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMaSURBVHgB7dzhURtnEIDhPSogHYgKYioIVBBcQZIO0oGTDnAFgQ7cAVCBSQW+EtSBsp/uNAZyLMmMQXfW88x8Iw3Gv+yX3ZMOdfHEZrM5y4ef81zkWQX/1zrPfZ7rruuugkXrdk8yjON8+JDn9+Bb6fP8lqHcBou0DWSM4ybPu+A1/JqRXAeLczQ+tskhjtdzmT+EVsHidOM/3Jfgtd3mFDkPFqVNkA/BWzjLH0au7xamTZDPYb16K+0VrtOcJH2wCC2QTfCWrFoLchS8NavWgpgg+2HVWggTZD/a+05/BbMnkP2xai2AFWu/rFozZ4Lsl1Vr5gSyf1atGbNizYNVa6ZMkHmwas2UQOajrVoXwaxYsealrVonuWqtg1kwQebFqjUzJgiHoE3kPobPCrjL8+m/TmmBcKiu8vz50iuHAuHQXcYQyuREEQgM69f51DRxkQ7D57/d5Kz412/WmiDwVR9PJolA4LE+htt+ttckVix4bBUPPunHBIFp7Y6G3gSBadtfQTBBYNr2vjgTBKa1++IuBALP+0kg8Lx3rkHgeWuBQMGKBQWBQEEgUBAIFAQCBYFAQSBQEAgUBAIFgUBBIFAQCBQEAgWBQEEgUBAIFAQCBYFAQSBQEAgUBAIFgUBBIFAQCBQEAgWBQEEgUBAIFAQCBYFAQSBQEAgUBAIFgUBBIFAQCBQEAgWBQEEgUBAIFAQCBYFAQSBQEAgUBAIFgUBBIFAQCBQEAgWBQEEgUBAIFAQCBYFAQSBQEAgUBAKFFsg6gCnrFkgfwJS+BfJ3AFPuWyC3AUy56zabzXE++ZLnOICHfjjquq5dpF8H8NBVa6Nrz3KKrGKYIsDgJAPZXqRHe5IPHwNoPo5NRLf7yngt8jnPKuBw9XlOx0uPr++kj184D++LcLj6POe7OJpHt5qMY+V9iITD0+d5v1utdrqp7xwv2m/CusVh6GOYHP3TP5i8WbF9Y56TcOHO96/9Hz+diqPpXvrb4zT5I88vAd+H3Xt/l8+FsfNiIDvjq1wXec7y/BjD+uXdd5agBdHnuc9zl+fTwwvxyj+yXNHhhB6McwAAAABJRU5ErkJggg==',
    suggestRight: 'https://storage-us.atomm.com/resource/xart/static/agent/imgs/3d_modeling/meshy3d_right.png',
    suggestError: 'https://storage-us.atomm.com/resource/xart/static/agent/imgs/3d_modeling/meshy3d_error.jpeg',
    creditsIcon: 'https://storage-us.atomm.com/resource/xart/static/agent/imgs/credits.svg'
  };

  var ATOMM_3D_MATERIALS = [
    { id: 'sphere', name: 'Crystal Ball', shape: 'sphere', thumb: 'https://storage-us.atomm.com/resource/xart/static/agent/imgs/mock_material/p0104001274webp.webp' },
    { id: 'brick', name: 'Rectangle Crystal', shape: 'brick', thumb: 'https://storage-us.atomm.com/resource/xart/static/agent/imgs/mock_material/p0104001272webp.webp' },
    { id: 'p0104001375', name: '670 Crystal', shape: 'octagon', thumb: 'https://www.atomm.com/creativetools/generator/3d-model/images/modes/crystal_670.png' },
    { id: 'p0104001376', name: 'Patterned Heart Crystal', shape: 'heart_pattern', thumb: 'https://www.atomm.com/creativetools/generator/3d-model/images/modes/crystal_heart_pattern.png' },
    { id: 'p0104001377', name: 'Heart Crystal', shape: 'heart', thumb: 'https://www.atomm.com/creativetools/generator/3d-model/images/modes/crystal_heart.png' },
    { id: 'p0104001378', name: 'Candle Crystal', shape: 'candle', thumb: 'https://www.atomm.com/creativetools/generator/3d-model/images/modes/crystal_candle.png' }
  ];

  var ATOMM_3D_BASES = [
    { id: 'circle', name: 'Round Stand', sub: 'Color Selectable', colorSelectable: true, thumb: 'https://www.atomm.com/creativetools/generator/3d-model/assets/20260526-135711-F3YHAhll.jpg' },
    { id: 'square', name: 'Square Stand', sub: 'Color Selectable', colorSelectable: true, thumb: 'https://www.atomm.com/creativetools/generator/3d-model/assets/20260526-135705-BEdZbSNA.jpg' },
    { id: 'square_groove_beech', name: 'Grooved Square Stand', sub: 'Color Selectable', colorSelectable: true, thumb: 'https://www.atomm.com/creativetools/generator/3d-model/assets/base-square-groove-beech-Mr9TfF6d.webp' },
    { id: 'house_square', name: 'House Stand', sub: 'Fixed Warm Light', colorSelectable: false, thumb: 'https://www.atomm.com/creativetools/generator/3d-model/assets/base-house-square-wFZcejNE.webp' },
    { id: 'square_frame_beech', name: 'Round Window Stand', sub: 'Fixed Warm Light', colorSelectable: false, thumb: 'https://www.atomm.com/creativetools/generator/3d-model/assets/base-square-frame-beech-BsWUMZei.webp' },
    { id: 'round_flat_usb', name: 'Round Stand', sub: 'Fixed Warm Light', colorSelectable: false, thumb: 'https://www.atomm.com/creativetools/generator/3d-model/assets/base-round-flat-usb-B3bZF2Jw.webp' }
  ];

  var ATOMM_3D_LIGHT_COLORS = [
    { id: 'white', value: '#ffffff', label: 'Pure White' },
    { id: 'yellow', value: '#e8c87a', label: 'Warm Gold' },
    { id: 'orange', value: '#ffa94d', label: 'Sunset Amber' },
    { id: 'cyan', value: '#38bdf8', label: 'Crystal Cyan' },
    { id: 'rose', value: '#f472b6', label: 'Rose Pink' }
  ];

  var m3dState = {
    viewState: 'upload',    // 'upload' | 'viewer'
    genTab: 'modeling',     // 'photo' ('3D Photo' - 6 credits) | 'modeling' ('3D Modeling' - 70 credits)
    showAccessories: true,  // true = 'Preview' (Crystal + Wooden LED Stand Scene) | false = 'Model' (Standalone 3D Mesh / Point Cloud)
    interactionMode: 'SELECT', // 'SELECT' (Orbit 360) | 'DRAG' (Pan)
    modelEngine: 'Meshy 7.1',
    textureOn: true,
    optimizeOn: true,
    removeBg: true,
    procWidthMm: 70,
    procHeightMm: 70,
    dotSpacingMm: 0.03,
    autoAdjust: true,
    strengthPct: 68,
    renderMode: 'textured', // 'textured' | 'clay' | 'crystal' | 'gold' | 'wireframe'
    selectedMaterialId: 'brick',
    selectedBaseId: 'square',
    selectedLightColor: '#e8c87a',
    activePreset: 'chibi',  // 'uploaded' | 'chibi' | 'dragon' | 'astronaut'
    hasUploadedImage: false, // false = show Atomm guide image/video placeholder | true = show uploaded thumbnail + Replace
    activeModelId: 'm_chibi',
    rotX: 12,
    rotY: -22,
    rotZ: 0,
    fillRatio: 1.0,
    offsetYMm: 0,
    zoomPct: 100,
    panX: 0,
    panY: 0,
    uploadedImg: null,
    uploadedDataUrl: '',
    _meshCacheKey: '',
    _meshVertices: null,
    isGenerating: false,
    leftExpanded: true,
    models: [
      { id: 'm_chibi', title: 'Chibi Duo Figurine', engine: 'Meshy 7.1', genTab: 'modeling', mode: 'textured', preset: 'chibi', materialId: 'brick', baseId: 'square', createdAt: '2026/10/20 14:20', thumb: 'https://image-res.atomm.com/resource/xtool/xcs-cms//atomm/landingTemplate/53956759-4918-4ca4-86d6-163cfa0b176b.png?x-oss-process=image/resize,m_lfit,w_480,limit_0/format,webp' },
      { id: 'm_portrait', title: 'Portrait 3D Crystal', engine: '3D Photo', genTab: 'photo', mode: 'crystal', preset: 'astronaut', materialId: 'sphere', baseId: 'circle', createdAt: '2026/10/20 13:45', thumb: 'https://image-res.atomm.com/resource/xtool/xcs-cms//atomm/landingTemplate/35fc7285-4c24-48c0-8f93-834d82b6be8f.png?x-oss-process=image/resize,m_lfit,w_480,limit_0/format,webp' },
      { id: 'm_dragon', title: 'Imperial 3D Dragon', engine: 'Meshy 7.1', genTab: 'modeling', mode: 'gold', preset: 'dragon', materialId: 'p0104001375', baseId: 'square_groove_beech', createdAt: '2026/10/19 19:12', thumb: 'https://image-res.atomm.com/resource/xtool/xcs-cms//atomm/landingTemplate/4e413fb4-bb81-4d29-8f4f-312e2643ab7f.png?x-oss-process=image/resize,m_lfit,w_480,limit_0/format,webp' }
    ]
  };

  var m3dSourceCanvas = null;

  function getM3dCreditCost() {
    if (m3dState.genTab === 'photo') return 6;
    if (m3dState.modelEngine === 'Tripo') return m3dState.textureOn ? 35 : 25;
    if (m3dState.modelEngine === 'Hunyuan') return m3dState.textureOn ? 24 : 20;
    return m3dState.textureOn ? 70 : 50;
  }

  function drawM3dDefaultPreset(presetOverride) {
    if (!m3dSourceCanvas) {
      m3dSourceCanvas = document.createElement('canvas');
      m3dSourceCanvas.width = 240;
      m3dSourceCanvas.height = 240;
    }
    var ctx = m3dSourceCanvas.getContext('2d');
    var w = m3dSourceCanvas.width;
    var h = m3dSourceCanvas.height;
    ctx.clearRect(0, 0, w, h);

    var pType = presetOverride || m3dState.activePreset || 'chibi';
    if (pType === 'uploaded' && m3dState.uploadedImg) {
      var im = m3dState.uploadedImg;
      var sc = Math.min((w * 0.92) / im.width, (h * 0.92) / im.height);
      var dw = im.width * sc;
      var dh = im.height * sc;
      ctx.drawImage(im, (w - dw) / 2, (h - dh) / 2, dw, dh);
      return m3dSourceCanvas;
    }

    if (pType === 'dragon') {
      ctx.save();
      ctx.translate(w / 2, h / 2);
      var scD = w / 360;
      ctx.scale(scD, scD);
      var rGrad = ctx.createRadialGradient(-24, -28, 12, 0, 0, 142);
      rGrad.addColorStop(0, '#FEF08A');
      rGrad.addColorStop(0.55, '#F59E0B');
      rGrad.addColorStop(1, '#78350F');
      ctx.fillStyle = rGrad;
      ctx.beginPath();
      ctx.arc(0, 0, 138, 0, Math.PI * 2);
      ctx.fill();
      ctx.lineWidth = 8;
      ctx.strokeStyle = '#FDE047';
      ctx.stroke();

      ctx.strokeStyle = '#FFFBEB';
      ctx.lineWidth = 24;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(-74, 52);
      ctx.bezierCurveTo(-106, -38, -14, -104, 50, -54);
      ctx.bezierCurveTo(102, -14, 74, 74, -6, 72);
      ctx.bezierCurveTo(-52, 70, -45, 10, 8, -8);
      ctx.stroke();
      ctx.strokeStyle = '#D97706';
      ctx.lineWidth = 14;
      ctx.stroke();

      ctx.fillStyle = '#FEF9C3';
      ctx.beginPath();
      ctx.arc(14, -12, 24, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = '#38BDF8';
      ctx.beginPath();
      ctx.arc(-44, 24, 16, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
      return m3dSourceCanvas;
    }

    if (pType === 'astronaut') {
      ctx.save();
      ctx.translate(w / 2, h / 2);
      var scA = w / 360;
      ctx.scale(scA, scA);
      ctx.fillStyle = '#94A3B8';
      ctx.beginPath();
      ctx.roundRect(-64, -38, 128, 114, 22);
      ctx.fill();
      ctx.fillStyle = '#F8FAFC';
      ctx.strokeStyle = '#475569';
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.roundRect(-50, -22, 100, 102, 26);
      ctx.fill();
      ctx.stroke();
      ctx.beginPath();
      ctx.roundRect(-82, -14, 30, 70, 14);
      ctx.roundRect(52, -14, 30, 70, 14);
      ctx.roundRect(-42, 74, 34, 58, 14);
      ctx.roundRect(8, 74, 34, 58, 14);
      ctx.fill();
      ctx.stroke();
      ctx.fillStyle = '#FFFFFF';
      ctx.beginPath();
      ctx.arc(0, -64, 54, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();
      var vGrad = ctx.createLinearGradient(-34, -88, 34, -40);
      vGrad.addColorStop(0, '#38BDF8');
      vGrad.addColorStop(0.5, '#0284C7');
      vGrad.addColorStop(1, '#0F172A');
      ctx.fillStyle = vGrad;
      ctx.beginPath();
      ctx.ellipse(0, -62, 40, 30, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = '#0EA5E9';
      ctx.fillRect(-22, 4, 44, 30);
      ctx.restore();
      return m3dSourceCanvas;
    }

    // Default 'chibi': Anime Chibi Duo Figurine
    var scRatio = w / 480;
    ctx.save();
    ctx.scale(scRatio, scRatio);
    ctx.fillStyle = '#B45309';
    ctx.strokeStyle = '#27272A';
    ctx.lineWidth = 4;
    ctx.fillRect(70, 255, 340, 22);
    ctx.strokeRect(70, 255, 340, 22);
    ctx.fillRect(70, 290, 340, 20);
    ctx.strokeRect(70, 290, 340, 20);
    ctx.fillRect(58, 330, 364, 18);
    ctx.strokeRect(58, 330, 364, 18);
    ctx.fillStyle = '#3F3F46';
    ctx.fillRect(92, 250, 14, 130);
    ctx.fillRect(374, 250, 14, 130);

    function drawChibiChar(cx, cy, hairCol, earCol, ribbonCol) {
      ctx.save();
      ctx.fillStyle = hairCol;
      ctx.strokeStyle = '#18181B';
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(cx - 42, cy - 52); ctx.lineTo(cx - 56, cy - 110); ctx.lineTo(cx - 16, cy - 72); ctx.closePath();
      ctx.moveTo(cx + 42, cy - 52); ctx.lineTo(cx + 56, cy - 110); ctx.lineTo(cx + 16, cy - 72); ctx.closePath();
      ctx.fill();
      ctx.stroke();

      ctx.fillStyle = '#E0E7FF';
      ctx.beginPath();
      ctx.roundRect(cx - 40, cy + 28, 80, 78, 16);
      ctx.fill();
      ctx.stroke();

      ctx.fillStyle = '#78350F';
      ctx.beginPath();
      ctx.roundRect(cx - 28, cy + 104, 22, 34, 8);
      ctx.roundRect(cx + 6, cy + 104, 22, 34, 8);
      ctx.fill();
      ctx.stroke();

      ctx.fillStyle = hairCol;
      ctx.beginPath();
      ctx.arc(cx, cy - 18, 58, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();

      ctx.fillStyle = '#FFFBEB';
      ctx.beginPath();
      ctx.arc(cx, cy - 8, 44, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();

      ctx.strokeStyle = '#18181B';
      ctx.lineWidth = 3.5;
      ctx.beginPath();
      ctx.arc(cx - 18, cy - 8, 9, 0.15 * Math.PI, 0.85 * Math.PI);
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(cx + 18, cy - 8, 9, 0.15 * Math.PI, 0.85 * Math.PI);
      ctx.stroke();

      ctx.fillStyle = 'rgba(244,63,94,0.35)';
      ctx.beginPath();
      ctx.ellipse(cx - 24, cy + 4, 8, 4.5, 0, 0, Math.PI * 2);
      ctx.ellipse(cx + 24, cy + 4, 8, 4.5, 0, 0, Math.PI * 2);
      ctx.fill();

      ctx.fillStyle = '#9A3412';
      ctx.strokeStyle = '#18181B';
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.ellipse(cx, cy + 36, 12, 20, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();
      ctx.fillStyle = '#FACC15';
      ctx.beginPath();
      ctx.arc(cx, cy + 22, 9, 0, Math.PI * 2);
      ctx.fill();

      ctx.fillStyle = ribbonCol;
      ctx.beginPath();
      ctx.arc(cx + 36, cy - 52, 11, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();
      ctx.restore();
    }

    drawChibiChar(172, 232, '#CBD5E1', '#94A3B8', '#FACC15');
    drawChibiChar(308, 232, '#573B2E', '#991B1B', '#EF4444');
    ctx.restore();
    return m3dSourceCanvas;
  }

  // Reconstructs a TRUE 3D Volumetric Vertex Cloud + Shaded Facets (NEVER a flat 2D square image!)
  function buildM3dVolumetricVertices() {
    var cacheKey = [
      m3dState.activePreset,
      m3dState.uploadedDataUrl ? m3dState.uploadedDataUrl.length : 0,
      m3dState.aiDepthImg ? 'aiDepth1' : 'aiDepth0',
      m3dState.removeBg ? 1 : 0,
      m3dState.strengthPct
    ].join('|');
    if (m3dState._meshCacheKey === cacheKey && m3dState._meshVertices) {
      return m3dState._meshVertices;
    }

    var src = drawM3dDefaultPreset(m3dState.activePreset);
    var gridW = 104;
    var gridH = 104;
    var off = document.createElement('canvas');
    off.width = gridW;
    off.height = gridH;
    var octx = off.getContext('2d');
    octx.drawImage(src, 0, 0, gridW, gridH);
    var imgData = octx.getImageData(0, 0, gridW, gridH).data;

    var aiDepthData = null;
    if (m3dState.aiDepthImg) {
      var dOff = document.createElement('canvas');
      dOff.width = gridW;
      dOff.height = gridH;
      var dCtx = dOff.getContext('2d');
      dCtx.drawImage(m3dState.aiDepthImg, 0, 0, gridW, gridH);
      aiDepthData = dCtx.getImageData(0, 0, gridW, gridH).data;
    }

    // 1. Sample perimeter border pixels (top, upper-left, upper-right, mid-left, mid-right) for automatic background removal
    var bgPalette = [];
    function addBgSample(gx, gy) {
      var idx = (gy * gridW + gx) * 4;
      if (imgData[idx + 3] > 30) {
        bgPalette.push([imgData[idx], imgData[idx + 1], imgData[idx + 2]]);
      }
    }
    for (var s = 2; s < gridW - 2; s += 5) {
      addBgSample(s, 2);
      addBgSample(s, 5);
    }
    for (var sy = 2; sy < Math.floor(gridH * 0.72); sy += 5) {
      addBgSample(2, sy);
      addBgSample(5, sy);
      addBgSample(gridW - 3, sy);
      addBgSample(gridW - 6, sy);
    }

    var rawMask = new Float32Array(gridW * gridH);
    var lumMap = new Float32Array(gridW * gridH);
    var isUploaded = (m3dState.activePreset === 'uploaded' && Boolean(m3dState.uploadedImg));

    for (var y = 0; y < gridH; y++) {
      var ny = (y - gridH * 0.5) / (gridH * 0.5); // -1 (top) to +1 (bottom)
      for (var x = 0; x < gridW; x++) {
        var nx = (x - gridW * 0.5) / (gridW * 0.5); // -1 (left) to +1 (right)
        var i = y * gridW + x;
        var p = i * 4;
        var r = imgData[p], g = imgData[p + 1], b = imgData[p + 2], a = imgData[p + 3];
        if (a < 30) {
          rawMask[i] = 0;
          continue;
        }
        var lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        lumMap[i] = lum;

        // Portrait / Figurine organic bust silhouette envelope (eliminates square photo corners!)
        var headDist = Math.sqrt(Math.pow(nx / 0.62, 2) + Math.pow((ny + 0.16) / 0.66, 2));
        var shoulderDist = (ny > 0.05) ? Math.sqrt(Math.pow(nx / 0.80, 2) + Math.pow((ny - 0.42) / 0.68, 2)) : 99;
        var bustDist = Math.min(headDist, shoulderDist);

        if (isUploaded && m3dState.removeBg && bgPalette.length > 0) {
          // Minimum distance to sampled perimeter background colors
          var minD2 = 999999;
          for (var bp = 0; bp < bgPalette.length; bp++) {
            var dr = r - bgPalette[bp][0];
            var dg = g - bgPalette[bp][1];
            var db = b - bgPalette[bp][2];
            var d2 = dr * dr + dg * dg + db * db;
            if (d2 < minD2) minD2 = d2;
          }
          var colDist = Math.sqrt(minD2);
          // Also suppress bright cyan/blue bokeh dots scattered in dark blue studio backgrounds
          var isBlueBokeh = (b > r + 32 && b > g + 12 && bustDist > 0.68);
          var spatialBoost = Math.max(0, 1.0 - bustDist) * 58;
          var score = colDist + spatialBoost;
          if (bustDist > 1.04 || isBlueBokeh || score < 52) {
            rawMask[i] = 0;
          } else if (score < 68) {
            rawMask[i] = (score - 52) / 16;
          } else {
            rawMask[i] = 1;
          }
        } else if (isUploaded) {
          // Even when Remove Background is off, softly round off the outer crystal boundary so it isn't a harsh 2D rectangle
          var rRad = Math.max(Math.abs(nx), Math.abs(ny));
          rawMask[i] = rRad > 0.92 ? 0 : 1;
        } else {
          rawMask[i] = a / 255;
        }
      }
    }

    // 2. Morphological despckle & smooth pass (removes isolated background dots)
    var cleanMask = new Float32Array(gridW * gridH);
    for (var cy = 1; cy < gridH - 1; cy++) {
      for (var cx = 1; cx < gridW - 1; cx++) {
        var ci = cy * gridW + cx;
        var sumN =
          rawMask[ci - gridW - 1] + rawMask[ci - gridW] + rawMask[ci - gridW + 1] +
          rawMask[ci - 1] + rawMask[ci] + rawMask[ci + 1] +
          rawMask[ci + gridW - 1] + rawMask[ci + gridW] + rawMask[ci + gridW + 1];
        cleanMask[ci] = sumN >= 4.2 ? Math.min(1, sumN / 7.5) : 0;
      }
    }

    // 3. Compute True 3D Silhouette Distance Transform (inflates silhouette into a rounded 3D statue/bust!)
    var distField = new Float32Array(gridW * gridH);
    for (var k = 0; k < gridW * gridH; k++) {
      distField[k] = cleanMask[k] > 0.15 ? 999 : 0;
    }
    // Forward chamfer pass
    for (var dy = 1; dy < gridH - 1; dy++) {
      for (var dx = 1; dx < gridW - 1; dx++) {
        var di = dy * gridW + dx;
        if (distField[di] > 0) {
          var m1 = Math.min(distField[di - 1] + 1, distField[di - gridW] + 1, distField[di - gridW - 1] + 1.4, distField[di - gridW + 1] + 1.4);
          if (m1 < distField[di]) distField[di] = m1;
        }
      }
    }
    // Backward chamfer pass
    var maxDist = 1;
    for (var by = gridH - 2; by >= 1; by--) {
      for (var bx = gridW - 2; bx >= 1; bx--) {
        var bi = by * gridW + bx;
        if (distField[bi] > 0) {
          var m2 = Math.min(distField[bi], distField[bi + 1] + 1, distField[bi + gridW] + 1, distField[bi + gridW - 1] + 1.4, distField[bi + gridW + 1] + 1.4);
          distField[bi] = m2;
          if (m2 > maxDist) maxDist = m2;
        }
      }
    }

    // 4. Combine smooth 3D rounded dome thickness + facial/detail relief heightfield Z(x,y)
    var zField = new Float32Array(gridW * gridH);
    var strengthScale = 0.55 + (m3dState.strengthPct / 100) * 0.75;
    for (var zy = 1; zy < gridH - 1; zy++) {
      for (var zx = 1; zx < gridW - 1; zx++) {
        var zi = zy * gridW + zx;
        if (cleanMask[zi] <= 0.15) continue;
        var normDist = Math.min(1, distField[zi] / Math.max(6, maxDist * 0.78));
        // Rounded ellipsoidal volume profile: sqrt(1 - (1 - d)^2)
        var domeVolume = Math.pow(normDist, 0.58);
        var detailRelief = lumMap[zi];
        if (aiDepthData) {
          var aiD = aiDepthData[zi * 4] / 255;
          zField[zi] = (aiD * 0.58 + domeVolume * 0.28 + detailRelief * 0.14) * strengthScale;
        } else {
          zField[zi] = (domeVolume * 0.64 + detailRelief * 0.36) * strengthScale;
        }
      }
    }

    // Smooth Z-field for organic ZBrush / Laser Crystal 3D curvature
    var smoothZ = new Float32Array(gridW * gridH);
    for (var sy2 = 1; sy2 < gridH - 1; sy2++) {
      for (var sx2 = 1; sx2 < gridW - 1; sx2++) {
        var si2 = sy2 * gridW + sx2;
        if (cleanMask[si2] <= 0.15) continue;
        smoothZ[si2] = (
          zField[si2] * 4 +
          zField[si2 - 1] * 2 + zField[si2 + 1] * 2 +
          zField[si2 - gridW] * 2 + zField[si2 + gridW] * 2 +
          zField[si2 - gridW - 1] + zField[si2 - gridW + 1] +
          zField[si2 + gridW - 1] + zField[si2 + gridW + 1]
        ) / 16;
      }
    }

    // 5. Emit 3D Vertices with Surface Normals (Nx, Ny, Nz), Color (R, G, B), Lum, and Back-Shell Thickness
    var vertices = [];
    for (var vy = 1; vy < gridH - 1; vy++) {
      var vny = (vy - gridH * 0.5) / (gridH * 0.5);
      for (var vx = 1; vx < gridW - 1; vx++) {
        var vi = vy * gridW + vx;
        if (cleanMask[vi] <= 0.18) continue;
        var vnx = (vx - gridW * 0.5) / (gridW * 0.5);
        var vz = smoothZ[vi];

        // 3D Surface Normal from Sobel gradient of smoothZ
        var dzdx = (smoothZ[vi + 1] - smoothZ[vi - 1]) * 3.8;
        var dzdy = (smoothZ[vi + gridW] - smoothZ[vi - gridW]) * 3.8;
        var nx3 = -dzdx, ny3 = -dzdy, nz3 = 1.0;
        var nlen = Math.sqrt(nx3 * nx3 + ny3 * ny3 + nz3 * nz3) || 1;
        nx3 /= nlen; ny3 /= nlen; nz3 /= nlen;

        var vp = vi * 4;
        var vr = imgData[vp], vg = imgData[vp + 1], vb = imgData[vp + 2];
        var isEdge = (
          cleanMask[vi - 1] <= 0.18 || cleanMask[vi + 1] <= 0.18 ||
          cleanMask[vi - gridW] <= 0.18 || cleanMask[vi + gridW] <= 0.18
        );

        vertices.push({
          x: vnx * 120,           // -120..+120 mm space
          y: vny * 120,           // -120..+120 mm space
          z: vz * 58,             // Front 3D sculpted relief depth (0..+58)
          backZ: -vz * 34,        // Back 3D statue volume (-34..0)
          nx: nx3,
          ny: ny3,
          nz: nz3,
          r: vr,
          g: vg,
          b: vb,
          lum: lumMap[vi],
          isEdge: isEdge,
          gx: vx,
          gy: vy
        });
      }
    }

    m3dState._meshCacheKey = cacheKey;
    m3dState._meshVertices = {
      gridW: gridW,
      gridH: gridH,
      smoothZ: smoothZ,
      cleanMask: cleanMask,
      list: vertices
    };
    return m3dState._meshVertices;
  }

  function hexToRgbObj(hex) {
    var h = String(hex || '#e8c87a').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var num = parseInt(h, 16) || 0xe8c87a;
    return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
  }

  function renderM3dViewportCanvas() {
    var canvas = document.getElementById('Tg3dModCanvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var w = canvas.width;
    var h = canvas.height;
    ctx.clearRect(0, 0, w, h);

    // 1. Atomm Viewer Surface Studio Backdrop (#393A3D with subtle radial depth)
    var bgGrad = ctx.createRadialGradient(w / 2, h * 0.45, 40, w / 2, h * 0.5, w * 0.7);
    bgGrad.addColorStop(0, '#45474B');
    bgGrad.addColorStop(0.65, '#393A3D');
    bgGrad.addColorStop(1, '#2B2C2F');
    ctx.fillStyle = bgGrad;
    ctx.fillRect(0, 0, w, h);

    var zoom = (m3dState.zoomPct / 100) * m3dState.fillRatio;
    var cx = w / 2 + m3dState.panX;
    var cy = h / 2 - 22 + m3dState.panY - m3dState.offsetYMm * 2.2;

    var radX = (m3dState.rotX * Math.PI) / 180;
    var radY = (m3dState.rotY * Math.PI) / 180;
    var radZ = (m3dState.rotZ * Math.PI) / 180;
    var cosX = Math.cos(radX), sinX = Math.sin(radX);
    var cosY = Math.cos(radY), sinY = Math.sin(radY);
    var cosZ = Math.cos(radZ), sinZ = Math.sin(radZ);
    var fov = 520;

    function project3D(x, y, z, cX, cY, sc) {
      // Rotate Z -> Y -> X
      var x0 = x * cosZ - y * sinZ;
      var y0 = x * sinZ + y * cosZ;
      var x1 = x0 * cosY + z * sinY;
      var z1 = -x0 * sinY + z * cosY;
      var y2 = y0 * cosX - z1 * sinX;
      var z2 = y0 * sinX + z1 * cosX;
      var pScale = (fov / Math.max(120, fov - z2)) * sc;
      return {
        sx: cX + x1 * pScale,
        sy: cY + y2 * pScale,
        z: z2,
        scale: pScale
      };
    }

    var ledHex = m3dState.selectedLightColor || '#e8c87a';
    var baseObj = ATOMM_3D_BASES.find(function (b) { return b.id === m3dState.selectedBaseId; }) || ATOMM_3D_BASES[0];
    if (!baseObj.colorSelectable) ledHex = '#e8c87a';
    var ledRgb = hexToRgbObj(ledHex);

    var matObj = ATOMM_3D_MATERIALS.find(function (m) { return m.id === m3dState.selectedMaterialId; }) || ATOMM_3D_MATERIALS[1];
    var showScene = m3dState.showAccessories;

    // 2. Draw Studio Floor / Wooden LED Pedestal Stand (when in Scene Preview mode)
    var baseTopY = cy + 138 * zoom;
    if (showScene) {
      // Radial LED Floor Glow Halo (Atomm createBaseFloorGlowTexture)
      ctx.save();
      var glowR = 230 * zoom;
      var floorGlow = ctx.createRadialGradient(cx, baseTopY + 26 * zoom, 6, cx, baseTopY + 26 * zoom, glowR);
      floorGlow.addColorStop(0, 'rgba(' + ledRgb.r + ',' + ledRgb.g + ',' + ledRgb.b + ',0.55)');
      floorGlow.addColorStop(0.35, 'rgba(' + ledRgb.r + ',' + ledRgb.g + ',' + ledRgb.b + ',0.22)');
      floorGlow.addColorStop(0.75, 'rgba(' + ledRgb.r + ',' + ledRgb.g + ',' + ledRgb.b + ',0.05)');
      floorGlow.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = floorGlow;
      ctx.beginPath();
      ctx.ellipse(cx, baseTopY + 28 * zoom, glowR, glowR * 0.34, 0, 0, Math.PI * 2);
      ctx.fill();

      // Draw Wooden Pedestal Base in 3D
      var isRoundBase = (baseObj.id === 'circle' || baseObj.id === 'round_flat_usb');
      var pedRx = 136 * zoom;
      var pedRy = Math.max(20, (30 + Math.abs(m3dState.rotX) * 0.45) * zoom);
      var pedH = (baseObj.id === 'house_square' ? 42 : 30) * zoom;

      // Pedestal Drop Shadow
      ctx.beginPath();
      ctx.ellipse(cx, baseTopY + pedH + 8, pedRx * 1.12, pedRy * 1.15, 0, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(0,0,0,0.58)';
      ctx.fill();

      // Warm Rubber Wood / Beech Wood Grain Gradient
      var woodBodyGrad = ctx.createLinearGradient(cx - pedRx, baseTopY, cx + pedRx, baseTopY);
      woodBodyGrad.addColorStop(0, '#5C3A21');
      woodBodyGrad.addColorStop(0.28, '#9A6B43');
      woodBodyGrad.addColorStop(0.55, '#B6865A');
      woodBodyGrad.addColorStop(0.82, '#855834');
      woodBodyGrad.addColorStop(1, '#4A2E19');

      if (isRoundBase) {
        ctx.fillStyle = woodBodyGrad;
        ctx.beginPath();
        ctx.ellipse(cx, baseTopY + pedH, pedRx, pedRy, 0, 0, Math.PI);
        ctx.lineTo(cx - pedRx, baseTopY);
        ctx.ellipse(cx, baseTopY, pedRx, pedRy, 0, Math.PI, 0, true);
        ctx.closePath();
        ctx.fill();

        var woodTopGrad = ctx.createRadialGradient(cx - 20, baseTopY - 5, 10, cx, baseTopY, pedRx);
        woodTopGrad.addColorStop(0, '#C89B6E');
        woodTopGrad.addColorStop(0.75, '#9A6B43');
        woodTopGrad.addColorStop(1, '#6E4726');
        ctx.fillStyle = woodTopGrad;
        ctx.beginPath();
        ctx.ellipse(cx, baseTopY, pedRx, pedRy, 0, 0, Math.PI * 2);
        ctx.fill();
        ctx.lineWidth = 1.5;
        ctx.strokeStyle = 'rgba(255,255,255,0.22)';
        ctx.stroke();
      } else {
        // 3D Square / Grooved Beech Wood Stand projected with camera yaw
        var bCornersTop = [
          project3D(-118, 138, -118, cx, cy, zoom),
          project3D(118, 138, -118, cx, cy, zoom),
          project3D(118, 138, 118, cx, cy, zoom),
          project3D(-118, 138, 118, cx, cy, zoom)
        ];
        var bCornersBot = [
          project3D(-122, 168, -122, cx, cy, zoom),
          project3D(122, 168, -122, cx, cy, zoom),
          project3D(122, 168, 122, cx, cy, zoom),
          project3D(-122, 168, 122, cx, cy, zoom)
        ];
        // Side walls of wooden block
        for (var sw = 0; sw < 4; sw++) {
          var nw = (sw + 1) % 4;
          ctx.beginPath();
          ctx.moveTo(bCornersTop[sw].sx, bCornersTop[sw].sy);
          ctx.lineTo(bCornersTop[nw].sx, bCornersTop[nw].sy);
          ctx.lineTo(bCornersBot[nw].sx, bCornersBot[nw].sy);
          ctx.lineTo(bCornersBot[sw].sx, bCornersBot[sw].sy);
          ctx.closePath();
          ctx.fillStyle = sw % 2 === 0 ? '#7C4F2B' : '#5E3A1E';
          ctx.fill();
          ctx.strokeStyle = 'rgba(0,0,0,0.25)';
          ctx.lineWidth = 1;
          ctx.stroke();
        }
        // Top face of wooden block
        ctx.beginPath();
        ctx.moveTo(bCornersTop[0].sx, bCornersTop[0].sy);
        ctx.lineTo(bCornersTop[1].sx, bCornersTop[1].sy);
        ctx.lineTo(bCornersTop[2].sx, bCornersTop[2].sy);
        ctx.lineTo(bCornersTop[3].sx, bCornersTop[3].sy);
        ctx.closePath();
        ctx.fillStyle = woodBodyGrad;
        ctx.fill();
        ctx.strokeStyle = 'rgba(255,235,200,0.32)';
        ctx.lineWidth = 1.5;
        ctx.stroke();
      }

      // Glowing Recessed LED Slot in the center of the wooden stand
      var slotGlow = ctx.createRadialGradient(cx, baseTopY, 2, cx, baseTopY, 72 * zoom);
      slotGlow.addColorStop(0, '#FFFFFF');
      slotGlow.addColorStop(0.28, ledHex);
      slotGlow.addColorStop(0.65, 'rgba(' + ledRgb.r + ',' + ledRgb.g + ',' + ledRgb.b + ',0.35)');
      slotGlow.addColorStop(1, 'rgba(' + ledRgb.r + ',' + ledRgb.g + ',' + ledRgb.b + ',0)');
      ctx.fillStyle = slotGlow;
      ctx.beginPath();
      ctx.ellipse(cx, baseTopY, 68 * zoom, pedRy * 0.55, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    } else {
      // Model Preview Mode: Draw Clean 3D Perspective Turntable Grid
      ctx.save();
      ctx.strokeStyle = 'rgba(255,255,255,0.09)';
      ctx.lineWidth = 1;
      for (var g = -120; g <= 120; g += 30) {
        var p1 = project3D(g, 135, -120, cx, cy, zoom);
        var p2 = project3D(g, 135, 120, cx, cy, zoom);
        ctx.beginPath(); ctx.moveTo(p1.sx, p1.sy); ctx.lineTo(p2.sx, p2.sy); ctx.stroke();
        var q1 = project3D(-120, 135, g, cx, cy, zoom);
        var q2 = project3D(120, 135, g, cx, cy, zoom);
        ctx.beginPath(); ctx.moveTo(q1.sx, q1.sy); ctx.lineTo(q2.sx, q2.sy); ctx.stroke();
      }
      ctx.restore();
    }

    // 3. Draw Back Glass Shell of K9 Crystal Blank (when in Scene Preview mode)
    var boxVerts = null;
    if (showScene) {
      ctx.save();
      if (matObj.shape === 'sphere') {
        var sphR = 136 * zoom;
        var sphGrad = ctx.createRadialGradient(cx - sphR * 0.28, cy - sphR * 0.28, sphR * 0.08, cx, cy, sphR);
        sphGrad.addColorStop(0, 'rgba(255,255,255,0.18)');
        sphGrad.addColorStop(0.55, 'rgba(' + ledRgb.r + ',' + ledRgb.g + ',' + ledRgb.b + ',0.08)');
        sphGrad.addColorStop(0.88, 'rgba(186,230,253,0.16)');
        sphGrad.addColorStop(1, 'rgba(255,255,255,0.38)');
        ctx.fillStyle = sphGrad;
        ctx.beginPath();
        ctx.arc(cx, cy, sphR, 0, Math.PI * 2);
        ctx.fill();
      } else if (matObj.shape === 'heart' || matObj.shape === 'heart_pattern') {
        ctx.save();
        ctx.translate(cx, cy + 8 * zoom);
        ctx.scale(zoom * 1.28, zoom * 1.28);
        ctx.beginPath();
        ctx.moveTo(0, 96);
        ctx.bezierCurveTo(-118, 22, -124, -78, -56, -96);
        ctx.bezierCurveTo(-18, -106, 0, -72, 0, -52);
        ctx.bezierCurveTo(0, -72, 18, -106, 56, -96);
        ctx.bezierCurveTo(124, -78, 118, 22, 0, 96);
        ctx.closePath();
        ctx.fillStyle = 'rgba(' + ledRgb.r + ',' + ledRgb.g + ',' + ledRgb.b + ',0.09)';
        ctx.fill();
        ctx.lineWidth = matObj.shape === 'heart_pattern' ? 3.5 : 2;
        ctx.strokeStyle = 'rgba(255,255,255,0.42)';
        ctx.stroke();
        ctx.restore();
      } else {
        // 3D Rectangular / Octagonal / Candle K9 Crystal Prism Block projected in 3D!
        var bw = matObj.shape === 'candle' ? 92 : 104;
        var bh = matObj.shape === 'candle' ? 118 : 134;
        var bd = 78;
        boxVerts = [
          project3D(-bw, -bh, -bd, cx, cy, zoom),
          project3D(bw, -bh, -bd, cx, cy, zoom),
          project3D(bw, bh, -bd, cx, cy, zoom),
          project3D(-bw, bh, -bd, cx, cy, zoom),
          project3D(-bw, -bh, bd, cx, cy, zoom),
          project3D(bw, -bh, bd, cx, cy, zoom),
          project3D(bw, bh, bd, cx, cy, zoom),
          project3D(-bw, bh, bd, cx, cy, zoom)
        ];
        // Back face & side glass tint
        ctx.beginPath();
        ctx.moveTo(boxVerts[0].sx, boxVerts[0].sy);
        ctx.lineTo(boxVerts[1].sx, boxVerts[1].sy);
        ctx.lineTo(boxVerts[2].sx, boxVerts[2].sy);
        ctx.lineTo(boxVerts[3].sx, boxVerts[3].sy);
        ctx.closePath();
        ctx.fillStyle = 'rgba(255,255,255,0.06)';
        ctx.fill();
        ctx.strokeStyle = 'rgba(255,255,255,0.22)';
        ctx.lineWidth = 1.2;
        ctx.stroke();

        // Upward LED Light Cone inside the crystal block
        var coneGrad = ctx.createLinearGradient(cx, baseTopY, cx, cy - 110 * zoom);
        coneGrad.addColorStop(0, 'rgba(' + ledRgb.r + ',' + ledRgb.g + ',' + ledRgb.b + ',0.34)');
        coneGrad.addColorStop(0.55, 'rgba(' + ledRgb.r + ',' + ledRgb.g + ',' + ledRgb.b + ',0.10)');
        coneGrad.addColorStop(1, 'rgba(255,255,255,0.02)');
        ctx.fillStyle = coneGrad;
        ctx.beginPath();
        ctx.moveTo(boxVerts[4].sx, boxVerts[4].sy);
        ctx.lineTo(boxVerts[5].sx, boxVerts[5].sy);
        ctx.lineTo(boxVerts[6].sx, boxVerts[6].sy);
        ctx.lineTo(boxVerts[7].sx, boxVerts[7].sy);
        ctx.closePath();
        ctx.fill();
      }
      ctx.restore();
    }

    // 4. Project & Render True 3D Volumetric Vertices (Point Cloud OR Z-Sorted 3D Mesh)
    var mesh = buildM3dVolumetricVertices();
    var vList = mesh.list;
    var isPhotoPointCloud = (m3dState.genTab === 'photo') || (m3dState.renderMode === 'crystal');
    var mode = m3dState.renderMode;
    if (!m3dState.textureOn && mode === 'textured') mode = 'clay';

    // Key light direction vector
    var lx = 0.48, ly = -0.52, lz = 0.70;

    if (isPhotoPointCloud) {
      // ATOMM 3D PHOTO / INNER CRYSTAL POINT CLOUD ENGINE:
      // Projects thousands of 3D (x,y,z) laser-etched micro-crystals inside the glass!
      var stride = m3dState.dotSpacingMm <= 0.04 ? 1 : (m3dState.dotSpacingMm <= 0.08 ? 2 : 3);
      var ptSize = Math.max(1.25, (2.1 - m3dState.dotSpacingMm * 6) * zoom);

      ctx.save();
      for (var i = 0; i < vList.length; i += stride) {
        var v = vList[i];
        // Front laser point layer
        var pf = project3D(v.x * 0.78, v.y * 0.78, v.z * 0.95, cx, cy, zoom);
        var diff = Math.max(0.15, v.nx * lx + v.ny * ly + v.nz * lz);
        // Bottom LED attenuation factor (points closer to the bottom LED stand glow brighter!)
        var heightAtten = Math.max(0.35, Math.min(1.15, 0.55 + (v.y + 120) / 260));
        var intensity = Math.min(1, (v.lum * 0.62 + diff * 0.48) * heightAtten);

        var pr = Math.min(255, Math.round(ledRgb.r * 0.42 + 215 * intensity));
        var pg = Math.min(255, Math.round(ledRgb.g * 0.42 + 215 * intensity));
        var pb = Math.min(255, Math.round(ledRgb.b * 0.42 + 220 * intensity));
        var alpha = Math.min(0.95, 0.24 + intensity * 0.72);

        ctx.fillStyle = 'rgba(' + pr + ',' + pg + ',' + pb + ',' + alpha.toFixed(2) + ')';
        ctx.fillRect(pf.sx - ptSize * 0.5, pf.sy - ptSize * 0.5, ptSize, ptSize);

        // Internal sub-surface depth layer for true 3D thickness when orbiting!
        if (i % 2 === 0 && v.z > 14) {
          var pbk = project3D(v.x * 0.78, v.y * 0.78, v.backZ * 0.65, cx, cy, zoom);
          ctx.fillStyle = 'rgba(' + pr + ',' + pg + ',' + pb + ',' + (alpha * 0.42).toFixed(2) + ')';
          ctx.fillRect(pbk.sx - ptSize * 0.4, pbk.sy - ptSize * 0.4, ptSize * 0.85, ptSize * 0.85);
        }
      }
      ctx.restore();
    } else if (mode === 'wireframe') {
      // 3D Perspective Wireframe Mesh
      ctx.save();
      ctx.fillStyle = '#38BDF8';
      for (var wIdx = 0; wIdx < vList.length; wIdx += 2) {
        var wv = vList[wIdx];
        var wp = project3D(wv.x * 0.82, wv.y * 0.82, wv.z, cx, cy, zoom);
        ctx.fillRect(wp.sx - 1, wp.sy - 1, 2.2, 2.2);
      }
      ctx.restore();
    } else {
      // ATOMM 3D MODELING Z-SORTED VOLUMETRIC MESH ENGINE:
      // Collects front & back 3D surface micro-facets, sorts by camera Z, and renders with Blinn-Phong 3D lighting!
      var projected = [];
      for (var mIdx = 0; mIdx < vList.length; mIdx++) {
        var mv = vList[mIdx];
        var mp = project3D(mv.x * 0.82, mv.y * 0.82, mv.z, cx, cy, zoom);
        // Rotate normal into camera space for live directional lighting as you orbit!
        var rnx = mv.nx * cosY + mv.nz * sinY;
        var rnz = -mv.nx * sinY + mv.nz * cosY;
        var rny = mv.ny * cosX - rnz * sinX;
        var rnz2 = mv.ny * sinX + rnz * cosX;

        var mDiff = Math.max(0.18, rnx * lx + rny * ly + rnz2 * lz);
        var mSpec = Math.pow(Math.max(0, rnz2), 18);
        var mRim = Math.pow(1.0 - Math.max(0, Math.abs(rnz2)), 2.0);

        var mr, mg, mb;
        if (mode === 'clay') {
          mr = 212 * (0.28 + mDiff * 0.76) + mSpec * 95 + mRim * 45;
          mg = 202 * (0.28 + mDiff * 0.76) + mSpec * 95 + mRim * 45;
          mb = 194 * (0.28 + mDiff * 0.76) + mSpec * 98 + mRim * 50;
        } else if (mode === 'gold') {
          mr = 244 * (0.24 + mDiff * 0.82) + mSpec * 160 + mRim * 60;
          mg = 182 * (0.20 + mDiff * 0.80) + mSpec * 140 + mRim * 40;
          mb = 44 * (0.14 + mDiff * 0.65) + mSpec * 80 + mRim * 15;
        } else {
          // Textured 3D Mesh (slightly illuminated by bottom LED when inside crystal)
          var shade = 0.38 + mDiff * 0.78;
          var ledMix = showScene ? 0.14 : 0;
          mr = (mv.r * (1 - ledMix) + ledRgb.r * ledMix) * shade + mSpec * 68 + mRim * 32;
          mg = (mv.g * (1 - ledMix) + ledRgb.g * ledMix) * shade + mSpec * 68 + mRim * 32;
          mb = (mv.b * (1 - ledMix) + ledRgb.b * ledMix) * shade + mSpec * 72 + mRim * 38;
        }

        projected.push({
          sx: mp.sx,
          sy: mp.sy,
          z: mp.z,
          size: Math.max(2.6, 3.3 * mp.scale),
          col: 'rgb(' + Math.min(255, Math.round(mr)) + ',' + Math.min(255, Math.round(mg)) + ',' + Math.min(255, Math.round(mb)) + ')'
        });

        // Add back-shell & silhouette side-wall volume so orbiting 360 degrees shows solid 3D thickness!
        if (mv.isEdge || mIdx % 2 === 0) {
          var bp2 = project3D(mv.x * 0.82, mv.y * 0.82, mv.backZ, cx, cy, zoom);
          projected.push({
            sx: bp2.sx,
            sy: bp2.sy,
            z: bp2.z,
            size: Math.max(2.6, 3.3 * bp2.scale),
            col: 'rgb(' + Math.min(255, Math.round(mr * 0.62)) + ',' + Math.min(255, Math.round(mg * 0.62)) + ',' + Math.min(255, Math.round(mb * 0.65)) + ')'
          });
        }
        if (mv.isEdge) {
          // Connect front & back contour edge for watertight 3D statue side wall
          for (var sStep = 0.25; sStep <= 0.75; sStep += 0.25) {
            var midZ = mv.backZ + (mv.z - mv.backZ) * sStep;
            var ep = project3D(mv.x * 0.82, mv.y * 0.82, midZ, cx, cy, zoom);
            projected.push({
              sx: ep.sx,
              sy: ep.sy,
              z: ep.z,
              size: Math.max(2.8, 3.4 * ep.scale),
              col: 'rgb(' + Math.min(255, Math.round(mr * 0.72)) + ',' + Math.min(255, Math.round(mg * 0.72)) + ',' + Math.min(255, Math.round(mb * 0.75)) + ')'
            });
          }
        }
      }

      // Painter's Algorithm Z-sort (back-to-front in 3D camera space)
      projected.sort(function (a, b) { return a.z - b.z; });

      ctx.save();
      for (var pIdx = 0; pIdx < projected.length; pIdx++) {
        var pt = projected[pIdx];
        ctx.fillStyle = pt.col;
        ctx.fillRect(pt.sx - pt.size * 0.5, pt.sy - pt.size * 0.5, pt.size, pt.size);
      }
      ctx.restore();
    }

    // 5. Draw Front Refractive K9 Crystal Bevel Edges & Specular Glass Reflections (when in Scene Preview mode)
    if (showScene) {
      ctx.save();
      if (matObj.shape === 'sphere') {
        var sR = 136 * zoom;
        ctx.strokeStyle = 'rgba(255,255,255,0.52)';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(cx, cy, sR, 0, Math.PI * 2);
        ctx.stroke();
        // Curved specular glass highlight arc
        ctx.strokeStyle = 'rgba(255,255,255,0.45)';
        ctx.lineWidth = 4 * zoom;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.arc(cx, cy, sR * 0.88, Math.PI * 1.12, Math.PI * 1.42);
        ctx.stroke();
      } else if (boxVerts) {
        // Front face & connecting 3D crystal bevel edges
        var edges = [
          [4, 5], [5, 6], [6, 7], [7, 4],
          [0, 4], [1, 5], [2, 6], [3, 7]
        ];
        ctx.strokeStyle = 'rgba(255,255,255,0.55)';
        ctx.lineWidth = 1.8;
        for (var eIdx = 0; eIdx < edges.length; eIdx++) {
          var vA = boxVerts[edges[eIdx][0]];
          var vB = boxVerts[edges[eIdx][1]];
          ctx.beginPath();
          ctx.moveTo(vA.sx, vA.sy);
          ctx.lineTo(vB.sx, vB.sy);
          ctx.stroke();
        }
        // Diagonal glass sheen on front crystal face
        var sheenGrad = ctx.createLinearGradient(boxVerts[4].sx, boxVerts[4].sy, boxVerts[6].sx, boxVerts[6].sy);
        sheenGrad.addColorStop(0, 'rgba(255,255,255,0.18)');
        sheenGrad.addColorStop(0.35, 'rgba(255,255,255,0.02)');
        sheenGrad.addColorStop(0.5, 'rgba(255,255,255,0.10)');
        sheenGrad.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = sheenGrad;
        ctx.beginPath();
        ctx.moveTo(boxVerts[4].sx, boxVerts[4].sy);
        ctx.lineTo(boxVerts[5].sx, boxVerts[5].sy);
        ctx.lineTo(boxVerts[6].sx, boxVerts[6].sy);
        ctx.lineTo(boxVerts[7].sx, boxVerts[7].sy);
        ctx.closePath();
        ctx.fill();
      }
      ctx.restore();
    }
  }

  function exportM3dStlFile() {
    if (m3dState.genTab === 'photo' && m3dState.aiPlyUrl) {
      fetch(m3dState.aiPlyUrl)
        .then(function (r) { return r.blob(); })
        .then(function (plyBlob) {
          var u = URL.createObjectURL(plyBlob);
          var dl = document.createElement('a');
          dl.href = u;
          dl.download = 'AImake_3D_' + Date.now().toString().slice(-6) + '.ply';
          document.body.appendChild(dl);
          dl.click();
          document.body.removeChild(dl);
          setTimeout(function () { URL.revokeObjectURL(u); }, 1000);
          showStudioAuthToast('Exported AI 3D PointCloud (' + dl.download + ') ready for K9 Laser Crystal!');
        })
        .catch(function () {});
      return;
    }
    var mesh = buildM3dVolumetricVertices();
    var gridW = mesh.gridW;
    var gridH = mesh.gridH;
    var smoothZ = mesh.smoothZ;
    var cleanMask = mesh.cleanMask;

    var stl = ['solid ThoughtyGift_Atomm_3D_Model'];
    var scaleXY = (m3dState.procWidthMm || 70) / gridW;
    var scaleZ = 18.0;

    function getZ(gx, gy) {
      var idx = gy * gridW + gx;
      if (cleanMask[idx] <= 0.15) return '0.000';
      return (1.6 + smoothZ[idx] * scaleZ).toFixed(3);
    }

    for (var y = 1; y < gridH - 2; y += 2) {
      for (var x = 1; x < gridW - 2; x += 2) {
        if (cleanMask[y * gridW + x] <= 0.15) continue;
        var x0 = (x * scaleXY).toFixed(2), x1 = ((x + 2) * scaleXY).toFixed(2);
        var y0 = (y * scaleXY).toFixed(2), y1 = ((y + 2) * scaleXY).toFixed(2);
        var z00 = getZ(x, y), z10 = getZ(x + 2, y), z01 = getZ(x, y + 2), z11 = getZ(x + 2, y + 2);
        stl.push('facet normal 0 0 1\n  outer loop\n    vertex ' + x0 + ' ' + y0 + ' ' + z00 + '\n    vertex ' + x1 + ' ' + y0 + ' ' + z10 + '\n    vertex ' + x1 + ' ' + y1 + ' ' + z11 + '\n  endloop\nendfacet');
        stl.push('facet normal 0 0 1\n  outer loop\n    vertex ' + x0 + ' ' + y0 + ' ' + z00 + '\n    vertex ' + x1 + ' ' + y1 + ' ' + z11 + '\n    vertex ' + x0 + ' ' + y1 + ' ' + z01 + '\n  endloop\nendfacet');
      }
    }
    stl.push('endsolid ThoughtyGift_Atomm_3D_Model');
    var ext = m3dState.genTab === 'photo' ? '.ply' : '.stl';
    var blob = new Blob([stl.join('\n')], { type: 'application/octet-stream' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = 'AImake_3D_' + Date.now().toString().slice(-6) + ext;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    showStudioAuthToast('Exported 3D file (' + a.download + ') ready for laser crystal & 3D printing!');
  }

  function syncM3dUploadPreview() {
    var src = drawM3dDefaultPreset(m3dState.uploadedImg ? 'uploaded' : m3dState.activePreset);
    var tmp = document.createElement('canvas');
    tmp.width = 240;
    tmp.height = 240;
    var tctx = tmp.getContext('2d');
    if (!m3dState.uploadedImg) {
      var bg = tctx.createLinearGradient(0, 0, 0, 240);
      bg.addColorStop(0, '#FDE68A');
      bg.addColorStop(0.72, '#FEF3C7');
      bg.addColorStop(0.73, '#BBF7D0');
      bg.addColorStop(1, '#86EFAC');
      tctx.fillStyle = bg;
      tctx.fillRect(0, 0, 240, 240);
    }
    tctx.drawImage(src, 0, 0, 240, 240);
    var dataUrl = m3dState.uploadedDataUrl || tmp.toDataURL('image/png');

    // Sync Studio Upload Modal
    var emptyBox = document.getElementById('Tg3dModEmptyBox');
    var thumbBox = document.getElementById('Tg3dModThumbBox');
    var guideImg = document.getElementById('Tg3dModGuideImg');
    var guideVid = document.getElementById('Tg3dModGuideVid');
    var guideTitle = document.getElementById('Tg3dModGuideTitle');
    if (emptyBox && thumbBox) {
      emptyBox.style.display = m3dState.hasUploadedImage ? 'none' : 'flex';
      thumbBox.style.display = m3dState.hasUploadedImage ? 'flex' : 'none';
    }
    if (guideImg && guideVid) {
      guideImg.style.display = m3dState.genTab === 'photo' ? 'block' : 'none';
      guideVid.style.display = m3dState.genTab === 'modeling' ? 'block' : 'none';
    }
    if (guideTitle) {
      guideTitle.textContent = m3dState.genTab === 'photo'
        ? 'Convert your photo into a 3D-like relief with depth effects'
        : 'Generate a fully 360° 3D model with complete geometry from a single image.';
    }

    var fgImg = document.getElementById('Tg3dModPreviewImg');
    var bgImg = document.getElementById('Tg3dModPreviewBlurBg');
    var origThumb = document.getElementById('Tg3dOrigThumbImg');
    if (fgImg) fgImg.src = dataUrl;
    if (bgImg) bgImg.src = dataUrl;
    if (origThumb) origThumb.src = dataUrl;

    // Also sync Landing Page .ai-3d-generator-block if open
    var lndEmpty = document.getElementById('Tgl3dHeroEmptyBox');
    var lndThumb = document.getElementById('Tgl3dHeroThumbBox');
    var lndGuideImg = document.getElementById('Tgl3dHeroGuideImg');
    var lndGuideVid = document.getElementById('Tgl3dHeroGuideVid');
    var lndGuideTitle = document.getElementById('Tgl3dHeroGuideTitle');
    var lndFg = document.getElementById('Tgl3dHeroPreviewImg');
    var lndBg = document.getElementById('Tgl3dHeroPreviewBlurBg');
    if (lndEmpty && lndThumb) {
      lndEmpty.style.display = m3dState.hasUploadedImage ? 'none' : 'flex';
      lndThumb.style.display = m3dState.hasUploadedImage ? 'flex' : 'none';
    }
    if (lndGuideImg && lndGuideVid) {
      lndGuideImg.style.display = m3dState.genTab === 'photo' ? 'block' : 'none';
      lndGuideVid.style.display = m3dState.genTab === 'modeling' ? 'block' : 'none';
    }
    if (lndGuideTitle) {
      lndGuideTitle.textContent = m3dState.genTab === 'photo'
        ? 'Convert your photo into a 3D-like relief with depth effects'
        : 'Generate a fully 360° 3D model with complete geometry from a single image.';
    }
    if (lndFg) lndFg.src = dataUrl;
    if (lndBg) lndBg.src = dataUrl;

    // Sync parameter bars (Photo vs Modeling) & Credit cost badges
    var cost = getM3dCreditCost();
    var costEls = document.querySelectorAll('.tg-3d-cost-val');
    for (var c = 0; c < costEls.length; c++) costEls[c].textContent = String(cost);

    var photoParamBars = document.querySelectorAll('.tg-3d-params-photo');
    var modelParamBars = document.querySelectorAll('.tg-3d-params-modeling');
    for (var p = 0; p < photoParamBars.length; p++) {
      photoParamBars[p].style.display = m3dState.genTab === 'photo' ? 'flex' : 'none';
    }
    for (var m = 0; m < modelParamBars.length; m++) {
      modelParamBars[m].style.display = m3dState.genTab === 'modeling' ? 'flex' : 'none';
    }

    var tabBtns = document.querySelectorAll('[data-tg3d-tab]');
    for (var t = 0; t < tabBtns.length; t++) {
      var isAct = tabBtns[t].getAttribute('data-tg3d-tab') === m3dState.genTab;
      tabBtns[t].classList.toggle('active', isAct);
      var bar = tabBtns[t].querySelector('.tg3d-tab-bar');
      if (bar) bar.style.opacity = isAct ? '1' : '0';
    }
  }

  function renderM3dModelsSidebarList() {
    var listEl = document.getElementById('Tg3dModList');
    if (!listEl) return;
    var pendingHtml = '';
    if (m3dState.isGenerating) {
      pendingHtml =
        '<div class="tg-3d-pending-card" style="position:relative;aspect-ratio:4/3;border-radius:8px;border:1px solid #E5E6EB;background:#F6F6FA;overflow:hidden;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;flex-shrink:0;">' +
          '<div class="tg-atomm-conic-loader"></div>' +
          '<div style="display:flex;align-items:center;justify-content:center;color:#848B96;font-size:12px;font-weight:400;line-height:20px;">' +
            '<span>Generating</span>' +
            '<span class="tg-3d-pending-pct" style="width:34px;margin-left:4px;text-align:center;">' + Math.round(m3dState.genPct || 8) + '%</span>' +
          '</div>' +
        '</div>';
    }
    listEl.innerHTML = pendingHtml + m3dState.models.map(function (m, idx) {
      var isAct = !m3dState.isGenerating && m.id === m3dState.activeModelId;
      var borderCol = isAct ? '#171719' : '#E5E6EB';
      var ringStyle = isAct ? 'box-shadow:0 0 0 1.5px #171719;' : '';
      return (
        '<div data-m3d-item="' + idx + '" style="position:relative;aspect-ratio:4/3;border-radius:8px;border:1px solid ' + borderCol + ';' + ringStyle + 'background:#F6F6FA;overflow:hidden;cursor:pointer;flex-shrink:0;">' +
          (m.thumb ? '<img src="' + esc(m.thumb) + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block;"/>' : '') +
          '<div style="position:absolute;inset:0;background:linear-gradient(180deg,rgba(0,0,0,0.05) 0%,rgba(0,0,0,0.68) 100%);display:flex;flex-direction:column;justify-content:space-between;padding:6px 8px;">' +
            '<div style="display:flex;justify-content:space-between;align-items:center;">' +
              '<span style="font-size:10px;font-weight:600;color:#ffffff;background:rgba(0,0,0,0.55);padding:1px 6px;border-radius:4px;">' + esc(m.engine) + '</span>' +
              '<button type="button" data-m3d-del="' + idx + '" title="Delete" style="width:20px;height:20px;border:none;border-radius:4px;background:rgba(255,255,255,0.9);color:#171719;font-size:11px;cursor:pointer;display:flex;align-items:center;justify-content:center;">×</button>' +
            '</div>' +
            '<div>' +
              '<div style="font-size:11px;font-weight:600;color:#ffffff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + esc(m.title) + '</div>' +
              '<div style="font-size:9.5px;color:rgba(255,255,255,0.78);">' + esc(m.createdAt || '2026/10/20') + '</div>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    var items = listEl.querySelectorAll('[data-m3d-item]');
    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('click', function (e) {
        if (e.target.closest('[data-m3d-del]')) return;
        var idx = parseInt(this.getAttribute('data-m3d-item'), 10);
        var rec = m3dState.models[idx];
        if (!rec) return;
        m3dState.activeModelId = rec.id;
        m3dState.modelEngine = rec.engine || 'Meshy 7.1';
        m3dState.genTab = rec.genTab || 'modeling';
        m3dState.renderMode = rec.mode || 'textured';
        if (rec.materialId) m3dState.selectedMaterialId = rec.materialId;
        if (rec.baseId) m3dState.selectedBaseId = rec.baseId;
        if (rec.uploadedImg) {
          m3dState.uploadedImg = rec.uploadedImg;
          m3dState.uploadedDataUrl = rec.uploadedDataUrl || '';
          m3dState.aiDepthImg = rec.aiDepthImg || null;
          m3dState.aiPlyUrl = rec.aiPlyUrl || '';
          m3dState.activePreset = 'uploaded';
          m3dState.hasUploadedImage = true;
        } else {
          m3dState.aiDepthImg = null;
          m3dState.aiPlyUrl = '';
          m3dState.activePreset = rec.preset || 'chibi';
        }
        m3dState._meshCacheKey = '';
        m3dState.viewState = 'viewer';
        syncM3dUploadPreview();
        syncM3dViewMode();
        renderM3dModelsSidebarList();
        renderM3dViewportCanvas();
      });
    }

    var delBtns = listEl.querySelectorAll('[data-m3d-del]');
    for (var d = 0; d < delBtns.length; d++) {
      delBtns[d].addEventListener('click', function (e) {
        e.stopPropagation();
        var idx = parseInt(this.getAttribute('data-m3d-del'), 10);
        if (m3dState.models.length <= 1) return;
        m3dState.models.splice(idx, 1);
        renderM3dModelsSidebarList();
      });
    }
  }

  function syncM3dViewMode() {
    var upModal = document.getElementById('Tg3dModUploadModal');
    var topBar = document.getElementById('Tg3dEditorTopBar');
    var rightPanel = document.getElementById('Tg3dModRightInspector');
    var disclaimer = document.getElementById('Tg3dPreviewDisclaimer');

    if (upModal) upModal.style.display = m3dState.viewState === 'upload' ? 'flex' : 'none';
    if (topBar) topBar.style.display = m3dState.viewState === 'viewer' ? 'flex' : 'none';
    if (rightPanel) rightPanel.style.display = m3dState.viewState === 'viewer' ? 'flex' : 'none';
    if (disclaimer) disclaimer.style.display = (m3dState.viewState === 'viewer' && m3dState.showAccessories) ? 'block' : 'none';

    // Sync Preview vs Model segment buttons
    var segScene = document.getElementById('Tg3dSegSceneBtn');
    var segModel = document.getElementById('Tg3dSegModelBtn');
    if (segScene && segModel) {
      segScene.style.background = m3dState.showAccessories ? '#ffffff' : 'transparent';
      segScene.style.color = m3dState.showAccessories ? '#171719' : '#929499';
      segScene.style.boxShadow = m3dState.showAccessories ? '0 2px 4px rgba(0,0,0,0.1)' : 'none';
      segModel.style.background = !m3dState.showAccessories ? '#ffffff' : 'transparent';
      segModel.style.color = !m3dState.showAccessories ? '#171719' : '#929499';
      segModel.style.boxShadow = !m3dState.showAccessories ? '0 2px 4px rgba(0,0,0,0.1)' : 'none';
    }

    // Show/hide right accordion blocks based on genTab and showAccessories
    var photoAdjustBox = document.getElementById('Tg3dPhotoAdjustBlock');
    var modelInfoBox = document.getElementById('Tg3dModelInfoBlock');
    var sceneMatBlock = document.getElementById('Tg3dSceneMaterialBlock');
    if (photoAdjustBox) photoAdjustBox.style.display = m3dState.genTab === 'photo' ? 'flex' : 'none';
    if (modelInfoBox) modelInfoBox.style.display = m3dState.genTab === 'modeling' ? 'flex' : 'none';
    if (sceneMatBlock) sceneMatBlock.style.display = m3dState.showAccessories ? 'block' : 'none';

    var engTag = document.getElementById('Tg3dInfoEngineTag');
    var texTag = document.getElementById('Tg3dInfoTexTag');
    if (engTag) engTag.textContent = m3dState.modelEngine;
    if (texTag) texTag.textContent = m3dState.textureOn ? 'Textured' : 'No Texture';

    // Sync Material cards
    var matCards = document.querySelectorAll('[data-m3d-mat]');
    for (var m = 0; m < matCards.length; m++) {
      var mAct = matCards[m].getAttribute('data-m3d-mat') === m3dState.selectedMaterialId;
      matCards[m].style.borderColor = mAct ? '#000000' : 'transparent';
      matCards[m].style.background = mAct ? '#F6F6FA' : 'transparent';
    }

    // Sync Base cards
    var baseCards = document.querySelectorAll('[data-m3d-base]');
    for (var b = 0; b < baseCards.length; b++) {
      var bAct = baseCards[b].getAttribute('data-m3d-base') === m3dState.selectedBaseId;
      baseCards[b].style.borderColor = bAct ? '#000000' : 'transparent';
      baseCards[b].style.background = bAct ? '#F6F6FA' : 'transparent';
    }

    // Sync Light Color dots
    var lightDots = document.querySelectorAll('[data-m3d-lcol]');
    for (var l = 0; l < lightDots.length; l++) {
      var lAct = lightDots[l].getAttribute('data-m3d-lcol') === m3dState.selectedLightColor;
      lightDots[l].style.borderColor = lAct ? '#000000' : '#B3B9C2';
      lightDots[l].style.transform = lAct ? 'scale(1.1)' : 'scale(1)';
    }

    // Sync Render Mode buttons
    var modeBtns = document.querySelectorAll('[data-m3d-rmode]');
    for (var r = 0; r < modeBtns.length; r++) {
      var rAct = modeBtns[r].getAttribute('data-m3d-rmode') === m3dState.renderMode;
      modeBtns[r].style.borderColor = rAct ? '#171719' : '#E5E6EB';
      modeBtns[r].style.background = rAct ? '#171719' : '#ffffff';
      modeBtns[r].style.color = rAct ? '#ffffff' : '#2D3541';
    }

    // Sync Bottom-Left Tool buttons & Zoom label
    var selBtn = document.getElementById('Tg3dToolSelectBtn');
    var dragBtn = document.getElementById('Tg3dToolDragBtn');
    if (selBtn && dragBtn) {
      selBtn.style.background = m3dState.interactionMode === 'SELECT' ? '#171719' : '#ffffff';
      selBtn.style.color = m3dState.interactionMode === 'SELECT' ? '#ffffff' : '#070B10';
      dragBtn.style.background = m3dState.interactionMode === 'DRAG' ? '#171719' : '#ffffff';
      dragBtn.style.color = m3dState.interactionMode === 'DRAG' ? '#ffffff' : '#070B10';
    }
    var zoomLbl = document.getElementById('Tg3dZoomLabel');
    if (zoomLbl) zoomLbl.textContent = Math.round(m3dState.zoomPct) + '%';
  }

  function handleM3dFileSelected(file, openStudioAfterLoad) {
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) {
      showStudioAuthToast('Upload failed: image must be smaller than 10MB.');
      return;
    }
    var reader = new FileReader();
    reader.onload = function (ev) {
      var img = new Image();
      img.onload = function () {
        m3dState.uploadedImg = img;
        m3dState.uploadedDataUrl = ev.target.result;
        m3dState.aiDepthImg = null;
        m3dState.aiPlyUrl = '';
        m3dState.activePreset = 'uploaded';
        m3dState.hasUploadedImage = true;
        m3dState._meshCacheKey = '';
        syncM3dUploadPreview();
        if (openStudioAfterLoad) {
          var rec = getUserProjectsForApp(activeSession.slug || 'ai-3d-model-generator')[0] || createNewProjectForApp(activeSession.slug || 'ai-3d-model-generator');
          openProjectInStudio(activeSession.slug || 'ai-3d-model-generator', rec.gid, activeSession.pdpUrl);
        } else {
          renderM3dViewportCanvas();
        }
      };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
  }

  function runNative3dModelGeneration(fromLanding) {
    if (m3dState.isGenerating) return;
    var reqCost = getM3dCreditCost();
    var curBal = getCreditBalance();
    var actualCost = curBal >= reqCost ? reqCost : (curBal >= 6 ? 6 : reqCost);
    var nextBal = deductAiCredits(actualCost);
    if (nextBal === null) {
      return { ok: false, reason: 'insufficient_credits', credits: getCreditBalance() };
    }

    if (fromLanding) {
      var rec = createNewProjectForApp(activeSession.slug || 'ai-3d-model-generator');
      openProjectInStudio(activeSession.slug || 'ai-3d-model-generator', rec.gid, activeSession.pdpUrl);
    }

    m3dState.isGenerating = true;
    m3dState.genPct = 8;
    m3dState.viewState = 'viewer';
    syncM3dViewMode();
    renderM3dModelsSidebarList();

    var runBtn = document.getElementById('Tg3dModRunBtn');
    if (runBtn) {
      runBtn.disabled = true;
      runBtn.style.cursor = 'progress';
    }

    var loadOverlay = document.getElementById('Tg3dPreviewLoadingOverlay');
    var loadFill = document.getElementById('Tg3dPreviewLoadingFill');
    var loadTitle = document.getElementById('Tg3dPreviewLoadingTitle');
    var loadSub = document.getElementById('Tg3dPreviewLoadingSub');
    if (loadOverlay) {
      loadOverlay.style.display = 'flex';
      if (loadFill) loadFill.style.width = '8%';
      if (loadTitle) {
        loadTitle.textContent = m3dState.genTab === 'photo'
          ? 'Generating 3D photo... (8%)'
          : 'Generating 3D model (' + m3dState.modelEngine + ')... (8%)';
      }
      if (loadSub) {
        loadSub.textContent = m3dState.genTab === 'photo'
          ? 'Expected to take 30 seconds, safe to leave this page.'
          : 'Expected to take 3–5 minutes, safe to leave this page.';
      }
    }

    if (m3dState._genProgressTimer) clearInterval(m3dState._genProgressTimer);
    var genStart = performance.now();
    var tauSec = m3dState.genTab === 'photo' ? 7.5 : 9.0;
    m3dState._genProgressTimer = setInterval(function () {
      if (!m3dState.isGenerating) {
        clearInterval(m3dState._genProgressTimer);
        m3dState._genProgressTimer = null;
        return;
      }
      var elapsed = (performance.now() - genStart) / 1000;
      var expPct = Math.min(95, Math.round(95 * (1 - Math.exp(-elapsed / tauSec))));
      m3dState.genPct = Math.max(m3dState.genPct || 8, expPct);
      if (loadFill) loadFill.style.width = m3dState.genPct + '%';
      if (loadTitle) {
        loadTitle.textContent = m3dState.genTab === 'photo'
          ? 'Generating 3D photo... (' + m3dState.genPct + '%)'
          : 'Generating 3D model (' + m3dState.modelEngine + ')... (' + m3dState.genPct + '%)';
      }
      var pendEls = document.querySelectorAll('.tg-3d-pending-pct');
      for (var p = 0; p < pendEls.length; p++) pendEls[p].textContent = m3dState.genPct + '%';
    }, 180);

    // Prepare source image data URL to send to real relief-3d AI on cinai.app
    var srcDataUrl = m3dState.uploadedDataUrl;
    if (!srcDataUrl) {
      var defCnv = drawM3dDefaultPreset(m3dState.activePreset || 'chibi');
      srcDataUrl = defCnv.toDataURL('image/png');
    }

    callStorefrontAiGateway(
      { mode: 'image-to-3d', image: srcDataUrl },
      function (step) {
        if (m3dState.isGenerating) {
          var pct = Math.min(95, 18 + step * 14);
          m3dState.genPct = Math.max(m3dState.genPct || 8, pct);
          if (loadFill) loadFill.style.width = m3dState.genPct + '%';
        }
      }
    ).then(function (res) {
      m3dState.isGenerating = false;
      if (m3dState._genProgressTimer) {
        clearInterval(m3dState._genProgressTimer);
        m3dState._genProgressTimer = null;
      }
      if (runBtn) {
        runBtn.disabled = false;
        runBtn.style.cursor = 'pointer';
      }
      if (loadFill) loadFill.style.width = '100%';
      setTimeout(function () {
        if (loadOverlay && !m3dState.isGenerating) loadOverlay.style.display = 'none';
      }, 180);
      if (res && res.ok) {
        if (res.imgElement) {
          m3dState.uploadedImg = res.imgElement;
          m3dState.uploadedDataUrl = res.cutoutUrl || res.imageUrl || srcDataUrl;
          m3dState.activePreset = 'uploaded';
          m3dState.hasUploadedImage = true;
        }
        if (res.depthImgElement) {
          m3dState.aiDepthImg = res.depthImgElement;
        }
        m3dState.aiPlyUrl = res.plyUrl || '';
      } else if (m3dState.uploadedImg) {
        m3dState.activePreset = 'uploaded';
      }
      m3dState.renderMode = m3dState.genTab === 'photo' ? 'crystal' : 'textured';
      m3dState._meshCacheKey = '';

      syncM3dUploadPreview();
      syncM3dViewMode();
      renderM3dViewportCanvas();

      var c = document.getElementById('Tg3dModCanvas');
      var thumb = c ? c.toDataURL('image/png') : (m3dState.uploadedDataUrl || '');
      var now = new Date();
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var ts = now.getFullYear() + '/' + pad(now.getMonth() + 1) + '/' + pad(now.getDate()) + ' ' + pad(now.getHours()) + ':' + pad(now.getMinutes());
      var newId = 'm_' + Date.now();
      m3dState.activeModelId = newId;
      m3dState.models.unshift({
        id: newId,
        title: m3dState.genTab === 'photo' ? ('3D Photo Crystal #' + (m3dState.models.length + 1)) : ('3D Model #' + (m3dState.models.length + 1)),
        engine: m3dState.genTab === 'photo' ? '3D Photo' : m3dState.modelEngine,
        genTab: m3dState.genTab,
        mode: m3dState.renderMode,
        preset: m3dState.activePreset,
        materialId: m3dState.selectedMaterialId,
        baseId: m3dState.selectedBaseId,
        uploadedImg: m3dState.uploadedImg,
        uploadedDataUrl: m3dState.uploadedDataUrl,
        aiDepthImg: m3dState.aiDepthImg,
        aiPlyUrl: m3dState.aiPlyUrl,
        createdAt: ts,
        thumb: thumb
      });
      renderM3dModelsSidebarList();
      saveCurrentStudioToDraft(false, thumb, (m3dState.genTab === 'photo' ? '3D Photo' : m3dState.modelEngine) + ' Crystal');
      showStudioAuthToast((m3dState.genTab === 'photo' ? 'AI 3D Photo Point Cloud' : m3dState.modelEngine + ' AI 3D Model') + ' generated! -' + actualCost + ' Credits (' + nextBal + ' remaining)');
    });

    return { ok: true, engine: m3dState.modelEngine, creditsRemaining: nextBal };
  }

  function ensureNative3dModelStudioDom(slug) {
    var wrap = document.getElementById('Kc3dEngineWrap');
    if (!wrap) return;
    var curSlug = String(slug || activeSession.slug || '').toLowerCase();
    var is3dAiModelApp = /^(ai-3d-model-generator|ai-3d-model|personalized-3d-laser-engraved-crystal-heart-couple-photo-lamp)$/i.test(curSlug);

    var host = document.getElementById('Tg3dModelStudioHost');
    if (!host) {
      host = document.createElement('div');
      host.id = 'Tg3dModelStudioHost';
      host.style.cssText = 'position:absolute;inset:0;z-index:61;background:#F1F2F4;display:none;font-family:Inter,sans-serif;color:#171719;overflow:hidden;';

      host.innerHTML =
        // 1. Atomm Left Sidebar (.editor-history.expanded, #FCFCFD, width 180px)
        '<aside id="Tg3dLeftHistoryAside" style="width:180px;flex:0 0 180px;height:100%;background:#FCFCFD;border-right:1px solid #D9DBDE;display:flex;flex-direction:column;z-index:15;transition:width .2s;">' +
          '<div style="display:flex;align-items:center;justify-content:space-between;padding:16px 16px 12px;">' +
            '<span style="font-size:14px;font-weight:600;color:#171719;">My Models</span>' +
            '<button type="button" id="Tg3dToggleLeftBtn" title="Toggle My Models" style="width:22px;height:22px;border:none;border-radius:5px;background:#F6F6FA;color:#2D3541;cursor:pointer;display:flex;align-items:center;justify-content:center;">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M9 3v18"/></svg>' +
            '</button>' +
          '</div>' +
          '<div style="padding:0 16px 12px;">' +
            '<button type="button" id="Tg3dModBtnNew" style="width:100%;height:44px;border:1px dashed #D6D8DB;border-radius:6px;background:#ffffff;color:#171719;font-size:13px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;transition:all .15s;">' +
              '<span style="font-size:16px;line-height:1;">+</span><span>Generate New</span>' +
            '</button>' +
          '</div>' +
          '<div id="Tg3dModList" style="flex:1;overflow-y:auto;padding:0 16px 76px;display:flex;flex-direction:column;gap:12px;"></div>' +
        '</aside>' +

        // 2. Center Workspace (.editor-workspace, #393A3D)
        '<main style="flex:1;min-width:0;height:100%;position:relative;display:flex;flex-direction:column;background:#393A3D;overflow:hidden;">' +

          // 2A. Top Floating Bar (.editor-top-bar: Scene Preview | Model Preview + Tips button)
          '<div id="Tg3dEditorTopBar" style="position:absolute;top:16px;left:0;right:0;z-index:20;display:none;align-items:center;justify-content:center;height:32px;pointer-events:none;">' +
            '<div style="pointer-events:auto;display:flex;align-items:center;height:32px;padding:2px;background:#E8E9EB;border-radius:6px;box-shadow:0 2px 8px rgba(0,0,0,0.18);">' +
              '<button type="button" id="Tg3dSegSceneBtn" style="width:112px;height:28px;border:none;border-radius:5px;background:#ffffff;color:#171719;font-size:12px;font-weight:600;cursor:pointer;box-shadow:0 2px 4px rgba(0,0,0,0.1);">Preview</button>' +
              '<button type="button" id="Tg3dSegModelBtn" style="width:112px;height:28px;border:none;border-radius:5px;background:transparent;color:#929499;font-size:12px;font-weight:600;cursor:pointer;">Model</button>' +
            '</div>' +
            '<button type="button" id="Tg3dTipsBtn" style="pointer-events:auto;position:absolute;right:16px;height:32px;padding:0 12px 0 8px;border:1px solid #D9DBDE;border-radius:100px;background:#ffffff;color:#3D3E42;font-size:13px;font-weight:500;cursor:pointer;display:inline-flex;align-items:center;gap:4px;box-shadow:0 2px 8px rgba(0,0,0,0.12);">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FF7C23" stroke-width="2"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>' +
              '<span>Tips</span>' +
            '</button>' +
          '</div>' +

          // 2B. Atomm Upload Modal Overlay (.editor-block-modal, shown when viewState === 'upload')
          '<div id="Tg3dModUploadModal" style="position:absolute;inset:0;z-index:30;background:rgba(26,26,30,0.52);backdrop-filter:blur(2px);display:flex;align-items:center;justify-content:center;padding:16px;">' +
            '<div style="width:760px;max-width:96%;background:#ffffff;border-radius:12px;padding:16px 20px;box-shadow:0 8px 32px rgba(0,0,0,0.28);display:flex;flex-direction:column;gap:14px;">' +
              // Modal Header with Atomm 3D Photo / 3D Modeling Mode Tabs + Close button
              '<div style="display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #F0F0F5;padding-bottom:10px;">' +
                '<div style="display:flex;align-items:center;gap:24px;">' +
                  '<button type="button" data-tg3d-tab="photo" style="position:relative;border:none;background:transparent;padding:4px 6px 8px;cursor:pointer;display:flex;align-items:center;gap:8px;font-size:14px;font-weight:700;color:#171719;">' +
                    '<img src="' + ATOMM_3D_ASSETS.tabPhoto + '" alt="3D Photo" style="width:32px;height:32px;border-radius:999px;object-fit:cover;"/>' +
                    '<span>3D Photo</span>' +
                    '<span class="tg3d-tab-bar" style="position:absolute;left:12px;right:12px;bottom:0;height:2.5px;background:#FF0035;border-radius:99px;opacity:0;transition:opacity .15s;"></span>' +
                  '</button>' +
                  '<button type="button" data-tg3d-tab="modeling" class="active" style="position:relative;border:none;background:transparent;padding:4px 6px 8px;cursor:pointer;display:flex;align-items:center;gap:8px;font-size:14px;font-weight:700;color:#171719;">' +
                    '<img src="' + ATOMM_3D_ASSETS.tabModeling + '" alt="3D Modeling" style="width:32px;height:32px;border-radius:999px;object-fit:cover;"/>' +
                    '<span>3D Modeling</span>' +
                    '<span class="tg3d-tab-bar" style="position:absolute;left:12px;right:12px;bottom:0;height:2.5px;background:#FF0035;border-radius:99px;opacity:1;transition:opacity .15s;"></span>' +
                  '</button>' +
                '</div>' +
                '<button type="button" id="Tg3dModCloseUploadBtn" title="Switch to 3D Preview" style="width:28px;height:28px;border:none;border-radius:6px;background:#F6F6FA;color:#4E5969;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;">×</button>' +
              '</div>' +

              // Atomm .upload-area (350px height, #F6F6FA)
              '<div style="position:relative;width:100%;height:348px;border-radius:12px;border:1px dashed rgba(83,91,136,0.16);background:#F6F6FA;overflow:hidden;display:flex;align-items:center;justify-content:center;">' +
                // State 1: Empty Placeholder (exact Atomm guide image/video + Upload image button)
                '<div id="Tg3dModEmptyBox" style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;padding:20px;text-align:center;width:100%;">' +
                  '<img id="Tg3dModGuideImg" src="' + ATOMM_3D_ASSETS.photoGuide + '" alt="3D Photo Guide" style="width:160px;height:120px;object-fit:contain;display:none;"/>' +
                  '<video id="Tg3dModGuideVid" src="' + ATOMM_3D_ASSETS.modelingVideo + '" autoplay loop muted playsinline style="width:220px;height:164px;object-fit:contain;border-radius:8px;display:block;"></video>' +
                  '<p id="Tg3dModGuideTitle" style="font-size:15px;font-weight:600;color:#171719;margin:4px 0 0;">Generate a fully 360° 3D model with complete geometry from a single image.</p>' +
                  '<p style="font-size:12px;color:#848B96;margin:0;">Supported formats: JPG/JPEG/PNG/WEBP, Maximum size: 10M.</p>' +
                  '<button type="button" id="Tg3dSuggestBtn" style="border:none;background:transparent;color:#FF7C23;font-size:12px;font-weight:500;cursor:pointer;display:inline-flex;align-items:center;gap:4px;padding:2px 6px;">' +
                    '<span>Image upload suggestions</span>' +
                    '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M8 14.667A6.667 6.667 0 1 1 8 1.333a6.667 6.667 0 0 1 0 13.334ZM7.333 4.667v1.333h1.334V4.667H7.333Zm0 2.666v4h1.334v-4H7.333Z" fill="#FF7C23"/></svg>' +
                  '</button>' +
                  '<div style="display:flex;align-items:center;gap:8px;margin-top:4px;flex-wrap:wrap;justify-content:center;">' +
                    '<label style="height:36px;padding:0 16px;border-radius:8px;background:#EBEDF0;color:#171719;font-size:13px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:6px;transition:background .15s;">' +
                      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3v12"/><path d="m17 8-5-5-5 5"/><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/></svg>' +
                      '<span>Upload image</span>' +
                      '<input type="file" id="Tg3dModFileInp" accept="image/*" style="display:none;"/>' +
                    '</label>' +
                    '<button type="button" data-m3d-sample="chibi" style="height:36px;padding:0 12px;border-radius:8px;border:1px solid #D8DADF;background:#ffffff;color:#2D3541;font-size:12px;font-weight:600;cursor:pointer;">Try Sample: Chibi Figurine</button>' +
                    '<button type="button" data-m3d-sample="astronaut" style="height:36px;padding:0 12px;border-radius:8px;border:1px solid #D8DADF;background:#ffffff;color:#2D3541;font-size:12px;font-weight:600;cursor:pointer;">Try Sample: 3D Astronaut</button>' +
                  '</div>' +
                '</div>' +

                // State 2: Uploaded Thumbnail Preview (blurred bg + sharp image + Replace button)
                '<div id="Tg3dModThumbBox" style="display:none;position:relative;width:100%;height:100%;align-items:center;justify-content:center;overflow:hidden;">' +
                  '<img id="Tg3dModPreviewBlurBg" src="" alt="" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;filter:blur(20px);opacity:0.65;"/>' +
                  '<img id="Tg3dModPreviewImg" src="" alt="Preview" style="position:relative;z-index:2;max-width:100%;max-height:100%;object-fit:contain;display:block;"/>' +
                  '<div style="position:absolute;top:12px;right:12px;z-index:5;display:flex;gap:6px;">' +
                    '<label style="height:32px;padding:0 12px;border-radius:8px;background:#ffffff;color:#171719;font-size:12px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:5px;box-shadow:0 2px 8px rgba(0,0,0,0.14);">' +
                      '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 3v12"/><path d="m17 8-5-5-5 5"/><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/></svg>' +
                      '<span>Replace</span>' +
                      '<input type="file" id="Tg3dModReplaceInp" accept="image/*" style="display:none;"/>' +
                    '</label>' +
                    '<button type="button" id="Tg3dModClearImgBtn" title="Clear image" style="height:32px;padding:0 10px;border:none;border-radius:8px;background:rgba(23,23,25,0.75);color:#ffffff;font-size:12px;font-weight:600;cursor:pointer;">Clear</button>' +
                  '</div>' +
                '</div>' +

                // Upload Suggestions Popover Card
                '<div id="Tg3dSuggestPopover" style="display:none;position:absolute;bottom:52px;left:50%;transform:translateX(-50%);z-index:25;width:290px;background:#1C1C21;color:#ffffff;border-radius:10px;padding:14px;box-shadow:0 12px 32px rgba(0,0,0,0.35);">' +
                  '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">' +
                    '<span style="font-size:13px;font-weight:600;">Image upload suggestions</span>' +
                    '<button type="button" id="Tg3dSuggestCloseBtn" style="border:none;background:transparent;color:#9CA3AF;cursor:pointer;font-size:15px;">×</button>' +
                  '</div>' +
                  '<div style="display:flex;gap:8px;margin-bottom:10px;">' +
                    '<div style="flex:1;position:relative;text-align:center;">' +
                      '<img src="' + ATOMM_3D_ASSETS.suggestError + '" alt="Don\'t" style="width:100%;height:105px;object-fit:cover;border-radius:6px;border:2px solid #EC221F;"/>' +
                      '<span style="position:absolute;bottom:-6px;left:50%;transform:translateX(-50%);background:#EC221F;color:#fff;width:18px;height:18px;border-radius:99px;font-size:11px;font-weight:800; line-height:18px;">✕</span>' +
                    '</div>' +
                    '<div style="flex:1;position:relative;text-align:center;">' +
                      '<img src="' + ATOMM_3D_ASSETS.suggestRight + '" alt="Do" style="width:100%;height:105px;object-fit:cover;border-radius:6px;border:2px solid #16B364;"/>' +
                      '<span style="position:absolute;bottom:-6px;left:50%;transform:translateX(-50%);background:#16B364;color:#fff;width:18px;height:18px;border-radius:99px;font-size:11px;font-weight:800;line-height:18px;">✓</span>' +
                    '</div>' +
                  '</div>' +
                  '<ul style="margin:6px 0 0;padding-left:16px;font-size:11.5px;color:#D1D5DB;line-height:1.5;">' +
                    '<li>Simple background</li>' +
                    '<li>Clear, large subject in image</li>' +
                    '<li>No text or watermarks</li>' +
                  '</ul>' +
                '</div>' +
              '</div>' +

              // Atomm .operation-area (Bottom Parameter Bar inside Upload Modal)
              '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;min-height:36px;">' +
                // 3D Photo Parameters: Remove Background + Processing Size(mm)
                '<div class="tg-3d-params-photo" style="display:none;align-items:center;gap:16px;flex-wrap:wrap;">' +
                  '<label style="display:inline-flex;align-items:center;gap:6px;font-size:12px;color:#848B96;cursor:pointer;">' +
                    '<span>Remove Background</span>' +
                    '<input type="checkbox" id="Tg3dPhotoBgChk" checked style="width:15px;height:15px;accent-color:#171719;cursor:pointer;"/>' +
                  '</label>' +
                  '<div style="display:inline-flex;align-items:center;gap:6px;font-size:12px;color:#848B96;">' +
                    '<span>Processing Size(mm)</span>' +
                    '<input type="number" id="Tg3dPhotoWInp" value="70" min="20" max="200" style="width:48px;height:28px;border:1px solid #E5E6EB;border-radius:6px;background:#F6F6FA;text-align:center;font-size:12px;font-weight:600;color:#171719;"/>' +
                    '<span>x</span>' +
                    '<input type="number" id="Tg3dPhotoHInp" value="70" min="20" max="200" style="width:48px;height:28px;border:1px solid #E5E6EB;border-radius:6px;background:#F6F6FA;text-align:center;font-size:12px;font-weight:600;color:#171719;"/>' +
                  '</div>' +
                '</div>' +

                // 3D Modeling Parameters: Model Dropdown + Texture + Image Optimization
                '<div class="tg-3d-params-modeling" style="display:flex;align-items:center;gap:16px;flex-wrap:wrap;">' +
                  '<div style="display:inline-flex;align-items:center;gap:6px;font-size:12px;color:#848B96;">' +
                    '<span>Model</span>' +
                    '<select id="Tg3dModEngineSelect" style="height:32px;min-width:170px;padding:0 10px;border-radius:6px;border:1px solid #E5E6EB;background:#F6F6FA;color:#171719;font-size:12px;font-weight:600;cursor:pointer;outline:none;">' +
                      '<option value="Meshy 7.1">Meshy 7.1 (Recommend · 4min)</option>' +
                      '<option value="Tripo">Tripo (Fast · 3min)</option>' +
                      '<option value="Hi3d 3.0">Hi3d 3.0 (Rich Detail · 5min)</option>' +
                      '<option value="Hunyuan">Hunyuan (Pet & Anime · 3min)</option>' +
                    '</select>' +
                  '</div>' +
                  '<label style="display:inline-flex;align-items:center;gap:6px;font-size:12px;color:#848B96;cursor:pointer;">' +
                    '<span>Texture</span>' +
                    '<input type="checkbox" id="Tg3dModTexChk" checked style="width:15px;height:15px;accent-color:#171719;cursor:pointer;"/>' +
                  '</label>' +
                  '<label style="display:inline-flex;align-items:center;gap:6px;font-size:12px;color:#848B96;cursor:pointer;">' +
                    '<span>Image Optimization</span>' +
                    '<input type="checkbox" id="Tg3dModOptChk" checked style="width:15px;height:15px;accent-color:#171719;cursor:pointer;"/>' +
                  '</label>' +
                '</div>' +

                '<button type="button" id="Tg3dModRunBtn" style="height:36px;padding:0 18px;border:none;border-radius:8px;background:#171719;color:#ffffff;font-size:13px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:8px;">' +
                  '<span>Generate</span>' +
                  '<span style="display:inline-flex;align-items:center;gap:4px;">' +
                    '<img src="' + ATOMM_3D_ASSETS.creditsIcon + '" alt="" style="width:14px;height:14px;"/>' +
                    '<span class="tg-3d-cost-val">70</span>' +
                  '</span>' +
                '</button>' +
              '</div>' +
            '</div>' +
          '</div>' +

          // 2C. Atomm PreviewLoading Overlay (#424242, shown during generation — 1:1 with Atomm data-v-bf4b55fb & data-v-8a9d7ddf)
          '<div id="Tg3dPreviewLoadingOverlay" style="display:none;position:absolute;inset:0;z-index:35;background:#424242;align-items:center;justify-content:center;">' +
            '<div style="width:100%;max-width:280px;display:flex;flex-direction:column;align-items:center;padding:0 16px;box-sizing:border-box;text-align:center;">' +
              '<div class="tg-3d-preview-loading__cube">' +
                '<div class="tg-3d-cube-wrapper">' +
                  '<div class="tg-3d-cube">' +
                    '<div class="tg-3d-face tg-3d-front"></div>' +
                    '<div class="tg-3d-face tg-3d-back"></div>' +
                    '<div class="tg-3d-face tg-3d-right"></div>' +
                    '<div class="tg-3d-face tg-3d-left"></div>' +
                    '<div class="tg-3d-face tg-3d-top"></div>' +
                    '<div class="tg-3d-face tg-3d-bottom"></div>' +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<div style="width:100%;height:3px;border-radius:2px;background:rgba(255,255,255,0.15);overflow:hidden;margin-bottom:16px;">' +
                '<div id="Tg3dPreviewLoadingFill" style="width:8%;height:100%;background:#ffffff;border-radius:2px;transition:width .2s linear;"></div>' +
              '</div>' +
              '<div id="Tg3dPreviewLoadingTitle" style="font-size:14px;font-weight:400;line-height:1.4;color:#ffffff;margin-bottom:4px;">Generating 3D model...</div>' +
              '<div id="Tg3dPreviewLoadingSub" style="font-size:12px;font-weight:400;line-height:1.4;color:rgba(255,255,255,0.6);">Expected to take 3–5 minutes, safe to leave this page.</div>' +
            '</div>' +
          '</div>' +

          // 2D. Center 3D Viewer Surface (.viewer-surface)
          '<div style="flex:1;width:100%;height:100%;position:relative;display:flex;align-items:center;justify-content:center;background:#393A3D;">' +
            '<canvas id="Tg3dModCanvas" width="920" height="620" style="width:100%;height:100%;display:block;cursor:grab;"></canvas>' +

            // Atomm Bottom-Left Tools Bar (.tools-container: Select, Drag, Zoom -, 100%, Zoom +, Fit to canvas)
            '<div style="position:absolute;left:16px;bottom:16px;z-index:12;display:flex;align-items:center;gap:4px;">' +
              '<button type="button" id="Tg3dToolSelectBtn" title="Rotate 3D Model" style="width:32px;height:32px;border:none;border-radius:8px;background:#171719;color:#ffffff;cursor:pointer;display:flex;align-items:center;justify-content:center;">' +
                '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m3 3 7.07 16.97 2.51-7.39 7.39-2.51L3 3z"/></svg>' +
              '</button>' +
              '<button type="button" id="Tg3dToolDragBtn" title="Pan View" style="width:32px;height:32px;border:none;border-radius:8px;background:#ffffff;color:#070B10;cursor:pointer;display:flex;align-items:center;justify-content:center;">' +
                '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0"/><path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2"/><path d="M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8"/><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/></svg>' +
              '</button>' +
              '<div style="width:4px;"></div>' +
              '<button type="button" id="Tg3dZoomOutBtn" title="Zoom Out" style="width:32px;height:32px;border:none;border-radius:8px;background:#ffffff;color:#070B10;cursor:pointer;display:flex;align-items:center;justify-content:center;">' +
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8H13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
              '</button>' +
              '<div style="height:32px;min-width:52px;padding:0 8px;border-radius:8px;background:#ffffff;color:#070B10;font-size:12px;font-weight:500;display:flex;align-items:center;justify-content:center;" id="Tg3dZoomLabel">100%</div>' +
              '<button type="button" id="Tg3dZoomInBtn" title="Zoom In" style="width:32px;height:32px;border:none;border-radius:8px;background:#ffffff;color:#070B10;cursor:pointer;display:flex;align-items:center;justify-content:center;">' +
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
              '</button>' +
              '<div style="width:4px;"></div>' +
              '<button type="button" id="Tg3dFitCanvasBtn" title="Fit to canvas" style="width:32px;height:32px;border:none;border-radius:8px;background:#ffffff;color:#070B10;cursor:pointer;display:flex;align-items:center;justify-content:center;">' +
                '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M21 8V5a2 2 0 0 0-2-2h-3"/><path d="M3 16v3a2 2 0 0 0 2 2h3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/></svg>' +
              '</button>' +
            '</div>' +

            // Atomm Preview Disclaimer (.preview-disclaimer)
            '<div id="Tg3dPreviewDisclaimer" style="position:absolute;left:50%;bottom:16px;transform:translateX(-50%);font-size:12px;color:rgba(255,255,255,0.55);pointer-events:none;white-space:nowrap;">Preview is illustrative; actual product may vary.</div>' +
          '</div>' +
        '</main>' +

        // 3. Atomm Right Settings Sidebar (.right-settings, #FCFCFD, width 320px)
        '<aside id="Tg3dModRightInspector" style="width:320px;flex:0 0 320px;height:100%;background:#FCFCFD;border-left:1px solid #D9DBDE;display:none;flex-direction:column;z-index:15;">' +
          '<div style="flex:1;overflow-y:auto;padding:12px 16px;display:flex;flex-direction:column;gap:12px;">' +

            // Block 1: Basic Information (.right-side-block)
            '<div style="border:1px solid rgba(61,62,66,0.08);border-radius:8px;background:#ffffff;box-shadow:0 0 4px rgba(11,11,13,0.06);">' +
              '<div style="height:40px;padding:0 16px;border-bottom:1px solid rgba(61,62,66,0.08);display:flex;align-items:center;justify-content:space-between;font-size:12px;font-weight:600;color:#171719;">' +
                '<span>Basic Information</span>' +
              '</div>' +
              '<div style="padding:12px 16px;display:flex;flex-direction:column;gap:12px;">' +
                '<div style="display:flex;align-items:center;justify-content:space-between;">' +
                  '<span style="font-size:12px;font-weight:500;color:#2D3541;">Original Image</span>' +
                  '<div style="display:flex;align-items:center;gap:8px;">' +
                    '<img id="Tg3dOrigThumbImg" src="" alt="Original" style="width:44px;height:44px;border-radius:6px;object-fit:cover;border:1px solid #E5E6EB;background:#F6F6FA;"/>' +
                    '<button type="button" id="Tg3dReopenUploadBtn" style="height:28px;padding:0 10px;border:1px solid #D8DADF;border-radius:6px;background:#ffffff;color:#171719;font-size:11px;font-weight:600;cursor:pointer;">Replace</button>' +
                  '</div>' +
                '</div>' +

                // 3D Photo Adjustment sub-block (Dot Spacing + Auto Adjust + Strength)
                '<div id="Tg3dPhotoAdjustBlock" style="display:none;flex-direction:column;gap:10px;border-top:1px solid #F2F3F5;padding-top:10px;">' +
                  '<div style="font-size:12px;font-weight:500;color:#2D3541;">Adjustment</div>' +
                  '<div>' +
                    '<div style="display:flex;justify-content:space-between;font-size:12px;color:#848B96;margin-bottom:4px;">' +
                      '<span>Dot Spacing (mm)</span>' +
                      '<span id="Tg3dDotSpacingVal" style="color:#2D3541;font-weight:600;">0.03</span>' +
                    '</div>' +
                    '<input type="range" id="Tg3dDotSpacingRange" min="2" max="15" value="3" style="width:100%;accent-color:#171719;cursor:pointer;"/>' +
                  '</div>' +
                  '<div>' +
                    '<div style="display:flex;justify-content:space-between;align-items:center;font-size:12px;color:#848B96;margin-bottom:4px;">' +
                      '<span>Auto Adjust Strength</span>' +
                      '<span id="Tg3dStrengthVal" style="color:#2D3541;font-weight:600;">68%</span>' +
                    '</div>' +
                    '<input type="range" id="Tg3dStrengthRange" min="15" max="100" value="68" style="width:100%;accent-color:#171719;cursor:pointer;"/>' +
                  '</div>' +
                '</div>' +

                // 3D Model Info sub-block (Engine + Textured tags + Material shader pills)
                '<div id="Tg3dModelInfoBlock" style="display:flex;flex-direction:column;gap:10px;border-top:1px solid #F2F3F5;padding-top:10px;">' +
                  '<div style="display:flex;align-items:center;justify-content:space-between;">' +
                    '<span style="font-size:12px;font-weight:500;color:#2D3541;">Model Info</span>' +
                    '<div style="display:flex;gap:4px;">' +
                      '<span id="Tg3dInfoEngineTag" style="font-size:10px;color:#2D3541;background:#E7E9ED;padding:3px 8px;border-radius:4px;font-weight:500;">Meshy 7.1</span>' +
                      '<span id="Tg3dInfoTexTag" style="font-size:10px;color:#2D3541;background:#E7E9ED;padding:3px 8px;border-radius:4px;font-weight:500;">Textured</span>' +
                    '</div>' +
                  '</div>' +
                  '<div style="display:grid;grid-template-columns:repeat(2,1fr);gap:6px;">' +
                    '<button type="button" data-m3d-rmode="textured" style="height:28px;border-radius:6px;border:1px solid #171719;background:#171719;color:#ffffff;font-size:11px;font-weight:600;cursor:pointer;">Textured 3D</button>' +
                    '<button type="button" data-m3d-rmode="crystal" style="height:28px;border-radius:6px;border:1px solid #E5E6EB;background:#ffffff;color:#2D3541;font-size:11px;font-weight:600;cursor:pointer;">Laser Point Cloud</button>' +
                    '<button type="button" data-m3d-rmode="clay" style="height:28px;border-radius:6px;border:1px solid #E5E6EB;background:#ffffff;color:#2D3541;font-size:11px;font-weight:600;cursor:pointer;">White Clay</button>' +
                    '<button type="button" data-m3d-rmode="gold" style="height:28px;border-radius:6px;border:1px solid #E5E6EB;background:#ffffff;color:#2D3541;font-size:11px;font-weight:600;cursor:pointer;">24K Gold Relief</button>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +

            // Block 2: Model Placement (.right-side-block: Rotation X/Y/Z, Quick Angles, Size, Vertical Position, Reset)
            '<div style="border:1px solid rgba(61,62,66,0.08);border-radius:8px;background:#ffffff;box-shadow:0 0 4px rgba(11,11,13,0.06);">' +
              '<div style="height:40px;padding:0 16px;border-bottom:1px solid rgba(61,62,66,0.08);display:flex;align-items:center;justify-content:space-between;font-size:12px;font-weight:600;color:#171719;">' +
                '<span>Model Placement</span>' +
              '</div>' +
              '<div style="padding:12px 16px;display:flex;flex-direction:column;gap:10px;">' +
                '<div>' +
                  '<div style="display:flex;justify-content:space-between;font-size:12px;color:#848B96;margin-bottom:2px;">' +
                    '<span>Rotation Y (Turntable)</span><span id="Tg3dRotYLbl" style="color:#2D3541;font-weight:600;">-22°</span>' +
                  '</div>' +
                  '<input type="range" id="Tg3dRotYRange" min="-180" max="180" value="-22" style="width:100%;accent-color:#171719;cursor:pointer;"/>' +
                  '<div style="display:flex;gap:4px;margin-top:4px;">' +
                    '<button type="button" data-m3d-qangle="0" style="flex:1;padding:4px 0;border:1px solid #E7E9ED;border-radius:4px;background:#ffffff;font-size:11px;color:#2D3541;cursor:pointer;">0°</button>' +
                    '<button type="button" data-m3d-qangle="-35" style="flex:1;padding:4px 0;border:1px solid #E7E9ED;border-radius:4px;background:#ffffff;font-size:11px;color:#2D3541;cursor:pointer;">-35°</button>' +
                    '<button type="button" data-m3d-qangle="35" style="flex:1;padding:4px 0;border:1px solid #E7E9ED;border-radius:4px;background:#ffffff;font-size:11px;color:#2D3541;cursor:pointer;">35°</button>' +
                    '<button type="button" data-m3d-qangle="180" style="flex:1;padding:4px 0;border:1px solid #E7E9ED;border-radius:4px;background:#ffffff;font-size:11px;color:#2D3541;cursor:pointer;">180°</button>' +
                  '</div>' +
                '</div>' +
                '<div>' +
                  '<div style="display:flex;justify-content:space-between;font-size:12px;color:#848B96;margin-bottom:2px;">' +
                    '<span>Rotation X (Tilt)</span><span id="Tg3dRotXLbl" style="color:#2D3541;font-weight:600;">12°</span>' +
                  '</div>' +
                  '<input type="range" id="Tg3dRotXRange" min="-60" max="60" value="12" style="width:100%;accent-color:#171719;cursor:pointer;"/>' +
                '</div>' +
                '<div>' +
                  '<div style="display:flex;justify-content:space-between;font-size:12px;color:#848B96;margin-bottom:2px;">' +
                    '<span>Size</span><span id="Tg3dFillLbl" style="color:#2D3541;font-weight:600;">100%</span>' +
                  '</div>' +
                  '<input type="range" id="Tg3dFillRange" min="60" max="135" value="100" style="width:100%;accent-color:#171719;cursor:pointer;"/>' +
                '</div>' +
                '<div>' +
                  '<div style="display:flex;justify-content:space-between;font-size:12px;color:#848B96;margin-bottom:2px;">' +
                    '<span>Vertical Position</span><span id="Tg3dOffsetYLbl" style="color:#2D3541;font-weight:600;">0.0mm</span>' +
                  '</div>' +
                  '<input type="range" id="Tg3dOffsetYRange" min="-15" max="15" value="0" style="width:100%;accent-color:#171719;cursor:pointer;"/>' +
                '</div>' +
                '<button type="button" id="Tg3dResetCamBtn" style="width:100%;height:30px;border:1px solid #E5E6EB;border-radius:6px;background:#F6F6FA;color:#2D3541;font-size:12px;font-weight:600;cursor:pointer;">Reset</button>' +
              '</div>' +
            '</div>' +

            // Block 3: Preview Settings (Material Type, Pedestal Type, Light Color)
            '<div id="Tg3dSceneMaterialBlock" style="border:1px solid rgba(61,62,66,0.08);border-radius:8px;background:#ffffff;box-shadow:0 0 4px rgba(11,11,13,0.06);">' +
              '<div style="height:40px;padding:0 16px;border-bottom:1px solid rgba(61,62,66,0.08);display:flex;align-items:center;justify-content:space-between;font-size:12px;font-weight:600;color:#171719;">' +
                '<span>Preview Settings</span>' +
              '</div>' +
              '<div style="padding:12px 16px;display:flex;flex-direction:column;gap:14px;">' +
                '<div>' +
                  '<div style="font-size:12px;font-weight:500;color:#2D3541;margin-bottom:8px;">Material Type</div>' +
                  '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;">' +
                    ATOMM_3D_MATERIALS.map(function (mat) {
                      return (
                        '<div data-m3d-mat="' + mat.id + '" style="display:flex;flex-direction:column;gap:4px;padding:4px;border-radius:6px;border:1px solid transparent;cursor:pointer;transition:all .15s;">' +
                          '<div style="aspect-ratio:1/1;border-radius:6px;background:#F6F6FA;overflow:hidden;">' +
                            '<img src="' + mat.thumb + '" alt="' + esc(mat.name) + '" style="width:100%;height:100%;object-fit:cover;display:block;"/>' +
                          '</div>' +
                          '<div style="font-size:10px;color:#2D3541;line-height:1.25;">' + esc(mat.name) + '</div>' +
                        '</div>'
                      );
                    }).join('') +
                  '</div>' +
                '</div>' +

                '<div>' +
                  '<div style="font-size:12px;font-weight:500;color:#2D3541;margin-bottom:8px;">Pedestal Type</div>' +
                  '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;">' +
                    ATOMM_3D_BASES.map(function (bs) {
                      return (
                        '<div data-m3d-base="' + bs.id + '" style="display:flex;flex-direction:column;gap:3px;padding:4px;border-radius:6px;border:1px solid transparent;cursor:pointer;transition:all .15s;">' +
                          '<div style="aspect-ratio:1/1;border-radius:6px;background:#F6F6FA;overflow:hidden;">' +
                            '<img src="' + bs.thumb + '" alt="' + esc(bs.name) + '" style="width:100%;height:100%;object-fit:cover;display:block;"/>' +
                          '</div>' +
                          '<div style="font-size:10px;color:#2D3541;line-height:1.2;">' + esc(bs.name) + '</div>' +
                          '<div style="font-size:9px;color:#848B96;line-height:1.1;">' + esc(bs.sub) + '</div>' +
                        '</div>'
                      );
                    }).join('') +
                  '</div>' +
                '</div>' +

                '<div>' +
                  '<div style="font-size:12px;font-weight:500;color:#2D3541;margin-bottom:8px;">Light Color</div>' +
                  '<div style="display:flex;align-items:center;gap:8px;">' +
                    ATOMM_3D_LIGHT_COLORS.map(function (lc) {
                      return '<button type="button" data-m3d-lcol="' + lc.value + '" title="' + esc(lc.label) + '" style="width:28px;height:28px;border-radius:999px;border:2px solid #B3B9C2;background:' + lc.value + ';cursor:pointer;padding:0;transition:all .15s;"></button>';
                    }).join('') +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +

          '</div>' +

          // Atomm Bottom Export & Buy Materials Area (.export-area)
          '<div style="padding:14px 16px;background:#FCFCFD;border-top:1px solid #E5E6EB;display:flex;flex-direction:column;gap:10px;box-shadow:0 -4px 12px rgba(11,11,13,0.04);">' +
            '<button type="button" id="Tg3dBuyMaterialsBtn" style="width:100%;height:38px;border:none;border-radius:8px;background:#FF6500;color:#ffffff;font-size:13.5px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;">' +
              '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2.177 2.666H1.333V1.333h.844a2 2 0 0 1 1.98 1.717l.135.95H14a.667.667 0 0 1 .632.877l-1.03 3.088a2 2 0 0 1-1.897 1.368H5.054l.109.761a.667.667 0 0 0 .66.572H14v1.333H5.823a2 2 0 0 1-1.98-1.717L2.837 3.239a.667.667 0 0 0-.66-.573Z" fill="white"/></svg>' +
              '<span>Buy Materials</span>' +
            '</button>' +
            '<button type="button" id="Tg3dModDownloadStlBtn" style="width:100%;height:38px;border:none;border-radius:8px;background:#171719;color:#ffffff;font-size:13.5px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;">' +
              '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>' +
              '<span>Export (.STL / .PLY)</span>' +
            '</button>' +
          '</div>' +
        '</aside>' +

        // 4. Atomm Fabrication Tips Modal
        '<div id="Tg3dTipsModal" style="display:none;position:fixed;inset:0;z-index:2147483645;background:rgba(0,0,0,0.45);align-items:center;justify-content:center;padding:16px;">' +
          '<div style="width:480px;max-width:94vw;background:#ffffff;border-radius:12px;overflow:hidden;box-shadow:0 20px 50px rgba(0,0,0,0.3);">' +
            '<div style="display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #E5E6EB;">' +
              '<span style="font-size:16px;font-weight:700;color:#171719;">Fabrication Tips</span>' +
              '<button type="button" id="Tg3dTipsCloseBtn" style="border:none;background:transparent;font-size:20px;color:#848B96;cursor:pointer;">×</button>' +
            '</div>' +
            '<div style="padding:20px;display:flex;flex-direction:column;gap:12px;font-size:13px;color:#2D3541;line-height:1.55;">' +
              '<div style="padding:10px 12px;background:#F6F6FA;border-radius:8px;"><strong>1. Open in Studio:</strong> Import the generated 3D model or point cloud, and make sure the front of the model faces the laser direction.</div>' +
              '<div style="padding:10px 12px;background:#F6F6FA;border-radius:8px;"><strong>2. Install 3D Engraving Lens:</strong> Use the dedicated inner-engraving focal lens for K9 optical crystal blanks.</div>' +
              '<div style="padding:10px 12px;background:#F6F6FA;border-radius:8px;"><strong>3. Position the K9 Crystal:</strong> Place the K9 Crystal Ball or Rectangle Block on the engraving base and align with the center guide.</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div id="Tg3dMobileNav">' +
          '<button type="button" data-m3d-mob="models"><span>My Models</span></button>' +
          '<button type="button" data-m3d-mob="canvas" class="is-active"><span>3D Viewer</span></button>' +
          '<button type="button" data-m3d-mob="params"><span>Settings & Export</span></button>' +
        '</div>';

      host.setAttribute('data-mob-pane', 'canvas');
      wrap.appendChild(host);

      var m3dMobBtns = host.querySelectorAll('[data-m3d-mob]');
      for (var m3i = 0; m3i < m3dMobBtns.length; m3i++) {
        m3dMobBtns[m3i].addEventListener('click', function () {
          var pane = this.getAttribute('data-m3d-mob') || 'canvas';
          host.setAttribute('data-mob-pane', pane);
          for (var k = 0; k < m3dMobBtns.length; k++) {
            m3dMobBtns[k].classList.toggle('is-active', m3dMobBtns[k].getAttribute('data-m3d-mob') === pane);
          }
          if (pane === 'canvas') renderM3dViewportCanvas();
        });
      }

      // Wire events inside #Tg3dModelStudioHost
      document.getElementById('Tg3dToggleLeftBtn').addEventListener('click', function () {
        var aside = document.getElementById('Tg3dLeftHistoryAside');
        if (!aside) return;
        m3dState.leftExpanded = !m3dState.leftExpanded;
        aside.style.width = m3dState.leftExpanded ? '180px' : '52px';
        aside.style.flex = m3dState.leftExpanded ? '0 0 180px' : '0 0 52px';
        document.getElementById('Tg3dModList').style.display = m3dState.leftExpanded ? 'flex' : 'none';
        document.getElementById('Tg3dModBtnNew').style.display = m3dState.leftExpanded ? 'flex' : 'none';
      });

      document.getElementById('Tg3dModBtnNew').addEventListener('click', function () {
        m3dState.viewState = 'upload';
        syncM3dUploadPreview();
        syncM3dViewMode();
      });

      document.getElementById('Tg3dReopenUploadBtn').addEventListener('click', function () {
        m3dState.viewState = 'upload';
        syncM3dUploadPreview();
        syncM3dViewMode();
      });

      document.getElementById('Tg3dModCloseUploadBtn').addEventListener('click', function () {
        m3dState.viewState = 'viewer';
        syncM3dViewMode();
        renderM3dViewportCanvas();
      });

      var tabBtns = host.querySelectorAll('[data-tg3d-tab]');
      for (var t = 0; t < tabBtns.length; t++) {
        tabBtns[t].addEventListener('click', function () {
          m3dState.genTab = this.getAttribute('data-tg3d-tab') || 'modeling';
          syncM3dUploadPreview();
          syncM3dViewMode();
          renderM3dViewportCanvas();
        });
      }

      var sampleBtns = host.querySelectorAll('[data-m3d-sample]');
      for (var s = 0; s < sampleBtns.length; s++) {
        sampleBtns[s].addEventListener('click', function () {
          m3dState.activePreset = this.getAttribute('data-m3d-sample') || 'chibi';
          m3dState.uploadedImg = null;
          m3dState.uploadedDataUrl = '';
          m3dState.hasUploadedImage = true;
          m3dState._meshCacheKey = '';
          syncM3dUploadPreview();
        });
      }

      document.getElementById('Tg3dModClearImgBtn').addEventListener('click', function () {
        m3dState.hasUploadedImage = false;
        m3dState.uploadedImg = null;
        m3dState.uploadedDataUrl = '';
        syncM3dUploadPreview();
      });

      document.getElementById('Tg3dSuggestBtn').addEventListener('click', function () {
        var pop = document.getElementById('Tg3dSuggestPopover');
        if (pop) pop.style.display = pop.style.display === 'none' ? 'block' : 'none';
      });
      document.getElementById('Tg3dSuggestCloseBtn').addEventListener('click', function () {
        var pop = document.getElementById('Tg3dSuggestPopover');
        if (pop) pop.style.display = 'none';
      });

      document.getElementById('Tg3dModFileInp').addEventListener('change', function () {
        if (this.files && this.files[0]) handleM3dFileSelected(this.files[0], false);
      });
      document.getElementById('Tg3dModReplaceInp').addEventListener('change', function () {
        if (this.files && this.files[0]) handleM3dFileSelected(this.files[0], false);
      });

      document.getElementById('Tg3dPhotoBgChk').addEventListener('change', function () {
        m3dState.removeBg = Boolean(this.checked);
        m3dState._meshCacheKey = '';
        renderM3dViewportCanvas();
      });
      document.getElementById('Tg3dPhotoWInp').addEventListener('input', function () {
        m3dState.procWidthMm = parseInt(this.value, 10) || 70;
      });
      document.getElementById('Tg3dPhotoHInp').addEventListener('input', function () {
        m3dState.procHeightMm = parseInt(this.value, 10) || 70;
      });
      document.getElementById('Tg3dModEngineSelect').addEventListener('change', function () {
        m3dState.modelEngine = this.value;
        syncM3dUploadPreview();
      });
      document.getElementById('Tg3dModTexChk').addEventListener('change', function () {
        m3dState.textureOn = Boolean(this.checked);
        syncM3dUploadPreview();
        renderM3dViewportCanvas();
      });
      document.getElementById('Tg3dModOptChk').addEventListener('change', function () {
        m3dState.optimizeOn = Boolean(this.checked);
      });

      document.getElementById('Tg3dModRunBtn').addEventListener('click', function () {
        runNative3dModelGeneration(false);
      });

      document.getElementById('Tg3dSegSceneBtn').addEventListener('click', function () {
        m3dState.showAccessories = true;
        syncM3dViewMode();
        renderM3dViewportCanvas();
      });
      document.getElementById('Tg3dSegModelBtn').addEventListener('click', function () {
        m3dState.showAccessories = false;
        syncM3dViewMode();
        renderM3dViewportCanvas();
      });

      document.getElementById('Tg3dTipsBtn').addEventListener('click', function () {
        document.getElementById('Tg3dTipsModal').style.display = 'flex';
      });
      document.getElementById('Tg3dTipsCloseBtn').addEventListener('click', function () {
        document.getElementById('Tg3dTipsModal').style.display = 'none';
      });

      document.getElementById('Tg3dDotSpacingRange').addEventListener('input', function () {
        m3dState.dotSpacingMm = (parseInt(this.value, 10) || 3) / 100;
        document.getElementById('Tg3dDotSpacingVal').textContent = m3dState.dotSpacingMm.toFixed(2);
        renderM3dViewportCanvas();
      });
      document.getElementById('Tg3dStrengthRange').addEventListener('input', function () {
        m3dState.strengthPct = parseInt(this.value, 10) || 68;
        document.getElementById('Tg3dStrengthVal').textContent = m3dState.strengthPct + '%';
        m3dState._meshCacheKey = '';
        renderM3dViewportCanvas();
      });

      var rBtns = host.querySelectorAll('[data-m3d-rmode]');
      for (var r = 0; r < rBtns.length; r++) {
        rBtns[r].addEventListener('click', function () {
          m3dState.renderMode = this.getAttribute('data-m3d-rmode');
          syncM3dViewMode();
          renderM3dViewportCanvas();
        });
      }

      document.getElementById('Tg3dRotYRange').addEventListener('input', function () {
        m3dState.rotY = parseInt(this.value, 10) || 0;
        document.getElementById('Tg3dRotYLbl').textContent = m3dState.rotY + '°';
        renderM3dViewportCanvas();
      });
      document.getElementById('Tg3dRotXRange').addEventListener('input', function () {
        m3dState.rotX = parseInt(this.value, 10) || 0;
        document.getElementById('Tg3dRotXLbl').textContent = m3dState.rotX + '°';
        renderM3dViewportCanvas();
      });
      document.getElementById('Tg3dFillRange').addEventListener('input', function () {
        var pct = parseInt(this.value, 10) || 100;
        m3dState.fillRatio = pct / 100;
        document.getElementById('Tg3dFillLbl').textContent = pct + '%';
        renderM3dViewportCanvas();
      });
      document.getElementById('Tg3dOffsetYRange').addEventListener('input', function () {
        m3dState.offsetYMm = parseFloat(this.value) || 0;
        document.getElementById('Tg3dOffsetYLbl').textContent = (m3dState.offsetYMm > 0 ? '+' : '') + m3dState.offsetYMm.toFixed(1) + 'mm';
        renderM3dViewportCanvas();
      });

      var qBtns = host.querySelectorAll('[data-m3d-qangle]');
      for (var q = 0; q < qBtns.length; q++) {
        qBtns[q].addEventListener('click', function () {
          m3dState.rotY = parseInt(this.getAttribute('data-m3d-qangle'), 10) || 0;
          var rY = document.getElementById('Tg3dRotYRange');
          if (rY) rY.value = String(m3dState.rotY);
          document.getElementById('Tg3dRotYLbl').textContent = m3dState.rotY + '°';
          renderM3dViewportCanvas();
        });
      }

      document.getElementById('Tg3dResetCamBtn').addEventListener('click', function () {
        m3dState.rotX = 12;
        m3dState.rotY = -22;
        m3dState.rotZ = 0;
        m3dState.fillRatio = 1.0;
        m3dState.offsetYMm = 0;
        m3dState.zoomPct = 100;
        m3dState.panX = 0;
        m3dState.panY = 0;
        document.getElementById('Tg3dRotYRange').value = '-22';
        document.getElementById('Tg3dRotYLbl').textContent = '-22°';
        document.getElementById('Tg3dRotXRange').value = '12';
        document.getElementById('Tg3dRotXLbl').textContent = '12°';
        document.getElementById('Tg3dFillRange').value = '100';
        document.getElementById('Tg3dFillLbl').textContent = '100%';
        document.getElementById('Tg3dOffsetYRange').value = '0';
        document.getElementById('Tg3dOffsetYLbl').textContent = '0.0mm';
        syncM3dViewMode();
        renderM3dViewportCanvas();
      });

      var matCards = host.querySelectorAll('[data-m3d-mat]');
      for (var m = 0; m < matCards.length; m++) {
        matCards[m].addEventListener('click', function () {
          m3dState.selectedMaterialId = this.getAttribute('data-m3d-mat');
          syncM3dViewMode();
          renderM3dViewportCanvas();
        });
      }

      var baseCards = host.querySelectorAll('[data-m3d-base]');
      for (var b = 0; b < baseCards.length; b++) {
        baseCards[b].addEventListener('click', function () {
          m3dState.selectedBaseId = this.getAttribute('data-m3d-base');
          syncM3dViewMode();
          renderM3dViewportCanvas();
        });
      }

      var lColBtns = host.querySelectorAll('[data-m3d-lcol]');
      for (var l = 0; l < lColBtns.length; l++) {
        lColBtns[l].addEventListener('click', function () {
          m3dState.selectedLightColor = this.getAttribute('data-m3d-lcol');
          syncM3dViewMode();
          renderM3dViewportCanvas();
        });
      }

      document.getElementById('Tg3dToolSelectBtn').addEventListener('click', function () {
        m3dState.interactionMode = 'SELECT';
        syncM3dViewMode();
      });
      document.getElementById('Tg3dToolDragBtn').addEventListener('click', function () {
        m3dState.interactionMode = 'DRAG';
        syncM3dViewMode();
      });
      document.getElementById('Tg3dZoomOutBtn').addEventListener('click', function () {
        m3dState.zoomPct = Math.max(50, m3dState.zoomPct - 15);
        syncM3dViewMode();
        renderM3dViewportCanvas();
      });
      document.getElementById('Tg3dZoomInBtn').addEventListener('click', function () {
        m3dState.zoomPct = Math.min(220, m3dState.zoomPct + 15);
        syncM3dViewMode();
        renderM3dViewportCanvas();
      });
      document.getElementById('Tg3dFitCanvasBtn').addEventListener('click', function () {
        m3dState.zoomPct = 100;
        m3dState.panX = 0;
        m3dState.panY = 0;
        syncM3dViewMode();
        renderM3dViewportCanvas();
      });

      document.getElementById('Tg3dBuyMaterialsBtn').addEventListener('click', function () {
        if (typeof window.openSuppliesKitDrawer === 'function') window.openSuppliesKitDrawer();
      });
      document.getElementById('Tg3dModDownloadStlBtn').addEventListener('click', function () {
        exportM3dStlFile();
      });

      // Interactive 360° Orbit & Pan on #Tg3dModCanvas
      var c3d = document.getElementById('Tg3dModCanvas');
      var dragging = false;
      var lastX = 0, lastY = 0;
      c3d.addEventListener('mousedown', function (e) {
        dragging = true;
        lastX = e.clientX;
        lastY = e.clientY;
        c3d.style.cursor = 'grabbing';
      });
      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - lastX;
        var dy = e.clientY - lastY;
        lastX = e.clientX;
        lastY = e.clientY;
        if (m3dState.interactionMode === 'DRAG' || e.shiftKey) {
          m3dState.panX += dx;
          m3dState.panY += dy;
        } else {
          m3dState.rotY = Math.max(-180, Math.min(180, m3dState.rotY + dx * 0.55));
          m3dState.rotX = Math.max(-60, Math.min(60, m3dState.rotX + dy * 0.45));
          var rY = document.getElementById('Tg3dRotYRange');
          var rX = document.getElementById('Tg3dRotXRange');
          if (rY) rY.value = String(Math.round(m3dState.rotY));
          if (rX) rX.value = String(Math.round(m3dState.rotX));
          var lY = document.getElementById('Tg3dRotYLbl');
          var lX = document.getElementById('Tg3dRotXLbl');
          if (lY) lY.textContent = Math.round(m3dState.rotY) + '°';
          if (lX) lX.textContent = Math.round(m3dState.rotX) + '°';
        }
        renderM3dViewportCanvas();
      });
      window.addEventListener('mouseup', function () {
        if (dragging) {
          dragging = false;
          c3d.style.cursor = 'grab';
        }
      });
      c3d.addEventListener('wheel', function (e) {
        e.preventDefault();
        var delta = e.deltaY < 0 ? 10 : -10;
        m3dState.zoomPct = Math.max(50, Math.min(220, m3dState.zoomPct + delta));
        syncM3dViewMode();
        renderM3dViewportCanvas();
      }, { passive: false });

      syncM3dUploadPreview();
      syncM3dViewMode();
      renderM3dModelsSidebarList();
    }

    var ifrEl = document.getElementById('Kc3dEngineFrame');
    var footerOvr = document.getElementById('Kc3dFooterOverride');
    var quickCadBtn = document.getElementById('Kc3dQuickCadBtn');
    var b = getBridge();
    if (is3dAiModelApp) {
      if (!b || !b.state || b.state.engineMode !== 'cad') {
        wrap.style.display = 'block';
        if (b && b.state) b.state.engineMode = '3d';
      }
      host.style.display = 'flex';
      if (footerOvr) footerOvr.style.display = 'none';
      if (quickCadBtn) quickCadBtn.style.display = 'none';
      if (ifrEl) {
        ifrEl.style.opacity = '0';
        ifrEl.setAttribute('data-loaded-url', 'native-3d-model');
        if (ifrEl.src && ifrEl.src !== 'about:blank') ifrEl.src = 'about:blank';
      }
      var m3dLoader = document.getElementById('Kc3dAppLoadingOverlay');
      if (m3dLoader) {
        var topLoadTxt = document.getElementById('Kc3dTopLoadingTxt');
        var centerLoadTxt = document.getElementById('Kc3dCenterLoadingTitle');
        if (topLoadTxt) topLoadTxt.textContent = 'Loading 3D Model Generator...';
        if (centerLoadTxt) centerLoadTxt.textContent = 'Loading 3D Model Generator...';
        m3dLoader.style.display = 'flex';
        m3dLoader.style.opacity = '1';
        setTimeout(function () {
          m3dLoader.style.opacity = '0';
          setTimeout(function () {
            if (m3dLoader.style.opacity === '0') m3dLoader.style.display = 'none';
          }, 240);
        }, 360);
      }
      if (window.__tgPending3dLaunch) {
        var launch = window.__tgPending3dLaunch;
        window.__tgPending3dLaunch = null;
        m3dState.genTab = (launch.mode === 'model' || launch.mode === 'modeling') ? 'modeling' : 'photo';
        if (launch.imageUrl) {
          var lImg = new Image();
          lImg.onload = function () {
            m3dState.uploadedImg = lImg;
            m3dState.uploadedDataUrl = launch.imageUrl;
            m3dState.activePreset = 'uploaded';
            m3dState.hasUploadedImage = true;
            m3dState._meshCacheKey = '';
            syncM3dUploadPreview();
            var runBtn = document.getElementById('Tg3dModRunBtn');
            if (runBtn) runBtn.click();
          };
          lImg.src = launch.imageUrl;
        }
      }
      syncM3dUploadPreview();
      syncM3dViewMode();
      renderM3dViewportCanvas();
    } else {
      host.style.display = 'none';
      var hfHostEl = document.getElementById('TgHalftoneStudioHost');
      var hfVisible = hfHostEl && hfHostEl.style.display === 'flex';
      if (footerOvr) footerOvr.style.display = hfVisible ? 'none' : '';
      if (quickCadBtn) quickCadBtn.style.display = hfVisible ? 'none' : '';
    }
  }

  function ensureAiStudioWorkbench(slug) {
    // Remove floating AI 3D & Relief Generator Engine panel (#Tg3dAiStudioBar & #Tg3dAiCanvasPanel) per user request
    var oldBar = document.getElementById('Tg3dAiStudioBar');
    if (oldBar && oldBar.parentNode) oldBar.parentNode.removeChild(oldBar);
    var oldPanel = document.getElementById('Tg3dAiCanvasPanel');
    if (oldPanel && oldPanel.parentNode) oldPanel.parentNode.removeChild(oldPanel);
    var curSlug = slug || activeSession.slug || '';
    if (/crystal|ai-3d-model|glasses-free|mirror-cylinder/i.test(curSlug)) {
      aiState.finish = 'crystal_3d';
    } else if (/laser-prep|background-remover|image-upscaler|magic-eraser|design-extraction|parse-image|image-to-|style-match|ai-expand|ai-replace|ai-image-variations/i.test(curSlug)) {
      aiState.finish = 'laser_halftone';
    } else if (/relief|carv|halftone|stencil|emboss|stamp/i.test(curSlug)) {
      aiState.finish = 'wood_relief';
    } else {
      aiState.finish = 'gold_coin';
    }
    ensureNativeHalftoneStudioDom(curSlug);
    ensureNative3dModelStudioDom(curSlug);

    // Ensure embedded 3D/generator iframes load via our CinAI Proxy Gateway so credits & AI generation work natively
    var bStudio = getBridge();
    if (bStudio && bStudio.state && bStudio.state.runUrl && bStudio.state.runUrl.indexOf('https://www.atomm.com/') === 0) {
      bStudio.state.runUrl = bStudio.state.runUrl.replace('https://www.atomm.com/', 'https://shopify.cinai.app/proxy/tg-app/');
    }
    var ifrStudio = document.getElementById('Kc3dEngineFrame');
    if (ifrStudio && ifrStudio.src && ifrStudio.src.indexOf('https://www.atomm.com/') === 0) {
      var proxiedUrl = ifrStudio.src.replace('https://www.atomm.com/', 'https://shopify.cinai.app/proxy/tg-app/');
      ifrStudio.setAttribute('data-loaded-url', proxiedUrl);
      ifrStudio.src = proxiedUrl;
    }

    var kcAiBtn = document.getElementById('KcAiSendBtn');
    var kcAiInp = document.getElementById('KcAiPromptInput');
    if (kcAiBtn && kcAiInp && !kcAiBtn.getAttribute('data-tg-real-ai-bound')) {
      kcAiBtn.setAttribute('data-tg-real-ai-bound', '1');
      kcAiBtn.addEventListener('click', function () {
        var rawPrompt = kcAiInp.value.trim();
        if (!rawPrompt) return;
        kcAiBtn.disabled = true;
        kcAiBtn.style.opacity = '0.6';
        window.TgTraceAiKeychainShape(rawPrompt, function (res) {
          kcAiBtn.disabled = false;
          kcAiBtn.style.opacity = '1';
          var br = getBridge();
          if (res && res.ok && res.fullD && br && br.state) {
            br.state.customShape = {
              id: 'custom',
              fullD: res.fullD,
              contourD: res.contourD,
              back: '#C9CDD4',
              mid: '#1E293B'
            };
            br.state.shapeId = 'custom';
            br.state.uploadedImgUrl = res.imageUrl || '';
            if (res.luma) br.state.uploadedLuma = res.luma;
            if (typeof br.syncAllUI === 'function') br.syncAllUI(true);
            saveCurrentStudioToDraft(false, res.imageUrl, 'AI Vector: ' + rawPrompt.slice(0, 20));
          }
        });
      });
    }
  }

  function triggerE2eAiGeneration(opts) {
    opts = opts || {};
    var curSlug = (getBridge() && getBridge().state && getBridge().state.toolSlug) || activeSession.slug || 'commemorative-coin-generator';
    ensureAiStudioWorkbench(curSlug);

    if (opts.prompt) {
      aiState.prompt = String(opts.prompt).trim();
    }
    if (opts.finish) {
      aiState.finish = opts.finish;
    }
    if (opts.clearRefImg) {
      aiState.refImg = null;
    }

    var newBal = deductAiCredits(8);
    if (newBal === null) {
      return {
        ok: false,
        reason: 'insufficient_credits',
        slug: curSlug,
        creditsRemaining: getCreditBalance()
      };
    }

    aiState.lastGeneratedAt = Date.now();
    aiState.generationCount += 1;

    var b = getBridge();
    if (b && b.state) {
      b.state.nameEnabled = true;
      b.state.nameText = aiState.prompt.slice(0, 18).toUpperCase();
      b.state.subText = 'AI STUDIO EDITION';
      if (typeof b.syncAllUI === 'function') b.syncAllUI(true);
    }

    callStorefrontAiGateway({ mode: 'coin-relief', prompt: aiState.prompt }).then(function (res) {
      if (res && res.ok && res.imgElement) {
        aiState.refImg = res.imgElement;
        render3dAiCanvas();
        saveCurrentStudioToDraft(false, res.imageUrl, 'AI: ' + aiState.prompt.slice(0, 22));
      }
    });

    saveCurrentStudioToDraft(false, null, 'AI: ' + aiState.prompt.slice(0, 22));

    return {
      ok: true,
      slug: curSlug,
      prompt: aiState.prompt,
      finish: aiState.finish,
      creditsRemaining: newBal,
      generationCount: aiState.generationCount
    };
  }

  // ============================================================================
  // OPTION 1 + OPTION 2: REAL SHOPIFY CREDIT TOP-UP & CUSTOMER.ORDERS AUTO-SYNC
  // ============================================================================
  var CREDIT_VARIANT_MAP = {
    '500': { id: 52942339113240, credits: 500, price: '$4.99', title: '500 Credits — Starter Pack' },
    '2000': { id: 52942339146008, credits: 2000, price: '$14.99', title: '2,000 Credits — Creator Pro' },
    '5000': { id: 52942339178776, credits: 5000, price: '$29.99', title: '5,000 Credits — Studio Max' }
  };

  function syncPaidCreditOrders() {
    try {
      var orders = window.TG_PAID_CREDIT_ORDERS;
      if (!Array.isArray(orders) || !orders.length) return { syncedOrders: 0, addedCredits: 0, balance: getCreditBalance() };
      var claimKey = 'tg_claimed_orders_' + getCurrentUserId();
      var claimed = [];
      try {
        claimed = JSON.parse(localStorage.getItem(claimKey) || '[]');
        if (!Array.isArray(claimed)) claimed = [];
      } catch (e) {
        claimed = [];
      }

      var addedCredits = 0;
      var newlyClaimedNames = [];
      for (var i = 0; i < orders.length; i++) {
        var ord = orders[i];
        if (!ord || !ord.id) continue;
        var oid = String(ord.id);
        if (claimed.indexOf(oid) !== -1) continue;
        var cVal = parseInt(ord.credits, 10) || 0;
        if (cVal > 0) {
          addedCredits += cVal;
          claimed.push(oid);
          newlyClaimedNames.push((ord.name || '#' + oid) + ' (+' + cVal.toLocaleString('en-US') + ' cr)');
        }
      }

      if (addedCredits > 0) {
        localStorage.setItem(claimKey, JSON.stringify(claimed));
        var nextBal = setCreditBalance(getCreditBalance() + addedCredits);
        ensureCreditPaymentModalEnhancements();
        var syncBanner = document.getElementById('KcOrderSyncBanner');
        if (syncBanner) {
          syncBanner.style.display = 'flex';
          syncBanner.innerHTML =
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#059669" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M20 6 9 17l-5-5"/></svg>' +
            '<div><strong>Paid Shopify Order Synced!</strong> Added <strong>+' + addedCredits.toLocaleString('en-US') + ' Credits</strong> from order ' + newlyClaimedNames.join(', ') + '.</div>';
        }
        return { syncedOrders: newlyClaimedNames.length, addedCredits: addedCredits, balance: nextBal };
      }
      return { syncedOrders: 0, addedCredits: 0, balance: getCreditBalance() };
    } catch (err) {
      return { syncedOrders: 0, addedCredits: 0, balance: getCreditBalance() };
    }
  }

  function ensureCreditPaymentModalEnhancements() {
    var credBox = document.getElementById('KcMyCreditsBox');
    if (!credBox) return;

    // 1. Update Pack buttons with real prices ($4.99 / $14.99 / $29.99) and Variant IDs
    var packs = credBox.querySelectorAll('.kc-cred-pack');
    for (var i = 0; i < packs.length; i++) {
      var btn = packs[i];
      var addKey = btn.getAttribute('data-add') || '500';
      var cfg = CREDIT_VARIANT_MAP[addKey] || CREDIT_VARIANT_MAP['500'];
      btn.setAttribute('data-variant', String(cfg.id));
      btn.setAttribute('data-price', cfg.price);
      var subDivs = btn.querySelectorAll('div');
      if (subDivs.length >= 3) {
        subDivs[2].textContent = cfg.price;
        subDivs[2].style.fontSize = '13px';
        subDivs[2].style.fontWeight = '800';
      }
    }

    // 2. Zero-Credit Alert Banner (shown automatically when balance < 8)
    if (!document.getElementById('KcZeroCredAlert')) {
      var zeroBanner = document.createElement('div');
      zeroBanner.id = 'KcZeroCredAlert';
      zeroBanner.style.cssText = 'display:' + (getCreditBalance() < 8 ? 'flex' : 'none') + ';align-items:flex-start;gap:10px;background:#FEF2F2;border:1px solid #FECACA;border-radius:12px;padding:12px 14px;margin-bottom:14px;color:#991B1B;font-size:12px;line-height:1.45;';
      zeroBanner.innerHTML =
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#DC2626" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:1px;"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
        '<div><div style="font-weight:800;color:#7F1D1D;margin-bottom:2px;">Out of Studio AI Credits (0 Remaining)</div><div>Your 200 Free Starter Credits have been used. Select a Top-Up Pack below ($4.99 / $14.99 / $29.99) for instant Shopify Checkout, or claim Free Daily / Referral Credits!</div></div>';
      credBox.insertBefore(zeroBanner, credBox.firstChild);
    }

    // 3. Paid Order Auto-Sync Confirmation Banner
    if (!document.getElementById('KcOrderSyncBanner')) {
      var ordBanner = document.createElement('div');
      ordBanner.id = 'KcOrderSyncBanner';
      ordBanner.style.cssText = 'display:none;align-items:center;gap:8px;background:#ECFDF5;border:1px solid #A7F3D0;border-radius:10px;padding:10px 12px;margin-bottom:12px;color:#065F46;font-size:12px;line-height:1.4;';
      credBox.insertBefore(ordBanner, credBox.firstChild);
    }

    // 4. Interactive Shopify Checkout Action Bar + Option 2 Bundled Bonus Info
    if (!document.getElementById('KcCredCheckoutBar')) {
      var footerRow = credBox.lastElementChild;
      var checkoutBar = document.createElement('div');
      checkoutBar.id = 'KcCredCheckoutBar';
      checkoutBar.style.cssText = 'display:none;flex-direction:column;gap:8px;background:#FFF7ED;border:1px solid #FED7AA;border-radius:12px;padding:12px;margin-bottom:12px;';
      checkoutBar.innerHTML =
        '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">' +
          '<div style="font-size:12px;font-weight:700;color:#9A3412;" id="KcCredCheckoutStatus">Selected: +2,000 Credits ($14.99)</div>' +
          '<span style="font-size:10px;font-weight:700;background:#FFEDD5;color:#EA580C;padding:2px 7px;border-radius:999px;">Added to Shopify Cart</span>' +
        '</div>' +
        '<div style="display:flex;gap:8px;">' +
          '<a href="/checkout" id="KcBtnGoShopifyCheckout" style="flex:1;height:38px;border-radius:8px;background:linear-gradient(135deg,#FF7C23,#EA580C);color:#ffffff;font-size:13px;font-weight:800;text-decoration:none;display:inline-flex;align-items:center;justify-content:center;gap:6px;box-shadow:0 4px 12px rgba(234,88,12,0.28);">Proceed to Shopify Checkout →</a>' +
          '<a href="/cart" id="KcBtnViewShopifyCart" style="height:38px;padding:0 12px;border-radius:8px;border:1px solid #FDBA74;background:#ffffff;color:#9A3412;font-size:12px;font-weight:700;text-decoration:none;display:inline-flex;align-items:center;justify-content:center;">View Cart</a>' +
        '</div>';
      credBox.insertBefore(checkoutBar, footerRow);

      var bundleNote = document.createElement('div');
      bundleNote.id = 'KcBundledCredBanner';
      bundleNote.style.cssText = 'background:#F8FAFC;border:1px solid #E2E8F0;border-radius:10px;padding:10px 12px;margin-bottom:12px;display:flex;align-items:center;justify-content:space-between;gap:10px;font-size:11px;color:#475569;line-height:1.4;';
      bundleNote.innerHTML =
        '<div><strong style="color:#0F172A;">Supplies & Merch Bonus:</strong> Every <strong>$1 spent</strong> on physical Supplies Kits or Custom Merch automatically grants <strong>+100 Free AI Credits</strong> when paid!</div>' +
        '<button type="button" id="KcCredOpenSuppliesBtn" style="border:1px solid #CBD5E1;background:#ffffff;color:#0F172A;border-radius:6px;padding:5px 9px;font-size:11px;font-weight:700;cursor:pointer;white-space:nowrap;">Supplies Kit</button>';
      credBox.insertBefore(bundleNote, footerRow);

      var openSupBtn = document.getElementById('KcCredOpenSuppliesBtn');
      if (openSupBtn) {
        openSupBtn.addEventListener('click', function () {
          var host = document.getElementById('KcAccountModalHost');
          if (host) host.style.display = 'none';
          if (typeof window.openSuppliesKitDrawer === 'function') window.openSuppliesKitDrawer();
        });
      }
    }
  }

  function addCreditPackToShopifyCart(packBtn) {
    ensureCreditPaymentModalEnhancements();
    var addKey = packBtn.getAttribute('data-add') || '500';
    var cfg = CREDIT_VARIANT_MAP[addKey] || CREDIT_VARIANT_MAP['500'];
    var variantId = Number(packBtn.getAttribute('data-variant') || cfg.id);

    var allPacks = document.querySelectorAll('.kc-cred-pack');
    for (var i = 0; i < allPacks.length; i++) {
      allPacks[i].style.boxShadow = 'none';
    }
    packBtn.style.boxShadow = '0 0 0 3px rgba(255,124,35,0.35)';

    var bar = document.getElementById('KcCredCheckoutBar');
    var statusEl = document.getElementById('KcCredCheckoutStatus');
    var goBtn = document.getElementById('KcBtnGoShopifyCheckout');
    if (bar) bar.style.display = 'flex';
    if (statusEl) statusEl.textContent = 'Adding +' + cfg.credits.toLocaleString('en-US') + ' Credits (' + cfg.price + ') to Cart...';
    if (goBtn) goBtn.textContent = 'Proceed to Shopify Checkout (' + cfg.price + ') →';

    var payload = {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: {
            _Studio_Account: getCurrentUserId(),
            _Credit_Pack: '+' + cfg.credits + ' ThoughtyGift Studio AI Credits'
          }
        }
      ]
    };

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (statusEl) {
          statusEl.textContent = 'Added +' + cfg.credits.toLocaleString('en-US') + ' Credits (' + cfg.price + ') to Cart!';
        }
        return data;
      })
      .catch(function (err) {
        if (statusEl) {
          statusEl.textContent = 'Selected +' + cfg.credits.toLocaleString('en-US') + ' Credits (' + cfg.price + ')';
        }
        if (goBtn) {
          goBtn.href = '/cart/' + variantId + ':1';
        }
        return { error: String(err) };
      });
  }

  // ============================================================================
  // SUPPLIES KIT DRAWER: OPTION 2 BONUS CREDIT BADGE & REAL SHOPIFY CART CHECKOUT
  // ============================================================================
  function syncSuppliesKitBonusBadge() {
    var footer = document.querySelector('#KcSkPanel .gmp-footer');
    if (!footer) return;
    var totPriceEl = document.getElementById('KcSkTotalPrice');
    var priceNum = 14.99;
    if (totPriceEl && totPriceEl.textContent) {
      var p = parseFloat(totPriceEl.textContent.replace(/[^0-9.]/g, ''));
      if (!isNaN(p)) priceNum = p;
    }
    var bonusCreds = Math.max(100, Math.round(priceNum) * 100);
    var badge = document.getElementById('TgSkBonusCreditBadge');
    if (!badge) {
      badge = document.createElement('div');
      badge.id = 'TgSkBonusCreditBadge';
      badge.style.cssText = 'background:linear-gradient(90deg,#ECFDF5,#D1FAE5);border:1px solid #A7F3D0;border-radius:8px;padding:7px 10px;margin-bottom:8px;display:flex;align-items:center;justify-content:space-between;gap:8px;font-size:11px;color:#065F46;font-weight:600;';
      footer.insertBefore(badge, footer.firstChild);
    }
    badge.innerHTML =
      '<span style="display:inline-flex;align-items:center;gap:5px;"><img src="https://storage.atomm.com/xtool/aimake-static/static/icon/credits.svg" alt="" style="width:15px;height:15px;display:inline-block;flex-shrink:0;"/><span>Order Bonus (+100 cr/$1):</span></span>' +
      '<strong style="color:#047857;font-weight:800;">+' + bonusCreds.toLocaleString('en-US') + ' Free AI Credits</strong>';
  }

  function buySelectedSuppliesKitViaShopifyCart(buyBtn) {
    var listEl = document.getElementById('KcSkList');
    if (!listEl) return;
    var rows = listEl.querySelectorAll('.gmp-row');
    var selectedHandles = [];
    for (var i = 0; i < rows.length; i++) {
      var chk = rows[i].querySelector('input[type="checkbox"]');
      if (chk && chk.checked) {
        var link = rows[i].querySelector('a.gmp-row__name');
        var href = link ? (link.getAttribute('href') || '') : '';
        var qtyEl = rows[i].querySelector('.gmp-qty__value');
        var qty = qtyEl ? (parseInt(qtyEl.textContent, 10) || 1) : 1;
        var optTxts = Array.from(rows[i].querySelectorAll('.gmp-select__trigger span:first-child')).map(function (s) { return s.textContent.trim(); });
        var m = href.match(/\/products\/([^?#\/]+)/);
        if (m && m[1]) {
          selectedHandles.push({
            handle: m[1],
            qty: qty,
            title: link ? link.textContent.trim() : m[1],
            opts: optTxts.join(' / ')
          });
        }
      }
    }
    if (!selectedHandles.length) return;

    var origTxtEl = document.getElementById('KcSkBuyNowTxt');
    var origTxt = origTxtEl ? origTxtEl.textContent : 'Buy Now';
    if (origTxtEl) origTxtEl.textContent = 'Adding to Shopify Cart...';
    buyBtn.disabled = true;

    Promise.all(selectedHandles.map(function (item) {
      return fetch('/products/' + item.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (prod) {
          if (prod && prod.variants && prod.variants.length) {
            return {
              id: prod.variants[0].id,
              quantity: item.qty,
              properties: {
                _Studio_Tool: activeSession.slug || 'creative-studio',
                _Project_Draft_ID: activeSession.gid || '',
                Material_Spec: item.opts || 'Standard Laser Grade',
                Bonus_Studio_Credits: '+100 AI Credits per $1 spent'
              }
            };
          }
          return null;
        });
    })).then(function (cartItems) {
      var validItems = cartItems.filter(Boolean);
      if (!validItems.length) {
        window.location.href = '/products/' + selectedHandles[0].handle;
        return;
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: validItems })
      }).then(function () {
        if (origTxtEl) origTxtEl.textContent = 'Added! Proceeding to Checkout...';
        buyBtn.disabled = false;
        var footer = document.querySelector('#KcSkPanel .gmp-footer');
        var skBar = document.getElementById('TgSkCheckoutActionBar');
        if (!skBar && footer) {
          skBar = document.createElement('div');
          skBar.id = 'TgSkCheckoutActionBar';
          skBar.style.cssText = 'display:flex;gap:8px;margin-top:8px;';
          skBar.innerHTML =
            '<a href="/checkout" style="flex:1;height:36px;border-radius:8px;background:#10B981;color:#ffffff;font-size:12px;font-weight:800;text-decoration:none;display:inline-flex;align-items:center;justify-content:center;">Proceed to Checkout →</a>' +
            '<a href="/cart" style="height:36px;padding:0 12px;border-radius:8px;border:1px solid #D1D5DB;background:#ffffff;color:#111827;font-size:12px;font-weight:700;text-decoration:none;display:inline-flex;align-items:center;justify-content:center;">View Cart</a>';
          footer.appendChild(skBar);
        }
        setTimeout(function () {
          if (origTxtEl) origTxtEl.textContent = origTxt;
        }, 1600);
      });
    });
  }

  function ensureCatalogTopCreditPill() {
    if (document.getElementById('TgCatalogCreditBtn')) return;
    var heroNav = document.querySelector('.at-header__right, .at-hero__actions, .at-toolbar');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'TgCatalogCreditBtn';
    btn.title = 'My Studio AI Credits & Top-Up';
    btn.style.cssText = 'position:fixed;right:20px;bottom:20px;z-index:999;border:1px solid #FED7AA;background:linear-gradient(90deg,#1F2937 0%,#111827 100%);color:#ffffff;height:40px;padding:0 14px;border-radius:999px;font-size:12px;font-weight:700;cursor:pointer;display:inline-flex;align-items:center;gap:8px;box-shadow:0 10px 25px rgba(0,0,0,0.22);font-family:Inter,sans-serif;';
    btn.innerHTML =
      '<img src="https://storage.atomm.com/xtool/aimake-static/static/icon/credits.svg" alt="" style="width:16px;height:16px;display:inline-block;flex-shrink:0;"/>' +
      '<span id="TgCatalogCreditVal" style="color:#FBBF24;font-weight:800;">' + getCreditBalance().toLocaleString('en-US') + '</span><span>AI Credits</span>' +
      '<span style="background:#FF7C23;color:#ffffff;padding:2px 8px;border-radius:999px;font-size:10px;font-weight:800;">+ Top Up</span>';
    if (heroNav) {
      btn.style.position = 'static';
      btn.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
      heroNav.appendChild(btn);
    } else {
      document.body.appendChild(btn);
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openGlobalCreditsModal('credits');
    });
  }

  // ============================================================================
  // STUDIO AUTHENTICATION: SIGN IN, SIGN UP (+200 FREE CREDITS), AND LOG OUT
  // ============================================================================
  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getAccountsRegistry() {
    try {
      var raw = localStorage.getItem('tg_registered_users_v1');
      if (raw) {
        var parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') return parsed;
      }
    } catch (e) {}
    return {};
  }

  function saveAccountsRegistry(reg) {
    try {
      localStorage.setItem('tg_registered_users_v1', JSON.stringify(reg));
    } catch (e) {}
  }

  function showStudioAuthToast(msg, isError) {
    var t = document.getElementById('TgStudioAuthToast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'TgStudioAuthToast';
      t.style.cssText = 'position:fixed;top:18px;left:50%;transform:translateX(-50%);z-index:2147483647;padding:10px 18px;border-radius:999px;font-family:Inter,sans-serif;font-size:13px;font-weight:700;color:#ffffff;box-shadow:0 12px 30px rgba(0,0,0,0.28);display:none;align-items:center;gap:8px;pointer-events:none;';
      document.body.appendChild(t);
    }
    t.style.background = isError ? '#DC2626' : '#059669';
    t.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
      '<span>' + esc(msg) + '</span>';
    t.style.display = 'inline-flex';
    clearTimeout(t._timer);
    t._timer = setTimeout(function () {
      t.style.display = 'none';
    }, 3400);
  }

  function refreshAllUserViews() {
    var bal = getCreditBalance();
    setCreditBalance(bal);
    syncAuthProfileUi();
    syncPaidCreditOrders();
    try {
      var curSlug = (getBridge() && getBridge().state && getBridge().state.toolSlug) || activeSession.slug || 'table-lamp-generator';
      var list = getUserProjectsForApp(curSlug);
      if (list && list[0]) activeSession.gid = list[0].gid;
      syncStudioProjectHeaderBar();
      renderLandingProjects(curSlug);
      renderDrawerProjects(curSlug);
    } catch (e) {}
  }

  function signUpNewUser(opts) {
    opts = opts || {};
    var email = String(opts.email || '').trim().toLowerCase();
    var name = String(opts.name || '').trim();
    if (!email || email.indexOf('@') === -1) {
      return { ok: false, error: 'Please enter a valid email address.' };
    }
    if (!name) {
      name = email.split('@')[0].replace(/[._-]+/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
    var reg = getAccountsRegistry();
    var isBrandNew = !reg[email];
    reg[email] = {
      email: email,
      name: name,
      createdAt: reg[email] ? reg[email].createdAt : Date.now(),
      lastLoginAt: Date.now()
    };
    saveAccountsRegistry(reg);

    try {
      localStorage.setItem('vog_account_email', email);
      localStorage.setItem('vog_account_name', name);
      localStorage.setItem('tg_vip_member', 'true');
    } catch (e) {}

    var userKey = getCreditStorageKey();
    var starterGranted = false;
    try {
      if (isBrandNew || localStorage.getItem(userKey) === null) {
        localStorage.setItem(userKey, '200');
        starterGranted = true;
      }
    } catch (e) {}

    refreshAllUserViews();
    closeStudioAuthModal();
    showStudioAuthToast(
      starterGranted
        ? ('Welcome, ' + name + '! +200 Free Starter Credits added to your account.')
        : ('Welcome back, ' + name + '! (' + getCreditBalance() + ' Credits available)')
    );
    return {
      ok: true,
      isNewUser: starterGranted,
      user: getCurrentUserProfile(),
      credits: getCreditBalance(),
      creditStorageKey: userKey,
      projectStorageKey: getStorageKey()
    };
  }

  function signInExistingOrNewUser(opts) {
    opts = opts || {};
    var email = String(opts.email || '').trim().toLowerCase();
    if (!email || email.indexOf('@') === -1) {
      return { ok: false, error: 'Please enter a valid email address.' };
    }
    var reg = getAccountsRegistry();
    var existing = reg[email];
    var name = String(opts.name || (existing && existing.name) || '').trim();
    return signUpNewUser({ email: email, name: name, password: opts.password });
  }

  function signOutCurrentUser() {
    var prevUser = getCurrentUserProfile();
    try {
      localStorage.removeItem('vog_account_email');
      localStorage.removeItem('vog_account_name');
      localStorage.setItem('tg_studio_credits_v2', '0');
      // Generate a fresh guest session UID so logged-out state is a clean guest session
      var newGuestUid = 'u_' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
      localStorage.setItem('tg_studio_uid', newGuestUid);
    } catch (e) {}
    window.TG_CUSTOMER_ID = '';
    window.TG_CUSTOMER_EMAIL = '';
    window.TG_CUSTOMER_NAME = '';
    if (typeof window.TgSetCreditBalance === 'function') {
      try { window.TgSetCreditBalance(0); } catch (e) {}
    }
    refreshAllUserViews();
    closeStudioAuthModal();
    showStudioAuthToast('Signed out of ' + (prevUser.email || 'account') + '. Credits reset to 0.');
    return {
      ok: true,
      previousUser: prevUser.email,
      currentUser: getCurrentUserProfile(),
      credits: getCreditBalance()
    };
  }

  function ensureStudioAuthModalDom() {
    var host = document.getElementById('TgAuthModalHost');
    if (host) return host;
    host = document.createElement('div');
    host.id = 'TgAuthModalHost';
    host.style.cssText = 'position:fixed;inset:0;z-index:2147483647;background:rgba(15,23,42,0.62);backdrop-filter:blur(4px);display:none;align-items:center;justify-content:center;padding:16px;font-family:Inter,sans-serif;';
    host.innerHTML =
      '<div style="background:#ffffff;border-radius:18px;max-width:440px;width:100%;box-shadow:0 25px 50px -12px rgba(0,0,0,0.32);overflow:hidden;position:relative;color:#111827;">' +
        '<button type="button" id="TgAuthModalClose" style="position:absolute;top:14px;right:14px;width:32px;height:32px;border-radius:999px;border:none;background:#F3F4F6;color:#374151;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;">×</button>' +
        '<div style="padding:24px 24px 20px;">' +
          '<div style="display:inline-flex;align-items:center;gap:6px;background:#FFF7ED;border:1px solid #FED7AA;color:#EA580C;font-size:11px;font-weight:800;padding:4px 10px;border-radius:999px;margin-bottom:10px;">' +
            '<img src="https://storage.atomm.com/xtool/aimake-static/static/icon/credits.svg" alt="" style="width:15px;height:15px;display:inline-block;flex-shrink:0;"/>' +
            '<span>NEW USER STARTER BONUS · +200 FREE AI CREDITS</span>' +
          '</div>' +
          '<h3 style="margin:0 0 4px;font-size:20px;font-weight:800;color:#111827;" id="TgAuthModalHeading">ThoughtyGift Creator Account</h3>' +
          '<p style="margin:0 0 16px;font-size:12.5px;color:#6B7280;line-height:1.45;">Sign in or create a free account to receive <strong>200 Free Starter AI Credits</strong> and save your custom 3D & laser projects to your personal workspace.</p>' +
          '<div style="display:grid;grid-template-columns:1fr 1fr;gap:4px;background:#F3F4F6;padding:4px;border-radius:10px;margin-bottom:16px;">' +
            '<button type="button" id="TgAuthTabSignUp" data-auth-tab="signup" style="height:34px;border:none;border-radius:8px;background:#ffffff;color:#111827;font-size:12.5px;font-weight:800;cursor:pointer;box-shadow:0 1px 2px rgba(0,0,0,0.06);">Create Account (+200 Cr)</button>' +
            '<button type="button" id="TgAuthTabSignIn" data-auth-tab="signin" style="height:34px;border:none;border-radius:8px;background:transparent;color:#4B5563;font-size:12.5px;font-weight:700;cursor:pointer;">Sign In</button>' +
          '</div>' +
          '<div id="TgAuthModalError" style="display:none;background:#FEF2F2;border:1px solid #FECACA;color:#991B1B;padding:8px 12px;border-radius:8px;font-size:12px;font-weight:600;margin-bottom:12px;"></div>' +
          '<form id="TgAuthForm" style="display:flex;flex-direction:column;gap:12px;">' +
            '<div id="TgAuthNameFieldWrap">' +
              '<label style="display:block;font-size:12px;font-weight:700;color:#374151;margin-bottom:4px;">Your Name</label>' +
              '<input type="text" id="TgAuthNameInp" placeholder="e.g. Alice Creator" style="width:100%;height:40px;padding:0 12px;border:1px solid #D1D5DB;border-radius:8px;font-size:13px;color:#111827;outline:none;box-sizing:border-box;"/>' +
            '</div>' +
            '<div>' +
              '<label style="display:block;font-size:12px;font-weight:700;color:#374151;margin-bottom:4px;">Email Address</label>' +
              '<input type="email" id="TgAuthEmailInp" placeholder="you@example.com" required style="width:100%;height:40px;padding:0 12px;border:1px solid #D1D5DB;border-radius:8px;font-size:13px;color:#111827;outline:none;box-sizing:border-box;"/>' +
            '</div>' +
            '<div>' +
              '<label style="display:block;font-size:12px;font-weight:700;color:#374151;margin-bottom:4px;">Password</label>' +
              '<input type="password" id="TgAuthPassInp" placeholder="Enter password (min 6 chars)" value="thoughty2026" required style="width:100%;height:40px;padding:0 12px;border:1px solid #D1D5DB;border-radius:8px;font-size:13px;color:#111827;outline:none;box-sizing:border-box;"/>' +
            '</div>' +
            '<button type="submit" id="TgAuthSubmitBtn" style="height:42px;border:none;border-radius:10px;background:linear-gradient(135deg,#FF7C23,#EA580C);color:#ffffff;font-size:13.5px;font-weight:800;cursor:pointer;box-shadow:0 6px 16px rgba(234,88,12,0.28);margin-top:2px;">Create Account & Claim 200 Free Credits →</button>' +
          '</form>' +
          '<div style="margin-top:14px;padding-top:12px;border-top:1px solid #F3F4F6;display:flex;align-items:center;justify-content:space-between;font-size:11.5px;color:#6B7280;">' +
            '<span>Instant 200 Free Credits for every new user</span>' +
            '<a href="/account" style="color:#EA580C;font-weight:700;text-decoration:none;">Full Account Center →</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(host);

    var tabSignUp = document.getElementById('TgAuthTabSignUp');
    var tabSignIn = document.getElementById('TgAuthTabSignIn');
    var nameWrap = document.getElementById('TgAuthNameFieldWrap');
    var submitBtn = document.getElementById('TgAuthSubmitBtn');
    var form = document.getElementById('TgAuthForm');
    var errBox = document.getElementById('TgAuthModalError');
    host._mode = 'signup';

    function setTabMode(mode) {
      host._mode = mode;
      if (errBox) errBox.style.display = 'none';
      if (mode === 'signin') {
        tabSignIn.style.background = '#ffffff';
        tabSignIn.style.color = '#111827';
        tabSignIn.style.boxShadow = '0 1px 2px rgba(0,0,0,0.06)';
        tabSignUp.style.background = 'transparent';
        tabSignUp.style.color = '#4B5563';
        tabSignUp.style.boxShadow = 'none';
        nameWrap.style.display = 'none';
        submitBtn.textContent = 'Sign In to Studio →';
      } else {
        tabSignUp.style.background = '#ffffff';
        tabSignUp.style.color = '#111827';
        tabSignUp.style.boxShadow = '0 1px 2px rgba(0,0,0,0.06)';
        tabSignIn.style.background = 'transparent';
        tabSignIn.style.color = '#4B5563';
        tabSignIn.style.boxShadow = 'none';
        nameWrap.style.display = 'block';
        submitBtn.textContent = 'Create Account & Claim 200 Free Credits →';
      }
    }
    host._setTabMode = setTabMode;

    tabSignUp.addEventListener('click', function () { setTabMode('signup'); });
    tabSignIn.addEventListener('click', function () { setTabMode('signin'); });
    document.getElementById('TgAuthModalClose').addEventListener('click', closeStudioAuthModal);
    host.addEventListener('click', function (e) {
      if (e.target === host) closeStudioAuthModal();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var em = document.getElementById('TgAuthEmailInp').value.trim();
      var nm = document.getElementById('TgAuthNameInp').value.trim();
      var pw = document.getElementById('TgAuthPassInp').value;
      var res = host._mode === 'signin'
        ? signInExistingOrNewUser({ email: em, name: nm, password: pw })
        : signUpNewUser({ email: em, name: nm, password: pw });
      if (!res.ok && errBox) {
        errBox.textContent = res.error || 'Authentication failed';
        errBox.style.display = 'block';
      }
    });

    return host;
  }

  function openStudioAuthModal(mode) {
    var host = ensureStudioAuthModalDom();
    if (host._setTabMode) host._setTabMode(mode === 'signin' ? 'signin' : 'signup');
    host.style.display = 'flex';
    var emInp = document.getElementById('TgAuthEmailInp');
    if (emInp) setTimeout(function () { emInp.focus(); }, 40);
  }

  function closeStudioAuthModal() {
    var host = document.getElementById('TgAuthModalHost');
    if (host) host.style.display = 'none';
  }

  function syncAuthProfileUi() {
    var prof = getCurrentUserProfile();
    var bal = getCreditBalance();
    var CREDIT_ICON_URL = 'https://storage.atomm.com/xtool/aimake-static/static/icon/credits.svg';

    // Synchronize all credit pill / button icons across the page to the exact Atomm diamond-star credit icon
    var credPill = document.getElementById('KcCreditsPill');
    if (credPill) {
      var oldSvg = credPill.querySelector('svg');
      if (oldSvg) {
        var cImg = document.createElement('img');
        cImg.src = CREDIT_ICON_URL;
        cImg.alt = '';
        cImg.style.cssText = 'width:16px;height:16px;display:inline-block;flex-shrink:0;';
        credPill.replaceChild(cImg, oldSvg);
      }
    }
    var aiSendBtn = document.getElementById('KcAiSendBtn');
    if (aiSendBtn) {
      var aiFirstSpan = aiSendBtn.querySelector('span');
      var aiOldSvg = aiFirstSpan ? aiFirstSpan.querySelector('svg') : null;
      if (aiOldSvg) {
        var aiImg = document.createElement('img');
        aiImg.src = CREDIT_ICON_URL;
        aiImg.alt = '';
        aiImg.style.cssText = 'width:15px;height:15px;display:inline-block;flex-shrink:0;';
        aiFirstSpan.replaceChild(aiImg, aiOldSvg);
      }
    }
    var credModalBal = document.getElementById('KcCredModalBal');
    if (credModalBal && credModalBal.parentNode) {
      var mOldSvg = credModalBal.parentNode.querySelector('svg');
      if (mOldSvg) {
        var mImg = document.createElement('img');
        mImg.src = CREDIT_ICON_URL;
        mImg.alt = '';
        mImg.style.cssText = 'width:24px;height:24px;display:inline-block;flex-shrink:0;';
        credModalBal.parentNode.replaceChild(mImg, mOldSvg);
      }
    }
    var menuMyCred = document.getElementById('KcMenuMyCredits');
    if (menuMyCred) {
      var mcSvg = menuMyCred.querySelector('svg');
      if (mcSvg) {
        var mcImg = document.createElement('img');
        mcImg.src = CREDIT_ICON_URL;
        mcImg.alt = '';
        mcImg.style.cssText = 'width:16px;height:16px;display:inline-block;flex-shrink:0;';
        menuMyCred.replaceChild(mcImg, mcSvg);
      }
    }

    var avatarBtn = document.getElementById('KcAvatarBtn');
    if (avatarBtn) {
      avatarBtn.textContent = prof.initial;
      avatarBtn.title = prof.isLoggedIn ? (prof.name + ' (' + prof.email + ')') : 'Guest Creator — Click to Sign In / Register (+200 Credits)';
      avatarBtn.style.background = prof.isLoggedIn ? 'linear-gradient(135deg,#FF7C23,#E85D2A)' : 'rgba(3,116,128,0.16)';
      avatarBtn.style.color = prof.isLoggedIn ? '#ffffff' : '#037480';
    }

    // Inject prominent Sign Up / Login (+200 Cr) button in Studio Header (.kc-header__right)
    var modal = document.getElementById('CinaiStudioModal');
    var headerRight = modal ? modal.querySelector('.kc-header__right') : null;
    if (headerRight && avatarBtn) {
      var hAuthBtn = document.getElementById('KcHeaderAuthBtn');
      if (!hAuthBtn) {
        hAuthBtn = document.createElement('button');
        hAuthBtn.type = 'button';
        hAuthBtn.id = 'KcHeaderAuthBtn';
        headerRight.insertBefore(hAuthBtn, avatarBtn);
        hAuthBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (getCurrentUserProfile().isLoggedIn) {
            var uDrop = document.getElementById('KcUserMenuDropdown');
            if (uDrop) uDrop.style.display = uDrop.style.display === 'block' ? 'none' : 'block';
          } else {
            openStudioAuthModal('signup');
          }
        });
      }
      if (prof.isLoggedIn) {
        hAuthBtn.style.cssText = 'height:32px;padding:0 10px;border-radius:999px;border:1px solid #D1FAE5;background:#ECFDF5;color:#065F46;font-size:12px;font-weight:700;cursor:pointer;display:inline-flex;align-items:center;gap:6px;';
        hAuthBtn.innerHTML = '<span style="width:7px;height:7px;border-radius:999px;background:#10B981;"></span><span>' + esc(prof.name.slice(0, 14)) + '</span>';
      } else {
        hAuthBtn.style.cssText = 'height:32px;padding:0 12px;border-radius:999px;border:none;background:linear-gradient(135deg,#FF7C23,#EA580C);color:#ffffff;font-size:12px;font-weight:800;cursor:pointer;display:inline-flex;align-items:center;gap:5px;box-shadow:0 2px 8px rgba(234,88,12,0.25);';
        hAuthBtn.innerHTML = '<span>Sign Up / Login (+200 Cr)</span>';
      }
    }

    // Inject prominent Sign Up / Login (+200 Cr) button in Landing Page Topbar
    var tglTopCreditBtn = document.getElementById('TglTopCreditBtn');
    if (tglTopCreditBtn && tglTopCreditBtn.parentNode) {
      var lAuthBtn = document.getElementById('TglTopAuthBtn');
      if (!lAuthBtn) {
        lAuthBtn = document.createElement('button');
        lAuthBtn.type = 'button';
        lAuthBtn.id = 'TglTopAuthBtn';
        tglTopCreditBtn.parentNode.insertBefore(lAuthBtn, tglTopCreditBtn);
        lAuthBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          openStudioAuthModal(getCurrentUserProfile().isLoggedIn ? 'signin' : 'signup');
        });
      }
      if (prof.isLoggedIn) {
        lAuthBtn.style.cssText = 'height:34px;padding:0 12px;border-radius:999px;border:1px solid #D1FAE5;background:#ECFDF5;color:#065F46;font-size:12px;font-weight:700;cursor:pointer;display:inline-flex;align-items:center;gap:6px;';
        lAuthBtn.innerHTML = '<span style="width:7px;height:7px;border-radius:999px;background:#10B981;"></span><span>' + esc(prof.name.slice(0, 16)) + '</span>';
      } else {
        lAuthBtn.style.cssText = 'height:34px;padding:0 12px;border-radius:999px;border:none;background:linear-gradient(135deg,#FF7C23,#EA580C);color:#ffffff;font-size:12px;font-weight:800;cursor:pointer;display:inline-flex;align-items:center;gap:5px;';
        lAuthBtn.innerHTML = '<span>Sign Up / Login (+200 Cr)</span>';
      }
    }

    var userDrop = document.getElementById('KcUserMenuDropdown');
    if (userDrop) {
      userDrop.style.width = '268px';
      userDrop.innerHTML =
        '<div style="display:flex;align-items:center;gap:10px;padding:8px 10px 10px;border-bottom:1px solid #F3F4F6;margin-bottom:4px;">' +
          '<div id="KcProfAvatarCircle" style="width:36px;height:36px;border-radius:9999px;background:' + (prof.isLoggedIn ? 'linear-gradient(135deg,#FF7C23,#E85D2A)' : '#64748B') + ';color:#fff;font-weight:800;font-size:15px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">' + esc(prof.initial) + '</div>' +
          '<div style="min-width:0;flex:1;">' +
            '<div style="display:flex;align-items:center;gap:5px;">' +
              '<span style="font-size:13px;font-weight:700;color:#111827;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" id="KcProfName">' + esc(prof.name) + '</span>' +
              '<span style="width:7px;height:7px;border-radius:999px;background:' + (prof.isLoggedIn ? '#10B981' : '#F59E0B') + ';flex-shrink:0;"></span>' +
            '</div>' +
            '<div style="font-size:11px;color:#6B7280;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" id="KcProfEmailSub">' + esc(prof.email) + '</div>' +
          '</div>' +
        '</div>' +
        '<a href="/account" id="KcProfLinkAccount" style="text-decoration:none;width:100%;box-sizing:border-box;padding:8px 10px;border-radius:8px;display:flex;align-items:center;gap:8px;font-size:13px;font-weight:500;color:#111827;cursor:pointer;">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>' +
          '<span id="KcProfMyProfileTxt">My Profile & Account Hub</span>' +
        '</a>' +
        '<button type="button" id="KcProfBtnCredits" style="width:100%;border:none;background:transparent;padding:8px 10px;border-radius:8px;display:flex;align-items:center;justify-content:space-between;font-size:13px;font-weight:500;color:#111827;cursor:pointer;text-align:left;">' +
          '<span style="display:inline-flex;align-items:center;gap:8px;"><img src="https://storage.atomm.com/xtool/aimake-static/static/icon/credits.svg" alt="" style="width:16px;height:16px;display:inline-block;flex-shrink:0;"/><span id="KcProfCreditsTxt">My Studio Credits</span></span>' +
          '<span id="KcProfMenuCredBadge" style="font-size:11px;font-weight:800;color:#FF7C23;background:#FFF7ED;padding:2px 7px;border-radius:999px;display:inline-flex;align-items:center;gap:4px;"><img src="https://storage.atomm.com/xtool/aimake-static/static/icon/credits.svg" alt="" style="width:12px;height:12px;display:inline-block;"/><span>' + bal.toLocaleString('en-US') + '</span></span>' +
        '</button>' +
        '<button type="button" id="KcProfBtnOrders" style="width:100%;border:none;background:transparent;padding:8px 10px;border-radius:8px;display:flex;align-items:center;gap:8px;font-size:13px;font-weight:500;color:#111827;cursor:pointer;text-align:left;">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
          '<span id="KcProfOrdersTxt">Supplies Kit & Order</span>' +
        '</button>' +
        '<div style="height:1px;background:#F3F4F6;margin:4px 0;"></div>' +
        (prof.isLoggedIn
          ? (
            '<button type="button" id="KcProfBtnSwitchAuth" style="width:100%;border:none;background:transparent;padding:8px 10px;border-radius:8px;display:flex;align-items:center;gap:8px;font-size:12.5px;font-weight:600;color:#374151;cursor:pointer;text-align:left;">' +
              '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" x2="19" y1="8" y2="14"/><line x1="22" x2="16" y1="11" y2="11"/></svg>' +
              '<span>Switch / Create New User (+200 Cr)</span>' +
            '</button>' +
            '<button type="button" id="KcProfBtnLogout" style="width:100%;border:none;background:#FEF2F2;padding:8px 10px;border-radius:8px;display:flex;align-items:center;gap:8px;font-size:12.5px;font-weight:700;color:#DC2626;cursor:pointer;text-align:left;margin-top:2px;">' +
              '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" x2="9" y1="12" y2="12"/></svg>' +
              '<span id="KcProfSignTxt">Log Out (Sign Out)</span>' +
            '</button>'
          )
          : (
            '<button type="button" id="KcProfBtnOpenSignUp" style="width:100%;border:none;background:linear-gradient(135deg,#FF7C23,#EA580C);padding:9px 10px;border-radius:8px;display:flex;align-items:center;justify-content:center;gap:6px;font-size:12.5px;font-weight:800;color:#ffffff;cursor:pointer;margin-bottom:4px;">' +
              '<span>Sign Up Free (+200 Credits)</span>' +
            '</button>' +
            '<button type="button" id="KcProfBtnOpenSignIn" style="width:100%;border:1px solid #E5E7EB;background:#F9FAFB;padding:7px 10px;border-radius:8px;display:flex;align-items:center;justify-content:center;gap:6px;font-size:12px;font-weight:700;color:#374151;cursor:pointer;">' +
              '<span>Sign In Existing Account</span>' +
            '</button>'
          )
        );

      var btnCred = userDrop.querySelector('#KcProfBtnCredits');
      if (btnCred) {
        btnCred.addEventListener('click', function (e) {
          e.stopPropagation();
          userDrop.style.display = 'none';
          openGlobalCreditsModal('credits');
        });
      }
      var btnOrd = userDrop.querySelector('#KcProfBtnOrders');
      if (btnOrd) {
        btnOrd.addEventListener('click', function (e) {
          e.stopPropagation();
          userDrop.style.display = 'none';
          if (typeof window.openSuppliesKitDrawer === 'function') window.openSuppliesKitDrawer();
        });
      }
      var btnSwitch = userDrop.querySelector('#KcProfBtnSwitchAuth');
      if (btnSwitch) {
        btnSwitch.addEventListener('click', function (e) {
          e.stopPropagation();
          userDrop.style.display = 'none';
          openStudioAuthModal('signup');
        });
      }
      var btnLogout = userDrop.querySelector('#KcProfBtnLogout');
      if (btnLogout) {
        btnLogout.addEventListener('click', function (e) {
          e.stopPropagation();
          userDrop.style.display = 'none';
          signOutCurrentUser();
        });
      }
      var btnSignUp = userDrop.querySelector('#KcProfBtnOpenSignUp');
      if (btnSignUp) {
        btnSignUp.addEventListener('click', function (e) {
          e.stopPropagation();
          userDrop.style.display = 'none';
          openStudioAuthModal('signup');
        });
      }
      var btnSignIn = userDrop.querySelector('#KcProfBtnOpenSignIn');
      if (btnSignIn) {
        btnSignIn.addEventListener('click', function (e) {
          e.stopPropagation();
          userDrop.style.display = 'none';
          openStudioAuthModal('signin');
        });
      }
    }
  }

  window.TgAuth = {
    signUp: signUpNewUser,
    signIn: signInExistingOrNewUser,
    signOut: signOutCurrentUser,
    getCurrentUser: getCurrentUserProfile,
    getCreditBalance: getCreditBalance,
    openAuthModal: openStudioAuthModal,
    closeAuthModal: closeStudioAuthModal,
    syncUI: syncAuthProfileUi
  };

  window.TgAiEngine = {
    generate: triggerE2eAiGeneration,
    render: render3dAiCanvas,
    exportDepthmap: exportAiDepthmapPng,
    exportSvg: exportAiVectorSvg,
    getCreditBalance: getCreditBalance,
    setCreditBalance: setCreditBalance,
    syncPaidCreditOrders: syncPaidCreditOrders,
    getStateSnapshot: function () {
      return {
        prompt: aiState.prompt,
        rimText: aiState.rimText,
        finish: aiState.finish,
        depth: aiState.depth,
        diameterMm: aiState.diameterMm,
        generationCount: aiState.generationCount,
        credits: getCreditBalance()
      };
    }
  };

  // Expose public APIs
  window.openTgAppLanding = openLandingPage;
  window.closeTgAppLanding = closeLandingPage;
  window.openTgHistoryDrawer = openHistoryDrawer;
  window.saveTgStudioDraft = saveCurrentStudioToDraft;
  window.getTgUserProjectsForApp = getUserProjectsForApp;
  window.TgSyncPaidOrders = syncPaidCreditOrders;
  window.openTgCreditsModal = openGlobalCreditsModal;

  function initLandingAndProjectHooks() {
    ensureLandingAndDrawerDom();
    ensureCatalogTopCreditPill();
    ensureStudioAuthModalDom();
    setCreditBalance(getCreditBalance());
    syncAuthProfileUi();
    syncPaidCreditOrders();

    // Intercept card clicks on /pages/creative-tools in capture phase so clicking an app card opens its 1:1 Landing Page first
    document.addEventListener('click', function (e) {
      var packBtn = e.target.closest('.kc-cred-pack');
      if (packBtn) {
        e.preventDefault();
        e.stopImmediatePropagation();
        addCreditPackToShopifyCart(packBtn);
        return;
      }

      var skBuyBtn = e.target.closest('#KcSkBuyNowBtn');
      if (skBuyBtn && !document.querySelector('form[action*="/cart/add"]')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        buySelectedSuppliesKitViaShopifyCart(skBuyBtn);
        return;
      }

      if (e.target.closest('#Kc3dBtnBuyMaterials, #KcBtnHeaderOrder, #KcProfBtnOrders, [data-sk-qty], [data-sk-check]')) {
        setTimeout(syncSuppliesKitBonusBadge, 40);
      }

      if (e.target.closest('#KcAvatarBtn')) {
        syncAuthProfileUi();
      }

      if (e.target.closest('#KcCreditsPill, #KcMenuMyCredits, #KcMenuBuyCredits, #KcProfBtnCredits')) {
        setTimeout(ensureCreditPaymentModalEnhancements, 20);
      }

      var cardLink = e.target.closest('a.at-card');
      if (cardLink && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.target.closest('.at-card__bookmark')) {
        var href = cardLink.getAttribute('href') || '';
        var gridItem = cardLink.closest('[data-id]');
        var slug = gridItem ? gridItem.getAttribute('data-id') : '';
        if (!slug && href.indexOf('tool=') !== -1) {
          var m = href.match(/[?&]tool=([^&#]+)/);
          if (m) slug = decodeURIComponent(m[1]);
        }
        if (slug && document.getElementById('CinaiStudioModal')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openLandingPage(slug, href);
        }
      }
    }, true);

    // Wire Commemorative Coin presets, Mystery Box ("Try Idea"), Crystal 3D buttons, and 2D AI Send button to E2E AI Engine
    document.addEventListener('click', function (e) {
      var mysteryBtn = e.target.closest('#KcCoinMysteryCard');
      if (mysteryBtn) {
        var ideas = [
          { p: 'Royal Sovereign Gold Lion & Crown', f: 'gold_coin' },
          { p: 'Celestial Astral Compass & Moon', f: 'silver_coin' },
          { p: 'Phoenix Rising Collector Medallion', f: 'bronze_coin' },
          { p: 'ThoughtyGift 1000 Guilloche Note', f: 'banknote' }
        ];
        var pick = ideas[Math.floor(Math.random() * ideas.length)];
        triggerE2eAiGeneration({ prompt: pick.p, finish: pick.f, clearRefImg: true });
        return;
      }

      var coinPreset = e.target.closest('.kc-coin-preset');
      if (coinPreset) {
        var pid = coinPreset.getAttribute('data-coin-preset') || '';
        var map = {
          founder: { p: 'Founder Gold Crest Lion & Laurel', f: 'gold_coin' },
          celestial: { p: 'Celestial Star & Crescent Medallion', f: 'silver_coin' },
          tia: { p: 'Tia Collector Mascot Emblem Coin', f: 'bronze_coin' }
        };
        var cfg = map[pid] || map.founder;
        triggerE2eAiGeneration({ prompt: cfg.p, finish: cfg.f, clearRefImg: true });
        return;
      }

      var crystalBtn = e.target.closest('.kc-crystal-mode-btn');
      if (crystalBtn) {
        var modeTxt = (crystalBtn.textContent || '3D Crystal').trim();
        triggerE2eAiGeneration({ prompt: '3D K9 Crystal ' + modeTxt + ' Sculpture', finish: 'crystal_3d' });
        return;
      }

      if (e.target.closest('#Kc3dBtnExportFree')) {
        var hfHost = document.getElementById('TgHalftoneStudioHost');
        if (hfHost && hfHost.style.display === 'flex') {
          e.preventDefault();
          e.stopImmediatePropagation();
          exportHalftoneSvgFile();
          saveCurrentStudioToDraft(false);
          return;
        }
        var m3dHost = document.getElementById('Tg3dModelStudioHost');
        if (m3dHost && m3dHost.style.display === 'flex') {
          e.preventDefault();
          e.stopImmediatePropagation();
          exportM3dStlFile();
          exportAiVectorSvg();
          saveCurrentStudioToDraft(false);
          return;
        }
      }

      if (e.target.closest('#KcBtnDownloadSvg, #Kc3dBtnExportFree, #Kc3dBtnBuyMaterials, #KcBtnHeaderOrder')) {
        saveCurrentStudioToDraft(false);
      }
    });

    // Hook CinaiStudioBridge.syncLiveEngineFrame, openCinaiStudio & closeCinaiStudio so Halftone/AI Studio, Atomm Loading Overlay & URL state always sync
    function ensureStudioAppLoaderOverlay() {
      var wrap = document.getElementById('Kc3dEngineWrap');
      if (!wrap) return null;
      if (!document.getElementById('KcAtommLoaderKeyframes')) {
        var kfSt = document.createElement('style');
        kfSt.id = 'KcAtommLoaderKeyframes';
        kfSt.textContent = '@keyframes kcAtommSpin{to{transform:rotate(360deg)}}@keyframes kcAtommSlideDown{from{opacity:0;transform:translate(-50%,-10px)}to{opacity:1;transform:translate(-50%,0)}}@keyframes kcAtommBarPulse{0%{width:18%}50%{width:78%}100%{width:92%}}';
        document.head.appendChild(kfSt);
      }
      var appLoader = document.getElementById('Kc3dAppLoadingOverlay');
      var ifr = document.getElementById('Kc3dEngineFrame');
      if (!appLoader) {
        appLoader = document.createElement('div');
        appLoader.id = 'Kc3dAppLoadingOverlay';
        appLoader.style.cssText = 'position:absolute;inset:0;z-index:82;background:#F1F2F4;display:none;flex-direction:column;align-items:center;justify-content:center;transition:opacity 0.25s ease;font-family:Inter,system-ui,-apple-system,sans-serif;';
        appLoader.innerHTML =
          '<div id="Kc3dTopLoadingPill" style="position:absolute;top:16px;left:50%;transform:translateX(-50%);display:inline-flex;align-items:center;border-radius:8px;padding:10px 16px 10px 36px;border:1px solid #3867FF;background:#F0F4FF;box-shadow:0 6px 20px rgba(56,103,255,0.16),0 2px 6px rgba(7,11,16,0.08);color:#070B10;font-size:12px;font-weight:500;line-height:16px;animation:kcAtommSlideDown 0.25s ease;">' +
            '<svg style="position:absolute;left:12px;width:16px;height:16px;animation:kcAtommSpin 0.9s linear infinite;color:#070B10;" viewBox="0 0 24 24" fill="none"><path d="M12 2.75a9.25 9.25 0 1 0 9.25 9.25" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
            '<span id="Kc3dTopLoadingTxt">Loading...</span>' +
          '</div>' +
          '<div style="width:280px;display:flex;flex-direction:column;align-items:center;padding:24px 20px;text-align:center;background:#ffffff;border-radius:14px;border:1px solid rgba(61,62,66,0.08);box-shadow:0 12px 32px rgba(7,11,16,0.06);">' +
            '<div style="position:relative;width:44px;height:44px;margin-bottom:16px;display:flex;align-items:center;justify-content:center;">' +
              '<svg style="position:absolute;inset:0;width:44px;height:44px;animation:kcAtommSpin 1.1s linear infinite;color:#FF7C23;" viewBox="0 0 24 24" fill="none"><path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><circle cx="12" cy="12" r="10" stroke="#E5E7EB" stroke-width="2.2" opacity="0.35"/></svg>' +
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#171719" stroke-width="1.9"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>' +
            '</div>' +
            '<div style="width:100%;height:3px;border-radius:2px;background:#F0F0F5;overflow:hidden;margin-bottom:12px;"><div id="Kc3dLoadingBarFill" style="width:35%;height:100%;background:linear-gradient(90deg,#3867FF 0%,#FF7C23 100%);animation:kcAtommBarPulse 2.2s ease-in-out infinite;"></div></div>' +
            '<div id="Kc3dCenterLoadingTitle" style="font-size:13.5px;font-weight:600;color:#171719;margin-bottom:4px;">Loading Studio...</div>' +
            '<div id="Kc3dCenterLoadingSub" style="font-size:12px;color:#848B96;">Preparing 3D workspace & templates...</div>' +
          '</div>';
        wrap.appendChild(appLoader);
      }
      if (ifr && !ifr._tgLoadBound) {
        ifr._tgLoadBound = true;
        ifr.style.transition = 'opacity 0.22s ease';
        ifr.addEventListener('load', function () {
          var loadedTarget = ifr.getAttribute('data-loaded-url') || '';
          if (!loadedTarget || loadedTarget === 'about:blank' || loadedTarget.indexOf('native-') === 0) return;
          setTimeout(function () {
            if (ifr.getAttribute('data-loaded-url') !== loadedTarget) return;
            ifr.style.opacity = '1';
            var ld = document.getElementById('Kc3dAppLoadingOverlay');
            if (ld) {
              ld.style.opacity = '0';
              setTimeout(function () {
                if (ld.style.opacity === '0') ld.style.display = 'none';
              }, 250);
            }
          }, 360);
        });
      }
      return appLoader;
    }

    function bindBridgeHooks() {
      var b = getBridge();
      if (b && !b._tgHooked) {
        b._tgHooked = true;
        var origSync = b.syncLiveEngineFrame;
        if (typeof origSync === 'function') {
          b.syncLiveEngineFrame = function () {
            var ifrPre = document.getElementById('Kc3dEngineFrame');
            var prevLoadedUrl = ifrPre ? (ifrPre.getAttribute('data-loaded-url') || '') : '';
            var nextRunUrl = (b.state && b.state.runUrl) || '';
            var isSwitchingUrl = Boolean(b.state && b.state.engineMode === '3d' && nextRunUrl && prevLoadedUrl !== nextRunUrl);
            if (ifrPre && isSwitchingUrl) {
              ifrPre.style.opacity = '0';
              ifrPre.src = 'about:blank';
            }
            origSync.apply(this, arguments);
            var cur = (b.state && b.state.toolSlug) || activeSession.slug || '';
            var loaderEl = ensureStudioAppLoaderOverlay();
            var ifrPost = document.getElementById('Kc3dEngineFrame');
            if (isSwitchingUrl && loaderEl && ifrPost) {
              var meta = getToolMeta(cur);
              var topTxt = document.getElementById('Kc3dTopLoadingTxt');
              var cenTxt = document.getElementById('Kc3dCenterLoadingTitle');
              if (topTxt) topTxt.textContent = 'Loading ' + meta.enTitle + '...';
              if (cenTxt) cenTxt.textContent = 'Loading ' + meta.enTitle + '...';
              loaderEl.style.display = 'flex';
              loaderEl.style.opacity = '1';
              ifrPost.style.opacity = '0';
              var targetUrl = (b.state && b.state.runUrl) || '';
              setTimeout(function () {
                if (ifrPost.getAttribute('data-loaded-url') === targetUrl) {
                  ifrPost.style.opacity = '1';
                  loaderEl.style.opacity = '0';
                  setTimeout(function () {
                    if (loaderEl.style.opacity === '0') loaderEl.style.display = 'none';
                  }, 250);
                }
              }, 3800);
            }
            ensureAiStudioWorkbench(cur);
            syncAuthProfileUi();
          };
        }
      }
      if (typeof window.openCinaiStudio === 'function' && !window.openCinaiStudio._tgHooked) {
        var origOpen = window.openCinaiStudio;
        var wrappedOpen = function (slug, pdpUrl) {
          var ifrPre = document.getElementById('Kc3dEngineFrame');
          if (ifrPre) {
            ifrPre.style.opacity = '0';
            ifrPre.setAttribute('data-loaded-url', '');
            ifrPre.src = 'about:blank';
          }
          origOpen.apply(this, arguments);
          var cur = slug || (getBridge() && getBridge().state && getBridge().state.toolSlug) || activeSession.slug || '';
          syncStudioProjectHeaderBar();
          ensureAiStudioWorkbench(cur);
          syncAuthProfileUi();
        };
        wrappedOpen._tgHooked = true;
        window.openCinaiStudio = wrappedOpen;
      }
      if (typeof window.closeCinaiStudio === 'function' && !window.closeCinaiStudio._tgHooked) {
        var origClose = window.closeCinaiStudio;
        var wrappedClose = function () {
          origClose.apply(this, arguments);
          var ifrEl = document.getElementById('Kc3dEngineFrame');
          if (ifrEl) {
            ifrEl.style.opacity = '0';
            ifrEl.setAttribute('data-loaded-url', '');
            ifrEl.src = 'about:blank';
          }
          var ldEl = document.getElementById('Kc3dAppLoadingOverlay');
          if (ldEl) {
            ldEl.style.opacity = '0';
            ldEl.style.display = 'none';
          }
          try {
            var nextUrl = new URL(window.location.href);
            nextUrl.searchParams.delete('openStudio');
            nextUrl.searchParams.delete('studio');
            nextUrl.searchParams.delete('gid');
            if (!nextUrl.searchParams.get('landing')) {
              nextUrl.searchParams.delete('tool');
            }
            window.history.replaceState({}, '', nextUrl.toString());
          } catch (e) {}
        };
        wrappedClose._tgHooked = true;
        window.closeCinaiStudio = wrappedClose;
      }
      var closeBtnEl = document.getElementById('KcBtnClose');
      if (closeBtnEl && !closeBtnEl._tgCloseBound) {
        closeBtnEl._tgCloseBound = true;
        closeBtnEl.addEventListener('click', function () {
          activeSession.gid = '';
          if (typeof window.closeCinaiStudio === 'function') {
            window.closeCinaiStudio();
          }
        });
      }
    }
    bindBridgeHooks();

    window.addEventListener('popstate', function () {
      try {
        var p = new URLSearchParams(window.location.search);
        var lSlug = p.get('landing');
        var tSlug = p.get('tool') || p.get('app') || '';
        var isSt = p.get('openStudio') === '1' || p.get('studio') === '1';
        if (lSlug) {
          openLandingPage(lSlug);
        } else if (isSt && tSlug) {
          openProjectInStudio(tSlug, p.get('gid') || '');
        } else {
          var ov = document.getElementById('TgAppLandingOverlay');
          if (ov) ov.classList.remove('is-open');
          var stM = document.getElementById('CinaiStudioModal');
          if (stM && stM.classList.contains('is-open') && typeof window.closeCinaiStudio === 'function') {
            window.closeCinaiStudio();
          }
          document.body.style.overflow = '';
        }
      } catch (e) {}
    });

    // Check URL params on load
    setTimeout(function () {
      try {
        bindBridgeHooks();
        setCreditBalance(getCreditBalance());
        syncAuthProfileUi();
        syncPaidCreditOrders();
        ensureCreditPaymentModalEnhancements();
        var params = new URLSearchParams(window.location.search);
        var landingSlug = params.get('landing');
        var qTool = params.get('tool') || params.get('app') || '';
        var qGid = params.get('gid') || '';
        if (landingSlug) {
          openLandingPage(landingSlug);
        } else if (params.get('openStudio') === '1' || params.get('studio') === '1') {
          if (qTool) activeSession.slug = qTool;
          if (qGid) activeSession.gid = qGid;
          syncStudioProjectHeaderBar();
          ensureAiStudioWorkbench(activeSession.slug);
          syncAuthProfileUi();
          setTimeout(function () {
            ensureAiStudioWorkbench(activeSession.slug);
            syncAuthProfileUi();
          }, 550);
        } else if (qTool) {
          openLandingPage(qTool);
        }
      } catch (err) {}
    }, 260);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLandingAndProjectHooks);
  } else {
    initLandingAndProjectHooks();
  }
})();
